
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3e1a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3e1a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4DjaP", function(module, exports) {
/*! For license information please see api.js.LICENSE.txt */ !function(e, t) {
    module.exports = t();
}("undefined" != typeof self ? self : module.exports, ()=>(()=>{
        var e = {
            1673: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    D: ()=>s
                });
                var n = Object.prototype, i = n.toString, o = n.hasOwnProperty, a = new Map;
                function s(e, t) {
                    try {
                        return u(e, t);
                    } finally{
                        a.clear();
                    }
                }
                function u(e, t) {
                    if (e === t) return !0;
                    var r = i.call(e);
                    if (r !== i.call(t)) return !1;
                    switch(r){
                        case "[object Array]":
                            if (e.length !== t.length) return !1;
                        case "[object Object]":
                            if (c(e, t)) return !0;
                            var n = Object.keys(e), a = Object.keys(t), s = n.length;
                            if (s !== a.length) return !1;
                            for(var l = 0; l < s; ++l)if (!o.call(t, n[l])) return !1;
                            for(l = 0; l < s; ++l){
                                var f = n[l];
                                if (!u(e[f], t[f])) return !1;
                            }
                            return !0;
                        case "[object Error]":
                            return e.name === t.name && e.message === t.message;
                        case "[object Number]":
                            if (e != e) return t != t;
                        case "[object Boolean]":
                        case "[object Date]":
                            return +e == +t;
                        case "[object RegExp]":
                        case "[object String]":
                            return e == "" + t;
                        case "[object Map]":
                        case "[object Set]":
                            if (e.size !== t.size) return !1;
                            if (c(e, t)) return !0;
                            for(var p = e.entries(), d = "[object Map]" === r;;){
                                var h = p.next();
                                if (h.done) break;
                                var v = h.value, m = v[0], y = v[1];
                                if (!t.has(m)) return !1;
                                if (d && !u(y, t.get(m))) return !1;
                            }
                            return !0;
                    }
                    return !1;
                }
                function c(e, t) {
                    var r = a.get(e);
                    if (r) {
                        if (r.has(t)) return !0;
                    } else a.set(e, r = new Set);
                    return r.add(t), !1;
                }
            },
            7298: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    ApolloClient: ()=>A,
                    ApolloError: ()=>y,
                    ApolloLink: ()=>u.i0,
                    FetchType: ()=>m,
                    HeuristicFragmentMatcher: ()=>ve,
                    HttpLink: ()=>Xe,
                    InMemoryCache: ()=>Fe,
                    IntrospectionFragmentMatcher: ()=>me,
                    NetworkStatus: ()=>n,
                    ObjectCache: ()=>we,
                    Observable: ()=>u.y$,
                    ObservableQuery: ()=>g,
                    StoreReader: ()=>be,
                    StoreWriter: ()=>xe,
                    WriteError: ()=>Ie,
                    assertIdValue: ()=>Oe,
                    concat: ()=>u.zo,
                    createOperation: ()=>u.zi,
                    default: ()=>rt,
                    defaultDataIdFromObject: ()=>Me,
                    defaultNormalizedCacheFactory: ()=>Te,
                    empty: ()=>u.cS,
                    enhanceErrorWithDocument: ()=>Re,
                    execute: ()=>u.ht,
                    from: ()=>u.Dp,
                    fromError: ()=>u.Qc,
                    fromPromise: ()=>u.p4,
                    getOperationName: ()=>u.rY,
                    gql: ()=>Ze.default,
                    isApolloError: ()=>v,
                    makePromise: ()=>u.$y,
                    split: ()=>u.Vl,
                    toPromise: ()=>u.Vi
                });
                var n, i = r(5949), o = r(52), a = r(1673), s = r(674), u = r(4907), c = r(1603), l = r(8754), f = r(7525);
                function p(e) {
                    return e < 7;
                }
                !function(e) {
                    e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
                }(n || (n = {}));
                var d = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return (0, i.ZT)(t, e), t.prototype[c.Z] = function() {
                        return this;
                    }, t.prototype["@@observable"] = function() {
                        return this;
                    }, t;
                }(s.Z);
                function h(e) {
                    return Array.isArray(e) && e.length > 0;
                }
                function v(e) {
                    return e.hasOwnProperty("graphQLErrors");
                }
                var m, y = function(e) {
                    function t(r) {
                        var n, i, o = r.graphQLErrors, a = r.networkError, s = r.errorMessage, u = r.extraInfo, c = e.call(this, s) || this;
                        return c.graphQLErrors = o || [], c.networkError = a || null, c.message = s || (i = "", h((n = c).graphQLErrors) && n.graphQLErrors.forEach(function(e) {
                            i += "GraphQL error: " + (e ? e.message : "Error message not found.") + "\n";
                        }), n.networkError && (i += "Network error: " + n.networkError.message + "\n"), i = i.replace(/\n$/, "")), c.extraInfo = u, c.__proto__ = t.prototype, c;
                    }
                    return (0, i.ZT)(t, e), t;
                }(Error);
                !function(e) {
                    e[e.normal = 1] = "normal", e[e.refetch = 2] = "refetch", e[e.poll = 3] = "poll";
                }(m || (m = {}));
                var g = function(e) {
                    function t(t) {
                        var r = t.queryManager, n = t.options, i = t.shouldSubscribe, a = void 0 === i || i, s = e.call(this, function(e) {
                            return s.onSubscribe(e);
                        }) || this;
                        s.observers = new Set, s.subscriptions = new Set, s.isTornDown = !1, s.options = n, s.variables = n.variables || {}, s.queryId = r.generateQueryId(), s.shouldSubscribe = a;
                        var u = (0, o.$H)(n.query);
                        return s.queryName = u && u.name && u.name.value, s.queryManager = r, s;
                    }
                    return (0, i.ZT)(t, e), t.prototype.result = function() {
                        var e = this;
                        return new Promise(function(t, r) {
                            var n = {
                                next: function(r) {
                                    t(r), e.observers.delete(n), e.observers.size || e.queryManager.removeQuery(e.queryId), setTimeout(function() {
                                        i.unsubscribe();
                                    }, 0);
                                },
                                error: r
                            }, i = e.subscribe(n);
                        });
                    }, t.prototype.currentResult = function() {
                        var e = this.getCurrentResult();
                        return void 0 === e.data && (e.data = {}), e;
                    }, t.prototype.getCurrentResult = function() {
                        if (this.isTornDown) {
                            var e = this.lastResult;
                            return {
                                data: !this.lastError && e && e.data || void 0,
                                error: this.lastError,
                                loading: !1,
                                networkStatus: n.error
                            };
                        }
                        var t, r, o, a = this.queryManager.getCurrentQueryResult(this), s = a.data, u = a.partial, c = this.queryManager.queryStore.get(this.queryId), l = this.options.fetchPolicy, f = "network-only" === l || "no-cache" === l;
                        if (c) {
                            var d = c.networkStatus;
                            if (void 0 === (o = this.options.errorPolicy) && (o = "none"), (r = c) && (r.networkError || "none" === o && h(r.graphQLErrors))) return {
                                data: void 0,
                                loading: !1,
                                networkStatus: d,
                                error: new y({
                                    graphQLErrors: c.graphQLErrors,
                                    networkError: c.networkError
                                })
                            };
                            c.variables && (this.options.variables = (0, i.pi)((0, i.pi)({}, this.options.variables), c.variables), this.variables = this.options.variables), t = {
                                data: s,
                                loading: p(d),
                                networkStatus: d
                            }, c.graphQLErrors && "all" === this.options.errorPolicy && (t.errors = c.graphQLErrors);
                        } else {
                            var v = f || u && "cache-only" !== l;
                            t = {
                                data: s,
                                loading: v,
                                networkStatus: v ? n.loading : n.ready
                            };
                        }
                        return u || this.updateLastResult((0, i.pi)((0, i.pi)({}, t), {
                            stale: !1
                        })), (0, i.pi)((0, i.pi)({}, t), {
                            partial: u
                        });
                    }, t.prototype.isDifferentFromLastResult = function(e) {
                        var t = this.lastResultSnapshot;
                        return !(t && e && t.networkStatus === e.networkStatus && t.stale === e.stale && (0, a.D)(t.data, e.data));
                    }, t.prototype.getLastResult = function() {
                        return this.lastResult;
                    }, t.prototype.getLastError = function() {
                        return this.lastError;
                    }, t.prototype.resetLastResults = function() {
                        delete this.lastResult, delete this.lastResultSnapshot, delete this.lastError, this.isTornDown = !1;
                    }, t.prototype.resetQueryStoreErrors = function() {
                        var e = this.queryManager.queryStore.get(this.queryId);
                        e && (e.networkError = null, e.graphQLErrors = []);
                    }, t.prototype.refetch = function(e) {
                        var t = this.options.fetchPolicy;
                        return "cache-only" === t ? Promise.reject(new l.ej(1)) : ("no-cache" !== t && "cache-and-network" !== t && (t = "network-only"), (0, a.D)(this.variables, e) || (this.variables = (0, i.pi)((0, i.pi)({}, this.variables), e)), (0, a.D)(this.options.variables, this.variables) || (this.options.variables = (0, i.pi)((0, i.pi)({}, this.options.variables), this.variables)), this.queryManager.fetchQuery(this.queryId, (0, i.pi)((0, i.pi)({}, this.options), {
                            fetchPolicy: t
                        }), m.refetch));
                    }, t.prototype.fetchMore = function(e) {
                        var t = this;
                        (0, l.kG)(e.updateQuery, 2);
                        var r = (0, i.pi)((0, i.pi)({}, e.query ? e : (0, i.pi)((0, i.pi)((0, i.pi)({}, this.options), e), {
                            variables: (0, i.pi)((0, i.pi)({}, this.variables), e.variables)
                        })), {
                            fetchPolicy: "network-only"
                        }), n = this.queryManager.generateQueryId();
                        return this.queryManager.fetchQuery(n, r, m.normal, this.queryId).then(function(i) {
                            return t.updateQuery(function(t) {
                                return e.updateQuery(t, {
                                    fetchMoreResult: i.data,
                                    variables: r.variables
                                });
                            }), t.queryManager.stopQuery(n), i;
                        }, function(e) {
                            throw t.queryManager.stopQuery(n), e;
                        });
                    }, t.prototype.subscribeToMore = function(e) {
                        var t = this, r = this.queryManager.startGraphQLSubscription({
                            query: e.document,
                            variables: e.variables
                        }).subscribe({
                            next: function(r) {
                                var n = e.updateQuery;
                                n && t.updateQuery(function(e, t) {
                                    return n(e, {
                                        subscriptionData: r,
                                        variables: t.variables
                                    });
                                });
                            },
                            error: function(t) {
                                e.onError && e.onError(t);
                            }
                        });
                        return this.subscriptions.add(r), function() {
                            t.subscriptions.delete(r) && r.unsubscribe();
                        };
                    }, t.prototype.setOptions = function(e) {
                        var t = this.options.fetchPolicy;
                        this.options = (0, i.pi)((0, i.pi)({}, this.options), e), e.pollInterval ? this.startPolling(e.pollInterval) : 0 === e.pollInterval && this.stopPolling();
                        var r = e.fetchPolicy;
                        return this.setVariables(this.options.variables, t !== r && ("cache-only" === t || "standby" === t || "network-only" === r), e.fetchResults);
                    }, t.prototype.setVariables = function(e, t, r) {
                        return void 0 === t && (t = !1), void 0 === r && (r = !0), this.isTornDown = !1, e = e || this.variables, !t && (0, a.D)(e, this.variables) ? this.observers.size && r ? this.result() : Promise.resolve() : (this.variables = this.options.variables = e, this.observers.size ? this.queryManager.fetchQuery(this.queryId, this.options) : Promise.resolve());
                    }, t.prototype.updateQuery = function(e) {
                        var t = this.queryManager, r = t.getQueryWithPreviousResult(this.queryId), n = r.previousResult, i = r.variables, a = r.document, s = (0, o.XY)(function() {
                            return e(n, {
                                variables: i
                            });
                        });
                        s && (t.dataStore.markUpdateQueryResult(a, i, s), t.broadcastQueries());
                    }, t.prototype.stopPolling = function() {
                        this.queryManager.stopPollingQuery(this.queryId), this.options.pollInterval = void 0;
                    }, t.prototype.startPolling = function(e) {
                        S(this), this.options.pollInterval = e, this.queryManager.startPollingQuery(this.options, this.queryId);
                    }, t.prototype.updateLastResult = function(e) {
                        var t = this.lastResult;
                        return this.lastResult = e, this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? e : (0, o.Xh)(e), t;
                    }, t.prototype.onSubscribe = function(e) {
                        var t = this;
                        try {
                            var r = e._subscription._observer;
                            r && !r.error && (r.error = E);
                        } catch (e) {}
                        var n = !this.observers.size;
                        return this.observers.add(e), e.next && this.lastResult && e.next(this.lastResult), e.error && this.lastError && e.error(this.lastError), n && this.setUpQuery(), function() {
                            t.observers.delete(e) && !t.observers.size && t.tearDownQuery();
                        };
                    }, t.prototype.setUpQuery = function() {
                        var e = this, t = this.queryManager, r = this.queryId;
                        this.shouldSubscribe && t.addObservableQuery(r, this), this.options.pollInterval && (S(this), t.startPollingQuery(this.options, r));
                        var o = function(t) {
                            e.updateLastResult((0, i.pi)((0, i.pi)({}, e.lastResult), {
                                errors: t.graphQLErrors,
                                networkStatus: n.error,
                                loading: !1
                            })), b(e.observers, "error", e.lastError = t);
                        };
                        t.observeQuery(r, this.options, {
                            next: function(r) {
                                if (e.lastError || e.isDifferentFromLastResult(r)) {
                                    var n = e.updateLastResult(r), i = e.options, o = i.query, s = i.variables, u = i.fetchPolicy;
                                    t.transform(o).hasClientExports ? t.getLocalState().addExportedVariables(o, s).then(function(i) {
                                        var s = e.variables;
                                        e.variables = e.options.variables = i, !r.loading && n && "cache-only" !== u && t.transform(o).serverQuery && !(0, a.D)(s, i) ? e.refetch() : b(e.observers, "next", r);
                                    }) : b(e.observers, "next", r);
                                }
                            },
                            error: o
                        }).catch(o);
                    }, t.prototype.tearDownQuery = function() {
                        var e = this.queryManager;
                        this.isTornDown = !0, e.stopPollingQuery(this.queryId), this.subscriptions.forEach(function(e) {
                            return e.unsubscribe();
                        }), this.subscriptions.clear(), e.removeObservableQuery(this.queryId), e.stopQuery(this.queryId), this.observers.clear();
                    }, t;
                }(d);
                function E(e) {}
                function b(e, t, r) {
                    var n = [];
                    e.forEach(function(e) {
                        return e[t] && n.push(e);
                    }), n.forEach(function(e) {
                        return e[t](r);
                    });
                }
                function S(e) {
                    var t = e.options.fetchPolicy;
                    (0, l.kG)("cache-first" !== t && "cache-only" !== t, 3);
                }
                var _ = function() {
                    function e() {
                        this.store = {};
                    }
                    return e.prototype.getStore = function() {
                        return this.store;
                    }, e.prototype.get = function(e) {
                        return this.store[e];
                    }, e.prototype.initMutation = function(e, t, r) {
                        this.store[e] = {
                            mutation: t,
                            variables: r || {},
                            loading: !0,
                            error: null
                        };
                    }, e.prototype.markMutationError = function(e, t) {
                        var r = this.store[e];
                        r && (r.loading = !1, r.error = t);
                    }, e.prototype.markMutationResult = function(e) {
                        var t = this.store[e];
                        t && (t.loading = !1, t.error = null);
                    }, e.prototype.reset = function() {
                        this.store = {};
                    }, e;
                }(), O = function() {
                    function e() {
                        this.store = {};
                    }
                    return e.prototype.getStore = function() {
                        return this.store;
                    }, e.prototype.get = function(e) {
                        return this.store[e];
                    }, e.prototype.initQuery = function(e) {
                        var t = this.store[e.queryId];
                        (0, l.kG)(!t || t.document === e.document || (0, a.D)(t.document, e.document), 19);
                        var r = !1, i = null;
                        e.storePreviousVariables && t && t.networkStatus !== n.loading && ((0, a.D)(t.variables, e.variables) || (r = !0, i = t.variables));
                        var o = [];
                        t && t.graphQLErrors && (o = t.graphQLErrors), this.store[e.queryId] = {
                            document: e.document,
                            variables: e.variables,
                            previousVariables: i,
                            networkError: null,
                            graphQLErrors: o,
                            networkStatus: r ? n.setVariables : e.isPoll ? n.poll : e.isRefetch ? n.refetch : n.loading,
                            metadata: e.metadata
                        }, "string" == typeof e.fetchMoreForQueryId && this.store[e.fetchMoreForQueryId] && (this.store[e.fetchMoreForQueryId].networkStatus = n.fetchMore);
                    }, e.prototype.markQueryResult = function(e, t, r) {
                        this.store && this.store[e] && (this.store[e].networkError = null, this.store[e].graphQLErrors = h(t.errors) ? t.errors : [], this.store[e].previousVariables = null, this.store[e].networkStatus = n.ready, "string" == typeof r && this.store[r] && (this.store[r].networkStatus = n.ready));
                    }, e.prototype.markQueryError = function(e, t, r) {
                        this.store && this.store[e] && (this.store[e].networkError = t, this.store[e].networkStatus = n.error, "string" == typeof r && this.markQueryResultClient(r, !0));
                    }, e.prototype.markQueryResultClient = function(e, t) {
                        var r = this.store && this.store[e];
                        r && (r.networkError = null, r.previousVariables = null, t && (r.networkStatus = n.ready));
                    }, e.prototype.stopQuery = function(e) {
                        delete this.store[e];
                    }, e.prototype.reset = function(e) {
                        var t = this;
                        Object.keys(this.store).forEach(function(r) {
                            e.indexOf(r) < 0 ? t.stopQuery(r) : t.store[r].networkStatus = n.loading;
                        });
                    }, e;
                }();
                var w = function() {
                    function e(e) {
                        var t = e.client, r = e.resolvers, n = e.fragmentMatcher;
                        this.cache = e.cache, t && (this.client = t), r && this.addResolvers(r), n && this.setFragmentMatcher(n);
                    }
                    return e.prototype.addResolvers = function(e) {
                        var t = this;
                        this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(e) {
                            t.resolvers = (0, o.Ee)(t.resolvers, e);
                        }) : this.resolvers = (0, o.Ee)(this.resolvers, e);
                    }, e.prototype.setResolvers = function(e) {
                        this.resolvers = {}, this.addResolvers(e);
                    }, e.prototype.getResolvers = function() {
                        return this.resolvers || {};
                    }, e.prototype.runResolvers = function(e) {
                        var t = e.document, r = e.remoteResult, n = e.context, o = e.variables, a = e.onlyRunForcedResolvers, s = void 0 !== a && a;
                        return (0, i.mG)(this, void 0, void 0, function() {
                            return (0, i.Jh)(this, function(e) {
                                return t ? [
                                    2,
                                    this.resolveDocument(t, r.data, n, o, this.fragmentMatcher, s).then(function(e) {
                                        return (0, i.pi)((0, i.pi)({}, r), {
                                            data: e.result
                                        });
                                    })
                                ] : [
                                    2,
                                    r
                                ];
                            });
                        });
                    }, e.prototype.setFragmentMatcher = function(e) {
                        this.fragmentMatcher = e;
                    }, e.prototype.getFragmentMatcher = function() {
                        return this.fragmentMatcher;
                    }, e.prototype.clientQuery = function(e) {
                        return (0, o.FS)([
                            "client"
                        ], e) && this.resolvers ? e : null;
                    }, e.prototype.serverQuery = function(e) {
                        return this.resolvers ? (0, o.ob)(e) : e;
                    }, e.prototype.prepareContext = function(e) {
                        void 0 === e && (e = {});
                        var t = this.cache;
                        return (0, i.pi)((0, i.pi)({}, e), {
                            cache: t,
                            getCacheKey: function(e) {
                                if (t.config) return t.config.dataIdFromObject(e);
                                (0, l.kG)(!1, 6);
                            }
                        });
                    }, e.prototype.addExportedVariables = function(e, t, r) {
                        return void 0 === t && (t = {}), void 0 === r && (r = {}), (0, i.mG)(this, void 0, void 0, function() {
                            return (0, i.Jh)(this, function(n) {
                                return e ? [
                                    2,
                                    this.resolveDocument(e, this.buildRootValueFromCache(e, t) || {}, this.prepareContext(r), t).then(function(e) {
                                        return (0, i.pi)((0, i.pi)({}, t), e.exportedVariables);
                                    })
                                ] : [
                                    2,
                                    (0, i.pi)({}, t)
                                ];
                            });
                        });
                    }, e.prototype.shouldForceResolvers = function(e) {
                        var t = !1;
                        return (0, f.Vn)(e, {
                            Directive: {
                                enter: function(e) {
                                    if ("client" === e.name.value && e.arguments && (t = e.arguments.some(function(e) {
                                        return "always" === e.name.value && "BooleanValue" === e.value.kind && !0 === e.value.value;
                                    }))) return f.$_;
                                }
                            }
                        }), t;
                    }, e.prototype.buildRootValueFromCache = function(e, t) {
                        return this.cache.diff({
                            query: (0, o.aL)(e),
                            variables: t,
                            returnPartialData: !0,
                            optimistic: !1
                        }).result;
                    }, e.prototype.resolveDocument = function(e, t, r, n, a, s) {
                        return void 0 === r && (r = {}), void 0 === n && (n = {}), void 0 === a && (a = function() {
                            return !0;
                        }), void 0 === s && (s = !1), (0, i.mG)(this, void 0, void 0, function() {
                            var u, c, l, f, p, d, h, v, m;
                            return (0, i.Jh)(this, function(y) {
                                var g;
                                return u = (0, o.p$)(e), c = (0, o.kU)(e), l = (0, o.F)(c), p = (f = u.operation) ? (g = f).charAt(0).toUpperCase() + g.slice(1) : "Query", h = (d = this).cache, v = d.client, m = {
                                    fragmentMap: l,
                                    context: (0, i.pi)((0, i.pi)({}, r), {
                                        cache: h,
                                        client: v
                                    }),
                                    variables: n,
                                    fragmentMatcher: a,
                                    defaultOperationType: p,
                                    exportedVariables: {},
                                    onlyRunForcedResolvers: s
                                }, [
                                    2,
                                    this.resolveSelectionSet(u.selectionSet, t, m).then(function(e) {
                                        return {
                                            result: e,
                                            exportedVariables: m.exportedVariables
                                        };
                                    })
                                ];
                            });
                        });
                    }, e.prototype.resolveSelectionSet = function(e, t, r) {
                        return (0, i.mG)(this, void 0, void 0, function() {
                            var n, a, s, u, c, f = this;
                            return (0, i.Jh)(this, function(p) {
                                return n = r.fragmentMap, a = r.context, s = r.variables, u = [
                                    t
                                ], c = function(e) {
                                    return (0, i.mG)(f, void 0, void 0, function() {
                                        var c;
                                        return (0, i.Jh)(this, function(i) {
                                            return (0, o.LZ)(e, s) ? (0, o.My)(e) ? [
                                                2,
                                                this.resolveField(e, t, r).then(function(t) {
                                                    var r;
                                                    void 0 !== t && u.push(((r = {})[(0, o.u2)(e)] = t, r));
                                                })
                                            ] : ((0, o.Ao)(e) ? c = e : (0, l.kG)(c = n[e.name.value], 7), c && c.typeCondition && r.fragmentMatcher(t, c.typeCondition.name.value, a) ? [
                                                2,
                                                this.resolveSelectionSet(c.selectionSet, t, r).then(function(e) {
                                                    u.push(e);
                                                })
                                            ] : [
                                                2
                                            ]) : [
                                                2
                                            ];
                                        });
                                    });
                                }, [
                                    2,
                                    Promise.all(e.selections.map(c)).then(function() {
                                        return (0, o.bw)(u);
                                    })
                                ];
                            });
                        });
                    }, e.prototype.resolveField = function(e, t, r) {
                        return (0, i.mG)(this, void 0, void 0, function() {
                            var n, a, s, u, c, l, f, p, d, h = this;
                            return (0, i.Jh)(this, function(i) {
                                return n = r.variables, a = e.name.value, s = (0, o.u2)(e), u = a !== s, c = t[s] || t[a], l = Promise.resolve(c), r.onlyRunForcedResolvers && !this.shouldForceResolvers(e) || (f = t.__typename || r.defaultOperationType, (p = this.resolvers && this.resolvers[f]) && (d = p[u ? a : s]) && (l = Promise.resolve(d(t, (0, o.NC)(e, n), r.context, {
                                    field: e,
                                    fragmentMap: r.fragmentMap
                                })))), [
                                    2,
                                    l.then(function(t) {
                                        return void 0 === t && (t = c), e.directives && e.directives.forEach(function(e) {
                                            "export" === e.name.value && e.arguments && e.arguments.forEach(function(e) {
                                                "as" === e.name.value && "StringValue" === e.value.kind && (r.exportedVariables[e.value.value] = t);
                                            });
                                        }), e.selectionSet ? null == t ? t : Array.isArray(t) ? h.resolveSubSelectedArray(e, t, r) : e.selectionSet ? h.resolveSelectionSet(e.selectionSet, t, r) : void 0 : t;
                                    })
                                ];
                            });
                        });
                    }, e.prototype.resolveSubSelectedArray = function(e, t, r) {
                        var n = this;
                        return Promise.all(t.map(function(t) {
                            return null === t ? null : Array.isArray(t) ? n.resolveSubSelectedArray(e, t, r) : e.selectionSet ? n.resolveSelectionSet(e.selectionSet, t, r) : void 0;
                        }));
                    }, e;
                }();
                function T(e) {
                    var t = new Set, r = null;
                    return new d(function(n) {
                        return t.add(n), r = r || e.subscribe({
                            next: function(e) {
                                t.forEach(function(t) {
                                    return t.next && t.next(e);
                                });
                            },
                            error: function(e) {
                                t.forEach(function(t) {
                                    return t.error && t.error(e);
                                });
                            },
                            complete: function() {
                                t.forEach(function(e) {
                                    return e.complete && e.complete();
                                });
                            }
                        }), function() {
                            t.delete(n) && !t.size && r && (r.unsubscribe(), r = null);
                        };
                    });
                }
                var I = Object.prototype.hasOwnProperty, R = function() {
                    function e(e) {
                        var t = e.link, r = e.queryDeduplication, n = void 0 !== r && r, i = e.store, a = e.onBroadcast, s = void 0 === a ? function() {} : a, u = e.ssrMode, c = void 0 !== u && u, l = e.clientAwareness, f = void 0 === l ? {} : l, p = e.localState, d = e.assumeImmutableResults;
                        this.mutationStore = new _, this.queryStore = new O, this.clientAwareness = {}, this.idCounter = 1, this.queries = new Map, this.fetchQueryRejectFns = new Map, this.transformCache = new (o.mr ? WeakMap : Map), this.inFlightLinkObservables = new Map, this.pollingInfoByQueryId = new Map, this.link = t, this.queryDeduplication = n, this.dataStore = i, this.onBroadcast = s, this.clientAwareness = f, this.localState = p || new w({
                            cache: i.getCache()
                        }), this.ssrMode = c, this.assumeImmutableResults = !!d;
                    }
                    return e.prototype.stop = function() {
                        var e = this;
                        this.queries.forEach(function(t, r) {
                            e.stopQueryNoBroadcast(r);
                        }), this.fetchQueryRejectFns.forEach(function(e) {
                            e(new l.ej(8));
                        });
                    }, e.prototype.mutate = function(e) {
                        var t = e.mutation, r = e.variables, n = e.optimisticResponse, a = e.updateQueries, s = e.refetchQueries, u = void 0 === s ? [] : s, c = e.awaitRefetchQueries, f = void 0 !== c && c, p = e.update, d = e.errorPolicy, v = void 0 === d ? "none" : d, m = e.fetchPolicy, g = e.context, E = void 0 === g ? {} : g;
                        return (0, i.mG)(this, void 0, void 0, function() {
                            var e, s, c, d = this;
                            return (0, i.Jh)(this, function(g) {
                                switch(g.label){
                                    case 0:
                                        return (0, l.kG)(t, 9), (0, l.kG)(!m || "no-cache" === m, 10), e = this.generateQueryId(), t = this.transform(t).document, this.setQuery(e, function() {
                                            return {
                                                document: t
                                            };
                                        }), r = this.getVariables(t, r), this.transform(t).hasClientExports ? [
                                            4,
                                            this.localState.addExportedVariables(t, r, E)
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        r = g.sent(), g.label = 2;
                                    case 2:
                                        return s = function() {
                                            var e = {};
                                            return a && d.queries.forEach(function(t, r) {
                                                var n = t.observableQuery;
                                                if (n) {
                                                    var i = n.queryName;
                                                    i && I.call(a, i) && (e[r] = {
                                                        updater: a[i],
                                                        query: d.queryStore.get(r)
                                                    });
                                                }
                                            }), e;
                                        }, this.mutationStore.initMutation(e, t, r), this.dataStore.markMutationInit({
                                            mutationId: e,
                                            document: t,
                                            variables: r,
                                            updateQueries: s(),
                                            update: p,
                                            optimisticResponse: n
                                        }), this.broadcastQueries(), c = this, [
                                            2,
                                            new Promise(function(a, l) {
                                                var d, g;
                                                c.getObservableFromLink(t, (0, i.pi)((0, i.pi)({}, E), {
                                                    optimisticResponse: n
                                                }), r, !1).subscribe({
                                                    next: function(n) {
                                                        (0, o.d2)(n) && "none" === v ? g = new y({
                                                            graphQLErrors: n.errors
                                                        }) : (c.mutationStore.markMutationResult(e), "no-cache" !== m && c.dataStore.markMutationResult({
                                                            mutationId: e,
                                                            result: n,
                                                            document: t,
                                                            variables: r,
                                                            updateQueries: s(),
                                                            update: p
                                                        }), d = n);
                                                    },
                                                    error: function(t) {
                                                        c.mutationStore.markMutationError(e, t), c.dataStore.markMutationComplete({
                                                            mutationId: e,
                                                            optimisticResponse: n
                                                        }), c.broadcastQueries(), c.setQuery(e, function() {
                                                            return {
                                                                document: null
                                                            };
                                                        }), l(new y({
                                                            networkError: t
                                                        }));
                                                    },
                                                    complete: function() {
                                                        if (g && c.mutationStore.markMutationError(e, g), c.dataStore.markMutationComplete({
                                                            mutationId: e,
                                                            optimisticResponse: n
                                                        }), c.broadcastQueries(), g) l(g);
                                                        else {
                                                            "function" == typeof u && (u = u(d));
                                                            var t = [];
                                                            h(u) && u.forEach(function(e) {
                                                                if ("string" == typeof e) c.queries.forEach(function(r) {
                                                                    var n = r.observableQuery;
                                                                    n && n.queryName === e && t.push(n.refetch());
                                                                });
                                                                else {
                                                                    var r = {
                                                                        query: e.query,
                                                                        variables: e.variables,
                                                                        fetchPolicy: "network-only"
                                                                    };
                                                                    e.context && (r.context = e.context), t.push(c.query(r));
                                                                }
                                                            }), Promise.all(f ? t : []).then(function() {
                                                                c.setQuery(e, function() {
                                                                    return {
                                                                        document: null
                                                                    };
                                                                }), "ignore" === v && d && (0, o.d2)(d) && delete d.errors, a(d);
                                                            });
                                                        }
                                                    }
                                                });
                                            })
                                        ];
                                }
                            });
                        });
                    }, e.prototype.fetchQuery = function(e, t, r, n) {
                        return (0, i.mG)(this, void 0, void 0, function() {
                            var a, s, u, c, l, f, p, d, h, g, E, b, S, _, O, w, T = this;
                            return (0, i.Jh)(this, function(I) {
                                switch(I.label){
                                    case 0:
                                        return s = void 0 === (a = t.metadata) ? null : a, c = void 0 === (u = t.fetchPolicy) ? "cache-first" : u, f = void 0 === (l = t.context) ? {} : l, p = this.transform(t.query).document, d = this.getVariables(p, t.variables), this.transform(p).hasClientExports ? [
                                            4,
                                            this.localState.addExportedVariables(p, d, f)
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        d = I.sent(), I.label = 2;
                                    case 2:
                                        if (t = (0, i.pi)((0, i.pi)({}, t), {
                                            variables: d
                                        }), E = g = "network-only" === c || "no-cache" === c, g || (b = this.dataStore.getCache().diff({
                                            query: p,
                                            variables: d,
                                            returnPartialData: !0,
                                            optimistic: !1
                                        }), E = !b.complete || "cache-and-network" === c, h = b.result), S = E && "cache-only" !== c && "standby" !== c, (0, o.FS)([
                                            "live"
                                        ], p) && (S = !0), _ = this.idCounter++, O = "no-cache" !== c ? this.updateQueryWatch(e, p, t) : void 0, this.setQuery(e, function() {
                                            return {
                                                document: p,
                                                lastRequestId: _,
                                                invalidated: !0,
                                                cancel: O
                                            };
                                        }), this.invalidate(n), this.queryStore.initQuery({
                                            queryId: e,
                                            document: p,
                                            storePreviousVariables: S,
                                            variables: d,
                                            isPoll: r === m.poll,
                                            isRefetch: r === m.refetch,
                                            metadata: s,
                                            fetchMoreForQueryId: n
                                        }), this.broadcastQueries(), S) {
                                            if (w = this.fetchRequest({
                                                requestId: _,
                                                queryId: e,
                                                document: p,
                                                options: t,
                                                fetchMoreForQueryId: n
                                            }).catch(function(t) {
                                                throw v(t) ? t : (_ >= T.getQuery(e).lastRequestId && (T.queryStore.markQueryError(e, t, n), T.invalidate(e), T.invalidate(n), T.broadcastQueries()), new y({
                                                    networkError: t
                                                }));
                                            }), "cache-and-network" !== c) return [
                                                2,
                                                w
                                            ];
                                            w.catch(function() {});
                                        }
                                        return this.queryStore.markQueryResultClient(e, !S), this.invalidate(e), this.invalidate(n), this.transform(p).hasForcedResolvers ? [
                                            2,
                                            this.localState.runResolvers({
                                                document: p,
                                                remoteResult: {
                                                    data: h
                                                },
                                                context: f,
                                                variables: d,
                                                onlyRunForcedResolvers: !0
                                            }).then(function(r) {
                                                return T.markQueryResult(e, r, t, n), T.broadcastQueries(), r;
                                            })
                                        ] : (this.broadcastQueries(), [
                                            2,
                                            {
                                                data: h
                                            }
                                        ]);
                                }
                            });
                        });
                    }, e.prototype.markQueryResult = function(e, t, r, n) {
                        var i = r.variables, o = r.errorPolicy;
                        "no-cache" === r.fetchPolicy ? this.setQuery(e, function() {
                            return {
                                newData: {
                                    result: t.data,
                                    complete: !0
                                }
                            };
                        }) : this.dataStore.markQueryResult(t, this.getQuery(e).document, i, n, "ignore" === o || "all" === o);
                    }, e.prototype.queryListenerForObserver = function(e, t, r) {
                        var n = this;
                        function i(e, t) {
                            if (r[e]) try {
                                r[e](t);
                            } catch (e) {}
                        }
                        return function(r, o) {
                            if (n.invalidate(e, !1), r) {
                                var a = n.getQuery(e), s = a.observableQuery, u = a.document, c = s ? s.options.fetchPolicy : t.fetchPolicy;
                                if ("standby" !== c) {
                                    var l = p(r.networkStatus), f = s && s.getLastResult();
                                    if (!l || t.returnPartialData || !o && r.previousVariables || !(!f || f.networkStatus === r.networkStatus) && t.notifyOnNetworkStatusChange || "cache-only" === c || "cache-and-network" === c) {
                                        var d = h(r.graphQLErrors), v = s && s.options.errorPolicy || t.errorPolicy || "none";
                                        if ("none" === v && d || r.networkError) return i("error", new y({
                                            graphQLErrors: r.graphQLErrors,
                                            networkError: r.networkError
                                        }));
                                        try {
                                            var m = void 0, g = void 0;
                                            if (o) "no-cache" !== c && "network-only" !== c && n.setQuery(e, function() {
                                                return {
                                                    newData: null
                                                };
                                            }), m = o.result, g = !o.complete;
                                            else {
                                                var E = s && s.getLastError();
                                                if (f && f.data && !("none" !== v && (E && E.graphQLErrors) !== r.graphQLErrors)) m = f.data, g = !1;
                                                else {
                                                    var b = n.dataStore.getCache().diff({
                                                        query: u,
                                                        variables: r.previousVariables || r.variables,
                                                        returnPartialData: !0,
                                                        optimistic: !0
                                                    });
                                                    m = b.result, g = !b.complete;
                                                }
                                            }
                                            var S = g && !(t.returnPartialData || "cache-only" === c), _ = {
                                                data: S ? f && f.data : m,
                                                loading: l,
                                                networkStatus: r.networkStatus,
                                                stale: S
                                            };
                                            "all" === v && d && (_.errors = r.graphQLErrors), i("next", _);
                                        } catch (e) {
                                            i("error", new y({
                                                networkError: e
                                            }));
                                        }
                                    }
                                }
                            }
                        };
                    }, e.prototype.transform = function(e) {
                        var t = this.transformCache;
                        if (!t.has(e)) {
                            var r = this.dataStore.getCache(), n = r.transformDocument(e), i = (0, o.Fo)(r.transformForLink(n)), a = this.localState.clientQuery(n), s = this.localState.serverQuery(i), u = {
                                document: n,
                                hasClientExports: (0, o.mj)(n),
                                hasForcedResolvers: this.localState.shouldForceResolvers(n),
                                clientQuery: a,
                                serverQuery: s,
                                defaultVars: (0, o.O4)((0, o.$H)(n))
                            }, c = function(e) {
                                e && !t.has(e) && t.set(e, u);
                            };
                            c(e), c(n), c(a), c(s);
                        }
                        return t.get(e);
                    }, e.prototype.getVariables = function(e, t) {
                        return (0, i.pi)((0, i.pi)({}, this.transform(e).defaultVars), t);
                    }, e.prototype.watchQuery = function(e, t) {
                        void 0 === t && (t = !0), (0, l.kG)("standby" !== e.fetchPolicy, 11), e.variables = this.getVariables(e.query, e.variables), void 0 === e.notifyOnNetworkStatusChange && (e.notifyOnNetworkStatusChange = !1);
                        var r = (0, i.pi)({}, e);
                        return new g({
                            queryManager: this,
                            options: r,
                            shouldSubscribe: t
                        });
                    }, e.prototype.query = function(e) {
                        var t = this;
                        return (0, l.kG)(e.query, 12), (0, l.kG)("Document" === e.query.kind, 13), (0, l.kG)(!e.returnPartialData, 14), (0, l.kG)(!e.pollInterval, 15), new Promise(function(r, n) {
                            var i = t.watchQuery(e, !1);
                            t.fetchQueryRejectFns.set("query:" + i.queryId, n), i.result().then(r, n).then(function() {
                                return t.fetchQueryRejectFns.delete("query:" + i.queryId);
                            });
                        });
                    }, e.prototype.generateQueryId = function() {
                        return String(this.idCounter++);
                    }, e.prototype.stopQueryInStore = function(e) {
                        this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
                    }, e.prototype.stopQueryInStoreNoBroadcast = function(e) {
                        this.stopPollingQuery(e), this.queryStore.stopQuery(e), this.invalidate(e);
                    }, e.prototype.addQueryListener = function(e, t) {
                        this.setQuery(e, function(e) {
                            return e.listeners.add(t), {
                                invalidated: !1
                            };
                        });
                    }, e.prototype.updateQueryWatch = function(e, t, r) {
                        var n = this, i = this.getQuery(e).cancel;
                        i && i();
                        return this.dataStore.getCache().watch({
                            query: t,
                            variables: r.variables,
                            optimistic: !0,
                            previousResult: function() {
                                var t = null, r = n.getQuery(e).observableQuery;
                                if (r) {
                                    var i = r.getLastResult();
                                    i && (t = i.data);
                                }
                                return t;
                            },
                            callback: function(t) {
                                n.setQuery(e, function() {
                                    return {
                                        invalidated: !0,
                                        newData: t
                                    };
                                });
                            }
                        });
                    }, e.prototype.addObservableQuery = function(e, t) {
                        this.setQuery(e, function() {
                            return {
                                observableQuery: t
                            };
                        });
                    }, e.prototype.removeObservableQuery = function(e) {
                        var t = this.getQuery(e).cancel;
                        this.setQuery(e, function() {
                            return {
                                observableQuery: null
                            };
                        }), t && t();
                    }, e.prototype.clearStore = function() {
                        this.fetchQueryRejectFns.forEach(function(e) {
                            e(new l.ej(16));
                        });
                        var e = [];
                        return this.queries.forEach(function(t, r) {
                            t.observableQuery && e.push(r);
                        }), this.queryStore.reset(e), this.mutationStore.reset(), this.dataStore.reset();
                    }, e.prototype.resetStore = function() {
                        var e = this;
                        return this.clearStore().then(function() {
                            return e.reFetchObservableQueries();
                        });
                    }, e.prototype.reFetchObservableQueries = function(e) {
                        var t = this;
                        void 0 === e && (e = !1);
                        var r = [];
                        return this.queries.forEach(function(n, i) {
                            var o = n.observableQuery;
                            if (o) {
                                var a = o.options.fetchPolicy;
                                o.resetLastResults(), "cache-only" === a || !e && "standby" === a || r.push(o.refetch()), t.setQuery(i, function() {
                                    return {
                                        newData: null
                                    };
                                }), t.invalidate(i);
                            }
                        }), this.broadcastQueries(), Promise.all(r);
                    }, e.prototype.observeQuery = function(e, t, r) {
                        return this.addQueryListener(e, this.queryListenerForObserver(e, t, r)), this.fetchQuery(e, t);
                    }, e.prototype.startQuery = function(e, t, r) {
                        return this.addQueryListener(e, r), this.fetchQuery(e, t).catch(function() {}), e;
                    }, e.prototype.startGraphQLSubscription = function(e) {
                        var t = this, r = e.query, n = e.fetchPolicy, i = e.variables;
                        r = this.transform(r).document, i = this.getVariables(r, i);
                        var a = function(e) {
                            return t.getObservableFromLink(r, {}, e, !1).map(function(i) {
                                if (n && "no-cache" === n || (t.dataStore.markSubscriptionResult(i, r, e), t.broadcastQueries()), (0, o.d2)(i)) throw new y({
                                    graphQLErrors: i.errors
                                });
                                return i;
                            });
                        };
                        if (this.transform(r).hasClientExports) {
                            var s = this.localState.addExportedVariables(r, i).then(a);
                            return new d(function(e) {
                                var t = null;
                                return s.then(function(r) {
                                    return t = r.subscribe(e);
                                }, e.error), function() {
                                    return t && t.unsubscribe();
                                };
                            });
                        }
                        return a(i);
                    }, e.prototype.stopQuery = function(e) {
                        this.stopQueryNoBroadcast(e), this.broadcastQueries();
                    }, e.prototype.stopQueryNoBroadcast = function(e) {
                        this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
                    }, e.prototype.removeQuery = function(e) {
                        this.fetchQueryRejectFns.delete("query:" + e), this.fetchQueryRejectFns.delete("fetchRequest:" + e), this.getQuery(e).subscriptions.forEach(function(e) {
                            return e.unsubscribe();
                        }), this.queries.delete(e);
                    }, e.prototype.getCurrentQueryResult = function(e, t) {
                        void 0 === t && (t = !0);
                        var r = e.options, n = r.variables, i = r.query, o = r.fetchPolicy, a = r.returnPartialData, s = e.getLastResult(), u = this.getQuery(e.queryId).newData;
                        if (u && u.complete) return {
                            data: u.result,
                            partial: !1
                        };
                        if ("no-cache" === o || "network-only" === o) return {
                            data: void 0,
                            partial: !1
                        };
                        var c = this.dataStore.getCache().diff({
                            query: i,
                            variables: n,
                            previousResult: s ? s.data : void 0,
                            returnPartialData: !0,
                            optimistic: t
                        }), l = c.complete;
                        return {
                            data: l || a ? c.result : void 0,
                            partial: !l
                        };
                    }, e.prototype.getQueryWithPreviousResult = function(e) {
                        var t;
                        if ("string" == typeof e) {
                            var r = this.getQuery(e).observableQuery;
                            (0, l.kG)(r, 17), t = r;
                        } else t = e;
                        var n = t.options, i = n.variables, o = n.query;
                        return {
                            previousResult: this.getCurrentQueryResult(t, !1).data,
                            variables: i,
                            document: o
                        };
                    }, e.prototype.broadcastQueries = function() {
                        var e = this;
                        this.onBroadcast(), this.queries.forEach(function(t, r) {
                            t.invalidated && t.listeners.forEach(function(n) {
                                n && n(e.queryStore.get(r), t.newData);
                            });
                        });
                    }, e.prototype.getLocalState = function() {
                        return this.localState;
                    }, e.prototype.getObservableFromLink = function(e, t, r, n) {
                        var a, s = this;
                        void 0 === n && (n = this.queryDeduplication);
                        var c = this.transform(e).serverQuery;
                        if (c) {
                            var l = this.inFlightLinkObservables, f = this.link, p = {
                                query: c,
                                variables: r,
                                operationName: (0, o.rY)(c) || void 0,
                                context: this.prepareContext((0, i.pi)((0, i.pi)({}, t), {
                                    forceFetch: !n
                                }))
                            };
                            if (t = p.context, n) {
                                var h = l.get(c) || new Map;
                                l.set(c, h);
                                var v = JSON.stringify(r);
                                if (!(a = h.get(v))) {
                                    h.set(v, a = T((0, u.ht)(f, p)));
                                    var m = function() {
                                        h.delete(v), h.size || l.delete(c), y.unsubscribe();
                                    }, y = a.subscribe({
                                        next: m,
                                        error: m,
                                        complete: m
                                    });
                                }
                            } else a = T((0, u.ht)(f, p));
                        } else a = d.of({
                            data: {}
                        }), t = this.prepareContext(t);
                        var g = this.transform(e).clientQuery;
                        return g && (a = function(e, t) {
                            return new d(function(r) {
                                var n = r.next, i = r.error, o = r.complete, a = 0, s = !1, u = {
                                    next: function(e) {
                                        ++a, new Promise(function(r) {
                                            r(t(e));
                                        }).then(function(e) {
                                            --a, n && n.call(r, e), s && u.complete();
                                        }, function(e) {
                                            --a, i && i.call(r, e);
                                        });
                                    },
                                    error: function(e) {
                                        i && i.call(r, e);
                                    },
                                    complete: function() {
                                        s = !0, a || o && o.call(r);
                                    }
                                }, c = e.subscribe(u);
                                return function() {
                                    return c.unsubscribe();
                                };
                            });
                        }(a, function(e) {
                            return s.localState.runResolvers({
                                document: g,
                                remoteResult: e,
                                context: t,
                                variables: r
                            });
                        })), a;
                    }, e.prototype.fetchRequest = function(e) {
                        var t, r, i = this, o = e.requestId, a = e.queryId, s = e.document, u = e.options, c = e.fetchMoreForQueryId, l = u.variables, f = u.errorPolicy, p = void 0 === f ? "none" : f, d = u.fetchPolicy;
                        return new Promise(function(e, f) {
                            var v = i.getObservableFromLink(s, u.context, l), m = "fetchRequest:" + a;
                            i.fetchQueryRejectFns.set(m, f);
                            var g = function() {
                                i.fetchQueryRejectFns.delete(m), i.setQuery(a, function(e) {
                                    e.subscriptions.delete(E);
                                });
                            }, E = v.map(function(e) {
                                if (o >= i.getQuery(a).lastRequestId && (i.markQueryResult(a, e, u, c), i.queryStore.markQueryResult(a, e, c), i.invalidate(a), i.invalidate(c), i.broadcastQueries()), "none" === p && h(e.errors)) return f(new y({
                                    graphQLErrors: e.errors
                                }));
                                if ("all" === p && (r = e.errors), c || "no-cache" === d) t = e.data;
                                else {
                                    var n = i.dataStore.getCache().diff({
                                        variables: l,
                                        query: s,
                                        optimistic: !1,
                                        returnPartialData: !0
                                    });
                                    (n.complete || u.returnPartialData) && (t = n.result);
                                }
                            }).subscribe({
                                error: function(e) {
                                    g(), f(e);
                                },
                                complete: function() {
                                    g(), e({
                                        data: t,
                                        errors: r,
                                        loading: !1,
                                        networkStatus: n.ready,
                                        stale: !1
                                    });
                                }
                            });
                            i.setQuery(a, function(e) {
                                e.subscriptions.add(E);
                            });
                        });
                    }, e.prototype.getQuery = function(e) {
                        return this.queries.get(e) || {
                            listeners: new Set,
                            invalidated: !1,
                            document: null,
                            newData: null,
                            lastRequestId: 1,
                            observableQuery: null,
                            subscriptions: new Set
                        };
                    }, e.prototype.setQuery = function(e, t) {
                        var r = this.getQuery(e), n = (0, i.pi)((0, i.pi)({}, r), t(r));
                        this.queries.set(e, n);
                    }, e.prototype.invalidate = function(e, t) {
                        void 0 === t && (t = !0), e && this.setQuery(e, function() {
                            return {
                                invalidated: t
                            };
                        });
                    }, e.prototype.prepareContext = function(e) {
                        void 0 === e && (e = {});
                        var t = this.localState.prepareContext(e);
                        return (0, i.pi)((0, i.pi)({}, t), {
                            clientAwareness: this.clientAwareness
                        });
                    }, e.prototype.checkInFlight = function(e) {
                        var t = this.queryStore.get(e);
                        return t && t.networkStatus !== n.ready && t.networkStatus !== n.error;
                    }, e.prototype.startPollingQuery = function(e, t, r) {
                        var n = this, o = e.pollInterval;
                        if ((0, l.kG)(o, 18), !this.ssrMode) {
                            var a = this.pollingInfoByQueryId.get(t);
                            a || this.pollingInfoByQueryId.set(t, a = {}), a.interval = o, a.options = (0, i.pi)((0, i.pi)({}, e), {
                                fetchPolicy: "network-only"
                            });
                            var s = function() {
                                var e = n.pollingInfoByQueryId.get(t);
                                e && (n.checkInFlight(t) ? u() : n.fetchQuery(t, e.options, m.poll).then(u, u));
                            }, u = function() {
                                var e = n.pollingInfoByQueryId.get(t);
                                e && (clearTimeout(e.timeout), e.timeout = setTimeout(s, e.interval));
                            };
                            r && this.addQueryListener(t, r), u();
                        }
                        return t;
                    }, e.prototype.stopPollingQuery = function(e) {
                        this.pollingInfoByQueryId.delete(e);
                    }, e;
                }(), x = function() {
                    function e(e) {
                        this.cache = e;
                    }
                    return e.prototype.getCache = function() {
                        return this.cache;
                    }, e.prototype.markQueryResult = function(e, t, r, n, i) {
                        void 0 === i && (i = !1);
                        var a = !(0, o.d2)(e);
                        i && (0, o.d2)(e) && e.data && (a = !0), !n && a && this.cache.write({
                            result: e.data,
                            dataId: "ROOT_QUERY",
                            query: t,
                            variables: r
                        });
                    }, e.prototype.markSubscriptionResult = function(e, t, r) {
                        (0, o.d2)(e) || this.cache.write({
                            result: e.data,
                            dataId: "ROOT_SUBSCRIPTION",
                            query: t,
                            variables: r
                        });
                    }, e.prototype.markMutationInit = function(e) {
                        var t, r = this;
                        e.optimisticResponse && (t = "function" == typeof e.optimisticResponse ? e.optimisticResponse(e.variables) : e.optimisticResponse, this.cache.recordOptimisticTransaction(function(n) {
                            var i = r.cache;
                            r.cache = n;
                            try {
                                r.markMutationResult({
                                    mutationId: e.mutationId,
                                    result: {
                                        data: t
                                    },
                                    document: e.document,
                                    variables: e.variables,
                                    updateQueries: e.updateQueries,
                                    update: e.update
                                });
                            } finally{
                                r.cache = i;
                            }
                        }, e.mutationId));
                    }, e.prototype.markMutationResult = function(e) {
                        var t = this;
                        if (!(0, o.d2)(e.result)) {
                            var r = [
                                {
                                    result: e.result.data,
                                    dataId: "ROOT_MUTATION",
                                    query: e.document,
                                    variables: e.variables
                                }
                            ], n = e.updateQueries;
                            n && Object.keys(n).forEach(function(i) {
                                var a = n[i], s = a.query, u = a.updater, c = t.cache.diff({
                                    query: s.document,
                                    variables: s.variables,
                                    returnPartialData: !0,
                                    optimistic: !1
                                }), l = c.result;
                                if (c.complete) {
                                    var f = (0, o.XY)(function() {
                                        return u(l, {
                                            mutationResult: e.result,
                                            queryName: (0, o.rY)(s.document) || void 0,
                                            queryVariables: s.variables
                                        });
                                    });
                                    f && r.push({
                                        result: f,
                                        dataId: "ROOT_QUERY",
                                        query: s.document,
                                        variables: s.variables
                                    });
                                }
                            }), this.cache.performTransaction(function(t) {
                                r.forEach(function(e) {
                                    return t.write(e);
                                });
                                var n = e.update;
                                n && (0, o.XY)(function() {
                                    return n(t, e.result);
                                });
                            });
                        }
                    }, e.prototype.markMutationComplete = function(e) {
                        e.optimisticResponse && this.cache.removeOptimistic(e.mutationId);
                    }, e.prototype.markUpdateQueryResult = function(e, t, r) {
                        this.cache.write({
                            result: r,
                            dataId: "ROOT_QUERY",
                            variables: t,
                            query: e
                        });
                    }, e.prototype.reset = function() {
                        return this.cache.reset();
                    }, e;
                }(), A = function() {
                    function e(e) {
                        var t = this;
                        this.defaultOptions = {}, this.resetStoreCallbacks = [], this.clearStoreCallbacks = [];
                        var r = e.cache, n = e.ssrMode, i = void 0 !== n && n, o = e.ssrForceFetchDelay, a = void 0 === o ? 0 : o, s = e.connectToDevTools, c = e.queryDeduplication, f = void 0 === c || c, p = e.defaultOptions, d = e.assumeImmutableResults, h = void 0 !== d && d, v = e.resolvers, m = e.typeDefs, y = e.fragmentMatcher, g = e.name, E = e.version, b = e.link;
                        if (!b && v && (b = u.i0.empty()), !b || !r) throw new l.ej(4);
                        this.link = b, this.cache = r, this.store = new x(r), this.disableNetworkFetches = i || a > 0, this.queryDeduplication = f, this.defaultOptions = p || {}, this.typeDefs = m, a && setTimeout(function() {
                            return t.disableNetworkFetches = !1;
                        }, a), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
                        void 0 !== s && s && "undefined" != typeof window && (window.__APOLLO_CLIENT__ = this), this.version = "2.6.10", this.localState = new w({
                            cache: r,
                            client: this,
                            resolvers: v,
                            fragmentMatcher: y
                        }), this.queryManager = new R({
                            link: this.link,
                            store: this.store,
                            queryDeduplication: f,
                            ssrMode: i,
                            clientAwareness: {
                                name: g,
                                version: E
                            },
                            localState: this.localState,
                            assumeImmutableResults: h,
                            onBroadcast: function() {
                                t.devToolsHookCb && t.devToolsHookCb({
                                    action: {},
                                    state: {
                                        queries: t.queryManager.queryStore.getStore(),
                                        mutations: t.queryManager.mutationStore.getStore()
                                    },
                                    dataWithOptimisticResults: t.cache.extract(!0)
                                });
                            }
                        });
                    }
                    return e.prototype.stop = function() {
                        this.queryManager.stop();
                    }, e.prototype.watchQuery = function(e) {
                        return this.defaultOptions.watchQuery && (e = (0, i.pi)((0, i.pi)({}, this.defaultOptions.watchQuery), e)), !this.disableNetworkFetches || "network-only" !== e.fetchPolicy && "cache-and-network" !== e.fetchPolicy || (e = (0, i.pi)((0, i.pi)({}, e), {
                            fetchPolicy: "cache-first"
                        })), this.queryManager.watchQuery(e);
                    }, e.prototype.query = function(e) {
                        return this.defaultOptions.query && (e = (0, i.pi)((0, i.pi)({}, this.defaultOptions.query), e)), (0, l.kG)("cache-and-network" !== e.fetchPolicy, 5), this.disableNetworkFetches && "network-only" === e.fetchPolicy && (e = (0, i.pi)((0, i.pi)({}, e), {
                            fetchPolicy: "cache-first"
                        })), this.queryManager.query(e);
                    }, e.prototype.mutate = function(e) {
                        return this.defaultOptions.mutate && (e = (0, i.pi)((0, i.pi)({}, this.defaultOptions.mutate), e)), this.queryManager.mutate(e);
                    }, e.prototype.subscribe = function(e) {
                        return this.queryManager.startGraphQLSubscription(e);
                    }, e.prototype.readQuery = function(e, t) {
                        return void 0 === t && (t = !1), this.cache.readQuery(e, t);
                    }, e.prototype.readFragment = function(e, t) {
                        return void 0 === t && (t = !1), this.cache.readFragment(e, t);
                    }, e.prototype.writeQuery = function(e) {
                        var t = this.cache.writeQuery(e);
                        return this.queryManager.broadcastQueries(), t;
                    }, e.prototype.writeFragment = function(e) {
                        var t = this.cache.writeFragment(e);
                        return this.queryManager.broadcastQueries(), t;
                    }, e.prototype.writeData = function(e) {
                        var t = this.cache.writeData(e);
                        return this.queryManager.broadcastQueries(), t;
                    }, e.prototype.__actionHookForDevTools = function(e) {
                        this.devToolsHookCb = e;
                    }, e.prototype.__requestRaw = function(e) {
                        return (0, u.ht)(this.link, e);
                    }, e.prototype.initQueryManager = function() {
                        return this.queryManager;
                    }, e.prototype.resetStore = function() {
                        var e = this;
                        return Promise.resolve().then(function() {
                            return e.queryManager.clearStore();
                        }).then(function() {
                            return Promise.all(e.resetStoreCallbacks.map(function(e) {
                                return e();
                            }));
                        }).then(function() {
                            return e.reFetchObservableQueries();
                        });
                    }, e.prototype.clearStore = function() {
                        var e = this;
                        return Promise.resolve().then(function() {
                            return e.queryManager.clearStore();
                        }).then(function() {
                            return Promise.all(e.clearStoreCallbacks.map(function(e) {
                                return e();
                            }));
                        });
                    }, e.prototype.onResetStore = function(e) {
                        var t = this;
                        return this.resetStoreCallbacks.push(e), function() {
                            t.resetStoreCallbacks = t.resetStoreCallbacks.filter(function(t) {
                                return t !== e;
                            });
                        };
                    }, e.prototype.onClearStore = function(e) {
                        var t = this;
                        return this.clearStoreCallbacks.push(e), function() {
                            t.clearStoreCallbacks = t.clearStoreCallbacks.filter(function(t) {
                                return t !== e;
                            });
                        };
                    }, e.prototype.reFetchObservableQueries = function(e) {
                        return this.queryManager.reFetchObservableQueries(e);
                    }, e.prototype.extract = function(e) {
                        return this.cache.extract(e);
                    }, e.prototype.restore = function(e) {
                        return this.cache.restore(e);
                    }, e.prototype.addResolvers = function(e) {
                        this.localState.addResolvers(e);
                    }, e.prototype.setResolvers = function(e) {
                        this.localState.setResolvers(e);
                    }, e.prototype.getResolvers = function() {
                        return this.localState.getResolvers();
                    }, e.prototype.setLocalStateFragmentMatcher = function(e) {
                        this.localState.setFragmentMatcher(e);
                    }, e;
                }();
                const N = A;
                function C(e) {
                    return {
                        kind: "Document",
                        definitions: [
                            {
                                kind: "OperationDefinition",
                                operation: "query",
                                name: {
                                    kind: "Name",
                                    value: "GeneratedClientQuery"
                                },
                                selectionSet: k(e)
                            }
                        ]
                    };
                }
                function k(e) {
                    if ("number" == typeof e || "boolean" == typeof e || "string" == typeof e || null == e) return null;
                    if (Array.isArray(e)) return k(e[0]);
                    var t = [];
                    return Object.keys(e).forEach(function(r) {
                        var n = k(e[r]);
                        t.push({
                            kind: "Field",
                            name: {
                                kind: "Name",
                                value: r
                            },
                            selectionSet: n || void 0
                        });
                    }), {
                        kind: "SelectionSet",
                        selections: t
                    };
                }
                var M, P = {
                    kind: "Document",
                    definitions: [
                        {
                            kind: "OperationDefinition",
                            operation: "query",
                            name: null,
                            variableDefinitions: null,
                            directives: [],
                            selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                    {
                                        kind: "Field",
                                        alias: null,
                                        name: {
                                            kind: "Name",
                                            value: "__typename"
                                        },
                                        arguments: [],
                                        directives: [],
                                        selectionSet: null
                                    }
                                ]
                            }
                        }
                    ]
                }, D = function() {
                    function e() {}
                    return e.prototype.transformDocument = function(e) {
                        return e;
                    }, e.prototype.transformForLink = function(e) {
                        return e;
                    }, e.prototype.readQuery = function(e, t) {
                        return void 0 === t && (t = !1), this.read({
                            query: e.query,
                            variables: e.variables,
                            optimistic: t
                        });
                    }, e.prototype.readFragment = function(e, t) {
                        return void 0 === t && (t = !1), this.read({
                            query: (0, o.Yk)(e.fragment, e.fragmentName),
                            variables: e.variables,
                            rootId: e.id,
                            optimistic: t
                        });
                    }, e.prototype.writeQuery = function(e) {
                        this.write({
                            dataId: "ROOT_QUERY",
                            result: e.data,
                            query: e.query,
                            variables: e.variables
                        });
                    }, e.prototype.writeFragment = function(e) {
                        this.write({
                            dataId: e.id,
                            result: e.data,
                            variables: e.variables,
                            query: (0, o.Yk)(e.fragment, e.fragmentName)
                        });
                    }, e.prototype.writeData = function(e) {
                        var t, r, n = e.id, i = e.data;
                        if (void 0 !== n) {
                            var o = null;
                            try {
                                o = this.read({
                                    rootId: n,
                                    optimistic: !1,
                                    query: P
                                });
                            } catch (e) {}
                            var a = o && o.__typename || "__ClientData", s = Object.assign({
                                __typename: a
                            }, i);
                            this.writeFragment({
                                id: n,
                                fragment: (t = s, r = a, {
                                    kind: "Document",
                                    definitions: [
                                        {
                                            kind: "FragmentDefinition",
                                            typeCondition: {
                                                kind: "NamedType",
                                                name: {
                                                    kind: "Name",
                                                    value: r || "__FakeType"
                                                }
                                            },
                                            name: {
                                                kind: "Name",
                                                value: "GeneratedClientQuery"
                                            },
                                            selectionSet: k(t)
                                        }
                                    ]
                                }),
                                data: s
                            });
                        } else this.writeQuery({
                            query: C(i),
                            data: i
                        });
                    }, e;
                }();
                M || (M = {});
                var F = null, L = {}, j = 1, U = "@wry/context:Slot", B = Array, Q = B[U] || function() {
                    var e = function() {
                        function e() {
                            this.id = [
                                "slot",
                                j++,
                                Date.now(),
                                Math.random().toString(36).slice(2)
                            ].join(":");
                        }
                        return e.prototype.hasValue = function() {
                            for(var e = F; e; e = e.parent)if (this.id in e.slots) {
                                var t = e.slots[this.id];
                                if (t === L) break;
                                return e !== F && (F.slots[this.id] = t), !0;
                            }
                            return F && (F.slots[this.id] = L), !1;
                        }, e.prototype.getValue = function() {
                            if (this.hasValue()) return F.slots[this.id];
                        }, e.prototype.withValue = function(e, t, r, n) {
                            var i, o = ((i = {
                                __proto__: null
                            })[this.id] = e, i), a = F;
                            F = {
                                parent: a,
                                slots: o
                            };
                            try {
                                return t.apply(n, r);
                            } finally{
                                F = a;
                            }
                        }, e.bind = function(e) {
                            var t = F;
                            return function() {
                                var r = F;
                                try {
                                    return F = t, e.apply(this, arguments);
                                } finally{
                                    F = r;
                                }
                            };
                        }, e.noContext = function(e, t, r) {
                            if (!F) return e.apply(r, t);
                            var n = F;
                            try {
                                return F = null, e.apply(r, t);
                            } finally{
                                F = n;
                            }
                        }, e;
                    }();
                    try {
                        Object.defineProperty(B, U, {
                            value: B[U] = e,
                            enumerable: !1,
                            writable: !1,
                            configurable: !1
                        });
                    } finally{
                        return e;
                    }
                }();
                function V() {}
                var q = function() {
                    function e(e, t) {
                        void 0 === e && (e = 1 / 0), void 0 === t && (t = V), this.max = e, this.dispose = t, this.map = new Map, this.newest = null, this.oldest = null;
                    }
                    return e.prototype.has = function(e) {
                        return this.map.has(e);
                    }, e.prototype.get = function(e) {
                        var t = this.getEntry(e);
                        return t && t.value;
                    }, e.prototype.getEntry = function(e) {
                        var t = this.map.get(e);
                        if (t && t !== this.newest) {
                            var r = t.older, n = t.newer;
                            n && (n.older = r), r && (r.newer = n), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = n);
                        }
                        return t;
                    }, e.prototype.set = function(e, t) {
                        var r = this.getEntry(e);
                        return r ? r.value = t : (r = {
                            key: e,
                            value: t,
                            newer: null,
                            older: this.newest
                        }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(e, r), r.value);
                    }, e.prototype.clean = function() {
                        for(; this.oldest && this.map.size > this.max;)this.delete(this.oldest.key);
                    }, e.prototype.delete = function(e) {
                        var t = this.map.get(e);
                        return !!t && (t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.map.delete(e), this.dispose(t.value, e), !0);
                    }, e;
                }(), G = new Q, z = [], W = [], $ = 100;
                function H(e, t) {
                    if (!e) throw new Error(t || "assertion failure");
                }
                function K(e) {
                    switch(e.length){
                        case 0:
                            throw new Error("unknown value");
                        case 1:
                            return e[0];
                        case 2:
                            throw e[1];
                    }
                }
                var Y = function() {
                    function e(t, r) {
                        this.fn = t, this.args = r, this.parents = new Set, this.childValues = new Map, this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], ++e.count;
                    }
                    return e.prototype.recompute = function() {
                        if (H(!this.recomputing, "already recomputing"), function(e) {
                            var t = G.getValue();
                            if (t) return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), J(e) ? te(t, e) : re(t, e), t;
                        }(this) || !ie(this)) return J(this) ? function(e) {
                            var t = oe(e);
                            G.withValue(e, X, [
                                e
                            ]), function(e) {
                                if ("function" == typeof e.subscribe) try {
                                    se(e), e.unsubscribe = e.subscribe.apply(null, e.args);
                                } catch (t) {
                                    return e.setDirty(), !1;
                                }
                                return !0;
                            }(e) && function(e) {
                                if (e.dirty = !1, J(e)) return;
                                ee(e);
                            }(e);
                            return t.forEach(ie), K(e.value);
                        }(this) : K(this.value);
                    }, e.prototype.setDirty = function() {
                        this.dirty || (this.dirty = !0, this.value.length = 0, Z(this), se(this));
                    }, e.prototype.dispose = function() {
                        var e = this;
                        oe(this).forEach(ie), se(this), this.parents.forEach(function(t) {
                            t.setDirty(), ae(t, e);
                        });
                    }, e.count = 0, e;
                }();
                function X(e) {
                    e.recomputing = !0, e.value.length = 0;
                    try {
                        e.value[0] = e.fn.apply(null, e.args);
                    } catch (t) {
                        e.value[1] = t;
                    }
                    e.recomputing = !1;
                }
                function J(e) {
                    return e.dirty || !(!e.dirtyChildren || !e.dirtyChildren.size);
                }
                function Z(e) {
                    e.parents.forEach(function(t) {
                        return te(t, e);
                    });
                }
                function ee(e) {
                    e.parents.forEach(function(t) {
                        return re(t, e);
                    });
                }
                function te(e, t) {
                    if (H(e.childValues.has(t)), H(J(t)), e.dirtyChildren) {
                        if (e.dirtyChildren.has(t)) return;
                    } else e.dirtyChildren = W.pop() || new Set;
                    e.dirtyChildren.add(t), Z(e);
                }
                function re(e, t) {
                    H(e.childValues.has(t)), H(!J(t));
                    var r, n, i, o = e.childValues.get(t);
                    0 === o.length ? e.childValues.set(t, t.value.slice(0)) : (n = t.value, (i = (r = o).length) > 0 && i === n.length && r[i - 1] === n[i - 1] || e.setDirty()), ne(e, t), J(e) || ee(e);
                }
                function ne(e, t) {
                    var r = e.dirtyChildren;
                    r && (r.delete(t), 0 === r.size && (W.length < $ && W.push(r), e.dirtyChildren = null));
                }
                function ie(e) {
                    return 0 === e.parents.size && "function" == typeof e.reportOrphan && !0 === e.reportOrphan();
                }
                function oe(e) {
                    var t = z;
                    return e.childValues.size > 0 && (t = [], e.childValues.forEach(function(r, n) {
                        ae(e, n), t.push(n);
                    })), H(null === e.dirtyChildren), t;
                }
                function ae(e, t) {
                    t.parents.delete(e), e.childValues.delete(t), ne(e, t);
                }
                function se(e) {
                    var t = e.unsubscribe;
                    "function" == typeof t && (e.unsubscribe = void 0, t());
                }
                var ue = function() {
                    function e(e) {
                        this.weakness = e;
                    }
                    return e.prototype.lookup = function() {
                        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                        return this.lookupArray(e);
                    }, e.prototype.lookupArray = function(e) {
                        var t = this;
                        return e.forEach(function(e) {
                            return t = t.getChildTrie(e);
                        }), t.data || (t.data = Object.create(null));
                    }, e.prototype.getChildTrie = function(t) {
                        var r = this.weakness && function(e) {
                            switch(typeof e){
                                case "object":
                                    if (null === e) break;
                                case "function":
                                    return !0;
                            }
                            return !1;
                        }(t) ? this.weak || (this.weak = new WeakMap) : this.strong || (this.strong = new Map), n = r.get(t);
                        return n || r.set(t, n = new e(this.weakness)), n;
                    }, e;
                }();
                var ce = new ue("function" == typeof WeakMap);
                function le() {
                    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                    return ce.lookupArray(e);
                }
                var fe = new Set;
                function pe(e, t) {
                    void 0 === t && (t = Object.create(null));
                    var r = new q(t.max || Math.pow(2, 16), function(e) {
                        return e.dispose();
                    }), n = !!t.disposable, i = t.makeCacheKey || le;
                    function o() {
                        if (!n || G.hasValue()) {
                            var o = i.apply(null, arguments);
                            if (void 0 === o) return e.apply(null, arguments);
                            var a = Array.prototype.slice.call(arguments), s = r.get(o);
                            s ? s.args = a : (s = new Y(e, a), r.set(o, s), s.subscribe = t.subscribe, n && (s.reportOrphan = function() {
                                return r.delete(o);
                            }));
                            var u = s.recompute();
                            return r.set(o, s), fe.add(r), G.hasValue() || (fe.forEach(function(e) {
                                return e.clean();
                            }), fe.clear()), n ? void 0 : u;
                        }
                    }
                    return o.dirty = function() {
                        var e = i.apply(null, arguments), t = void 0 !== e && r.get(e);
                        t && t.setDirty();
                    }, o;
                }
                var de = !1;
                function he() {
                    var e = !de;
                    return (0, o.Y8)() || (de = !0), e;
                }
                var ve = function() {
                    function e() {}
                    return e.prototype.ensureReady = function() {
                        return Promise.resolve();
                    }, e.prototype.canBypassInit = function() {
                        return !0;
                    }, e.prototype.match = function(e, t, r) {
                        var n = r.store.get(e.id), i = "ROOT_QUERY" === e.id;
                        if (!n) return i;
                        var o = n.__typename, a = void 0 === o ? i && "Query" : o;
                        return a && a === t || (he(), "heuristic");
                    }, e;
                }(), me = function() {
                    function e(e) {
                        e && e.introspectionQueryResultData ? (this.possibleTypesMap = this.parseIntrospectionResult(e.introspectionQueryResultData), this.isReady = !0) : this.isReady = !1, this.match = this.match.bind(this);
                    }
                    return e.prototype.match = function(e, t, r) {
                        (0, l.kG)(this.isReady, 1);
                        var n = r.store.get(e.id), i = "ROOT_QUERY" === e.id;
                        if (!n) return i;
                        var o = n.__typename, a = void 0 === o ? i && "Query" : o;
                        if ((0, l.kG)(a, 2), a === t) return !0;
                        var s = this.possibleTypesMap[t];
                        return !!(a && s && s.indexOf(a) > -1);
                    }, e.prototype.parseIntrospectionResult = function(e) {
                        var t = {};
                        return e.__schema.types.forEach(function(e) {
                            "UNION" !== e.kind && "INTERFACE" !== e.kind || (t[e.name] = e.possibleTypes.map(function(e) {
                                return e.name;
                            }));
                        }), t;
                    }, e;
                }(), ye = Object.prototype.hasOwnProperty, ge = function() {
                    function e(e) {
                        var t = this;
                        void 0 === e && (e = Object.create(null)), this.data = e, this.depend = pe(function(e) {
                            return t.data[e];
                        }, {
                            disposable: !0,
                            makeCacheKey: function(e) {
                                return e;
                            }
                        });
                    }
                    return e.prototype.toObject = function() {
                        return this.data;
                    }, e.prototype.get = function(e) {
                        return this.depend(e), this.data[e];
                    }, e.prototype.set = function(e, t) {
                        t !== this.data[e] && (this.data[e] = t, this.depend.dirty(e));
                    }, e.prototype.delete = function(e) {
                        ye.call(this.data, e) && (delete this.data[e], this.depend.dirty(e));
                    }, e.prototype.clear = function() {
                        this.replace(null);
                    }, e.prototype.replace = function(e) {
                        var t = this;
                        e ? (Object.keys(e).forEach(function(r) {
                            t.set(r, e[r]);
                        }), Object.keys(this.data).forEach(function(r) {
                            ye.call(e, r) || t.delete(r);
                        })) : Object.keys(this.data).forEach(function(e) {
                            t.delete(e);
                        });
                    }, e;
                }();
                function Ee(e) {
                    return new ge(e);
                }
                var be = function() {
                    function e(e) {
                        var t = this, r = void 0 === e ? {} : e, n = r.cacheKeyRoot, i = void 0 === n ? new ue(o.mr) : n, a = r.freezeResults, s = this, u = s.executeStoreQuery, c = s.executeSelectionSet, l = s.executeSubSelectedArray;
                        this.freezeResults = void 0 !== a && a, this.executeStoreQuery = pe(function(e) {
                            return u.call(t, e);
                        }, {
                            makeCacheKey: function(e) {
                                var t = e.rootValue, r = e.contextValue;
                                if (r.store instanceof ge) return i.lookup(r.store, e.query, e.fragmentMatcher, JSON.stringify(e.variableValues), t.id);
                            }
                        }), this.executeSelectionSet = pe(function(e) {
                            return c.call(t, e);
                        }, {
                            makeCacheKey: function(e) {
                                var t = e.rootValue, r = e.execContext;
                                if (r.contextValue.store instanceof ge) return i.lookup(r.contextValue.store, e.selectionSet, r.fragmentMatcher, JSON.stringify(r.variableValues), t.id);
                            }
                        }), this.executeSubSelectedArray = pe(function(e) {
                            return l.call(t, e);
                        }, {
                            makeCacheKey: function(e) {
                                var t = e.execContext;
                                if (t.contextValue.store instanceof ge) return i.lookup(t.contextValue.store, e.field, e.array, JSON.stringify(t.variableValues));
                            }
                        });
                    }
                    return e.prototype.readQueryFromStore = function(e) {
                        return this.diffQueryAgainstStore((0, i.pi)((0, i.pi)({}, e), {
                            returnPartialData: !1
                        })).result;
                    }, e.prototype.diffQueryAgainstStore = function(e) {
                        var t = e.store, r = e.query, n = e.variables, i = e.previousResult, s = e.returnPartialData, u = void 0 === s || s, c = e.rootId, f = void 0 === c ? "ROOT_QUERY" : c, p = e.fragmentMatcherFunction, d = e.config, h = (0, o.iW)(r);
                        n = (0, o.f0)({}, (0, o.O4)(h), n);
                        var v = this.executeStoreQuery({
                            query: r,
                            rootValue: {
                                type: "id",
                                id: f,
                                generated: !0,
                                typename: "Query"
                            },
                            contextValue: {
                                store: t,
                                dataIdFromObject: d && d.dataIdFromObject,
                                cacheRedirects: d && d.cacheRedirects || {}
                            },
                            variableValues: n,
                            fragmentMatcher: p
                        }), m = v.missing && v.missing.length > 0;
                        return m && !u && v.missing.forEach(function(e) {
                            if (!e.tolerable) throw new l.ej(8);
                        }), i && (0, a.D)(i, v.result) && (v.result = i), {
                            result: v.result,
                            complete: !m
                        };
                    }, e.prototype.executeStoreQuery = function(e) {
                        var t = e.query, r = e.rootValue, n = e.contextValue, i = e.variableValues, a = e.fragmentMatcher, s = void 0 === a ? _e : a, u = (0, o.p$)(t), c = (0, o.kU)(t), l = (0, o.F)(c);
                        return this.executeSelectionSet({
                            selectionSet: u.selectionSet,
                            rootValue: r,
                            execContext: {
                                query: t,
                                fragmentMap: l,
                                contextValue: n,
                                variableValues: i,
                                fragmentMatcher: s
                            }
                        });
                    }, e.prototype.executeSelectionSet = function(e) {
                        var t = this, r = e.selectionSet, n = e.rootValue, a = e.execContext, s = a.fragmentMap, u = a.contextValue, c = a.variableValues, f = {
                            result: null
                        }, p = [], d = u.store.get(n.id), h = d && d.__typename || "ROOT_QUERY" === n.id && "Query" || void 0;
                        function v(e) {
                            var t;
                            return e.missing && (f.missing = f.missing || [], (t = f.missing).push.apply(t, e.missing)), e.result;
                        }
                        return r.selections.forEach(function(e) {
                            var r;
                            if ((0, o.LZ)(e, c)) {
                                if ((0, o.My)(e)) {
                                    var f = v(t.executeField(d, h, e, a));
                                    void 0 !== f && p.push(((r = {})[(0, o.u2)(e)] = f, r));
                                } else {
                                    var m = void 0;
                                    if ((0, o.Ao)(e)) m = e;
                                    else if (!(m = s[e.name.value])) throw new l.ej(9);
                                    var y = m.typeCondition && m.typeCondition.name.value, g = !y || a.fragmentMatcher(n, y, u);
                                    if (g) {
                                        var E = t.executeSelectionSet({
                                            selectionSet: m.selectionSet,
                                            rootValue: n,
                                            execContext: a
                                        });
                                        "heuristic" === g && E.missing && (E = (0, i.pi)((0, i.pi)({}, E), {
                                            missing: E.missing.map(function(e) {
                                                return (0, i.pi)((0, i.pi)({}, e), {
                                                    tolerable: !0
                                                });
                                            })
                                        })), p.push(v(E));
                                    }
                                }
                            }
                        }), f.result = (0, o.bw)(p), f;
                    }, e.prototype.executeField = function(e, t, r, n) {
                        var i = n.variableValues, a = n.contextValue, s = function(e, t, r, n, i, a) {
                            var s = a.directives, u = r;
                            (n || s) && (u = (0, o.PT)(u, n, s));
                            var c = void 0;
                            if (e && void 0 === (c = e[u]) && i.cacheRedirects && "string" == typeof t) {
                                var l = i.cacheRedirects[t];
                                if (l) {
                                    var f = l[r];
                                    f && (c = f(e, n, {
                                        getCacheKey: function(e) {
                                            var t = i.dataIdFromObject(e);
                                            return t && (0, o.aX)({
                                                id: t,
                                                typename: e.__typename
                                            });
                                        }
                                    }));
                                }
                            }
                            if (void 0 === c) return {
                                result: c,
                                missing: [
                                    {
                                        object: e,
                                        fieldName: u,
                                        tolerable: !1
                                    }
                                ]
                            };
                            (0, o.v4)(c) && (c = c.json);
                            return {
                                result: c
                            };
                        }(e, t, r.name.value, (0, o.NC)(r, i), a, {
                            resultKey: (0, o.u2)(r),
                            directives: (0, o.Qy)(r, i)
                        });
                        return Array.isArray(s.result) ? this.combineExecResults(s, this.executeSubSelectedArray({
                            field: r,
                            array: s.result,
                            execContext: n
                        })) : r.selectionSet ? null == s.result ? s : this.combineExecResults(s, this.executeSelectionSet({
                            selectionSet: r.selectionSet,
                            rootValue: s.result,
                            execContext: n
                        })) : (Se(r, s.result), s);
                    }, e.prototype.combineExecResults = function() {
                        for(var e, t = [], r = 0; r < arguments.length; r++)t[r] = arguments[r];
                        return t.forEach(function(t) {
                            t.missing && (e = e || []).push.apply(e, t.missing);
                        }), {
                            result: t.pop().result,
                            missing: e
                        };
                    }, e.prototype.executeSubSelectedArray = function(e) {
                        var t, r = this, n = e.field, i = e.array, o = e.execContext;
                        function a(e) {
                            return e.missing && (t = t || []).push.apply(t, e.missing), e.result;
                        }
                        return {
                            result: i = i.map(function(e) {
                                return null === e ? null : Array.isArray(e) ? a(r.executeSubSelectedArray({
                                    field: n,
                                    array: e,
                                    execContext: o
                                })) : n.selectionSet ? a(r.executeSelectionSet({
                                    selectionSet: n.selectionSet,
                                    rootValue: e,
                                    execContext: o
                                })) : (Se(n, e), e);
                            }),
                            missing: t
                        };
                    }, e;
                }();
                function Se(e, t) {
                    if (!e.selectionSet && (0, o.cQ)(t)) throw new l.ej(10);
                }
                function _e() {
                    return !0;
                }
                function Oe(e) {
                    (0, l.kG)((0, o.cQ)(e), 11);
                }
                var we = function() {
                    function e(e) {
                        void 0 === e && (e = Object.create(null)), this.data = e;
                    }
                    return e.prototype.toObject = function() {
                        return this.data;
                    }, e.prototype.get = function(e) {
                        return this.data[e];
                    }, e.prototype.set = function(e, t) {
                        this.data[e] = t;
                    }, e.prototype.delete = function(e) {
                        this.data[e] = void 0;
                    }, e.prototype.clear = function() {
                        this.data = Object.create(null);
                    }, e.prototype.replace = function(e) {
                        this.data = e || Object.create(null);
                    }, e;
                }();
                function Te(e) {
                    return new we(e);
                }
                var Ie = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.type = "WriteError", t;
                    }
                    return (0, i.ZT)(t, e), t;
                }(Error);
                function Re(e, t) {
                    var r = new Ie("Error writing result to store for query:\n " + JSON.stringify(t));
                    return r.message += "\n" + e.message, r.stack = e.stack, r;
                }
                var xe = function() {
                    function e() {}
                    return e.prototype.writeQueryToStore = function(e) {
                        var t = e.query, r = e.result, n = e.store, i = void 0 === n ? Ee() : n;
                        return this.writeResultToStore({
                            dataId: "ROOT_QUERY",
                            result: r,
                            document: t,
                            store: i,
                            variables: e.variables,
                            dataIdFromObject: e.dataIdFromObject,
                            fragmentMatcherFunction: e.fragmentMatcherFunction
                        });
                    }, e.prototype.writeResultToStore = function(e) {
                        var t = e.dataId, r = e.result, n = e.document, i = e.store, a = void 0 === i ? Ee() : i, s = e.variables, u = e.dataIdFromObject, c = e.fragmentMatcherFunction, l = (0, o.$H)(n);
                        try {
                            return this.writeSelectionSetToStore({
                                result: r,
                                dataId: t,
                                selectionSet: l.selectionSet,
                                context: {
                                    store: a,
                                    processedData: {},
                                    variables: (0, o.f0)({}, (0, o.O4)(l), s),
                                    dataIdFromObject: u,
                                    fragmentMap: (0, o.F)((0, o.kU)(n)),
                                    fragmentMatcherFunction: c
                                }
                            });
                        } catch (e) {
                            throw Re(e, n);
                        }
                    }, e.prototype.writeSelectionSetToStore = function(e) {
                        var t = this, r = e.result, n = e.dataId, i = e.context, a = i.variables, s = i.store, u = i.fragmentMap;
                        return e.selectionSet.selections.forEach(function(e) {
                            var s;
                            if ((0, o.LZ)(e, a)) {
                                if ((0, o.My)(e)) {
                                    var c = (0, o.u2)(e), f = r[c];
                                    if (void 0 !== f) t.writeFieldToStore({
                                        dataId: n,
                                        value: f,
                                        field: e,
                                        context: i
                                    });
                                    else e.directives && e.directives.length && (e.directives.some(function(e) {
                                        return e.name && "defer" === e.name.value;
                                    }), e.directives.some(function(e) {
                                        return e.name && "client" === e.name.value;
                                    }));
                                } else {
                                    var p = void 0;
                                    (0, o.Ao)(e) ? p = e : (0, l.kG)(p = (u || {})[e.name.value], 3);
                                    var d = !0;
                                    if (i.fragmentMatcherFunction && p.typeCondition) {
                                        var h = n || "self", v = (0, o.aX)({
                                            id: h,
                                            typename: void 0
                                        }), m = {
                                            store: new we((s = {}, s[h] = r, s)),
                                            cacheRedirects: {}
                                        }, y = i.fragmentMatcherFunction(v, p.typeCondition.name.value, m);
                                        (0, o.yv)(), d = !!y;
                                    }
                                    d && t.writeSelectionSetToStore({
                                        result: r,
                                        selectionSet: p.selectionSet,
                                        dataId: n,
                                        context: i
                                    });
                                }
                            }
                        }), s;
                    }, e.prototype.writeFieldToStore = function(e) {
                        var t, r, n, s = e.field, u = e.value, c = e.dataId, f = e.context, p = f.dataIdFromObject, d = f.store, h = (0, o.vf)(s, f.variables);
                        if (s.selectionSet && null !== u) {
                            if (Array.isArray(u)) r = this.processArrayValue(u, c + "." + h, s.selectionSet, f);
                            else {
                                var v = c + "." + h, m = !0;
                                if (Ae(v) || (v = "$" + v), p) {
                                    var y = p(u);
                                    (0, l.kG)(!y || !Ae(y), 4), (y || "number" == typeof y && 0 === y) && (v = y, m = !1);
                                }
                                Ce(v, s, f.processedData) || this.writeSelectionSetToStore({
                                    dataId: v,
                                    result: u,
                                    selectionSet: s.selectionSet,
                                    context: f
                                });
                                var g = u.__typename;
                                r = (0, o.aX)({
                                    id: v,
                                    typename: g
                                }, m);
                                var E = (n = d.get(c)) && n[h];
                                if (E !== r && (0, o.cQ)(E)) {
                                    var b = void 0 !== E.typename, S = void 0 !== g, _ = b && S && E.typename !== g;
                                    (0, l.kG)(!m || E.generated || _, 5), (0, l.kG)(!b || S, 6), E.generated && (_ ? m || d.delete(E.id) : Ne(E.id, r.id, d));
                                }
                            }
                        } else r = null != u && "object" == typeof u ? {
                            type: "json",
                            json: u
                        } : u;
                        (n = d.get(c)) && (0, a.D)(r, n[h]) || d.set(c, (0, i.pi)((0, i.pi)({}, n), ((t = {})[h] = r, t)));
                    }, e.prototype.processArrayValue = function(e, t, r, n) {
                        var i = this;
                        return e.map(function(e, a) {
                            if (null === e) return null;
                            var s = t + "." + a;
                            if (Array.isArray(e)) return i.processArrayValue(e, s, r, n);
                            var u = !0;
                            if (n.dataIdFromObject) {
                                var c = n.dataIdFromObject(e);
                                c && (s = c, u = !1);
                            }
                            return Ce(s, r, n.processedData) || i.writeSelectionSetToStore({
                                dataId: s,
                                result: e,
                                selectionSet: r,
                                context: n
                            }), (0, o.aX)({
                                id: s,
                                typename: e.__typename
                            }, u);
                        });
                    }, e;
                }();
                function Ae(e) {
                    return "$" === e[0];
                }
                function Ne(e, t, r) {
                    if (e === t) return !1;
                    var n = r.get(e), s = r.get(t), u = !1;
                    Object.keys(n).forEach(function(e) {
                        var t = n[e], i = s[e];
                        (0, o.cQ)(t) && Ae(t.id) && (0, o.cQ)(i) && !(0, a.D)(t, i) && Ne(t.id, i.id, r) && (u = !0);
                    }), r.delete(e);
                    var c = (0, i.pi)((0, i.pi)({}, n), s);
                    return (0, a.D)(c, s) ? u : (r.set(t, c), !0);
                }
                function Ce(e, t, r) {
                    if (!r) return !1;
                    if (r[e]) {
                        if (r[e].indexOf(t) >= 0) return !0;
                        r[e].push(t);
                    } else r[e] = [
                        t
                    ];
                    return !1;
                }
                var ke = {
                    fragmentMatcher: new ve,
                    dataIdFromObject: Me,
                    addTypename: !0,
                    resultCaching: !0,
                    freezeResults: !1
                };
                function Me(e) {
                    if (e.__typename) {
                        if (void 0 !== e.id) return e.__typename + ":" + e.id;
                        if (void 0 !== e._id) return e.__typename + ":" + e._id;
                    }
                    return null;
                }
                var Pe = Object.prototype.hasOwnProperty, De = function(e) {
                    function t(t, r, n) {
                        var i = e.call(this, Object.create(null)) || this;
                        return i.optimisticId = t, i.parent = r, i.transaction = n, i;
                    }
                    return (0, i.ZT)(t, e), t.prototype.toObject = function() {
                        return (0, i.pi)((0, i.pi)({}, this.parent.toObject()), this.data);
                    }, t.prototype.get = function(e) {
                        return Pe.call(this.data, e) ? this.data[e] : this.parent.get(e);
                    }, t;
                }(we), Fe = function(e) {
                    function t(t) {
                        void 0 === t && (t = {});
                        var r = e.call(this) || this;
                        r.watches = new Set, r.typenameDocumentCache = new Map, r.cacheKeyRoot = new ue(o.mr), r.silenceBroadcast = !1, r.config = (0, i.pi)((0, i.pi)({}, ke), t), r.config.customResolvers && (r.config.cacheRedirects = r.config.customResolvers), r.config.cacheResolvers && (r.config.cacheRedirects = r.config.cacheResolvers), r.addTypename = !!r.config.addTypename, r.data = r.config.resultCaching ? new ge : new we, r.optimisticData = r.data, r.storeWriter = new xe, r.storeReader = new be({
                            cacheKeyRoot: r.cacheKeyRoot,
                            freezeResults: t.freezeResults
                        });
                        var n = r, a = n.maybeBroadcastWatch;
                        return r.maybeBroadcastWatch = pe(function(e) {
                            return a.call(r, e);
                        }, {
                            makeCacheKey: function(e) {
                                if (!e.optimistic && !e.previousResult) return n.data instanceof ge ? n.cacheKeyRoot.lookup(e.query, JSON.stringify(e.variables)) : void 0;
                            }
                        }), r;
                    }
                    return (0, i.ZT)(t, e), t.prototype.restore = function(e) {
                        return e && this.data.replace(e), this;
                    }, t.prototype.extract = function(e) {
                        return void 0 === e && (e = !1), (e ? this.optimisticData : this.data).toObject();
                    }, t.prototype.read = function(e) {
                        if ("string" == typeof e.rootId && void 0 === this.data.get(e.rootId)) return null;
                        var t = this.config.fragmentMatcher, r = t && t.match;
                        return this.storeReader.readQueryFromStore({
                            store: e.optimistic ? this.optimisticData : this.data,
                            query: this.transformDocument(e.query),
                            variables: e.variables,
                            rootId: e.rootId,
                            fragmentMatcherFunction: r,
                            previousResult: e.previousResult,
                            config: this.config
                        }) || null;
                    }, t.prototype.write = function(e) {
                        var t = this.config.fragmentMatcher, r = t && t.match;
                        this.storeWriter.writeResultToStore({
                            dataId: e.dataId,
                            result: e.result,
                            variables: e.variables,
                            document: this.transformDocument(e.query),
                            store: this.data,
                            dataIdFromObject: this.config.dataIdFromObject,
                            fragmentMatcherFunction: r
                        }), this.broadcastWatches();
                    }, t.prototype.diff = function(e) {
                        var t = this.config.fragmentMatcher, r = t && t.match;
                        return this.storeReader.diffQueryAgainstStore({
                            store: e.optimistic ? this.optimisticData : this.data,
                            query: this.transformDocument(e.query),
                            variables: e.variables,
                            returnPartialData: e.returnPartialData,
                            previousResult: e.previousResult,
                            fragmentMatcherFunction: r,
                            config: this.config
                        });
                    }, t.prototype.watch = function(e) {
                        var t = this;
                        return this.watches.add(e), function() {
                            t.watches.delete(e);
                        };
                    }, t.prototype.evict = function(e) {
                        throw new l.ej(7);
                    }, t.prototype.reset = function() {
                        return this.data.clear(), this.broadcastWatches(), Promise.resolve();
                    }, t.prototype.removeOptimistic = function(e) {
                        for(var t = [], r = 0, n = this.optimisticData; n instanceof De;)n.optimisticId === e ? ++r : t.push(n), n = n.parent;
                        if (r > 0) {
                            for(this.optimisticData = n; t.length > 0;){
                                var i = t.pop();
                                this.performTransaction(i.transaction, i.optimisticId);
                            }
                            this.broadcastWatches();
                        }
                    }, t.prototype.performTransaction = function(e, t) {
                        var r = this.data, n = this.silenceBroadcast;
                        this.silenceBroadcast = !0, "string" == typeof t && (this.data = this.optimisticData = new De(t, this.optimisticData, e));
                        try {
                            e(this);
                        } finally{
                            this.silenceBroadcast = n, this.data = r;
                        }
                        this.broadcastWatches();
                    }, t.prototype.recordOptimisticTransaction = function(e, t) {
                        return this.performTransaction(e, t);
                    }, t.prototype.transformDocument = function(e) {
                        if (this.addTypename) {
                            var t = this.typenameDocumentCache.get(e);
                            return t || (t = (0, o.Gw)(e), this.typenameDocumentCache.set(e, t), this.typenameDocumentCache.set(t, t)), t;
                        }
                        return e;
                    }, t.prototype.broadcastWatches = function() {
                        var e = this;
                        this.silenceBroadcast || this.watches.forEach(function(t) {
                            return e.maybeBroadcastWatch(t);
                        });
                    }, t.prototype.maybeBroadcastWatch = function(e) {
                        e.callback(this.diff({
                            query: e.query,
                            variables: e.variables,
                            previousResult: e.previousResult && e.previousResult(),
                            optimistic: e.optimistic
                        }));
                    }, t;
                }(D), Le = r(3306);
                var je = {
                    Name: function(e) {
                        return e.value;
                    },
                    Variable: function(e) {
                        return "$" + e.name;
                    },
                    Document: function(e) {
                        return Be(e.definitions, "\n\n") + "\n";
                    },
                    OperationDefinition: function(e) {
                        var t = e.operation, r = e.name, n = Ve("(", Be(e.variableDefinitions, ", "), ")"), i = Be(e.directives, " "), o = e.selectionSet;
                        return r || i || n || "query" !== t ? Be([
                            t,
                            Be([
                                r,
                                n
                            ]),
                            i,
                            o
                        ], " ") : o;
                    },
                    VariableDefinition: function(e) {
                        var t = e.directives;
                        return e.variable + ": " + e.type + Ve(" = ", e.defaultValue) + Ve(" ", Be(t, " "));
                    },
                    SelectionSet: function(e) {
                        return Qe(e.selections);
                    },
                    Field: function(e) {
                        var t = e.name, r = e.arguments, n = e.directives, i = e.selectionSet;
                        return Be([
                            Ve("", e.alias, ": ") + t + Ve("(", Be(r, ", "), ")"),
                            Be(n, " "),
                            i
                        ], " ");
                    },
                    Argument: function(e) {
                        return e.name + ": " + e.value;
                    },
                    FragmentSpread: function(e) {
                        return "..." + e.name + Ve(" ", Be(e.directives, " "));
                    },
                    InlineFragment: function(e) {
                        var t = e.directives, r = e.selectionSet;
                        return Be([
                            "...",
                            Ve("on ", e.typeCondition),
                            Be(t, " "),
                            r
                        ], " ");
                    },
                    FragmentDefinition: function(e) {
                        var t = e.typeCondition, r = e.variableDefinitions, n = e.directives, i = e.selectionSet;
                        return "fragment ".concat(e.name).concat(Ve("(", Be(r, ", "), ")"), " ") + "on ".concat(t, " ").concat(Ve("", Be(n, " "), " ")) + i;
                    },
                    IntValue: function(e) {
                        return e.value;
                    },
                    FloatValue: function(e) {
                        return e.value;
                    },
                    StringValue: function(e, t) {
                        var r = e.value;
                        return e.block ? (0, Le.LZ)(r, "description" === t ? "" : "  ") : JSON.stringify(r);
                    },
                    BooleanValue: function(e) {
                        return e.value ? "true" : "false";
                    },
                    NullValue: function() {
                        return "null";
                    },
                    EnumValue: function(e) {
                        return e.value;
                    },
                    ListValue: function(e) {
                        return "[" + Be(e.values, ", ") + "]";
                    },
                    ObjectValue: function(e) {
                        return "{" + Be(e.fields, ", ") + "}";
                    },
                    ObjectField: function(e) {
                        return e.name + ": " + e.value;
                    },
                    Directive: function(e) {
                        return "@" + e.name + Ve("(", Be(e.arguments, ", "), ")");
                    },
                    NamedType: function(e) {
                        return e.name;
                    },
                    ListType: function(e) {
                        return "[" + e.type + "]";
                    },
                    NonNullType: function(e) {
                        return e.type + "!";
                    },
                    SchemaDefinition: function(e) {
                        var t = e.operationTypes;
                        return Be([
                            "schema",
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    },
                    OperationTypeDefinition: function(e) {
                        return e.operation + ": " + e.type;
                    },
                    ScalarTypeDefinition: Ue(function(e) {
                        return Be([
                            "scalar",
                            e.name,
                            Be(e.directives, " ")
                        ], " ");
                    }),
                    ObjectTypeDefinition: Ue(function(e) {
                        var t = e.directives, r = e.fields;
                        return Be([
                            "type",
                            e.name,
                            Ve("implements ", Be(e.interfaces, " & ")),
                            Be(t, " "),
                            Qe(r)
                        ], " ");
                    }),
                    FieldDefinition: Ue(function(e) {
                        var t = e.arguments, r = e.type, n = e.directives;
                        return e.name + (ze(t) ? Ve("(\n", qe(Be(t, "\n")), "\n)") : Ve("(", Be(t, ", "), ")")) + ": " + r + Ve(" ", Be(n, " "));
                    }),
                    InputValueDefinition: Ue(function(e) {
                        var t = e.directives;
                        return Be([
                            e.name + ": " + e.type,
                            Ve("= ", e.defaultValue),
                            Be(t, " ")
                        ], " ");
                    }),
                    InterfaceTypeDefinition: Ue(function(e) {
                        var t = e.fields;
                        return Be([
                            "interface",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    }),
                    UnionTypeDefinition: Ue(function(e) {
                        var t = e.types;
                        return Be([
                            "union",
                            e.name,
                            Be(e.directives, " "),
                            t && 0 !== t.length ? "= " + Be(t, " | ") : ""
                        ], " ");
                    }),
                    EnumTypeDefinition: Ue(function(e) {
                        var t = e.values;
                        return Be([
                            "enum",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    }),
                    EnumValueDefinition: Ue(function(e) {
                        return Be([
                            e.name,
                            Be(e.directives, " ")
                        ], " ");
                    }),
                    InputObjectTypeDefinition: Ue(function(e) {
                        var t = e.fields;
                        return Be([
                            "input",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    }),
                    DirectiveDefinition: Ue(function(e) {
                        var t = e.arguments, r = e.repeatable, n = e.locations;
                        return "directive @" + e.name + (ze(t) ? Ve("(\n", qe(Be(t, "\n")), "\n)") : Ve("(", Be(t, ", "), ")")) + (r ? " repeatable" : "") + " on " + Be(n, " | ");
                    }),
                    SchemaExtension: function(e) {
                        var t = e.operationTypes;
                        return Be([
                            "extend schema",
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    },
                    ScalarTypeExtension: function(e) {
                        return Be([
                            "extend scalar",
                            e.name,
                            Be(e.directives, " ")
                        ], " ");
                    },
                    ObjectTypeExtension: function(e) {
                        var t = e.directives, r = e.fields;
                        return Be([
                            "extend type",
                            e.name,
                            Ve("implements ", Be(e.interfaces, " & ")),
                            Be(t, " "),
                            Qe(r)
                        ], " ");
                    },
                    InterfaceTypeExtension: function(e) {
                        var t = e.fields;
                        return Be([
                            "extend interface",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    },
                    UnionTypeExtension: function(e) {
                        var t = e.types;
                        return Be([
                            "extend union",
                            e.name,
                            Be(e.directives, " "),
                            t && 0 !== t.length ? "= " + Be(t, " | ") : ""
                        ], " ");
                    },
                    EnumTypeExtension: function(e) {
                        var t = e.values;
                        return Be([
                            "extend enum",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    },
                    InputObjectTypeExtension: function(e) {
                        var t = e.fields;
                        return Be([
                            "extend input",
                            e.name,
                            Be(e.directives, " "),
                            Qe(t)
                        ], " ");
                    }
                };
                function Ue(e) {
                    return function(t) {
                        return Be([
                            t.description,
                            e(t)
                        ], "\n");
                    };
                }
                function Be(e, t) {
                    return e ? e.filter(function(e) {
                        return e;
                    }).join(t || "") : "";
                }
                function Qe(e) {
                    return e && 0 !== e.length ? "{\n" + qe(Be(e, "\n")) + "\n}" : "";
                }
                function Ve(e, t, r) {
                    return t ? e + t + (r || "") : "";
                }
                function qe(e) {
                    return e && "  " + e.replace(/\n/g, "\n  ");
                }
                function Ge(e) {
                    return -1 !== e.indexOf("\n");
                }
                function ze(e) {
                    return e && e.some(Ge);
                }
                var We = {
                    http: {
                        includeQuery: !0,
                        includeExtensions: !1
                    },
                    headers: {
                        accept: "*/*",
                        "content-type": "application/json"
                    },
                    options: {
                        method: "POST"
                    }
                }, $e = function(e, t, r) {
                    var n = new Error(r);
                    throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
                }, He = function(e, t) {
                    for(var r = [], n = 2; n < arguments.length; n++)r[n - 2] = arguments[n];
                    var o = (0, i.pi)({}, t.options, {
                        headers: t.headers,
                        credentials: t.credentials
                    }), a = t.http;
                    r.forEach(function(e) {
                        o = (0, i.pi)({}, o, e.options, {
                            headers: (0, i.pi)({}, o.headers, e.headers)
                        }), e.credentials && (o.credentials = e.credentials), a = (0, i.pi)({}, a, e.http);
                    });
                    var s = e.query, u = {
                        operationName: e.operationName,
                        variables: e.variables
                    };
                    return a.includeExtensions && (u.extensions = e.extensions), a.includeQuery && (u.query = (0, f.Vn)(s, {
                        leave: je
                    })), {
                        options: o,
                        body: u
                    };
                }, Ke = function(e, t) {
                    var r;
                    try {
                        r = JSON.stringify(e);
                    } catch (e) {
                        var n = new l.ej(2);
                        throw n.parseError = e, n;
                    }
                    return r;
                }, Ye = function(e) {
                    void 0 === e && (e = {});
                    var t = e.uri, r = void 0 === t ? "/graphql" : t, n = e.fetch, o = e.includeExtensions, a = e.useGETForQueries, c = (0, i._T)(e, [
                        "uri",
                        "fetch",
                        "includeExtensions",
                        "useGETForQueries"
                    ]);
                    !function(e) {
                        if (!e && "undefined" == typeof fetch) throw new l.ej(1);
                    }(n), n || (n = fetch);
                    var f = {
                        http: {
                            includeExtensions: o
                        },
                        options: c.fetchOptions,
                        credentials: c.credentials,
                        headers: c.headers
                    };
                    return new u.i0(function(e) {
                        var t = function(e, t) {
                            var r = e.getContext().uri;
                            return r || ("function" == typeof t ? t(e) : t || "/graphql");
                        }(e, r), o = e.getContext(), c = {};
                        if (o.clientAwareness) {
                            var l = o.clientAwareness, p = l.name, d = l.version;
                            p && (c["apollographql-client-name"] = p), d && (c["apollographql-client-version"] = d);
                        }
                        var h, v = (0, i.pi)({}, c, o.headers), m = He(e, We, f, {
                            http: o.http,
                            options: o.fetchOptions,
                            credentials: o.credentials,
                            headers: v
                        }), y = m.options, g = m.body;
                        if (!y.signal) {
                            var E = function() {
                                if ("undefined" == typeof AbortController) return {
                                    controller: !1,
                                    signal: !1
                                };
                                var e = new AbortController;
                                return {
                                    controller: e,
                                    signal: e.signal
                                };
                            }();
                            (h = E.controller) && (y.signal = E.signal);
                        }
                        if (a && !e.query.definitions.some(function(e) {
                            return "OperationDefinition" === e.kind && "mutation" === e.operation;
                        }) && (y.method = "GET"), "GET" === y.method) {
                            var b = function(e, t) {
                                var r = [], n = function(e, t) {
                                    r.push(e + "=" + encodeURIComponent(t));
                                };
                                "query" in t && n("query", t.query);
                                t.operationName && n("operationName", t.operationName);
                                if (t.variables) {
                                    var i = void 0;
                                    try {
                                        i = Ke(t.variables);
                                    } catch (e) {
                                        return {
                                            parseError: e
                                        };
                                    }
                                    n("variables", i);
                                }
                                if (t.extensions) {
                                    var o = void 0;
                                    try {
                                        o = Ke(t.extensions);
                                    } catch (e) {
                                        return {
                                            parseError: e
                                        };
                                    }
                                    n("extensions", o);
                                }
                                var a = "", s = e, u = e.indexOf("#");
                                -1 !== u && (a = e.substr(u), s = e.substr(0, u));
                                var c = -1 === s.indexOf("?") ? "?" : "&", l = s + c + r.join("&") + a;
                                return {
                                    newURI: l
                                };
                            }(t, g), S = b.newURI, _ = b.parseError;
                            if (_) return (0, u.Qc)(_);
                            t = S;
                        } else try {
                            y.body = Ke(g);
                        } catch (_) {
                            return (0, u.Qc)(_);
                        }
                        return new s.Z(function(r) {
                            var i;
                            return n(t, y).then(function(t) {
                                return e.setContext({
                                    response: t
                                }), t;
                            }).then((i = e, function(e) {
                                return e.text().then(function(t) {
                                    try {
                                        return JSON.parse(t);
                                    } catch (n) {
                                        var r = n;
                                        return r.name = "ServerParseError", r.response = e, r.statusCode = e.status, r.bodyText = t, Promise.reject(r);
                                    }
                                }).then(function(t) {
                                    return e.status >= 300 && $e(e, t, "Response not successful: Received status code " + e.status), Array.isArray(t) || t.hasOwnProperty("data") || t.hasOwnProperty("errors") || $e(e, t, "Server response was missing for query '" + (Array.isArray(i) ? i.map(function(e) {
                                        return e.operationName;
                                    }) : i.operationName) + "'."), t;
                                });
                            })).then(function(e) {
                                return r.next(e), r.complete(), e;
                            }).catch(function(e) {
                                "AbortError" !== e.name && (e.result && e.result.errors && e.result.data && r.next(e.result), r.error(e));
                            }), function() {
                                h && h.abort();
                            };
                        });
                    });
                };
                var Xe = function(e) {
                    function t(t) {
                        return e.call(this, Ye(t).request) || this;
                    }
                    return (0, i.ZT)(t, e), t;
                }(u.i0);
                function Je(e) {
                    return new u.i0(function(t, r) {
                        return new s.Z(function(n) {
                            var i, o, a;
                            try {
                                i = r(t).subscribe({
                                    next: function(i) {
                                        i.errors && (a = e({
                                            graphQLErrors: i.errors,
                                            response: i,
                                            operation: t,
                                            forward: r
                                        })) ? o = a.subscribe({
                                            next: n.next.bind(n),
                                            error: n.error.bind(n),
                                            complete: n.complete.bind(n)
                                        }) : n.next(i);
                                    },
                                    error: function(i) {
                                        (a = e({
                                            operation: t,
                                            networkError: i,
                                            graphQLErrors: i && i.result && i.result.errors,
                                            forward: r
                                        })) ? o = a.subscribe({
                                            next: n.next.bind(n),
                                            error: n.error.bind(n),
                                            complete: n.complete.bind(n)
                                        }) : n.error(i);
                                    },
                                    complete: function() {
                                        a || n.complete.bind(n)();
                                    }
                                });
                            } catch (i) {
                                e({
                                    networkError: i,
                                    operation: t,
                                    forward: r
                                }), n.error(i);
                            }
                            return function() {
                                i && i.unsubscribe(), o && i.unsubscribe();
                            };
                        });
                    });
                }
                !function(e) {
                    function t(t) {
                        var r = e.call(this) || this;
                        return r.link = Je(t), r;
                    }
                    (0, i.ZT)(t, e), t.prototype.request = function(e, t) {
                        return this.link.request(e, t);
                    };
                }(u.i0);
                var Ze = r(3941), et = [
                    "request",
                    "uri",
                    "credentials",
                    "headers",
                    "fetch",
                    "fetchOptions",
                    "clientState",
                    "onError",
                    "cacheRedirects",
                    "cache",
                    "name",
                    "version",
                    "resolvers",
                    "typeDefs",
                    "fragmentMatcher"
                ], tt = function(e) {
                    function t(t) {
                        void 0 === t && (t = {});
                        if (t) Object.keys(t).filter(function(e) {
                            return -1 === et.indexOf(e);
                        });
                        var r = t.request, n = t.uri, i = t.credentials, o = t.headers, a = t.fetch, c = t.fetchOptions, f = t.clientState, p = t.cacheRedirects, d = t.onError, h = t.name, v = t.version, m = t.resolvers, y = t.typeDefs, g = t.fragmentMatcher, E = t.cache;
                        (0, l.kG)(!E || !p, 1), E || (E = p ? new Fe({
                            cacheRedirects: p
                        }) : new Fe);
                        var b = Je(d || function(e) {
                            var t = e.graphQLErrors;
                            t && t.forEach(function(e) {
                                return !0;
                            });
                        }), S = !!r && new u.i0(function(e, t) {
                            return new s.Z(function(n) {
                                var i;
                                return Promise.resolve(e).then(function(e) {
                                    return r(e);
                                }).then(function() {
                                    i = t(e).subscribe({
                                        next: n.next.bind(n),
                                        error: n.error.bind(n),
                                        complete: n.complete.bind(n)
                                    });
                                }).catch(n.error.bind(n)), function() {
                                    i && i.unsubscribe();
                                };
                            });
                        }), _ = new Xe({
                            uri: n || "/graphql",
                            fetch: a,
                            fetchOptions: c || {},
                            credentials: i || "same-origin",
                            headers: o || {}
                        }), O = u.i0.from([
                            b,
                            S,
                            _
                        ].filter(function(e) {
                            return !!e;
                        })), w = m, T = y, I = g;
                        return f && (f.defaults && E.writeData({
                            data: f.defaults
                        }), w = f.resolvers, T = f.typeDefs, I = f.fragmentMatcher), e.call(this, {
                            cache: E,
                            link: O,
                            name: h,
                            version: v,
                            resolvers: w,
                            typeDefs: T,
                            fragmentMatcher: I
                        }) || this;
                    }
                    return (0, i.ZT)(t, e), t;
                }(N);
                const rt = tt;
            },
            7946: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    setContext: ()=>a
                });
                var n = r(5949), i = r(4907), o = r(674);
                function a(e) {
                    return new i.i0(function(t, r) {
                        var i = (0, n._T)(t, []);
                        return new o.Z(function(n) {
                            var o;
                            return Promise.resolve(i).then(function(r) {
                                return e(r, t.getContext());
                            }).then(t.setContext).then(function() {
                                o = r(t).subscribe({
                                    next: n.next.bind(n),
                                    error: n.error.bind(n),
                                    complete: n.complete.bind(n)
                                });
                            }).catch(n.error.bind(n)), function() {
                                o && o.unsubscribe();
                            };
                        });
                    });
                }
            },
            4907: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    $y: ()=>c,
                    Dp: ()=>m,
                    Qc: ()=>f,
                    Vi: ()=>u,
                    Vl: ()=>y,
                    cS: ()=>v,
                    ht: ()=>b,
                    i0: ()=>E,
                    p4: ()=>l,
                    rY: ()=>a.rY,
                    y$: ()=>n.Z,
                    zi: ()=>p,
                    zo: ()=>g
                });
                var n = r(674), i = r(8754), o = r(5949), a = r(52);
                !function(e) {
                    function t(t, r) {
                        var n = e.call(this, t) || this;
                        return n.link = r, n;
                    }
                    (0, o.ZT)(t, e);
                }(Error);
                function s(e) {
                    return e.request.length <= 1;
                }
                function u(e) {
                    var t = !1;
                    return new Promise(function(r, n) {
                        e.subscribe({
                            next: function(e) {
                                t || (t = !0, r(e));
                            },
                            error: n
                        });
                    });
                }
                var c = u;
                function l(e) {
                    return new n.Z(function(t) {
                        e.then(function(e) {
                            t.next(e), t.complete();
                        }).catch(t.error.bind(t));
                    });
                }
                function f(e) {
                    return new n.Z(function(t) {
                        t.error(e);
                    });
                }
                function p(e, t) {
                    var r = (0, o.pi)({}, e);
                    return Object.defineProperty(t, "setContext", {
                        enumerable: !1,
                        value: function(e) {
                            r = (0, o.pi)({}, r, "function" == typeof e ? e(r) : e);
                        }
                    }), Object.defineProperty(t, "getContext", {
                        enumerable: !1,
                        value: function() {
                            return (0, o.pi)({}, r);
                        }
                    }), Object.defineProperty(t, "toKey", {
                        enumerable: !1,
                        value: function() {
                            return function(e) {
                                var t = e.query, r = e.variables, n = e.operationName;
                                return JSON.stringify([
                                    n,
                                    t,
                                    r
                                ]);
                            }(t);
                        }
                    }), t;
                }
                function d(e, t) {
                    return t ? t(e) : n.Z.of();
                }
                function h(e) {
                    return "function" == typeof e ? new E(e) : e;
                }
                function v() {
                    return new E(function() {
                        return n.Z.of();
                    });
                }
                function m(e) {
                    return 0 === e.length ? v() : e.map(h).reduce(function(e, t) {
                        return e.concat(t);
                    });
                }
                function y(e, t, r) {
                    var i = h(t), o = h(r || new E(d));
                    return s(i) && s(o) ? new E(function(t) {
                        return e(t) ? i.request(t) || n.Z.of() : o.request(t) || n.Z.of();
                    }) : new E(function(t, r) {
                        return e(t) ? i.request(t, r) || n.Z.of() : o.request(t, r) || n.Z.of();
                    });
                }
                var g = function(e, t) {
                    var r = h(e);
                    if (s(r)) return r;
                    var i = h(t);
                    return s(i) ? new E(function(e) {
                        return r.request(e, function(e) {
                            return i.request(e) || n.Z.of();
                        }) || n.Z.of();
                    }) : new E(function(e, t) {
                        return r.request(e, function(e) {
                            return i.request(e, t) || n.Z.of();
                        }) || n.Z.of();
                    });
                }, E = function() {
                    function e(e) {
                        e && (this.request = e);
                    }
                    return e.prototype.split = function(t, r, n) {
                        return this.concat(y(t, r, n || new e(d)));
                    }, e.prototype.concat = function(e) {
                        return g(this, e);
                    }, e.prototype.request = function(e, t) {
                        throw new i.ej(1);
                    }, e.empty = v, e.from = m, e.split = y, e.execute = b, e;
                }();
                function b(e, t) {
                    return e.request(p(t.context, function(e) {
                        var t = {
                            variables: e.variables || {},
                            extensions: e.extensions || {},
                            operationName: e.operationName,
                            query: e.query
                        };
                        return t.operationName || (t.operationName = "string" != typeof t.query ? (0, a.rY)(t.query) : ""), t;
                    }(function(e) {
                        for(var t = [
                            "query",
                            "operationName",
                            "variables",
                            "extensions",
                            "context"
                        ], r = 0, n = Object.keys(e); r < n.length; r++)if (t.indexOf(n[r]) < 0) throw new i.ej(2);
                        return e;
                    }(t)))) || n.Z.of();
                }
            },
            52: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    $H: ()=>R,
                    Ao: ()=>v,
                    Ee: ()=>re,
                    F: ()=>k,
                    FS: ()=>S,
                    Fo: ()=>V,
                    Gw: ()=>B,
                    LZ: ()=>b,
                    My: ()=>h,
                    NC: ()=>p,
                    O4: ()=>M,
                    PT: ()=>f,
                    Qy: ()=>E,
                    XY: ()=>Z,
                    Xh: ()=>H,
                    Y8: ()=>J,
                    Yk: ()=>w,
                    aL: ()=>G,
                    aX: ()=>y,
                    bw: ()=>ne,
                    cQ: ()=>m,
                    d2: ()=>ee,
                    f0: ()=>T,
                    iW: ()=>N,
                    kU: ()=>A,
                    mj: ()=>_,
                    mr: ()=>W,
                    ob: ()=>z,
                    p$: ()=>C,
                    rY: ()=>x,
                    u2: ()=>d,
                    v4: ()=>g,
                    vf: ()=>c,
                    yv: ()=>X
                });
                var n = r(7525), i = r(8754), o = r(5949), a = r(7362), s = r.n(a);
                r(1673);
                function u(e, t, r, n) {
                    if (function(e) {
                        return "IntValue" === e.kind;
                    }(r) || function(e) {
                        return "FloatValue" === e.kind;
                    }(r)) e[t.value] = Number(r.value);
                    else if (function(e) {
                        return "BooleanValue" === e.kind;
                    }(r) || function(e) {
                        return "StringValue" === e.kind;
                    }(r)) e[t.value] = r.value;
                    else if (function(e) {
                        return "ObjectValue" === e.kind;
                    }(r)) {
                        var o = {};
                        r.fields.map(function(e) {
                            return u(o, e.name, e.value, n);
                        }), e[t.value] = o;
                    } else if (function(e) {
                        return "Variable" === e.kind;
                    }(r)) e[t.value] = (n || {})[r.name.value];
                    else if (function(e) {
                        return "ListValue" === e.kind;
                    }(r)) e[t.value] = r.values.map(function(e) {
                        var r = {};
                        return u(r, t, e, n), r[t.value];
                    });
                    else if (function(e) {
                        return "EnumValue" === e.kind;
                    }(r)) e[t.value] = r.value;
                    else {
                        if (!function(e) {
                            return "NullValue" === e.kind;
                        }(r)) throw new i.ej(17);
                        e[t.value] = null;
                    }
                }
                function c(e, t) {
                    var r = null;
                    e.directives && (r = {}, e.directives.forEach(function(e) {
                        r[e.name.value] = {}, e.arguments && e.arguments.forEach(function(n) {
                            return u(r[e.name.value], n.name, n.value, t);
                        });
                    }));
                    var n = null;
                    return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(e) {
                        return u(n, e.name, e.value, t);
                    })), f(e.name.value, n, r);
                }
                var l = [
                    "connection",
                    "include",
                    "skip",
                    "client",
                    "rest",
                    "export"
                ];
                function f(e, t, r) {
                    if (r && r.connection && r.connection.key) {
                        if (r.connection.filter && r.connection.filter.length > 0) {
                            var n = r.connection.filter ? r.connection.filter : [];
                            n.sort();
                            var i = t, o = {};
                            return n.forEach(function(e) {
                                o[e] = i[e];
                            }), r.connection.key + "(" + JSON.stringify(o) + ")";
                        }
                        return r.connection.key;
                    }
                    var a = e;
                    if (t) {
                        var u = s()(t);
                        a += "(" + u + ")";
                    }
                    return r && Object.keys(r).forEach(function(e) {
                        -1 === l.indexOf(e) && (r[e] && Object.keys(r[e]).length ? a += "@" + e + "(" + JSON.stringify(r[e]) + ")" : a += "@" + e);
                    }), a;
                }
                function p(e, t) {
                    if (e.arguments && e.arguments.length) {
                        var r = {};
                        return e.arguments.forEach(function(e) {
                            return u(r, e.name, e.value, t);
                        }), r;
                    }
                    return null;
                }
                function d(e) {
                    return e.alias ? e.alias.value : e.name.value;
                }
                function h(e) {
                    return "Field" === e.kind;
                }
                function v(e) {
                    return "InlineFragment" === e.kind;
                }
                function m(e) {
                    return e && "id" === e.type && "boolean" == typeof e.generated;
                }
                function y(e, t) {
                    return void 0 === t && (t = !1), (0, o.pi)({
                        type: "id",
                        generated: t
                    }, "string" == typeof e ? {
                        id: e,
                        typename: void 0
                    } : e);
                }
                function g(e) {
                    return null != e && "object" == typeof e && "json" === e.type;
                }
                function E(e, t) {
                    if (e.directives && e.directives.length) {
                        var r = {};
                        return e.directives.forEach(function(e) {
                            r[e.name.value] = p(e, t);
                        }), r;
                    }
                    return null;
                }
                function b(e, t) {
                    var r;
                    return void 0 === t && (t = {}), (r = e.directives, r ? r.filter(O).map(function(e) {
                        var t = e.arguments;
                        (0, i.kG)(t && 1 === t.length, 14);
                        var r = t[0];
                        (0, i.kG)(r.name && "if" === r.name.value, 15);
                        var n = r.value;
                        return (0, i.kG)(n && ("Variable" === n.kind || "BooleanValue" === n.kind), 16), {
                            directive: e,
                            ifArgument: r
                        };
                    }) : []).every(function(e) {
                        var r = e.directive, n = e.ifArgument, o = !1;
                        return "Variable" === n.value.kind ? (0, i.kG)(void 0 !== (o = t[n.value.name.value]), 13) : o = n.value.value, "skip" === r.name.value ? !o : o;
                    });
                }
                function S(e, t) {
                    return (function(e) {
                        var t = [];
                        return (0, n.Vn)(e, {
                            Directive: function(e) {
                                t.push(e.name.value);
                            }
                        }), t;
                    })(t).some(function(t) {
                        return e.indexOf(t) > -1;
                    });
                }
                function _(e) {
                    return e && S([
                        "client"
                    ], e) && S([
                        "export"
                    ], e);
                }
                function O(e) {
                    var t = e.name.value;
                    return "skip" === t || "include" === t;
                }
                function w(e, t) {
                    var r = t, n = [];
                    return e.definitions.forEach(function(e) {
                        if ("OperationDefinition" === e.kind) throw new i.ej(11);
                        "FragmentDefinition" === e.kind && n.push(e);
                    }), void 0 === r && ((0, i.kG)(1 === n.length, 12), r = n[0].name.value), (0, o.pi)((0, o.pi)({}, e), {
                        definitions: (0, o.pr)([
                            {
                                kind: "OperationDefinition",
                                operation: "query",
                                selectionSet: {
                                    kind: "SelectionSet",
                                    selections: [
                                        {
                                            kind: "FragmentSpread",
                                            name: {
                                                kind: "Name",
                                                value: r
                                            }
                                        }
                                    ]
                                }
                            }
                        ], e.definitions)
                    });
                }
                function T(e) {
                    for(var t = [], r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    return t.forEach(function(t) {
                        null != t && Object.keys(t).forEach(function(r) {
                            e[r] = t[r];
                        });
                    }), e;
                }
                function I(e) {
                    (0, i.kG)(e && "Document" === e.kind, 2);
                    var t = e.definitions.filter(function(e) {
                        return "FragmentDefinition" !== e.kind;
                    }).map(function(e) {
                        if ("OperationDefinition" !== e.kind) throw new i.ej(3);
                        return e;
                    });
                    return (0, i.kG)(t.length <= 1, 4), e;
                }
                function R(e) {
                    return I(e), e.definitions.filter(function(e) {
                        return "OperationDefinition" === e.kind;
                    })[0];
                }
                function x(e) {
                    return e.definitions.filter(function(e) {
                        return "OperationDefinition" === e.kind && e.name;
                    }).map(function(e) {
                        return e.name.value;
                    })[0] || null;
                }
                function A(e) {
                    return e.definitions.filter(function(e) {
                        return "FragmentDefinition" === e.kind;
                    });
                }
                function N(e) {
                    var t = R(e);
                    return (0, i.kG)(t && "query" === t.operation, 6), t;
                }
                function C(e) {
                    var t;
                    I(e);
                    for(var r = 0, n = e.definitions; r < n.length; r++){
                        var o = n[r];
                        if ("OperationDefinition" === o.kind) {
                            var a = o.operation;
                            if ("query" === a || "mutation" === a || "subscription" === a) return o;
                        }
                        "FragmentDefinition" !== o.kind || t || (t = o);
                    }
                    if (t) return t;
                    throw new i.ej(10);
                }
                function k(e) {
                    void 0 === e && (e = []);
                    var t = {};
                    return e.forEach(function(e) {
                        t[e.name.value] = e;
                    }), t;
                }
                function M(e) {
                    if (e && e.variableDefinitions && e.variableDefinitions.length) {
                        var t = e.variableDefinitions.filter(function(e) {
                            return e.defaultValue;
                        }).map(function(e) {
                            var t = {};
                            return u(t, e.variable.name, e.defaultValue), t;
                        });
                        return T.apply(void 0, (0, o.pr)([
                            {}
                        ], t));
                    }
                    return {};
                }
                function P(e, t, r) {
                    var n = 0;
                    return e.forEach(function(r, i) {
                        t.call(this, r, i, e) && (e[n++] = r);
                    }, r), e.length = n, e;
                }
                var D = {
                    kind: "Field",
                    name: {
                        kind: "Name",
                        value: "__typename"
                    }
                };
                function F(e, t) {
                    return e.selectionSet.selections.every(function(e) {
                        return "FragmentSpread" === e.kind && F(t[e.name.value], t);
                    });
                }
                function L(e) {
                    return F(R(e) || function(e) {
                        (0, i.kG)("Document" === e.kind, 7), (0, i.kG)(e.definitions.length <= 1, 8);
                        var t = e.definitions[0];
                        return (0, i.kG)("FragmentDefinition" === t.kind, 9), t;
                    }(e), k(A(e))) ? null : e;
                }
                function j(e) {
                    return function(t) {
                        return e.some(function(e) {
                            return e.name && e.name === t.name.value || e.test && e.test(t);
                        });
                    };
                }
                function U(e, t) {
                    var r = Object.create(null), i = [], a = Object.create(null), s = [], u = L((0, n.Vn)(t, {
                        Variable: {
                            enter: function(e, t, n) {
                                "VariableDefinition" !== n.kind && (r[e.name.value] = !0);
                            }
                        },
                        Field: {
                            enter: function(t) {
                                if (e && t.directives && e.some(function(e) {
                                    return e.remove;
                                }) && t.directives && t.directives.some(j(e))) return t.arguments && t.arguments.forEach(function(e) {
                                    "Variable" === e.value.kind && i.push({
                                        name: e.value.name.value
                                    });
                                }), t.selectionSet && q(t.selectionSet).forEach(function(e) {
                                    s.push({
                                        name: e.name.value
                                    });
                                }), null;
                            }
                        },
                        FragmentSpread: {
                            enter: function(e) {
                                a[e.name.value] = !0;
                            }
                        },
                        Directive: {
                            enter: function(t) {
                                if (j(e)(t)) return null;
                            }
                        }
                    }));
                    return u && P(i, function(e) {
                        return !r[e.name];
                    }).length && (u = function(e, t) {
                        var r = function(e) {
                            return function(t) {
                                return e.some(function(e) {
                                    return t.value && "Variable" === t.value.kind && t.value.name && (e.name === t.value.name.value || e.test && e.test(t));
                                });
                            };
                        }(e);
                        return L((0, n.Vn)(t, {
                            OperationDefinition: {
                                enter: function(t) {
                                    return (0, o.pi)((0, o.pi)({}, t), {
                                        variableDefinitions: t.variableDefinitions.filter(function(t) {
                                            return !e.some(function(e) {
                                                return e.name === t.variable.name.value;
                                            });
                                        })
                                    });
                                }
                            },
                            Field: {
                                enter: function(t) {
                                    if (e.some(function(e) {
                                        return e.remove;
                                    })) {
                                        var n = 0;
                                        if (t.arguments.forEach(function(e) {
                                            r(e) && (n += 1);
                                        }), 1 === n) return null;
                                    }
                                }
                            },
                            Argument: {
                                enter: function(e) {
                                    if (r(e)) return null;
                                }
                            }
                        }));
                    }(i, u)), u && P(s, function(e) {
                        return !a[e.name];
                    }).length && (u = function(e, t) {
                        function r(t) {
                            if (e.some(function(e) {
                                return e.name === t.name.value;
                            })) return null;
                        }
                        return L((0, n.Vn)(t, {
                            FragmentSpread: {
                                enter: r
                            },
                            FragmentDefinition: {
                                enter: r
                            }
                        }));
                    }(s, u)), u;
                }
                function B(e) {
                    return (0, n.Vn)(I(e), {
                        SelectionSet: {
                            enter: function(e, t, r) {
                                if (!r || "OperationDefinition" !== r.kind) {
                                    var n = e.selections;
                                    if (n) {
                                        if (!n.some(function(e) {
                                            return h(e) && ("__typename" === e.name.value || 0 === e.name.value.lastIndexOf("__", 0));
                                        })) {
                                            var i = r;
                                            if (!(h(i) && i.directives && i.directives.some(function(e) {
                                                return "export" === e.name.value;
                                            }))) return (0, o.pi)((0, o.pi)({}, e), {
                                                selections: (0, o.pr)(n, [
                                                    D
                                                ])
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    });
                }
                var Q = {
                    test: function(e) {
                        var t = "connection" === e.name.value;
                        return t && (!e.arguments || e.arguments.some(function(e) {
                            return "key" === e.name.value;
                        })), t;
                    }
                };
                function V(e) {
                    return U([
                        Q
                    ], I(e));
                }
                function q(e) {
                    var t = [];
                    return e.selections.forEach(function(e) {
                        (h(e) || v(e)) && e.selectionSet ? q(e.selectionSet).forEach(function(e) {
                            return t.push(e);
                        }) : "FragmentSpread" === e.kind && t.push(e);
                    }), t;
                }
                function G(e) {
                    return "query" === C(e).operation ? e : (0, n.Vn)(e, {
                        OperationDefinition: {
                            enter: function(e) {
                                return (0, o.pi)((0, o.pi)({}, e), {
                                    operation: "query"
                                });
                            }
                        }
                    });
                }
                function z(e) {
                    I(e);
                    var t = U([
                        {
                            test: function(e) {
                                return "client" === e.name.value;
                            },
                            remove: !0
                        }
                    ], e);
                    return t && (t = (0, n.Vn)(t, {
                        FragmentDefinition: {
                            enter: function(e) {
                                if (e.selectionSet && e.selectionSet.selections.every(function(e) {
                                    return h(e) && "__typename" === e.name.value;
                                })) return null;
                            }
                        }
                    })), t;
                }
                var W = "function" == typeof WeakMap && !("object" == typeof navigator && "ReactNative" === navigator.product), $ = Object.prototype.toString;
                function H(e) {
                    return K(e, new Map);
                }
                function K(e, t) {
                    switch($.call(e)){
                        case "[object Array]":
                            if (t.has(e)) return t.get(e);
                            var r = e.slice(0);
                            return t.set(e, r), r.forEach(function(e, n) {
                                r[n] = K(e, t);
                            }), r;
                        case "[object Object]":
                            if (t.has(e)) return t.get(e);
                            var n = Object.create(Object.getPrototypeOf(e));
                            return t.set(e, n), Object.keys(e).forEach(function(r) {
                                n[r] = K(e[r], t);
                            }), n;
                        default:
                            return e;
                    }
                }
                function Y(e) {
                    return "development" === e;
                }
                function X() {
                    return !0 === Y("production");
                }
                function J() {
                    return !0 === Y("test");
                }
                function Z(e) {
                    try {
                        return e();
                    } catch (e) {
                        console.error && console.error(e);
                    }
                }
                function ee(e) {
                    return e.errors && e.errors.length;
                }
                var te = Object.prototype.hasOwnProperty;
                function re() {
                    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                    return ne(e);
                }
                function ne(e) {
                    var t = e[0] || {}, r = e.length;
                    if (r > 1) {
                        var n = [];
                        t = ae(t, n);
                        for(var i = 1; i < r; ++i)t = oe(t, e[i], n);
                    }
                    return t;
                }
                function ie(e) {
                    return null !== e && "object" == typeof e;
                }
                function oe(e, t, r) {
                    return ie(t) && ie(e) ? (Object.isExtensible && !Object.isExtensible(e) && (e = ae(e, r)), Object.keys(t).forEach(function(n) {
                        var i = t[n];
                        if (te.call(e, n)) {
                            var o = e[n];
                            i !== o && (e[n] = oe(ae(o, r), i, r));
                        } else e[n] = i;
                    }), e) : t;
                }
                function ae(e, t) {
                    return null !== e && "object" == typeof e && t.indexOf(e) < 0 && (e = Array.isArray(e) ? e.slice(0) : (0, o.pi)({
                        __proto__: Object.getPrototypeOf(e)
                    }, e), t.push(e)), e;
                }
                Object.create({});
            },
            3589: (e, t, r)=>{
                "use strict";
                var n, i, o;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SUPPORTED_IOS_VERSION = t.RemotePointerEventAction = t.PointerType = t.PointerEventType = t.PointerEventPenButton = void 0, function(e) {
                    e.MOUSE = "mouse", e.PEN = "pen", e.TOUCH = "touch";
                }(n || (t.PointerType = n = {})), function(e) {
                    e.MOVE = "pointermove", e.DOWN = "pointerdown", e.UP = "pointerup", e.LEAVE = "pointerleave", e.ACTIVITY = "pointeractivity", e.OUT = "pointerout";
                }(i || (t.PointerEventType = i = {})), function(e) {
                    e[e.NO_BUTTON = 0] = "NO_BUTTON", e[e.TIP = 1] = "TIP", e[e.BARREL = 2] = "BARREL", e[e.ERASER = 32] = "ERASER";
                }(o || (t.PointerEventPenButton = o = {}));
                t.SUPPORTED_IOS_VERSION = 13;
                var a;
                !function(e) {
                    e.SEND = "send-remote-pointer-event", e.PROPAGATE = "propagate-remote-pointer-event", e.DISPATCH = "dispatch-remote-pointer-event";
                }(a || (t.RemotePointerEventAction = a = {}));
            },
            8569: (e, t, r)=>{
                "use strict";
                var n, i;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.MediaInputType = t.CloseAction = void 0, function(e) {
                    e.VIDEO_INPUT = "videoinput", e.AUDIO_INPUT = "audioinput";
                }(n || (t.MediaInputType = n = {})), function(e) {
                    e.DISCONNECTED = "disconnected", e.CLOSED = "closed";
                }(i || (t.CloseAction = i = {}));
            },
            1427: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SessionStartProgress = void 0, function(e) {
                    e.CONNECTING = "connecting", e.CONNECTED = "connected", e.RECONNECTING = "reconnecting", e.DONE = "done";
                }(n || (t.SessionStartProgress = n = {}));
            },
            8083: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalConnectionErrorCode = void 0, function(e) {
                    e[e.CONNECT_TIMEOUT = 4101] = "CONNECT_TIMEOUT", e[e.CONNECTION_OFFLINE = 4102] = "CONNECTION_OFFLINE", e[e.RECONNECT = 4103] = "RECONNECT", e[e.CONNECTION_CANCELED = 4105] = "CONNECTION_CANCELED", e[e.RECONNECT_FAILED = 4106] = "RECONNECT_FAILED", e[e.SIGNALING_PEERS_TIMEOUT = 4107] = "SIGNALING_PEERS_TIMEOUT", e[e.WEBRTC_ICE_DISCONNECT = 4108] = "WEBRTC_ICE_DISCONNECT";
                }(n || (t.TerminalConnectionErrorCode = n = {}));
            },
            8980: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.GraphQlClient = void 0;
                var n = r(7298), i = r(7946), o = r(5901), a = r(9777);
                t.GraphQlClient = class extends n.ApolloClient {
                    constructor(e, t){
                        const r = new n.HttpLink({
                            uri: t.url
                        }), o = (0, i.setContext)(async ()=>({
                                headers: {
                                    authorization: `Bearer ${await e.getToken()}`
                                }
                            }));
                        super({
                            link: n.ApolloLink.from([
                                o,
                                r
                            ]),
                            cache: new n.InMemoryCache({
                                addTypename: !1
                            }),
                            defaultOptions: {
                                query: {
                                    fetchPolicy: "no-cache",
                                    errorPolicy: "all"
                                },
                                mutate: {
                                    fetchPolicy: "no-cache",
                                    errorPolicy: "all"
                                }
                            }
                        });
                    }
                    async mutate(e) {
                        const t = await super.mutate(e);
                        if (t.errors) throw new o.ServiceGraphQlError(t.errors);
                        if (!t.data) throw new a.UnexpectedServiceError;
                        return t.data;
                    }
                    async query(e) {
                        const t = await super.query(e);
                        if (t.errors) throw new o.ServiceGraphQlError(t.errors);
                        if (!t.data) throw new a.UnexpectedServiceError;
                        return t.data;
                    }
                };
            },
            1457: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SimpleTokenProvider = void 0;
                var n = r(6884);
                t.SimpleTokenProvider = class {
                    constructor(e){
                        this._token = e;
                    }
                    async getToken() {
                        if (!this._token) throw new n.InvalidStateError("SimpleTokenProvider: missing token.");
                        return this._token;
                    }
                    setToken(e) {
                        this._token = e;
                    }
                };
            },
            5910: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.TERMINAL_SYSTEM_CONFIG_QUERY = t.TERMINAL_CONFIG_QUERY = void 0;
                var o = i(r(3941));
                const a = o.default`
  fragment KeyboardProfileFragment on KeyboardProfile {
    languageId
    isDefault
    name
    configurations {
      clientOsName
      mappings {
        keys
        action
        remapKeys
      }
    }
  }
`;
                t.TERMINAL_CONFIG_QUERY = o.default`
    query TerminalConfigQuery($terminalConfigurationId: ID!) {
      user: me {
        id
        email
        firstName
        lastName
      }
      terminalConfiguration(terminalConfigurationId: $terminalConfigurationId) {
        kind
        keyboard {
          profiles {
            ...KeyboardProfileFragment
          }
        }
        session {
          idleTimeoutMinutes
          maxSessionDurationMinutes
          userInactivityTimeoutMinutes
          rebootTime
          rebootNotificationPeriod
        }
        system {
          terminalUrl
          environment
        }
        video {
          yuv444
          maxBandwidthKbps
          maxFrameRateFps
          maxVideoBitRateMbps
          maxVideoQuantization
          qosRateChange
        }
        audio {
          maxAudioBitRateKbps
          autoplay
        }
        features {
          appSwitching {isEnabled}
          clipboard {
            isEnabled,
            direction
          }
          download {isEnabled}
          camera {isEnabled}
          microphone {isEnabled}
          usbRedirection {isEnabled}
          print {isEnabled}
          settingsDialog {isEnabled}
          upload {isEnabled}
          customHeader {
            isEnabled
            message
            color
            backgroundColor
          }
          sessionShare {isEnabled}
          sessionSuspending {isEnabled}
        }
        experimental {
          advancedSessionStartParameters
        }
        logging {
          isLocalConsoleEnabled
          isLogglyEnabled
          isSentryEnabled
          isSplunkEnabled
          sessionMessagesUrl
          splunkLoggingUrl,
        }
        items {
          id
          kind
          name
          order
          parentId
          ...on ApplicationItem {
            applicationId
            path
            workingDirectory
            arguments
            iconUrl
          }
          ...on FolderItem {
            items {
              ...on ApplicationItem {
                id
                kind
                name
                order
                parentId
                applicationId
                path
                workingDirectory
                arguments
                iconUrl
              }
            }
          }
        }
      }
    }
    ${a}
  `, t.TERMINAL_SYSTEM_CONFIG_QUERY = o.default`
    query TerminalSystemConfigQuery($terminalConfigurationId: ID!) {
      terminalConfiguration(terminalConfigurationId: $terminalConfigurationId) {
        system {
          terminalUrl
          terminalBuild
        }
      }
    }
  `;
            },
            87: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalEvent = void 0, function(e) {
                    e.SESSION_STARTING = "session-starting", e.SESSION_STARTED = "session-started", e.SESSION_RESUMING = "session-resuming", e.SESSION_RESUMED = "session-resumed", e.SESSION_JOINING = "session-joining", e.SESSION_JOINED = "session-joined", e.SESSION_CLOSING = "session-closing", e.SESSION_CLOSED = "session-closed", e.SESSION_DISCONNECTED = "session-disconnected", e.SESSION_SUSPEND = "session-suspend", e.SESSION_STATISTICS = "session-statistics", e.NO_RUNNING_APPS = "no-running-apps", e.USER_INACTIVE = "user-inactive", e.READY_FOR_INTERACTION = "ready-for-interaction", e.SESSION_START_PROGRESS = "session-start-progress";
                }(n || (t.TerminalEvent = n = {}));
            },
            5141: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalState = void 0, function(e) {
                    e.READY = "ready", e.RUNNING = "running", e.STARTING = "starting", e.STOPPING = "stopping";
                }(n || (t.TerminalState = n = {}));
            },
            8901: (e, t, r)=>{
                "use strict";
                var n = r(5710);
                n(t, "__esModule", {
                    value: !0
                }), n(t, "SessionStartProgress", {
                    enumerable: !0,
                    get: function() {
                        return h.SessionStartProgress;
                    }
                }), n(t, "SessionState", {
                    enumerable: !0,
                    get: function() {
                        return d.SessionState;
                    }
                }), t.TerminalBuild = void 0, n(t, "TerminalError", {
                    enumerable: !0,
                    get: function() {
                        return l.ErrorType;
                    }
                }), n(t, "TerminalErrorCode", {
                    enumerable: !0,
                    get: function() {
                        return a.TerminalErrorCode;
                    }
                }), n(t, "TerminalEvent", {
                    enumerable: !0,
                    get: function() {
                        return f.TerminalEvent;
                    }
                }), n(t, "TerminalState", {
                    enumerable: !0,
                    get: function() {
                        return p.TerminalState;
                    }
                }), t.createInstance = async function(e) {
                    if (!(0, s.isBrowserSupported)()) {
                        const e = (0, u.getBrowserName)(), t = (0, u.getBrowserVersion)();
                        throw console.error("Frame Terminal", "unsupported browser", {
                            browserName: e,
                            browserVersion: t
                        }), new o.NotSupportedError(`Terminal: Browser ${e} version ${t} is not supported.`, a.TerminalErrorCode.UNSUPPORTED_BROWSER);
                    }
                    const t = await (0, c.getTerminalUrl)(e.terminalConfigId, e.token, e.serviceUrl), r = await (0, c.getTerminalManifest)(t);
                    return (await (0, c.getTerminalApi)(r["terminal.js"])).createTerminal({
                        assetUrl: t,
                        manifest: r,
                        ...e
                    });
                }, n(t, "isBrowserSupported", {
                    enumerable: !0,
                    get: function() {
                        return s.isBrowserSupported;
                    }
                }), r(8566);
                var i, o = r(8051), a = r(1158), s = r(4403), u = r(4709), c = r(4257), l = r(6368), f = r(87), p = r(5141), d = r(4958), h = r(1427);
                !function(e) {
                    e.LATEST = "latest", e.PREVIOUS = "previous", e.EXPERIMENTAL = "experimental";
                }(i || (t.TerminalBuild = i = {}));
            },
            4257: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.getTerminalApi = function(e) {
                    const t = window, r = t.TerminalApi;
                    delete t.TerminalApi;
                    const n = document.createElement("script");
                    return n.src = e, document.body.appendChild(n), new a.default((e, i)=>{
                        n.onload = ()=>{
                            t.TerminalApi ? e(t.TerminalApi) : i(new v.TerminalLoadFailedError("TerminalApi is not loaded")), r ? t.TerminalApi = r : delete t.TerminalApi;
                        }, n.onerror = i;
                    });
                }, t.getTerminalManifest = m, t.getTerminalUrl = async function(e, t, r) {
                    const n = new d.GraphQlClient(new h.SimpleTokenProvider(t), {
                        url: r
                    }), i = await n.query({
                        query: l.TERMINAL_SYSTEM_CONFIG_QUERY,
                        variables: {
                            terminalConfigurationId: e
                        }
                    }), { terminalUrl: o, terminalBuild: a } = i.terminalConfiguration.system;
                    return async function(e, t) {
                        let r = `${e}/${t}/${p.BundlePath.ES6}`;
                        t === f.TerminalBuild.LATEST || await async function(e) {
                            try {
                                return await m(e), !0;
                            } catch (t) {
                                return console.warn(`Failed to validate the terminal URL: ${e}, error`, t), !1;
                            }
                        }(r) || (r = `${e}/${f.TerminalBuild.LATEST}/${p.BundlePath.ES6}`);
                        return console.log(`Terminal url is set to ${r}`), r;
                    }(o, a);
                };
                var o = i(r(1982)), a = i(r(8756)), s = i(r(6812)), u = r(8362), c = r(3354), l = r(5910), f = r(8901), p = r(1660), d = r(8980), h = r(1457), v = r(1586);
                async function m(e) {
                    const t = new s.default((0, u.normalizeDirectoryUrl)(e)).filename("manifest.json").search(`t=${(0, o.default)()}`).toString(), r = await (await fetch(t)).json();
                    return (0, c.resolveAssetRecursive)(r, e);
                }
            },
            4958: (e, t, r)=>{
                "use strict";
                var n;
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SessionState = void 0, function(e) {
                    e.OPEN = "OPEN", e.CLOSED = "CLOSED", e.CLOSING = "CLOSING", e.FAILED = "FAILED", e.INIT = "INIT", e.RESERVED = "RESERVED";
                }(n || (t.SessionState = n = {}));
            },
            6368: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ErrorType = void 0;
                var n = r(5509), i = r(4104), o = r(5161), a = r(9680), s = r(3917), u = r(7422), c = r(6955), l = r(1423), f = r(8560), p = r(5551), d = r(2439), h = r(2127), v = r(9562), m = r(4401), y = r(5215), g = r(4281), E = r(2773), b = r(123), S = r(4909), _ = r(2141), O = r(2074), w = r(8404), T = r(6959), I = r(3645), R = r(4601), x = r(4813), A = r(5402), N = r(7491), C = r(5008), k = r(2743), M = r(806), P = r(2232), D = r(2145), F = r(5686), L = r(2502), j = r(4829), U = r(9043), B = r(8347), Q = r(2416), V = r(4934), q = r(3556), G = r(1419), z = r(1586), W = r(1934), $ = r(8280), H = r(4162), K = r(4046), Y = r(937), X = r(6868), J = r(9472), Z = r(6884), ee = r(1675), te = r(610), re = r(8051), ne = r(5680), ie = r(2569), oe = r(5901), ae = r(453), se = r(1158), ue = r(5421), ce = r(9777), le = r(3443), fe = r(7529), pe = r(2146), de = r(4111), he = r(2067), ve = r(1441), me = r(3549), ye = r(9418);
                t.ErrorType = {
                    AddMediaStreamTrackError: q.AddMediaStreamTrackError,
                    ApiDestroyedError: I.ApiDestroyedError,
                    ApplicationCloseFailedError: n.ApplicationCloseFailedError,
                    ApplicationFocusFailedError: i.ApplicationFocusFailedError,
                    ApplicationStartFailedError: o.ApplicationStartFailedError,
                    BufferTooSmallError: O.BufferTooSmallError,
                    CachedDataOverflowError: w.CachedDataOverflowError,
                    ConfigValidationError: G.ConfigValidationError,
                    ConnectionAbortedError: E.ConnectionAbortedError,
                    ConnectionCanceledError: b.ConnectionCanceledError,
                    ConnectionDestroyedError: pe.ConnectionDestroyedError,
                    ConnectionFailedError: S.ConnectionFailedError,
                    ConnectionLostError: de.ConnectionLostError,
                    ConnectionRefusedError: L.ConnectionRefusedError,
                    ControllerDestroyedError: $.ControllerDestroyedError,
                    DisplayConfigurationError: H.DisplayConfigurationError,
                    DomainJoinError: K.DomainJoinError,
                    FileModifiedError: p.FileModifiedError,
                    FileUploadCanceledError: d.FileUploadCanceledError,
                    FileUploadFailedError: h.FileUploadFailedError,
                    ForcePixelRatioError: Y.ForcePixelRatioError,
                    ForceResolutionError: X.ForceResolutionError,
                    InternalRpcError: he.InternalRpcError,
                    InvalidHidDeviceError: B.InvalidHidDeviceError,
                    InvalidMassStorageCmdError: j.InvalidMassStorageCmdError,
                    InvalidParamsError: J.InvalidParamsError,
                    InvalidStateError: Z.InvalidStateError,
                    MethodNotImplementedError: ee.MethodNotImplementedError,
                    MethodNotSupportedError: W.MethodNotSupportedError,
                    Mp4VideoStreamCorruptedError: a.Mp4VideoStreamCorruptedError,
                    Mp4VideoStreamFrozenError: s.Mp4VideoStreamFrozenError,
                    NotFoundError: te.NotFoundError,
                    NotSupportedError: re.NotSupportedError,
                    PlayerFailedError: l.PlayerFailedError,
                    PlayerStartCanceledError: m.PlayerStartCanceledError,
                    ReadingAbortedError: v.ReadingAbortedError,
                    RpcCallbackNotFoundError: ve.RpcCallbackNotFoundError,
                    RpcError: me.RpcError,
                    RpcExecutionError: ye.RpcExecutionError,
                    ServerApplicationStartFailedError: T.ServerApplicationStartFailedError,
                    ServerError: ne.ServerError,
                    ServiceError: ie.ServiceError,
                    ServiceGraphQlError: oe.ServiceGraphQlError,
                    ShortcutsConfigurationError: ae.ShortcutsConfigurationError,
                    SignalingConnectTimeoutError: k.SignalingConnectTimeoutError,
                    SignalingServerMissingUrlError: y.SignalingServerMissingUrlError,
                    TerminalError: se.TerminalError,
                    TerminalInternalError: ue.TerminalInternalError,
                    TerminalLoadFailedError: z.TerminalLoadFailedError,
                    TurnServerCredentialsError: M.TurnServerCredentialsError,
                    TurnServerCredentialsNotParsableError: P.TurnServerCredentialsNotParsableError,
                    TurnServerInternalServerError: D.TurnServerInternalServerError,
                    TurnServerMissingPropertyError: F.TurnServerMissingPropertyError,
                    UnexpectedServiceError: ce.UnexpectedServiceError,
                    UsbDeviceControllerError: Q.UsbDeviceControllerError,
                    UsbDeviceManagerError: V.UsbDeviceManagerError,
                    UsbDeviceNotFoundError: U.UsbDeviceNotFoundError,
                    UserAbortedConnectionError: f.UserAbortedConnectionError,
                    UserCanceledDomainJoinError: le.UserCanceledDomainJoinError,
                    UserInactivityError: g.UserInactivityError,
                    UserQuitDomainJoinError: fe.UserQuitDomainJoinError,
                    WebGlError: u.WebGlError,
                    WebRTCNegotiationTimeoutError: R.WebRTCNegotiationTimeoutError,
                    WebRTCPlayerCrashedError: c.WebRTCPlayerCrashedError,
                    WebRTCReconnectSignalingClientTimeoutError: x.WebRTCReconnectSignalingClientTimeoutError,
                    WebRTCRenegotiationTimeoutError: A.WebRTCRenegotiationTimeoutError,
                    WebRTCStunServerUnreachableError: N.WebRTCStunServerUnreachableError,
                    WebRTCTurnServerUnreachableError: C.WebRTCTurnServerUnreachableError,
                    WsConnectionError: _.WsConnectionError
                };
            },
            4403: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.BrowserVersion = t.Browser = void 0, t.isBrowserSupported = function() {
                    const e = (0, c.getBrowserName)(), t = (0, c.getBrowserVersion)(), r = (function(e) {
                        const t = new s.default([
                            [
                                o.CHROME,
                                a.CHROME
                            ],
                            [
                                o.FIREFOX,
                                a.FIREFOX
                            ],
                            [
                                o.SAFARI,
                                a.SAFARI
                            ],
                            [
                                o.EDGE,
                                a.EDGE
                            ],
                            [
                                o.ELECTRON,
                                a.ELECTRON
                            ]
                        ]), r = new s.default([
                            [
                                o.CHROME,
                                a.CHROME
                            ],
                            [
                                o.SAFARI,
                                a.SAFARI
                            ]
                        ]);
                        return e ? r : t;
                    })((0, c.isMobile)()).get(e);
                    return !!r && u.default.gte(t, r);
                };
                var o, a, s = i(r(8006)), u = i(r(6160)), c = r(4709);
                !function(e) {
                    e.CHROME = "chrome", e.FIREFOX = "firefox", e.EDGE = "microsoft edge", e.SAFARI = "safari", e.OCULUS = "OculusBrowser", e.ELECTRON = "electron";
                }(o || (t.Browser = o = {})), function(e) {
                    e.CHROME = "74.0.0", e.FIREFOX = "68.0.0", e.EDGE = "80.0.0", e.SAFARI = "12.0.0", e.ELECTRON = "20.1.1";
                }(a || (t.BrowserVersion = a = {}));
            },
            8362: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.normalizeDirectoryUrl = function(e) {
                    let t = new a.default(e).normalize().toString();
                    (0, o.default)(t).call(t, "/") || (t += "/");
                    return t;
                };
                var o = i(r(515)), a = i(r(6812));
            },
            3354: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.resolveAsset = s, t.resolveAssetRecursive = function e(t, r) {
                    for(const n in t)"string" == typeof t[n] ? t[n] = s(t[n], r) : "object" == typeof t[n] && e(t[n], r);
                    return t;
                };
                var o = i(r(6812)), a = r(8362);
                function s(e, t) {
                    const r = "undefined" != typeof self ? self : window, n = new o.default((0, a.normalizeDirectoryUrl)(t || r.TERMINAL_ROOT_URL)), i = e.split("?");
                    return n.filename(i[0]), i[1] && n.query(i[1]), n.normalize().toString();
                }
            },
            4709: (e, t, r)=>{
                "use strict";
                var n = r(7879), i = r(5710), o = r(3393), a = r(9534);
                i(t, "__esModule", {
                    value: !0
                }), t.PermissionState = t.PermissionQuery = t.CLIPBOARD_DATA_TYPE = t.BaseAudioContextState = void 0, t.arePointerEventsSupported = function() {
                    let e = !0;
                    if (M()) {
                        const t = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        t && Number(t[1]) < v.SUPPORTED_IOS_VERSION && (e = !1);
                    }
                    return e;
                }, t.createAudioContext = function() {
                    return new (window.AudioContext || window.webkitAudioContext);
                }, t.getAudioStream = $, t.getBrowserName = z, t.getBrowserVersion = W, t.getCameraPermissionStatus = async function(e) {
                    return e.permissions.query({
                        name: s.CAMERA
                    });
                }, t.getClientOsName = function() {
                    return d.os.family;
                }, t.getMediaStream = async function(e, t, r) {
                    return t === m.MediaInputType.AUDIO_INPUT ? $(e, r) : H(e, r);
                }, t.getMediaStreamTracks = async function(e, t) {
                    return t === m.MediaInputType.AUDIO_INPUT ? e.getAudioTracks() : e.getVideoTracks();
                }, t.getMicrophonePermissionStatus = async function(e) {
                    return e.permissions.query({
                        name: s.MICROPHONE
                    });
                }, t.getTerminalBrowserInfo = async function() {
                    const e = await async function() {
                        var e, t, r;
                        const n = null !== (e = await (null === (t = window.application) || void 0 === t ? void 0 : t.api.application.getInfo())) && void 0 !== e ? e : await (null === (r = window.xiframe) || void 0 === r || null === (r = r.application) || void 0 === r ? void 0 : r.getInfo());
                        return n ? {
                            version: n.version || S,
                            name: b
                        } : void 0;
                    }();
                    return null != e ? e : {
                        name: z(),
                        version: W()
                    };
                }, t.getVideoStream = H, t.hasClipboardApi = function() {
                    return (R() || x()) && "clipboard" in navigator && "function" == typeof navigator.clipboard.readText && "function" == typeof navigator.clipboard.writeText;
                }, t.hasFileEntrySupport = function() {
                    const e = window.DataTransferItem;
                    return !(!e || "function" != typeof e.prototype.getAsEntry && "function" != typeof e.prototype.webkitGetAsEntry);
                }, t.hasKeyboardLock = function() {
                    return "keyboard" in navigator && "lock" in navigator.keyboard && "unlock" in navigator.keyboard;
                }, t.isAndroid = P, t.isChromeBook = function() {
                    return !!navigator.userAgent.match(/CrOS/i);
                }, t.isChromiumBased = R, t.isElectron = I, t.isFirefox = x, t.isForcingPixelRatioSupported = function() {
                    return T() || I();
                }, t.isGenericUsbSupported = V, t.isHidUsbSupported = U, t.isIOS = M, t.isIpad = function() {
                    return !!navigator.userAgent.match(/iPad/i);
                }, t.isLinux = function() {
                    return w() === O.LINUX;
                }, t.isMac = function() {
                    return w() === O.MAC;
                }, t.isMobile = k, t.isMultiMonitorSupported = function() {
                    return R();
                }, t.isMultiScreenApiAvailable = function() {
                    return R() && "function" == typeof window.getScreenDetails;
                }, t.isNativeApp = F, t.isNativeAppInfoSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.application);
                }, t.isNativeClipboardSupported = D, t.isNativeClipboardTrackingSupported = function() {
                    var e, t, r;
                    return I() && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.clipboard) || void 0 === e ? void 0 : e.clipboardChangedEvent) && void 0 !== (null === (t = window.xiframe) || void 0 === t || null === (t = t.clipboard) || void 0 === t ? void 0 : t.startListeningForClipboardChangedEvent) && void 0 !== (null === (r = window.xiframe) || void 0 === r || null === (r = r.clipboard) || void 0 === r ? void 0 : r.stopListeningForClipboardChangedEvent);
                }, t.isNativeFullscreenSupported = function() {
                    var e;
                    return void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.monitor) || void 0 === e ? void 0 : e.setFullscreenStatusHandler);
                }, t.isNativeHidSupported = L, t.isNativeKeyboardSendingKeysSupported = function() {
                    var e;
                    return (I() || q()) && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.keyboard) || void 0 === e ? void 0 : e.setSendKeyHandler);
                }, t.isNativeKeyboardSupported = q, t.isNativeLogSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.logger);
                }, t.isNativeMonitorSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.monitor);
                }, t.isNativeMouseSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.mouse);
                }, t.isNativePrintSupported = function() {
                    return R() && !k() || A();
                }, t.isNativeScannerSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.scanner);
                }, t.isNativeSmartCardSupported = function() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.smartCard);
                }, t.isNativeUsbSupported = Q, t.isPdfjsPrintSupported = function() {
                    return x() && !k() || T() && k();
                }, t.isPenSupported = function() {
                    return T() || I();
                }, t.isPointerLockSupported = function() {
                    return "pointerLockElement" in document;
                }, t.isRichCopyPasteInNativeClipboardSupported = function() {
                    var e, t;
                    return D() && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.clipboard) || void 0 === e ? void 0 : e.read) && void 0 !== (null === (t = window.xiframe) || void 0 === t || null === (t = t.clipboard) || void 0 === t ? void 0 : t.write);
                }, t.isSafari = A, t.isSavingDisplaySetupSupported = function() {
                    var e;
                    return F() && I() && void 0 !== (null === (e = window.xiframe) || void 0 === e || null === (e = e.monitor) || void 0 === e ? void 0 : e.moveWindow);
                }, t.isSerialSupported = function() {
                    var e;
                    return I() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.serial);
                }, t.isTouchDevice = function() {
                    return "ontouchstart" in document.documentElement;
                }, t.isTouchUI = function() {
                    return P() || M();
                }, t.isUsbSupported = function() {
                    return U() || V();
                }, t.isWebHidSupported = j, t.isWebRTCSupported = function() {
                    return void 0 !== window.RTCPeerConnection;
                }, t.isWebUsbSupported = B, t.isWindows = N, t.isXrImmersiveModeSupported = async function() {
                    var e;
                    const t = null === (e = navigator) || void 0 === e ? void 0 : e.xr;
                    let r = !1;
                    if (void 0 !== t) try {
                        r = await t.isSessionSupported("immersive-vr");
                    } catch (e) {
                        console.log("XR is not supported");
                    }
                    return r;
                }, r(9064);
                var s, u, c, l = a(r(415)), f = a(r(1806)), p = E(r(9496)), d = E(r(5989)), h = a(r(6160)), v = r(3589), m = r(8569), y = r(4403);
                function g(e) {
                    if ("function" != typeof n) return null;
                    var t = new n, r = new n;
                    return (g = function(e) {
                        return e ? r : t;
                    })(e);
                }
                function E(e, t) {
                    if (!t && e && e.__esModule) return e;
                    if (null === e || "object" != typeof e && "function" != typeof e) return {
                        default: e
                    };
                    var r = g(t);
                    if (r && r.has(e)) return r.get(e);
                    var n = {
                        __proto__: null
                    }, a = i && o;
                    for(var s in e)if ("default" !== s && Object.prototype.hasOwnProperty.call(e, s)) {
                        var u = a ? o(e, s) : null;
                        u && (u.get || u.set) ? i(n, s, u) : n[s] = e[s];
                    }
                    return n.default = e, r && r.set(e, n), n;
                }
                !function(e) {
                    e.CAMERA = "camera", e.MICROPHONE = "microphone";
                }(s || (t.PermissionQuery = s = {})), function(e) {
                    e.GRANTED = "granted", e.DENIED = "denied", e.PROMPT = "prompt";
                }(u || (t.PermissionState = u = {})), function(e) {
                    e.SUSPENDED = "suspended", e.RUNNING = "running", e.CLOSED = "closed";
                }(c || (t.BaseAudioContextState = c = {}));
                const b = "FrameApp", S = "unknown";
                var _, O;
                function w() {
                    const e = navigator.appVersion.toLowerCase(), t = navigator.platform.toLowerCase();
                    return (0, l.default)(e).call(e, "mac") > -1 || (0, l.default)(t).call(t, "mac") > -1 ? O.MAC : (0, l.default)(e).call(e, "win") > -1 || (0, l.default)(t).call(t, "win") > -1 ? O.WINDOWS : (0, l.default)(e).call(e, "linux") > -1 || (0, l.default)(t).call(t, "linux") > -1 ? O.LINUX : O.UNKNOWN;
                }
                function T() {
                    return z() === y.Browser.CHROME;
                }
                function I() {
                    return z() === y.Browser.ELECTRON;
                }
                function R() {
                    return T() || I() || function() {
                        const e = W();
                        return z() === y.Browser.EDGE && h.default.gte(e, y.BrowserVersion.EDGE);
                    }();
                }
                function x() {
                    return z() === y.Browser.FIREFOX;
                }
                function A() {
                    return z() === y.Browser.SAFARI;
                }
                function N() {
                    return w() === O.WINDOWS;
                }
                function C() {
                    var e;
                    return (0, f.default)(e = navigator.userAgent).call(e, y.Browser.OCULUS);
                }
                function k() {
                    return !C() && (M() || P());
                }
                function M() {
                    return !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
                }
                function P() {
                    return !!navigator.userAgent.match(/^(?=.*Android)(?!.*Windows Phone).*/);
                }
                function D() {
                    var e;
                    return (I() || F()) && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.clipboard);
                }
                function F() {
                    return !!window.xiframe;
                }
                function L() {
                    var e;
                    return F() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.hid);
                }
                function j() {
                    return (!F() && !N() || I()) && void 0 !== window.navigator.hid;
                }
                function U() {
                    return L() || j();
                }
                function B() {
                    return (!F() && !N() || I()) && void 0 !== window.navigator.usb;
                }
                function Q() {
                    var e;
                    return F() && !I() && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.usb);
                }
                function V() {
                    return Q() || B();
                }
                function q() {
                    var e;
                    return (I() || F()) && void 0 !== (null === (e = window.xiframe) || void 0 === e ? void 0 : e.keyboard);
                }
                function G() {
                    let e;
                    const t = /(SamsungBrowser\/\d+.\d+)/g.exec(window.navigator.userAgent);
                    if (t && 2 === t.length && C()) {
                        const r = window.navigator.userAgent.replace(t[1], "");
                        e = p.getParser(r);
                    } else e = p.getParser(window.navigator.userAgent);
                    return e;
                }
                function z() {
                    return G().getBrowserName().toLowerCase();
                }
                function W() {
                    const e = G();
                    return h.default.valid(h.default.coerce(e.getBrowserVersion())) || S;
                }
                async function $(e, t) {
                    return await e.mediaDevices.getUserMedia({
                        audio: !t || {
                            deviceId: t
                        },
                        video: !1
                    });
                }
                async function H(e, t) {
                    return await e.mediaDevices.getUserMedia({
                        audio: !1,
                        video: !t || {
                            deviceId: t
                        }
                    });
                }
                !function(e) {
                    e.TEXT = "Text";
                }(_ || (t.CLIPBOARD_DATA_TYPE = _ = {})), function(e) {
                    e.WINDOWS = "Windows", e.MAC = "Mac", e.UNIX = "Unix", e.LINUX = "Linux", e.UNKNOWN = "UnknownOS";
                }(O || (O = {}));
            },
            5509: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ApplicationCloseFailedError = void 0;
                var n = r(1158);
                t.ApplicationCloseFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.APPLICATION_CLOSE_FAILED);
                    }
                };
            },
            4104: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ApplicationFocusFailedError = void 0;
                var n = r(1158);
                t.ApplicationFocusFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.APPLICATION_FOCUS_FAILED);
                    }
                };
            },
            5161: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ApplicationStartFailedError = void 0;
                var n = r(1158);
                t.ApplicationStartFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.APPLICATION_START_FAILED);
                    }
                };
            },
            9680: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.Mp4VideoStreamCorruptedError = void 0;
                var n = r(1158);
                t.Mp4VideoStreamCorruptedError = class extends n.TerminalError {
                    constructor(){
                        super("Mp4 video stream is corrupted.", n.TerminalErrorCode.MP4_VIDEO_STREAM_CORRUPTED);
                    }
                };
            },
            3917: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.Mp4VideoStreamFrozenError = void 0;
                var n = r(1158);
                t.Mp4VideoStreamFrozenError = class extends n.TerminalError {
                    constructor(){
                        super("Mp4 video stream is frozen.", n.TerminalErrorCode.MP4_VIDEO_STREAM_FROZEN);
                    }
                };
            },
            7422: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebGlError = void 0;
                var n = r(1158);
                t.WebGlError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalError.WEB_GL_ERROR);
                    }
                };
            },
            6955: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCPlayerCrashedError = void 0;
                var n = r(1158);
                t.WebRTCPlayerCrashedError = class extends n.TerminalError {
                    constructor(){
                        super("WebRTC player crashed.", n.TerminalErrorCode.WEB_RTC_PLAYER_CRASHED);
                    }
                };
            },
            1423: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.PlayerFailedError = void 0;
                var n = r(1158);
                t.PlayerFailedError = class extends n.TerminalError {
                    constructor(){
                        super("All players have failed", n.TerminalErrorCode.VIDEO_DECODERS_FAILED);
                    }
                };
            },
            8560: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UserAbortedConnectionError = void 0;
                var n = r(1158);
                t.UserAbortedConnectionError = class extends n.TerminalError {
                    constructor(e){
                        super(e || "User has aborted connection.", n.TerminalErrorCode.USER_ABORTED_CONNECTION);
                    }
                };
            },
            5551: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.FileModifiedError = void 0;
                var n = r(5421);
                t.FileModifiedError = class extends n.TerminalInternalError {
                };
            },
            2439: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.FileUploadCanceledError = void 0;
                var n = r(1158);
                t.FileUploadCanceledError = class extends n.TerminalError {
                    constructor(e){
                        super(e || "Upload was canceled", n.TerminalError.FILE_UPLOAD_CANCELED);
                    }
                };
            },
            2127: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.FileUploadFailedError = void 0;
                var n = r(1158);
                t.FileUploadFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e || "Unknown error occurred while uploading.", n.TerminalError.FILE_UPLOAD_FAILED);
                    }
                };
            },
            9562: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ReadingAbortedError = void 0;
                var n = r(5421);
                t.ReadingAbortedError = class extends n.TerminalInternalError {
                };
            },
            4401: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.PlayerStartCanceledError = void 0;
                var n = r(1158);
                t.PlayerStartCanceledError = class extends n.TerminalError {
                    constructor(e){
                        super(e || "Player start was canceled by Terminal.", n.TerminalErrorCode.PLAYER_START_CANCELED);
                    }
                };
            },
            5215: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SignalingServerMissingUrlError = void 0;
                var n = r(1158);
                t.SignalingServerMissingUrlError = class extends n.TerminalError {
                    constructor(){
                        super("Signaling server url is missing.", n.TerminalErrorCode.SIGNALING_SERVER_MISSING_URL_ERROR);
                    }
                };
            },
            4281: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UserInactivityError = void 0;
                var n = r(5421);
                t.UserInactivityError = class extends n.TerminalInternalError {
                    constructor(){
                        super("User inactivity timeout error.");
                    }
                };
            },
            2773: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionAbortedError = void 0;
                var n = r(1158);
                t.ConnectionAbortedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.CONNECTION_ABORTED);
                    }
                };
            },
            123: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionCanceledError = void 0;
                var n = r(2141);
                t.ConnectionCanceledError = class extends n.WsConnectionError {
                    constructor(e){
                        super("Web socket driver connection request was canceled by the Terminal.", e);
                    }
                };
            },
            4909: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionFailedError = void 0;
                var n = r(2141);
                t.ConnectionFailedError = class extends n.WsConnectionError {
                    constructor(e, t){
                        super(t || "Web socket driver connection has failed.", e);
                    }
                };
            },
            2141: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WsConnectionError = void 0;
                var n = r(1158);
                t.WsConnectionError = class extends n.TerminalError {
                };
            },
            2074: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.BufferTooSmallError = void 0;
                var n = r(5421);
                t.BufferTooSmallError = class extends n.TerminalInternalError {
                };
            },
            8404: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.CachedDataOverflowError = void 0;
                var n = r(5421);
                t.CachedDataOverflowError = class extends n.TerminalInternalError {
                };
            },
            6959: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ServerApplicationStartFailedError = void 0;
                var n = r(5680);
                t.ServerApplicationStartFailedError = class extends n.ServerError {
                };
            },
            3645: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ApiDestroyedError = void 0;
                var n = r(5421);
                t.ApiDestroyedError = class extends n.TerminalInternalError {
                    constructor(){
                        super("Api destroyed");
                    }
                };
            },
            4601: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCNegotiationTimeoutError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCNegotiationTimeoutError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_NEGOTIATION_TIMEOUT, "Connection negotiation timeout");
                    }
                };
            },
            4813: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCReconnectSignalingClientTimeoutError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCReconnectSignalingClientTimeoutError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_RECONNECT_SIGNALING_CLIENT_TIMEOUT, "Signaling client reconnect timeout");
                    }
                };
            },
            5402: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCRenegotiationTimeoutError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCRenegotiationTimeoutError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_RENEGOTIATION_TIMEOUT, "Connection renegotiation timeout");
                    }
                };
            },
            7491: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCStunServerUnreachableError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCStunServerUnreachableError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_STUN_SERVER_UNREACHABLE, "Stun server unreachable");
                    }
                };
            },
            5008: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.WebRTCTurnServerUnreachableError = void 0;
                var n = r(1158), i = r(4909);
                t.WebRTCTurnServerUnreachableError = class extends i.ConnectionFailedError {
                    constructor(){
                        super(n.TerminalErrorCode.WEB_RTC_TURN_SERVER_UNREACHABLE, "Turn server unreachable");
                    }
                };
            },
            2743: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.SignalingConnectTimeoutError = void 0;
                var n = r(8083), i = r(2141);
                t.SignalingConnectTimeoutError = class extends i.WsConnectionError {
                    constructor(e){
                        super(e || "Signaling connection timeout on waiting for server peers message.", n.TerminalConnectionErrorCode.SIGNALING_PEERS_TIMEOUT);
                    }
                };
            },
            806: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TurnServerCredentialsError = void 0;
                var n = r(1158);
                t.TurnServerCredentialsError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.TURN_SERVER_CREDENTIALS_ERROR);
                    }
                };
            },
            2232: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TurnServerCredentialsNotParsableError = void 0;
                var n = r(1158);
                t.TurnServerCredentialsNotParsableError = class extends n.TerminalError {
                    constructor(){
                        super("Turn server credentials parse error.", n.TerminalErrorCode.TURN_SERVER_NOT_PARSABLE_ERROR);
                    }
                };
            },
            2145: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TurnServerInternalServerError = void 0;
                var n = r(1158);
                t.TurnServerInternalServerError = class extends n.TerminalError {
                    constructor(){
                        super("Fetch TURN server returned internal server error.", n.TerminalErrorCode.TURN_SERVER_INTERNAL_SERVER_ERROR);
                    }
                };
            },
            5686: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TurnServerMissingPropertyError = void 0;
                var n = r(1158);
                t.TurnServerMissingPropertyError = class extends n.TerminalError {
                    constructor(){
                        super("Turn server credential property is missing.", n.TerminalErrorCode.TURN_SERVER_MISSING_PROPERTY_ERROR);
                    }
                };
            },
            2502: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionRefusedError = void 0;
                var n = r(1158);
                t.ConnectionRefusedError = class extends n.TerminalError {
                };
            },
            2416: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UsbDeviceControllerError = void 0;
                var n = r(5421);
                t.UsbDeviceControllerError = class extends n.TerminalInternalError {
                };
            },
            4934: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UsbDeviceManagerError = void 0;
                var n = r(5421);
                t.UsbDeviceManagerError = class extends n.TerminalInternalError {
                    constructor(e){
                        super(e);
                    }
                };
            },
            4829: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InvalidMassStorageCmdError = void 0;
                var n = r(5421);
                t.InvalidMassStorageCmdError = class extends n.TerminalInternalError {
                };
            },
            9043: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UsbDeviceNotFoundError = void 0;
                var n = r(5421);
                t.UsbDeviceNotFoundError = class extends n.TerminalInternalError {
                };
            },
            8347: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InvalidHidDeviceError = void 0;
                var n = r(5421);
                t.InvalidHidDeviceError = class extends n.TerminalInternalError {
                };
            },
            3556: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.AddMediaStreamTrackError = void 0;
                var n = r(1158);
                t.AddMediaStreamTrackError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.ADD_MEDIA_STREAM_TRACK_ERROR);
                    }
                };
            },
            1419: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.ConfigValidationError = void 0;
                var o = i(r(1183)), a = r(1158);
                t.ConfigValidationError = class extends a.TerminalError {
                    constructor(e){
                        let t = "Config validation error\n";
                        e && (t = (0, o.default)(e).call(e, (e, t)=>e + `${t.message} (${t.dataPath})\n`, t)), super(t, a.TerminalErrorCode.CONFIG_VALIDATION_ERROR);
                    }
                };
            },
            1586: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalLoadFailedError = void 0;
                var n = r(1158);
                t.TerminalLoadFailedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.TERMINAL_LOAD_FAILED);
                    }
                };
            },
            1934: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.MethodNotSupportedError = void 0;
                var n = r(1158);
                t.MethodNotSupportedError = class extends n.TerminalError {
                    constructor(){
                        super("Method not supported", n.TerminalErrorCode.METHOD_NOT_SUPPORTED);
                    }
                };
            },
            4122: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.BaseError = void 0;
                class n extends Error {
                    get url() {
                        return this._url;
                    }
                    get code() {
                        return this._code;
                    }
                    constructor(e, t, r){
                        super(e), this.name = this.constructor.name, this._code = t, r && (this._url = r), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(e).stack;
                    }
                }
                t.BaseError = n;
            },
            8280: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ControllerDestroyedError = void 0;
                var n = r(1158);
                t.ControllerDestroyedError = class extends n.TerminalError {
                    constructor(e, t){
                        super(e, t || n.TerminalErrorCode.CONTROLLER_ALREADY_DESTROYED);
                    }
                };
            },
            4162: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.DisplayConfigurationError = void 0;
                var n = r(1158);
                t.DisplayConfigurationError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.DISPLAY_CONFIGURATION_ERROR);
                    }
                };
            },
            4046: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.DomainJoinError = void 0;
                var n = r(1158);
                t.DomainJoinError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.DOMAIN_JOIN_ERROR);
                    }
                };
            },
            937: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ForcePixelRatioError = void 0;
                var n = r(1158);
                t.ForcePixelRatioError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.UNKNOWN_INVALID_PARAMS);
                    }
                };
            },
            6868: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ForceResolutionError = void 0;
                var n = r(1158);
                t.ForceResolutionError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.UNKNOWN_INVALID_PARAMS);
                    }
                };
            },
            9472: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InvalidParamsError = void 0;
                var n = r(1158);
                t.InvalidParamsError = class extends n.TerminalError {
                    constructor(e, t){
                        super(e, t || n.TerminalErrorCode.UNKNOWN_INVALID_PARAMS);
                    }
                };
            },
            6884: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InvalidStateError = void 0;
                var n = r(1158);
                t.InvalidStateError = class extends n.TerminalError {
                    constructor(e, t){
                        super(e, t || n.TerminalErrorCode.UNKNOWN_INVALID_STATE);
                    }
                };
            },
            1675: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.MethodNotImplementedError = void 0;
                var n = r(1158);
                t.MethodNotImplementedError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalError.METHOD_NOT_IMPLEMENTED);
                    }
                };
            },
            610: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.NotFoundError = void 0;
                var n = r(1158);
                t.NotFoundError = class extends n.TerminalError {
                };
            },
            8051: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.NotSupportedError = void 0;
                var n = r(1158);
                t.NotSupportedError = class extends n.TerminalError {
                };
            },
            5680: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ServerError = void 0;
                var n = r(4122);
                t.ServerError = class extends n.BaseError {
                };
            },
            2569: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ServiceError = void 0;
                var n = r(4122);
                t.ServiceError = class extends n.BaseError {
                };
            },
            5901: (e, t, r)=>{
                "use strict";
                var n = r(5710), i = r(9534);
                n(t, "__esModule", {
                    value: !0
                }), t.ServiceGraphQlError = void 0;
                var o = i(r(1183)), a = r(2569);
                t.ServiceGraphQlError = class extends a.ServiceError {
                    get errors() {
                        return this._errors;
                    }
                    constructor(e){
                        super((0, o.default)(e).call(e, (t, r, n)=>{
                            let i = t + r.message;
                            return n + 1 < e.length && (i += "\n"), i;
                        }, "")), this._errors = e;
                    }
                };
            },
            453: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ShortcutsConfigurationError = void 0;
                var n = r(1158);
                t.ShortcutsConfigurationError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.UNKNOWN_INVALID_PARAMS);
                    }
                };
            },
            1158: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalErrorCode = t.TerminalError = void 0;
                var n = r(4122);
                const i = {
                    USER_ABORTED_CONNECTION: 0,
                    CONNECTION_ABORTED: 1,
                    CONNECTION_LOST: 2,
                    NO_PORT_FOUND: 3,
                    NO_PORT_RECEIVED: 4,
                    CONNECTION_DESTROYED: 5,
                    WEB_RTC_ICE_CONNECTION_FAILED: 6,
                    WEB_RTC_NEGOTIATION_TIMEOUT: 7,
                    WEB_RTC_CONNECTION_FAILED: 8,
                    WEB_RTC_STUN_SERVER_UNREACHABLE: 9,
                    WEB_RTC_TURN_SERVER_UNREACHABLE: 10,
                    CONFIG_VALIDATION_ERROR: 100,
                    TERMINAL_LOAD_FAILED: 101,
                    TOKEN_MISSING: 102,
                    TERMINAL_ACTION_INVALID_STATE: 110,
                    PLAYER_ACTION_INVALID_STATE: 111,
                    PLAYER_START_CANCELED: 200,
                    VIDEO_DECODERS_FAILED: 202,
                    USER_BLOCKED_AUDIO: 203,
                    MP4_VIDEO_STREAM_CORRUPTED: 204,
                    MP4_VIDEO_STREAM_FROZEN: 205,
                    WEB_RTC_PLAYER_CRASHED: 206,
                    DISPLAY_CONFIGURATION_ERROR: 207,
                    ADD_MEDIA_STREAM_TRACK_ERROR: 208,
                    AUDIO_PLAYBACK_FAILED: 209,
                    STREAM_CLIENT_FAILED: 210,
                    FILE_UPLOAD_CANCELED: 250,
                    FILE_UPLOAD_FAILED: 251,
                    STARTING_USER_MEDIA_INPUT_DEVICE_FAILED: 260,
                    SCAN_MEDIA_DEVICE_ERROR: 261,
                    SETTINGS_APPLY_FAILED: 270,
                    SETTINGS_LOAD_FAILED: 271,
                    CHANGE_RESOLUTION_FAILED: 280,
                    SETTING_KEYBOARD_LAYOUT_FAILED: 281,
                    TOGGLE_ONSCREEN_KEYBOARD_FAILED: 282,
                    APPLICATION_START_FAILED: 300,
                    APPLICATION_CLOSE_FAILED: 301,
                    APPLICATION_NOT_FOUND: 302,
                    APPLICATION_START_FORBIDDEN_PARAMETER: 303,
                    APPLICATION_ID_PARAMETER_MISSING: 304,
                    APPLICATION_FOCUS_FAILED: 305,
                    APPLICATION_ONBOARD_FAILED: 350,
                    SESSION_REQUEST_ACTIVE: 400,
                    SESSION_REQUEST_ALREADY_OPEN: 401,
                    SESSION_REQUEST_ABORTED: 402,
                    SESSION_RESUME_MISSING_PARAMETER: 403,
                    SESSION_IN_INVALID_STATE: 404,
                    NO_ACTIVE_SESSION: 405,
                    DOMAIN_JOIN_ERROR: 406,
                    USER_CANCELED_DOMAIN_JOIN: 407,
                    USER_QUIT_DOMAIN_JOIN: 408,
                    CREDENTIALS_EXPIRED_DOMAIN_JOIN: 409,
                    CREDENTIALS_TOO_MANY_TRIES_DOMAIN_JOIN: 410,
                    CREDENTIALS_UNKNOWN_STATUS_CODE_DOMAIN_JOIN: 411,
                    FCP_PROBLEM_DOMAIN_JOIN: 412,
                    ACCOUNT_DATA_MISMATCH_DOMAIN_JOIN: 413,
                    ACCOUNT_DISABLED_DOMAIN_JOIN: 414,
                    COMPUTER_NOT_TRUSTED_DOMAIN_JOIN: 415,
                    SERVICE_SIDE_ERROR_DOMAIN_JOIN: 416,
                    INTERACTIVE_LOGON_DOMAIN_JOIN: 417,
                    CREDENTIALS_INTEGRITY_ERROR_DOMAIN_JOIN: 418,
                    SSO_CREDENTIALS_NOT_SET_ERROR_DOMAIN_JOIN: 419,
                    SCANNER_CANNOT_SET_RESOLUTION: 500,
                    SCANNER_CANNOT_SET_IMAGE_SIZE: 501,
                    SCANNER_CANNOT_SET_IMAGE_TYPE: 502,
                    INTERNAL_ERROR: 900,
                    UNEXPECTED_SERVICE_ERROR: 901,
                    UNKNOWN_INVALID_PARAMS: 902,
                    UNKNOWN_INVALID_STATE: 903,
                    CONTROLLER_ALREADY_DESTROYED: 904,
                    INTERNAL_RPC_ERROR: 905,
                    RPC_ERROR: 906,
                    WEB_GL_ERROR: 907,
                    UNSUPPORTED_BROWSER: 908,
                    TURN_SERVER_FORBIDDEN: 909,
                    TURN_SERVER_NOT_PARSABLE_ERROR: 910,
                    TURN_SERVER_INTERNAL_SERVER_ERROR: 911,
                    TURN_SERVER_MISSING_PROPERTY_ERROR: 912,
                    SIGNALING_SERVER_MISSING_URL_ERROR: 913,
                    TURN_SERVER_CREDENTIALS_ERROR: 914,
                    METHOD_NOT_SUPPORTED: 998,
                    METHOD_NOT_IMPLEMENTED: 999
                }, o = 5e3, a = t.TerminalErrorCode = {};
                for(const e in i)if (i.hasOwnProperty(e)) {
                    const t = o + i[e];
                    if (t < o || t > 5999) throw new Error(`TerminalError: error code ${t} out of range.`);
                    if (a[t]) throw new Error("TerminalError: error code already registered.");
                    a[e] = t;
                }
                t.TerminalError = class extends n.BaseError {
                    constructor(e, t){
                        super(e, t, "");
                    }
                };
            },
            5421: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.TerminalInternalError = void 0;
                var n = r(1158);
                t.TerminalInternalError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.INTERNAL_ERROR);
                    }
                };
            },
            9777: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UnexpectedServiceError = void 0;
                var n = r(2569), i = r(1158);
                t.UnexpectedServiceError = class extends n.ServiceError {
                    constructor(){
                        super("Unexpected service error. Please contact our support.", i.TerminalError.UNEXPECTED_SERVICE_ERROR);
                    }
                };
            },
            3443: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UserCanceledDomainJoinError = void 0;
                var n = r(1158);
                t.UserCanceledDomainJoinError = class extends n.TerminalError {
                    constructor(){
                        super("User has disconnected the session before logging in.", n.TerminalErrorCode.USER_CANCELED_DOMAIN_JOIN);
                    }
                };
            },
            7529: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.UserQuitDomainJoinError = void 0;
                var n = r(1158);
                t.UserQuitDomainJoinError = class extends n.TerminalError {
                    constructor(){
                        super("User has quit the session before logging in.", n.TerminalErrorCode.USER_QUIT_DOMAIN_JOIN);
                    }
                };
            },
            2146: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionDestroyedError = void 0;
                var n = r(8280), i = r(1158);
                t.ConnectionDestroyedError = class extends n.ControllerDestroyedError {
                    constructor(e){
                        super(e, i.TerminalErrorCode.CONNECTION_DESTROYED);
                    }
                };
            },
            4111: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.ConnectionLostError = void 0;
                var n = r(1158);
                t.ConnectionLostError = class extends n.TerminalError {
                    constructor(e){
                        super(e, n.TerminalErrorCode.CONNECTION_LOST);
                    }
                };
            },
            2067: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.InternalRpcErrorType = t.InternalRpcError = void 0;
                var n = r(1158);
                t.InternalRpcErrorType = {
                    PARSE_ERROR: "rpc-parse-error",
                    INVALID_REQUEST: "rpc-invalid-request",
                    METHOD_NOT_FOUND: "rpc-method-not-found",
                    INVALID_PARAMS: "rpc-invalid-params",
                    INTERNAL_ERROR: "rpc-internal-error"
                };
                t.InternalRpcError = class extends n.TerminalError {
                    constructor(e, t){
                        super("Internal rpc error.", n.TerminalErrorCode.INTERNAL_RPC_ERROR), this.requestId = e, this.errorId = t;
                    }
                };
            },
            1441: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.RpcCallbackNotFoundError = void 0;
                var n = r(5421);
                t.RpcCallbackNotFoundError = class extends n.TerminalInternalError {
                };
            },
            3549: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.RpcError = void 0;
                var n = r(1158);
                t.RpcError = class extends n.TerminalError {
                    constructor(e, t){
                        super(t.message, n.TerminalErrorCode.RPC_ERROR), this.requestId = e, this.error = t;
                    }
                };
            },
            9418: (e, t, r)=>{
                "use strict";
                r(5710)(t, "__esModule", {
                    value: !0
                }), t.RpcExecutionError = void 0;
                var n = r(1158);
                t.RpcExecutionError = class extends n.TerminalError {
                    constructor(e, t){
                        super(e, t);
                    }
                    toString() {
                        return `RpcExecutionError { code: ${this.code}, message: ${this.message} }`;
                    }
                };
            },
            1660: (e)=>{
                "use strict";
                e.exports.BundlePath = {
                    ES6: "es6"
                };
            },
            9496: function(e) {
                e.exports = function(e) {
                    var t = {};
                    function r(n) {
                        if (t[n]) return t[n].exports;
                        var i = t[n] = {
                            i: n,
                            l: !1,
                            exports: {}
                        };
                        return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
                    }
                    return r.m = e, r.c = t, r.d = function(e, t, n) {
                        r.o(e, t) || Object.defineProperty(e, t, {
                            enumerable: !0,
                            get: n
                        });
                    }, r.r = function(e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e, "__esModule", {
                            value: !0
                        });
                    }, r.t = function(e, t) {
                        if (1 & t && (e = r(e)), 8 & t) return e;
                        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                        var n = Object.create(null);
                        if (r.r(n), Object.defineProperty(n, "default", {
                            enumerable: !0,
                            value: e
                        }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                            return e[t];
                        }).bind(null, i));
                        return n;
                    }, r.n = function(e) {
                        var t = e && e.__esModule ? function() {
                            return e.default;
                        } : function() {
                            return e;
                        };
                        return r.d(t, "a", t), t;
                    }, r.o = function(e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t);
                    }, r.p = "", r(r.s = 90);
                }({
                    17: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n = r(18), i = function() {
                            function e() {}
                            return e.getFirstMatch = function(e, t) {
                                var r = t.match(e);
                                return r && r.length > 0 && r[1] || "";
                            }, e.getSecondMatch = function(e, t) {
                                var r = t.match(e);
                                return r && r.length > 1 && r[2] || "";
                            }, e.matchAndReturnConst = function(e, t, r) {
                                if (e.test(t)) return r;
                            }, e.getWindowsVersionName = function(e) {
                                switch(e){
                                    case "NT":
                                        return "NT";
                                    case "XP":
                                    case "NT 5.1":
                                        return "XP";
                                    case "NT 5.0":
                                        return "2000";
                                    case "NT 5.2":
                                        return "2003";
                                    case "NT 6.0":
                                        return "Vista";
                                    case "NT 6.1":
                                        return "7";
                                    case "NT 6.2":
                                        return "8";
                                    case "NT 6.3":
                                        return "8.1";
                                    case "NT 10.0":
                                        return "10";
                                    default:
                                        return;
                                }
                            }, e.getMacOSVersionName = function(e) {
                                var t = e.split(".").splice(0, 2).map(function(e) {
                                    return parseInt(e, 10) || 0;
                                });
                                if (t.push(0), 10 === t[0]) switch(t[1]){
                                    case 5:
                                        return "Leopard";
                                    case 6:
                                        return "Snow Leopard";
                                    case 7:
                                        return "Lion";
                                    case 8:
                                        return "Mountain Lion";
                                    case 9:
                                        return "Mavericks";
                                    case 10:
                                        return "Yosemite";
                                    case 11:
                                        return "El Capitan";
                                    case 12:
                                        return "Sierra";
                                    case 13:
                                        return "High Sierra";
                                    case 14:
                                        return "Mojave";
                                    case 15:
                                        return "Catalina";
                                    default:
                                        return;
                                }
                            }, e.getAndroidVersionName = function(e) {
                                var t = e.split(".").splice(0, 2).map(function(e) {
                                    return parseInt(e, 10) || 0;
                                });
                                if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                            }, e.getVersionPrecision = function(e) {
                                return e.split(".").length;
                            }, e.compareVersions = function(t, r, n) {
                                void 0 === n && (n = !1);
                                var i = e.getVersionPrecision(t), o = e.getVersionPrecision(r), a = Math.max(i, o), s = 0, u = e.map([
                                    t,
                                    r
                                ], function(t) {
                                    var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                                    return e.map(n.split("."), function(e) {
                                        return new Array(20 - e.length).join("0") + e;
                                    }).reverse();
                                });
                                for(n && (s = a - Math.min(i, o)), a -= 1; a >= s;){
                                    if (u[0][a] > u[1][a]) return 1;
                                    if (u[0][a] === u[1][a]) {
                                        if (a === s) return 0;
                                        a -= 1;
                                    } else if (u[0][a] < u[1][a]) return -1;
                                }
                            }, e.map = function(e, t) {
                                var r, n = [];
                                if (Array.prototype.map) return Array.prototype.map.call(e, t);
                                for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                                return n;
                            }, e.find = function(e, t) {
                                var r, n;
                                if (Array.prototype.find) return Array.prototype.find.call(e, t);
                                for(r = 0, n = e.length; r < n; r += 1){
                                    var i = e[r];
                                    if (t(i, r)) return i;
                                }
                            }, e.assign = function(e) {
                                for(var t, r, n = e, i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)o[a - 1] = arguments[a];
                                if (Object.assign) return Object.assign.apply(Object, [
                                    e
                                ].concat(o));
                                var s = function() {
                                    var e = o[t];
                                    "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                                        n[t] = e[t];
                                    });
                                };
                                for(t = 0, r = o.length; t < r; t += 1)s();
                                return e;
                            }, e.getBrowserAlias = function(e) {
                                return n.BROWSER_ALIASES_MAP[e];
                            }, e.getBrowserTypeByAlias = function(e) {
                                return n.BROWSER_MAP[e] || "";
                            }, e;
                        }();
                        t.default = i, e.exports = t.default;
                    },
                    18: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
                            "Amazon Silk": "amazon_silk",
                            "Android Browser": "android",
                            Bada: "bada",
                            BlackBerry: "blackberry",
                            Chrome: "chrome",
                            Chromium: "chromium",
                            Electron: "electron",
                            Epiphany: "epiphany",
                            Firefox: "firefox",
                            Focus: "focus",
                            Generic: "generic",
                            "Google Search": "google_search",
                            Googlebot: "googlebot",
                            "Internet Explorer": "ie",
                            "K-Meleon": "k_meleon",
                            Maxthon: "maxthon",
                            "Microsoft Edge": "edge",
                            "MZ Browser": "mz",
                            "NAVER Whale Browser": "naver",
                            Opera: "opera",
                            "Opera Coast": "opera_coast",
                            PhantomJS: "phantomjs",
                            Puffin: "puffin",
                            QupZilla: "qupzilla",
                            QQ: "qq",
                            QQLite: "qqlite",
                            Safari: "safari",
                            Sailfish: "sailfish",
                            "Samsung Internet for Android": "samsung_internet",
                            SeaMonkey: "seamonkey",
                            Sleipnir: "sleipnir",
                            Swing: "swing",
                            Tizen: "tizen",
                            "UC Browser": "uc",
                            Vivaldi: "vivaldi",
                            "WebOS Browser": "webos",
                            WeChat: "wechat",
                            "Yandex Browser": "yandex",
                            Roku: "roku"
                        }, t.BROWSER_MAP = {
                            amazon_silk: "Amazon Silk",
                            android: "Android Browser",
                            bada: "Bada",
                            blackberry: "BlackBerry",
                            chrome: "Chrome",
                            chromium: "Chromium",
                            electron: "Electron",
                            epiphany: "Epiphany",
                            firefox: "Firefox",
                            focus: "Focus",
                            generic: "Generic",
                            googlebot: "Googlebot",
                            google_search: "Google Search",
                            ie: "Internet Explorer",
                            k_meleon: "K-Meleon",
                            maxthon: "Maxthon",
                            edge: "Microsoft Edge",
                            mz: "MZ Browser",
                            naver: "NAVER Whale Browser",
                            opera: "Opera",
                            opera_coast: "Opera Coast",
                            phantomjs: "PhantomJS",
                            puffin: "Puffin",
                            qupzilla: "QupZilla",
                            qq: "QQ Browser",
                            qqlite: "QQ Browser Lite",
                            safari: "Safari",
                            sailfish: "Sailfish",
                            samsung_internet: "Samsung Internet for Android",
                            seamonkey: "SeaMonkey",
                            sleipnir: "Sleipnir",
                            swing: "Swing",
                            tizen: "Tizen",
                            uc: "UC Browser",
                            vivaldi: "Vivaldi",
                            webos: "WebOS Browser",
                            wechat: "WeChat",
                            yandex: "Yandex Browser"
                        }, t.PLATFORMS_MAP = {
                            tablet: "tablet",
                            mobile: "mobile",
                            desktop: "desktop",
                            tv: "tv"
                        }, t.OS_MAP = {
                            WindowsPhone: "Windows Phone",
                            Windows: "Windows",
                            MacOS: "macOS",
                            iOS: "iOS",
                            Android: "Android",
                            WebOS: "WebOS",
                            BlackBerry: "BlackBerry",
                            Bada: "Bada",
                            Tizen: "Tizen",
                            Linux: "Linux",
                            ChromeOS: "Chrome OS",
                            PlayStation4: "PlayStation 4",
                            Roku: "Roku"
                        }, t.ENGINE_MAP = {
                            EdgeHTML: "EdgeHTML",
                            Blink: "Blink",
                            Trident: "Trident",
                            Presto: "Presto",
                            Gecko: "Gecko",
                            WebKit: "WebKit"
                        };
                    },
                    90: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(91)) && n.__esModule ? n : {
                            default: n
                        }, o = r(18);
                        function a(e, t) {
                            for(var r = 0; r < t.length; r++){
                                var n = t[r];
                                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                            }
                        }
                        var s = function() {
                            function e() {}
                            var t, r, n;
                            return e.getParser = function(e, t) {
                                if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                                return new i.default(e, t);
                            }, e.parse = function(e) {
                                return new i.default(e).getResult();
                            }, t = e, n = [
                                {
                                    key: "BROWSER_MAP",
                                    get: function() {
                                        return o.BROWSER_MAP;
                                    }
                                },
                                {
                                    key: "ENGINE_MAP",
                                    get: function() {
                                        return o.ENGINE_MAP;
                                    }
                                },
                                {
                                    key: "OS_MAP",
                                    get: function() {
                                        return o.OS_MAP;
                                    }
                                },
                                {
                                    key: "PLATFORMS_MAP",
                                    get: function() {
                                        return o.PLATFORMS_MAP;
                                    }
                                }
                            ], r = null, n && a(t, n), e;
                        }();
                        t.default = s, e.exports = t.default;
                    },
                    91: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n = u(r(92)), i = u(r(93)), o = u(r(94)), a = u(r(95)), s = u(r(17));
                        function u(e) {
                            return e && e.__esModule ? e : {
                                default: e
                            };
                        }
                        var c = function() {
                            function e(e, t) {
                                if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                                this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                            }
                            var t = e.prototype;
                            return t.getUA = function() {
                                return this._ua;
                            }, t.test = function(e) {
                                return e.test(this._ua);
                            }, t.parseBrowser = function() {
                                var e = this;
                                this.parsedResult.browser = {};
                                var t = s.default.find(n.default, function(t) {
                                    if ("function" == typeof t.test) return t.test(e);
                                    if (t.test instanceof Array) return t.test.some(function(t) {
                                        return e.test(t);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                            }, t.getBrowser = function() {
                                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                            }, t.getBrowserName = function(e) {
                                return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                            }, t.getBrowserVersion = function() {
                                return this.getBrowser().version;
                            }, t.getOS = function() {
                                return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                            }, t.parseOS = function() {
                                var e = this;
                                this.parsedResult.os = {};
                                var t = s.default.find(i.default, function(t) {
                                    if ("function" == typeof t.test) return t.test(e);
                                    if (t.test instanceof Array) return t.test.some(function(t) {
                                        return e.test(t);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                            }, t.getOSName = function(e) {
                                var t = this.getOS().name;
                                return e ? String(t).toLowerCase() || "" : t || "";
                            }, t.getOSVersion = function() {
                                return this.getOS().version;
                            }, t.getPlatform = function() {
                                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                            }, t.getPlatformType = function(e) {
                                void 0 === e && (e = !1);
                                var t = this.getPlatform().type;
                                return e ? String(t).toLowerCase() || "" : t || "";
                            }, t.parsePlatform = function() {
                                var e = this;
                                this.parsedResult.platform = {};
                                var t = s.default.find(o.default, function(t) {
                                    if ("function" == typeof t.test) return t.test(e);
                                    if (t.test instanceof Array) return t.test.some(function(t) {
                                        return e.test(t);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                            }, t.getEngine = function() {
                                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                            }, t.getEngineName = function(e) {
                                return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                            }, t.parseEngine = function() {
                                var e = this;
                                this.parsedResult.engine = {};
                                var t = s.default.find(a.default, function(t) {
                                    if ("function" == typeof t.test) return t.test(e);
                                    if (t.test instanceof Array) return t.test.some(function(t) {
                                        return e.test(t);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                            }, t.parse = function() {
                                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                            }, t.getResult = function() {
                                return s.default.assign({}, this.parsedResult);
                            }, t.satisfies = function(e) {
                                var t = this, r = {}, n = 0, i = {}, o = 0;
                                if (Object.keys(e).forEach(function(t) {
                                    var a = e[t];
                                    "string" == typeof a ? (i[t] = a, o += 1) : "object" == typeof a && (r[t] = a, n += 1);
                                }), n > 0) {
                                    var a = Object.keys(r), u = s.default.find(a, function(e) {
                                        return t.isOS(e);
                                    });
                                    if (u) {
                                        var c = this.satisfies(r[u]);
                                        if (void 0 !== c) return c;
                                    }
                                    var l = s.default.find(a, function(e) {
                                        return t.isPlatform(e);
                                    });
                                    if (l) {
                                        var f = this.satisfies(r[l]);
                                        if (void 0 !== f) return f;
                                    }
                                }
                                if (o > 0) {
                                    var p = Object.keys(i), d = s.default.find(p, function(e) {
                                        return t.isBrowser(e, !0);
                                    });
                                    if (void 0 !== d) return this.compareVersion(i[d]);
                                }
                            }, t.isBrowser = function(e, t) {
                                void 0 === t && (t = !1);
                                var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = s.default.getBrowserTypeByAlias(n);
                                return t && i && (n = i.toLowerCase()), n === r;
                            }, t.compareVersion = function(e) {
                                var t = [
                                    0
                                ], r = e, n = !1, i = this.getBrowserVersion();
                                if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], t.push(">" === e[0] ? 1 : -1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(s.default.compareVersions(i, r, n)) > -1;
                            }, t.isOS = function(e) {
                                return this.getOSName(!0) === String(e).toLowerCase();
                            }, t.isPlatform = function(e) {
                                return this.getPlatformType(!0) === String(e).toLowerCase();
                            }, t.isEngine = function(e) {
                                return this.getEngineName(!0) === String(e).toLowerCase();
                            }, t.is = function(e, t) {
                                return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                            }, t.some = function(e) {
                                var t = this;
                                return void 0 === e && (e = []), e.some(function(e) {
                                    return t.is(e);
                                });
                            }, e;
                        }();
                        t.default = c, e.exports = t.default;
                    },
                    92: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(17)) && n.__esModule ? n : {
                            default: n
                        }, o = /version\/(\d+(\.?_?\d+)+)/i, a = [
                            {
                                test: [
                                    /googlebot/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Googlebot"
                                    }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /opera/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Opera"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /opr\/|opios/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Opera"
                                    }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /SamsungBrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Samsung Internet for Android"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /Whale/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "NAVER Whale Browser"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /MZBrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "MZ Browser"
                                    }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /focus/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Focus"
                                    }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /swing/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Swing"
                                    }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /coast/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Opera Coast"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /opt\/\d+(?:.?_?\d+)+/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Opera Touch"
                                    }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /yabrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Yandex Browser"
                                    }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /ucbrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "UC Browser"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /Maxthon|mxios/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Maxthon"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /epiphany/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Epiphany"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /puffin/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Puffin"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /sleipnir/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Sleipnir"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /k-meleon/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "K-Meleon"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /micromessenger/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "WeChat"
                                    }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /qqbrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                                    }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /msie|trident/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Internet Explorer"
                                    }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /\sedg\//i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Microsoft Edge"
                                    }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /edg([ea]|ios)/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Microsoft Edge"
                                    }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /vivaldi/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Vivaldi"
                                    }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /seamonkey/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "SeaMonkey"
                                    }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /sailfish/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Sailfish"
                                    }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /silk/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Amazon Silk"
                                    }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /phantom/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "PhantomJS"
                                    }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /slimerjs/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "SlimerJS"
                                    }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /blackberry|\bbb\d+/i,
                                    /rim\stablet/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "BlackBerry"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /(web|hpw)[o0]s/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "WebOS Browser"
                                    }, r = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /bada/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Bada"
                                    }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /tizen/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Tizen"
                                    }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /qupzilla/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "QupZilla"
                                    }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /firefox|iceweasel|fxios/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Firefox"
                                    }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /electron/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Electron"
                                    }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /MiuiBrowser/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Miui"
                                    }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /chromium/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Chromium"
                                    }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /chrome|crios|crmo/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Chrome"
                                    }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /GSA/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Google Search"
                                    }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: function(e) {
                                    var t = !e.test(/like android/i), r = e.test(/android/i);
                                    return t && r;
                                },
                                describe: function(e) {
                                    var t = {
                                        name: "Android Browser"
                                    }, r = i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /playstation 4/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "PlayStation 4"
                                    }, r = i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /safari|applewebkit/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: "Safari"
                                    }, r = i.default.getFirstMatch(o, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /.*/i
                                ],
                                describe: function(e) {
                                    var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                                    return {
                                        name: i.default.getFirstMatch(t, e),
                                        version: i.default.getSecondMatch(t, e)
                                    };
                                }
                            }
                        ];
                        t.default = a, e.exports = t.default;
                    },
                    93: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(17)) && n.__esModule ? n : {
                            default: n
                        }, o = r(18), a = [
                            {
                                test: [
                                    /Roku\/DVP/
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                                    return {
                                        name: o.OS_MAP.Roku,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /windows phone/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                                    return {
                                        name: o.OS_MAP.WindowsPhone,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /windows /i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                                    return {
                                        name: o.OS_MAP.Windows,
                                        version: t,
                                        versionName: r
                                    };
                                }
                            },
                            {
                                test: [
                                    /Macintosh(.*?) FxiOS(.*?)\//
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: o.OS_MAP.iOS
                                    }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /macintosh/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                                        name: o.OS_MAP.MacOS,
                                        version: t
                                    };
                                    return r && (n.versionName = r), n;
                                }
                            },
                            {
                                test: [
                                    /(ipod|iphone|ipad)/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                                    return {
                                        name: o.OS_MAP.iOS,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t = !e.test(/like android/i), r = e.test(/android/i);
                                    return t && r;
                                },
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                                        name: o.OS_MAP.Android,
                                        version: t
                                    };
                                    return r && (n.versionName = r), n;
                                }
                            },
                            {
                                test: [
                                    /(web|hpw)[o0]s/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                                        name: o.OS_MAP.WebOS
                                    };
                                    return t && t.length && (r.version = t), r;
                                }
                            },
                            {
                                test: [
                                    /blackberry|\bbb\d+/i,
                                    /rim\stablet/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                                    return {
                                        name: o.OS_MAP.BlackBerry,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /bada/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                                    return {
                                        name: o.OS_MAP.Bada,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /tizen/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                                    return {
                                        name: o.OS_MAP.Tizen,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /linux/i
                                ],
                                describe: function() {
                                    return {
                                        name: o.OS_MAP.Linux
                                    };
                                }
                            },
                            {
                                test: [
                                    /CrOS/
                                ],
                                describe: function() {
                                    return {
                                        name: o.OS_MAP.ChromeOS
                                    };
                                }
                            },
                            {
                                test: [
                                    /PlayStation 4/
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                                    return {
                                        name: o.OS_MAP.PlayStation4,
                                        version: t
                                    };
                                }
                            }
                        ];
                        t.default = a, e.exports = t.default;
                    },
                    94: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(17)) && n.__esModule ? n : {
                            default: n
                        }, o = r(18), a = [
                            {
                                test: [
                                    /googlebot/i
                                ],
                                describe: function() {
                                    return {
                                        type: "bot",
                                        vendor: "Google"
                                    };
                                }
                            },
                            {
                                test: [
                                    /huawei/i
                                ],
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "Huawei"
                                    };
                                    return t && (r.model = t), r;
                                }
                            },
                            {
                                test: [
                                    /nexus\s*(?:7|8|9|10).*/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Nexus"
                                    };
                                }
                            },
                            {
                                test: [
                                    /ipad/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Apple",
                                        model: "iPad"
                                    };
                                }
                            },
                            {
                                test: [
                                    /Macintosh(.*?) FxiOS(.*?)\//
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Apple",
                                        model: "iPad"
                                    };
                                }
                            },
                            {
                                test: [
                                    /kftt build/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Amazon",
                                        model: "Kindle Fire HD 7"
                                    };
                                }
                            },
                            {
                                test: [
                                    /silk/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet,
                                        vendor: "Amazon"
                                    };
                                }
                            },
                            {
                                test: [
                                    /tablet(?! pc)/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                                    return t && !r;
                                },
                                describe: function(e) {
                                    var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                                    return {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "Apple",
                                        model: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /nexus\s*[0-6].*/i,
                                    /galaxy nexus/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "Nexus"
                                    };
                                }
                            },
                            {
                                test: [
                                    /[^-]mobi/i
                                ],
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "blackberry" === e.getBrowserName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "BlackBerry"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "bada" === e.getBrowserName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "windows phone" === e.getBrowserName();
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile,
                                        vendor: "Microsoft"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t = Number(String(e.getOSVersion()).split(".")[0]);
                                    return "android" === e.getOSName(!0) && t >= 3;
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tablet
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "android" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "macos" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.desktop,
                                        vendor: "Apple"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "windows" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.desktop
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "linux" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.desktop
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "playstation 4" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tv
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "roku" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: o.PLATFORMS_MAP.tv
                                    };
                                }
                            }
                        ];
                        t.default = a, e.exports = t.default;
                    },
                    95: function(e, t, r) {
                        "use strict";
                        t.__esModule = !0, t.default = void 0;
                        var n, i = (n = r(17)) && n.__esModule ? n : {
                            default: n
                        }, o = r(18), a = [
                            {
                                test: function(e) {
                                    return "microsoft edge" === e.getBrowserName(!0);
                                },
                                describe: function(e) {
                                    if (/\sedg\//i.test(e)) return {
                                        name: o.ENGINE_MAP.Blink
                                    };
                                    var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                                    return {
                                        name: o.ENGINE_MAP.EdgeHTML,
                                        version: t
                                    };
                                }
                            },
                            {
                                test: [
                                    /trident/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: o.ENGINE_MAP.Trident
                                    }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: function(e) {
                                    return e.test(/presto/i);
                                },
                                describe: function(e) {
                                    var t = {
                                        name: o.ENGINE_MAP.Presto
                                    }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: function(e) {
                                    var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                                    return t && !r;
                                },
                                describe: function(e) {
                                    var t = {
                                        name: o.ENGINE_MAP.Gecko
                                    }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            },
                            {
                                test: [
                                    /(apple)?webkit\/537\.36/i
                                ],
                                describe: function() {
                                    return {
                                        name: o.ENGINE_MAP.Blink
                                    };
                                }
                            },
                            {
                                test: [
                                    /(apple)?webkit/i
                                ],
                                describe: function(e) {
                                    var t = {
                                        name: o.ENGINE_MAP.WebKit
                                    }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                                    return r && (t.version = r), t;
                                }
                            }
                        ];
                        t.default = a, e.exports = t.default;
                    }
                });
            },
            7362: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    t || (t = {}), "function" == typeof t && (t = {
                        cmp: t
                    });
                    var r, n = "boolean" == typeof t.cycles && t.cycles, i = t.cmp && (r = t.cmp, function(e) {
                        return function(t, n) {
                            return r({
                                key: t,
                                value: e[t]
                            }, {
                                key: n,
                                value: e[n]
                            });
                        };
                    }), o = [];
                    return function e(t) {
                        if (t && t.toJSON && "function" == typeof t.toJSON && (t = t.toJSON()), void 0 !== t) {
                            if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
                            if ("object" != typeof t) return JSON.stringify(t);
                            var r, a;
                            if (Array.isArray(t)) {
                                for(a = "[", r = 0; r < t.length; r++)r && (a += ","), a += e(t[r]) || "null";
                                return a + "]";
                            }
                            if (null === t) return "null";
                            if (-1 !== o.indexOf(t)) {
                                if (n) return JSON.stringify("__cycle__");
                                throw new TypeError("Converting circular structure to JSON");
                            }
                            var s = o.push(t) - 1, u = Object.keys(t).sort(i && i(t));
                            for(a = "", r = 0; r < u.length; r++){
                                var c = u[r], l = e(t[c]);
                                l && (a && (a += ","), a += JSON.stringify(c) + ":" + l);
                            }
                            return o.splice(s, 1), "{" + a + "}";
                        }
                    }(e);
                };
            },
            3941: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>X,
                    disableExperimentalFragmentVariables: ()=>G,
                    disableFragmentWarnings: ()=>V,
                    enableExperimentalFragmentVariables: ()=>q,
                    gql: ()=>B,
                    resetCaches: ()=>Q
                });
                var n = function() {
                    return n = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, n.apply(this, arguments);
                };
                "function" == typeof SuppressedError && SuppressedError;
                var i = r(4636);
                function o(e, t) {
                    if (!Boolean(e)) throw new Error(t);
                }
                var a = r(8921);
                function s(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.prototype.toString;
                    e.prototype.toJSON = t, e.prototype.inspect = t, a.Z && (e.prototype[a.Z] = t);
                }
                function u(e) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, u(e);
                }
                function c(e, t) {
                    for(var r, n = /\r\n|[\n\r]/g, i = 1, o = t + 1; (r = n.exec(e.body)) && r.index < t;)i += 1, o = t + 1 - (r.index + r[0].length);
                    return {
                        line: i,
                        column: o
                    };
                }
                function l(e) {
                    return f(e.source, c(e.source, e.start));
                }
                function f(e, t) {
                    var r = e.locationOffset.column - 1, n = d(r) + e.body, i = t.line - 1, o = t.line + (e.locationOffset.line - 1), a = t.column + (1 === t.line ? r : 0), s = "".concat(e.name, ":").concat(o, ":").concat(a, "\n"), u = n.split(/\r\n|[\n\r]/g), c = u[i];
                    if (c.length > 120) {
                        for(var l = Math.floor(a / 80), f = a % 80, h = [], v = 0; v < c.length; v += 80)h.push(c.slice(v, v + 80));
                        return s + p([
                            [
                                "".concat(o),
                                h[0]
                            ]
                        ].concat(h.slice(1, l + 1).map(function(e) {
                            return [
                                "",
                                e
                            ];
                        }), [
                            [
                                " ",
                                d(f - 1) + "^"
                            ],
                            [
                                "",
                                h[l + 1]
                            ]
                        ]));
                    }
                    return s + p([
                        [
                            "".concat(o - 1),
                            u[i - 1]
                        ],
                        [
                            "".concat(o),
                            c
                        ],
                        [
                            "",
                            d(a - 1) + "^"
                        ],
                        [
                            "".concat(o + 1),
                            u[i + 1]
                        ]
                    ]);
                }
                function p(e) {
                    var t = e.filter(function(e) {
                        return void 0 !== e[1];
                    }), r = Math.max.apply(Math, t.map(function(e) {
                        return e[0].length;
                    }));
                    return t.map(function(e) {
                        var t, n = e[1];
                        return d(r - (t = e[0]).length) + t + (n ? " | " + n : " |");
                    }).join("\n");
                }
                function d(e) {
                    return Array(e + 1).join(" ");
                }
                function h(e, t, r, n, i, o, a) {
                    var s = Array.isArray(t) ? 0 !== t.length ? t : void 0 : t ? [
                        t
                    ] : void 0, l = r;
                    if (!l && s) {
                        var f = s[0];
                        l = f && f.loc && f.loc.source;
                    }
                    var p, d = n;
                    !d && s && (d = s.reduce(function(e, t) {
                        return t.loc && e.push(t.loc.start), e;
                    }, [])), d && 0 === d.length && (d = void 0), n && r ? p = n.map(function(e) {
                        return c(r, e);
                    }) : s && (p = s.reduce(function(e, t) {
                        return t.loc && e.push(c(t.loc.source, t.loc.start)), e;
                    }, []));
                    var v, m = a;
                    if (null == m && null != o) {
                        var y = o.extensions;
                        "object" == u(v = y) && null !== v && (m = y);
                    }
                    Object.defineProperties(this, {
                        message: {
                            value: e,
                            enumerable: !0,
                            writable: !0
                        },
                        locations: {
                            value: p || void 0,
                            enumerable: Boolean(p)
                        },
                        path: {
                            value: i || void 0,
                            enumerable: Boolean(i)
                        },
                        nodes: {
                            value: s || void 0
                        },
                        source: {
                            value: l || void 0
                        },
                        positions: {
                            value: d || void 0
                        },
                        originalError: {
                            value: o
                        },
                        extensions: {
                            value: m || void 0,
                            enumerable: Boolean(m)
                        }
                    }), o && o.stack ? Object.defineProperty(this, "stack", {
                        value: o.stack,
                        writable: !0,
                        configurable: !0
                    }) : Error.captureStackTrace ? Error.captureStackTrace(this, h) : Object.defineProperty(this, "stack", {
                        value: Error().stack,
                        writable: !0,
                        configurable: !0
                    });
                }
                function v(e, t, r) {
                    return new h("Syntax Error: ".concat(r), void 0, e, [
                        t
                    ]);
                }
                h.prototype = Object.create(Error.prototype, {
                    constructor: {
                        value: h
                    },
                    name: {
                        value: "GraphQLError"
                    },
                    toString: {
                        value: function() {
                            return function(e) {
                                var t = e.message;
                                if (e.nodes) for(var r = 0, n = e.nodes; r < n.length; r++){
                                    var i = n[r];
                                    i.loc && (t += "\n\n" + l(i.loc));
                                }
                                else if (e.source && e.locations) for(var o = 0, a = e.locations; o < a.length; o++)t += "\n\n" + f(e.source, a[o]);
                                return t;
                            }(this);
                        }
                    }
                });
                var m = Object.freeze({
                    NAME: "Name",
                    DOCUMENT: "Document",
                    OPERATION_DEFINITION: "OperationDefinition",
                    VARIABLE_DEFINITION: "VariableDefinition",
                    SELECTION_SET: "SelectionSet",
                    FIELD: "Field",
                    ARGUMENT: "Argument",
                    FRAGMENT_SPREAD: "FragmentSpread",
                    INLINE_FRAGMENT: "InlineFragment",
                    FRAGMENT_DEFINITION: "FragmentDefinition",
                    VARIABLE: "Variable",
                    INT: "IntValue",
                    FLOAT: "FloatValue",
                    STRING: "StringValue",
                    BOOLEAN: "BooleanValue",
                    NULL: "NullValue",
                    ENUM: "EnumValue",
                    LIST: "ListValue",
                    OBJECT: "ObjectValue",
                    OBJECT_FIELD: "ObjectField",
                    DIRECTIVE: "Directive",
                    NAMED_TYPE: "NamedType",
                    LIST_TYPE: "ListType",
                    NON_NULL_TYPE: "NonNullType",
                    SCHEMA_DEFINITION: "SchemaDefinition",
                    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
                    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
                    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
                    FIELD_DEFINITION: "FieldDefinition",
                    INPUT_VALUE_DEFINITION: "InputValueDefinition",
                    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
                    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
                    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
                    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
                    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
                    DIRECTIVE_DEFINITION: "DirectiveDefinition",
                    SCHEMA_EXTENSION: "SchemaExtension",
                    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
                    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
                    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
                    UNION_TYPE_EXTENSION: "UnionTypeExtension",
                    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
                    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
                });
                var y, g = function(e, t, r) {
                    this.body = e, this.name = t || "GraphQL request", this.locationOffset = r || {
                        line: 1,
                        column: 1
                    }, this.locationOffset.line > 0 || o(0, "line in locationOffset is 1-indexed and must be positive"), this.locationOffset.column > 0 || o(0, "column in locationOffset is 1-indexed and must be positive");
                };
                y = g, "function" == typeof Symbol && Symbol.toStringTag && Object.defineProperty(y.prototype, Symbol.toStringTag, {
                    get: function() {
                        return this.constructor.name;
                    }
                });
                var E = r(3306), b = Object.freeze({
                    SOF: "<SOF>",
                    EOF: "<EOF>",
                    BANG: "!",
                    DOLLAR: "$",
                    AMP: "&",
                    PAREN_L: "(",
                    PAREN_R: ")",
                    SPREAD: "...",
                    COLON: ":",
                    EQUALS: "=",
                    AT: "@",
                    BRACKET_L: "[",
                    BRACKET_R: "]",
                    BRACE_L: "{",
                    PIPE: "|",
                    BRACE_R: "}",
                    NAME: "Name",
                    INT: "Int",
                    FLOAT: "Float",
                    STRING: "String",
                    BLOCK_STRING: "BlockString",
                    COMMENT: "Comment"
                });
                function S() {
                    return this.lastToken = this.token, this.token = this.lookahead();
                }
                function _() {
                    var e = this.token;
                    if (e.kind !== b.EOF) do e = e.next || (e.next = T(this, e));
                    while (e.kind === b.COMMENT);
                    return e;
                }
                function O(e, t, r, n, i, o, a) {
                    this.kind = e, this.start = t, this.end = r, this.line = n, this.column = i, this.value = a, this.prev = o, this.next = null;
                }
                function w(e) {
                    return isNaN(e) ? b.EOF : e < 127 ? JSON.stringify(String.fromCharCode(e)) : '"\\u'.concat(("00" + e.toString(16).toUpperCase()).slice(-4), '"');
                }
                function T(e, t) {
                    var r = e.source, n = r.body, i = n.length, o = function(e, t, r) {
                        var n = e.length, i = t;
                        for(; i < n;){
                            var o = e.charCodeAt(i);
                            if (9 === o || 32 === o || 44 === o || 65279 === o) ++i;
                            else if (10 === o) ++i, ++r.line, r.lineStart = i;
                            else {
                                if (13 !== o) break;
                                10 === e.charCodeAt(i + 1) ? i += 2 : ++i, ++r.line, r.lineStart = i;
                            }
                        }
                        return i;
                    }(n, t.end, e), a = e.line, s = 1 + o - e.lineStart;
                    if (o >= i) return new O(b.EOF, i, i, a, s, t);
                    var u = n.charCodeAt(o);
                    switch(u){
                        case 33:
                            return new O(b.BANG, o, o + 1, a, s, t);
                        case 35:
                            return function(e, t, r, n, i) {
                                var o, a = e.body, s = t;
                                do o = a.charCodeAt(++s);
                                while (!isNaN(o) && (o > 31 || 9 === o));
                                return new O(b.COMMENT, t, s, r, n, i, a.slice(t + 1, s));
                            }(r, o, a, s, t);
                        case 36:
                            return new O(b.DOLLAR, o, o + 1, a, s, t);
                        case 38:
                            return new O(b.AMP, o, o + 1, a, s, t);
                        case 40:
                            return new O(b.PAREN_L, o, o + 1, a, s, t);
                        case 41:
                            return new O(b.PAREN_R, o, o + 1, a, s, t);
                        case 46:
                            if (46 === n.charCodeAt(o + 1) && 46 === n.charCodeAt(o + 2)) return new O(b.SPREAD, o, o + 3, a, s, t);
                            break;
                        case 58:
                            return new O(b.COLON, o, o + 1, a, s, t);
                        case 61:
                            return new O(b.EQUALS, o, o + 1, a, s, t);
                        case 64:
                            return new O(b.AT, o, o + 1, a, s, t);
                        case 91:
                            return new O(b.BRACKET_L, o, o + 1, a, s, t);
                        case 93:
                            return new O(b.BRACKET_R, o, o + 1, a, s, t);
                        case 123:
                            return new O(b.BRACE_L, o, o + 1, a, s, t);
                        case 124:
                            return new O(b.PIPE, o, o + 1, a, s, t);
                        case 125:
                            return new O(b.BRACE_R, o, o + 1, a, s, t);
                        case 65:
                        case 66:
                        case 67:
                        case 68:
                        case 69:
                        case 70:
                        case 71:
                        case 72:
                        case 73:
                        case 74:
                        case 75:
                        case 76:
                        case 77:
                        case 78:
                        case 79:
                        case 80:
                        case 81:
                        case 82:
                        case 83:
                        case 84:
                        case 85:
                        case 86:
                        case 87:
                        case 88:
                        case 89:
                        case 90:
                        case 95:
                        case 97:
                        case 98:
                        case 99:
                        case 100:
                        case 101:
                        case 102:
                        case 103:
                        case 104:
                        case 105:
                        case 106:
                        case 107:
                        case 108:
                        case 109:
                        case 110:
                        case 111:
                        case 112:
                        case 113:
                        case 114:
                        case 115:
                        case 116:
                        case 117:
                        case 118:
                        case 119:
                        case 120:
                        case 121:
                        case 122:
                            return function(e, t, r, n, i) {
                                var o = e.body, a = o.length, s = t + 1, u = 0;
                                for(; s !== a && !isNaN(u = o.charCodeAt(s)) && (95 === u || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122);)++s;
                                return new O(b.NAME, t, s, r, n, i, o.slice(t, s));
                            }(r, o, a, s, t);
                        case 45:
                        case 48:
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                            return function(e, t, r, n, i, o) {
                                var a = e.body, s = r, u = t, c = !1;
                                45 === s && (s = a.charCodeAt(++u));
                                if (48 === s) {
                                    if ((s = a.charCodeAt(++u)) >= 48 && s <= 57) throw v(e, u, "Invalid number, unexpected digit after 0: ".concat(w(s), "."));
                                } else u = I(e, u, s), s = a.charCodeAt(u);
                                46 === s && (c = !0, s = a.charCodeAt(++u), u = I(e, u, s), s = a.charCodeAt(u));
                                69 !== s && 101 !== s || (c = !0, 43 !== (s = a.charCodeAt(++u)) && 45 !== s || (s = a.charCodeAt(++u)), u = I(e, u, s), s = a.charCodeAt(u));
                                if (46 === s || 69 === s || 101 === s) throw v(e, u, "Invalid number, expected digit but got: ".concat(w(s), "."));
                                return new O(c ? b.FLOAT : b.INT, t, u, n, i, o, a.slice(t, u));
                            }(r, o, u, a, s, t);
                        case 34:
                            return 34 === n.charCodeAt(o + 1) && 34 === n.charCodeAt(o + 2) ? function(e, t, r, n, i, o) {
                                var a = e.body, s = t + 3, u = s, c = 0, l = "";
                                for(; s < a.length && !isNaN(c = a.charCodeAt(s));){
                                    if (34 === c && 34 === a.charCodeAt(s + 1) && 34 === a.charCodeAt(s + 2)) return l += a.slice(u, s), new O(b.BLOCK_STRING, t, s + 3, r, n, i, (0, E.W7)(l));
                                    if (c < 32 && 9 !== c && 10 !== c && 13 !== c) throw v(e, s, "Invalid character within String: ".concat(w(c), "."));
                                    10 === c ? (++s, ++o.line, o.lineStart = s) : 13 === c ? (10 === a.charCodeAt(s + 1) ? s += 2 : ++s, ++o.line, o.lineStart = s) : 92 === c && 34 === a.charCodeAt(s + 1) && 34 === a.charCodeAt(s + 2) && 34 === a.charCodeAt(s + 3) ? (l += a.slice(u, s) + '"""', u = s += 4) : ++s;
                                }
                                throw v(e, s, "Unterminated string.");
                            }(r, o, a, s, t, e) : function(e, t, r, n, i) {
                                var o = e.body, a = t + 1, s = a, u = 0, c = "";
                                for(; a < o.length && !isNaN(u = o.charCodeAt(a)) && 10 !== u && 13 !== u;){
                                    if (34 === u) return c += o.slice(s, a), new O(b.STRING, t, a + 1, r, n, i, c);
                                    if (u < 32 && 9 !== u) throw v(e, a, "Invalid character within String: ".concat(w(u), "."));
                                    if (++a, 92 === u) {
                                        switch(c += o.slice(s, a - 1), u = o.charCodeAt(a)){
                                            case 34:
                                                c += '"';
                                                break;
                                            case 47:
                                                c += "/";
                                                break;
                                            case 92:
                                                c += "\\";
                                                break;
                                            case 98:
                                                c += "\b";
                                                break;
                                            case 102:
                                                c += "\f";
                                                break;
                                            case 110:
                                                c += "\n";
                                                break;
                                            case 114:
                                                c += "\r";
                                                break;
                                            case 116:
                                                c += "\t";
                                                break;
                                            case 117:
                                                var l = R(o.charCodeAt(a + 1), o.charCodeAt(a + 2), o.charCodeAt(a + 3), o.charCodeAt(a + 4));
                                                if (l < 0) {
                                                    var f = o.slice(a + 1, a + 5);
                                                    throw v(e, a, "Invalid character escape sequence: \\u".concat(f, "."));
                                                }
                                                c += String.fromCharCode(l), a += 4;
                                                break;
                                            default:
                                                throw v(e, a, "Invalid character escape sequence: \\".concat(String.fromCharCode(u), "."));
                                        }
                                        s = ++a;
                                    }
                                }
                                throw v(e, a, "Unterminated string.");
                            }(r, o, a, s, t);
                    }
                    throw v(r, o, function(e) {
                        if (e < 32 && 9 !== e && 10 !== e && 13 !== e) return "Cannot contain the invalid character ".concat(w(e), ".");
                        if (39 === e) return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
                        return "Cannot parse the unexpected character ".concat(w(e), ".");
                    }(u));
                }
                function I(e, t, r) {
                    var n = e.body, i = t, o = r;
                    if (o >= 48 && o <= 57) {
                        do o = n.charCodeAt(++i);
                        while (o >= 48 && o <= 57);
                        return i;
                    }
                    throw v(e, i, "Invalid number, expected digit but got: ".concat(w(o), "."));
                }
                function R(e, t, r, n) {
                    return x(e) << 12 | x(t) << 8 | x(r) << 4 | x(n);
                }
                function x(e) {
                    return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
                }
                s(O, function() {
                    return {
                        kind: this.kind,
                        value: this.value,
                        line: this.line,
                        column: this.column
                    };
                });
                var A = Object.freeze({
                    QUERY: "QUERY",
                    MUTATION: "MUTATION",
                    SUBSCRIPTION: "SUBSCRIPTION",
                    FIELD: "FIELD",
                    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
                    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
                    INLINE_FRAGMENT: "INLINE_FRAGMENT",
                    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
                    SCHEMA: "SCHEMA",
                    SCALAR: "SCALAR",
                    OBJECT: "OBJECT",
                    FIELD_DEFINITION: "FIELD_DEFINITION",
                    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
                    INTERFACE: "INTERFACE",
                    UNION: "UNION",
                    ENUM: "ENUM",
                    ENUM_VALUE: "ENUM_VALUE",
                    INPUT_OBJECT: "INPUT_OBJECT",
                    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
                });
                var N = function() {
                    function e(e, t) {
                        var r = "string" == typeof e ? new g(e) : e;
                        r instanceof g || o(0, "Must provide Source. Received: ".concat((0, i.Z)(r))), this._lexer = function(e, t) {
                            var r = new O(b.SOF, 0, 0, 0, 0, null);
                            return {
                                source: e,
                                options: t,
                                lastToken: r,
                                token: r,
                                line: 1,
                                lineStart: 0,
                                advance: S,
                                lookahead: _
                            };
                        }(r), this._options = t || {};
                    }
                    var t = e.prototype;
                    return t.parseName = function() {
                        var e = this.expectToken(b.NAME);
                        return {
                            kind: m.NAME,
                            value: e.value,
                            loc: this.loc(e)
                        };
                    }, t.parseDocument = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.DOCUMENT,
                            definitions: this.many(b.SOF, this.parseDefinition, b.EOF),
                            loc: this.loc(e)
                        };
                    }, t.parseDefinition = function() {
                        if (this.peek(b.NAME)) switch(this._lexer.token.value){
                            case "query":
                            case "mutation":
                            case "subscription":
                                return this.parseOperationDefinition();
                            case "fragment":
                                return this.parseFragmentDefinition();
                            case "schema":
                            case "scalar":
                            case "type":
                            case "interface":
                            case "union":
                            case "enum":
                            case "input":
                            case "directive":
                                return this.parseTypeSystemDefinition();
                            case "extend":
                                return this.parseTypeSystemExtension();
                        }
                        else {
                            if (this.peek(b.BRACE_L)) return this.parseOperationDefinition();
                            if (this.peekDescription()) return this.parseTypeSystemDefinition();
                        }
                        throw this.unexpected();
                    }, t.parseOperationDefinition = function() {
                        var e = this._lexer.token;
                        if (this.peek(b.BRACE_L)) return {
                            kind: m.OPERATION_DEFINITION,
                            operation: "query",
                            name: void 0,
                            variableDefinitions: [],
                            directives: [],
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        };
                        var t, r = this.parseOperationType();
                        return this.peek(b.NAME) && (t = this.parseName()), {
                            kind: m.OPERATION_DEFINITION,
                            operation: r,
                            name: t,
                            variableDefinitions: this.parseVariableDefinitions(),
                            directives: this.parseDirectives(!1),
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        };
                    }, t.parseOperationType = function() {
                        var e = this.expectToken(b.NAME);
                        switch(e.value){
                            case "query":
                                return "query";
                            case "mutation":
                                return "mutation";
                            case "subscription":
                                return "subscription";
                        }
                        throw this.unexpected(e);
                    }, t.parseVariableDefinitions = function() {
                        return this.optionalMany(b.PAREN_L, this.parseVariableDefinition, b.PAREN_R);
                    }, t.parseVariableDefinition = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.VARIABLE_DEFINITION,
                            variable: this.parseVariable(),
                            type: (this.expectToken(b.COLON), this.parseTypeReference()),
                            defaultValue: this.expectOptionalToken(b.EQUALS) ? this.parseValueLiteral(!0) : void 0,
                            directives: this.parseDirectives(!0),
                            loc: this.loc(e)
                        };
                    }, t.parseVariable = function() {
                        var e = this._lexer.token;
                        return this.expectToken(b.DOLLAR), {
                            kind: m.VARIABLE,
                            name: this.parseName(),
                            loc: this.loc(e)
                        };
                    }, t.parseSelectionSet = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.SELECTION_SET,
                            selections: this.many(b.BRACE_L, this.parseSelection, b.BRACE_R),
                            loc: this.loc(e)
                        };
                    }, t.parseSelection = function() {
                        return this.peek(b.SPREAD) ? this.parseFragment() : this.parseField();
                    }, t.parseField = function() {
                        var e, t, r = this._lexer.token, n = this.parseName();
                        return this.expectOptionalToken(b.COLON) ? (e = n, t = this.parseName()) : t = n, {
                            kind: m.FIELD,
                            alias: e,
                            name: t,
                            arguments: this.parseArguments(!1),
                            directives: this.parseDirectives(!1),
                            selectionSet: this.peek(b.BRACE_L) ? this.parseSelectionSet() : void 0,
                            loc: this.loc(r)
                        };
                    }, t.parseArguments = function(e) {
                        return this.optionalMany(b.PAREN_L, e ? this.parseConstArgument : this.parseArgument, b.PAREN_R);
                    }, t.parseArgument = function() {
                        var e = this._lexer.token, t = this.parseName();
                        return this.expectToken(b.COLON), {
                            kind: m.ARGUMENT,
                            name: t,
                            value: this.parseValueLiteral(!1),
                            loc: this.loc(e)
                        };
                    }, t.parseConstArgument = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.ARGUMENT,
                            name: this.parseName(),
                            value: (this.expectToken(b.COLON), this.parseValueLiteral(!0)),
                            loc: this.loc(e)
                        };
                    }, t.parseFragment = function() {
                        var e = this._lexer.token;
                        this.expectToken(b.SPREAD);
                        var t = this.expectOptionalKeyword("on");
                        return !t && this.peek(b.NAME) ? {
                            kind: m.FRAGMENT_SPREAD,
                            name: this.parseFragmentName(),
                            directives: this.parseDirectives(!1),
                            loc: this.loc(e)
                        } : {
                            kind: m.INLINE_FRAGMENT,
                            typeCondition: t ? this.parseNamedType() : void 0,
                            directives: this.parseDirectives(!1),
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        };
                    }, t.parseFragmentDefinition = function() {
                        var e = this._lexer.token;
                        return this.expectKeyword("fragment"), this._options.experimentalFragmentVariables ? {
                            kind: m.FRAGMENT_DEFINITION,
                            name: this.parseFragmentName(),
                            variableDefinitions: this.parseVariableDefinitions(),
                            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
                            directives: this.parseDirectives(!1),
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        } : {
                            kind: m.FRAGMENT_DEFINITION,
                            name: this.parseFragmentName(),
                            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
                            directives: this.parseDirectives(!1),
                            selectionSet: this.parseSelectionSet(),
                            loc: this.loc(e)
                        };
                    }, t.parseFragmentName = function() {
                        if ("on" === this._lexer.token.value) throw this.unexpected();
                        return this.parseName();
                    }, t.parseValueLiteral = function(e) {
                        var t = this._lexer.token;
                        switch(t.kind){
                            case b.BRACKET_L:
                                return this.parseList(e);
                            case b.BRACE_L:
                                return this.parseObject(e);
                            case b.INT:
                                return this._lexer.advance(), {
                                    kind: m.INT,
                                    value: t.value,
                                    loc: this.loc(t)
                                };
                            case b.FLOAT:
                                return this._lexer.advance(), {
                                    kind: m.FLOAT,
                                    value: t.value,
                                    loc: this.loc(t)
                                };
                            case b.STRING:
                            case b.BLOCK_STRING:
                                return this.parseStringLiteral();
                            case b.NAME:
                                return "true" === t.value || "false" === t.value ? (this._lexer.advance(), {
                                    kind: m.BOOLEAN,
                                    value: "true" === t.value,
                                    loc: this.loc(t)
                                }) : "null" === t.value ? (this._lexer.advance(), {
                                    kind: m.NULL,
                                    loc: this.loc(t)
                                }) : (this._lexer.advance(), {
                                    kind: m.ENUM,
                                    value: t.value,
                                    loc: this.loc(t)
                                });
                            case b.DOLLAR:
                                if (!e) return this.parseVariable();
                        }
                        throw this.unexpected();
                    }, t.parseStringLiteral = function() {
                        var e = this._lexer.token;
                        return this._lexer.advance(), {
                            kind: m.STRING,
                            value: e.value,
                            block: e.kind === b.BLOCK_STRING,
                            loc: this.loc(e)
                        };
                    }, t.parseList = function(e) {
                        var t = this, r = this._lexer.token;
                        return {
                            kind: m.LIST,
                            values: this.any(b.BRACKET_L, function() {
                                return t.parseValueLiteral(e);
                            }, b.BRACKET_R),
                            loc: this.loc(r)
                        };
                    }, t.parseObject = function(e) {
                        var t = this, r = this._lexer.token;
                        return {
                            kind: m.OBJECT,
                            fields: this.any(b.BRACE_L, function() {
                                return t.parseObjectField(e);
                            }, b.BRACE_R),
                            loc: this.loc(r)
                        };
                    }, t.parseObjectField = function(e) {
                        var t = this._lexer.token, r = this.parseName();
                        return this.expectToken(b.COLON), {
                            kind: m.OBJECT_FIELD,
                            name: r,
                            value: this.parseValueLiteral(e),
                            loc: this.loc(t)
                        };
                    }, t.parseDirectives = function(e) {
                        for(var t = []; this.peek(b.AT);)t.push(this.parseDirective(e));
                        return t;
                    }, t.parseDirective = function(e) {
                        var t = this._lexer.token;
                        return this.expectToken(b.AT), {
                            kind: m.DIRECTIVE,
                            name: this.parseName(),
                            arguments: this.parseArguments(e),
                            loc: this.loc(t)
                        };
                    }, t.parseTypeReference = function() {
                        var e, t = this._lexer.token;
                        return this.expectOptionalToken(b.BRACKET_L) ? (e = this.parseTypeReference(), this.expectToken(b.BRACKET_R), e = {
                            kind: m.LIST_TYPE,
                            type: e,
                            loc: this.loc(t)
                        }) : e = this.parseNamedType(), this.expectOptionalToken(b.BANG) ? {
                            kind: m.NON_NULL_TYPE,
                            type: e,
                            loc: this.loc(t)
                        } : e;
                    }, t.parseNamedType = function() {
                        var e = this._lexer.token;
                        return {
                            kind: m.NAMED_TYPE,
                            name: this.parseName(),
                            loc: this.loc(e)
                        };
                    }, t.parseTypeSystemDefinition = function() {
                        var e = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
                        if (e.kind === b.NAME) switch(e.value){
                            case "schema":
                                return this.parseSchemaDefinition();
                            case "scalar":
                                return this.parseScalarTypeDefinition();
                            case "type":
                                return this.parseObjectTypeDefinition();
                            case "interface":
                                return this.parseInterfaceTypeDefinition();
                            case "union":
                                return this.parseUnionTypeDefinition();
                            case "enum":
                                return this.parseEnumTypeDefinition();
                            case "input":
                                return this.parseInputObjectTypeDefinition();
                            case "directive":
                                return this.parseDirectiveDefinition();
                        }
                        throw this.unexpected(e);
                    }, t.peekDescription = function() {
                        return this.peek(b.STRING) || this.peek(b.BLOCK_STRING);
                    }, t.parseDescription = function() {
                        if (this.peekDescription()) return this.parseStringLiteral();
                    }, t.parseSchemaDefinition = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("schema");
                        var t = this.parseDirectives(!0), r = this.many(b.BRACE_L, this.parseOperationTypeDefinition, b.BRACE_R);
                        return {
                            kind: m.SCHEMA_DEFINITION,
                            directives: t,
                            operationTypes: r,
                            loc: this.loc(e)
                        };
                    }, t.parseOperationTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseOperationType();
                        this.expectToken(b.COLON);
                        var r = this.parseNamedType();
                        return {
                            kind: m.OPERATION_TYPE_DEFINITION,
                            operation: t,
                            type: r,
                            loc: this.loc(e)
                        };
                    }, t.parseScalarTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("scalar");
                        var r = this.parseName(), n = this.parseDirectives(!0);
                        return {
                            kind: m.SCALAR_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            loc: this.loc(e)
                        };
                    }, t.parseObjectTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("type");
                        var r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseDirectives(!0), o = this.parseFieldsDefinition();
                        return {
                            kind: m.OBJECT_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            interfaces: n,
                            directives: i,
                            fields: o,
                            loc: this.loc(e)
                        };
                    }, t.parseImplementsInterfaces = function() {
                        var e = [];
                        if (this.expectOptionalKeyword("implements")) {
                            this.expectOptionalToken(b.AMP);
                            do e.push(this.parseNamedType());
                            while (this.expectOptionalToken(b.AMP) || this._options.allowLegacySDLImplementsInterfaces && this.peek(b.NAME));
                        }
                        return e;
                    }, t.parseFieldsDefinition = function() {
                        return this._options.allowLegacySDLEmptyFields && this.peek(b.BRACE_L) && this._lexer.lookahead().kind === b.BRACE_R ? (this._lexer.advance(), this._lexer.advance(), []) : this.optionalMany(b.BRACE_L, this.parseFieldDefinition, b.BRACE_R);
                    }, t.parseFieldDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription(), r = this.parseName(), n = this.parseArgumentDefs();
                        this.expectToken(b.COLON);
                        var i = this.parseTypeReference(), o = this.parseDirectives(!0);
                        return {
                            kind: m.FIELD_DEFINITION,
                            description: t,
                            name: r,
                            arguments: n,
                            type: i,
                            directives: o,
                            loc: this.loc(e)
                        };
                    }, t.parseArgumentDefs = function() {
                        return this.optionalMany(b.PAREN_L, this.parseInputValueDef, b.PAREN_R);
                    }, t.parseInputValueDef = function() {
                        var e = this._lexer.token, t = this.parseDescription(), r = this.parseName();
                        this.expectToken(b.COLON);
                        var n, i = this.parseTypeReference();
                        this.expectOptionalToken(b.EQUALS) && (n = this.parseValueLiteral(!0));
                        var o = this.parseDirectives(!0);
                        return {
                            kind: m.INPUT_VALUE_DEFINITION,
                            description: t,
                            name: r,
                            type: i,
                            defaultValue: n,
                            directives: o,
                            loc: this.loc(e)
                        };
                    }, t.parseInterfaceTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("interface");
                        var r = this.parseName(), n = this.parseDirectives(!0), i = this.parseFieldsDefinition();
                        return {
                            kind: m.INTERFACE_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            fields: i,
                            loc: this.loc(e)
                        };
                    }, t.parseUnionTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("union");
                        var r = this.parseName(), n = this.parseDirectives(!0), i = this.parseUnionMemberTypes();
                        return {
                            kind: m.UNION_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            types: i,
                            loc: this.loc(e)
                        };
                    }, t.parseUnionMemberTypes = function() {
                        var e = [];
                        if (this.expectOptionalToken(b.EQUALS)) {
                            this.expectOptionalToken(b.PIPE);
                            do e.push(this.parseNamedType());
                            while (this.expectOptionalToken(b.PIPE));
                        }
                        return e;
                    }, t.parseEnumTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("enum");
                        var r = this.parseName(), n = this.parseDirectives(!0), i = this.parseEnumValuesDefinition();
                        return {
                            kind: m.ENUM_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            values: i,
                            loc: this.loc(e)
                        };
                    }, t.parseEnumValuesDefinition = function() {
                        return this.optionalMany(b.BRACE_L, this.parseEnumValueDefinition, b.BRACE_R);
                    }, t.parseEnumValueDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription(), r = this.parseName(), n = this.parseDirectives(!0);
                        return {
                            kind: m.ENUM_VALUE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            loc: this.loc(e)
                        };
                    }, t.parseInputObjectTypeDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("input");
                        var r = this.parseName(), n = this.parseDirectives(!0), i = this.parseInputFieldsDefinition();
                        return {
                            kind: m.INPUT_OBJECT_TYPE_DEFINITION,
                            description: t,
                            name: r,
                            directives: n,
                            fields: i,
                            loc: this.loc(e)
                        };
                    }, t.parseInputFieldsDefinition = function() {
                        return this.optionalMany(b.BRACE_L, this.parseInputValueDef, b.BRACE_R);
                    }, t.parseTypeSystemExtension = function() {
                        var e = this._lexer.lookahead();
                        if (e.kind === b.NAME) switch(e.value){
                            case "schema":
                                return this.parseSchemaExtension();
                            case "scalar":
                                return this.parseScalarTypeExtension();
                            case "type":
                                return this.parseObjectTypeExtension();
                            case "interface":
                                return this.parseInterfaceTypeExtension();
                            case "union":
                                return this.parseUnionTypeExtension();
                            case "enum":
                                return this.parseEnumTypeExtension();
                            case "input":
                                return this.parseInputObjectTypeExtension();
                        }
                        throw this.unexpected(e);
                    }, t.parseSchemaExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("schema");
                        var t = this.parseDirectives(!0), r = this.optionalMany(b.BRACE_L, this.parseOperationTypeDefinition, b.BRACE_R);
                        if (0 === t.length && 0 === r.length) throw this.unexpected();
                        return {
                            kind: m.SCHEMA_EXTENSION,
                            directives: t,
                            operationTypes: r,
                            loc: this.loc(e)
                        };
                    }, t.parseScalarTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("scalar");
                        var t = this.parseName(), r = this.parseDirectives(!0);
                        if (0 === r.length) throw this.unexpected();
                        return {
                            kind: m.SCALAR_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            loc: this.loc(e)
                        };
                    }, t.parseObjectTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("type");
                        var t = this.parseName(), r = this.parseImplementsInterfaces(), n = this.parseDirectives(!0), i = this.parseFieldsDefinition();
                        if (0 === r.length && 0 === n.length && 0 === i.length) throw this.unexpected();
                        return {
                            kind: m.OBJECT_TYPE_EXTENSION,
                            name: t,
                            interfaces: r,
                            directives: n,
                            fields: i,
                            loc: this.loc(e)
                        };
                    }, t.parseInterfaceTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("interface");
                        var t = this.parseName(), r = this.parseDirectives(!0), n = this.parseFieldsDefinition();
                        if (0 === r.length && 0 === n.length) throw this.unexpected();
                        return {
                            kind: m.INTERFACE_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            fields: n,
                            loc: this.loc(e)
                        };
                    }, t.parseUnionTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("union");
                        var t = this.parseName(), r = this.parseDirectives(!0), n = this.parseUnionMemberTypes();
                        if (0 === r.length && 0 === n.length) throw this.unexpected();
                        return {
                            kind: m.UNION_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            types: n,
                            loc: this.loc(e)
                        };
                    }, t.parseEnumTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("enum");
                        var t = this.parseName(), r = this.parseDirectives(!0), n = this.parseEnumValuesDefinition();
                        if (0 === r.length && 0 === n.length) throw this.unexpected();
                        return {
                            kind: m.ENUM_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            values: n,
                            loc: this.loc(e)
                        };
                    }, t.parseInputObjectTypeExtension = function() {
                        var e = this._lexer.token;
                        this.expectKeyword("extend"), this.expectKeyword("input");
                        var t = this.parseName(), r = this.parseDirectives(!0), n = this.parseInputFieldsDefinition();
                        if (0 === r.length && 0 === n.length) throw this.unexpected();
                        return {
                            kind: m.INPUT_OBJECT_TYPE_EXTENSION,
                            name: t,
                            directives: r,
                            fields: n,
                            loc: this.loc(e)
                        };
                    }, t.parseDirectiveDefinition = function() {
                        var e = this._lexer.token, t = this.parseDescription();
                        this.expectKeyword("directive"), this.expectToken(b.AT);
                        var r = this.parseName(), n = this.parseArgumentDefs(), i = this.expectOptionalKeyword("repeatable");
                        this.expectKeyword("on");
                        var o = this.parseDirectiveLocations();
                        return {
                            kind: m.DIRECTIVE_DEFINITION,
                            description: t,
                            name: r,
                            arguments: n,
                            repeatable: i,
                            locations: o,
                            loc: this.loc(e)
                        };
                    }, t.parseDirectiveLocations = function() {
                        this.expectOptionalToken(b.PIPE);
                        var e = [];
                        do e.push(this.parseDirectiveLocation());
                        while (this.expectOptionalToken(b.PIPE));
                        return e;
                    }, t.parseDirectiveLocation = function() {
                        var e = this._lexer.token, t = this.parseName();
                        if (void 0 !== A[t.value]) return t;
                        throw this.unexpected(e);
                    }, t.loc = function(e) {
                        if (!this._options.noLocation) return new C(e, this._lexer.lastToken, this._lexer.source);
                    }, t.peek = function(e) {
                        return this._lexer.token.kind === e;
                    }, t.expectToken = function(e) {
                        var t = this._lexer.token;
                        if (t.kind === e) return this._lexer.advance(), t;
                        throw v(this._lexer.source, t.start, "Expected ".concat(e, ", found ").concat(k(t)));
                    }, t.expectOptionalToken = function(e) {
                        var t = this._lexer.token;
                        if (t.kind === e) return this._lexer.advance(), t;
                    }, t.expectKeyword = function(e) {
                        var t = this._lexer.token;
                        if (t.kind !== b.NAME || t.value !== e) throw v(this._lexer.source, t.start, 'Expected "'.concat(e, '", found ').concat(k(t)));
                        this._lexer.advance();
                    }, t.expectOptionalKeyword = function(e) {
                        var t = this._lexer.token;
                        return t.kind === b.NAME && t.value === e && (this._lexer.advance(), !0);
                    }, t.unexpected = function(e) {
                        var t = e || this._lexer.token;
                        return v(this._lexer.source, t.start, "Unexpected ".concat(k(t)));
                    }, t.any = function(e, t, r) {
                        this.expectToken(e);
                        for(var n = []; !this.expectOptionalToken(r);)n.push(t.call(this));
                        return n;
                    }, t.optionalMany = function(e, t, r) {
                        if (this.expectOptionalToken(e)) {
                            var n = [];
                            do n.push(t.call(this));
                            while (!this.expectOptionalToken(r));
                            return n;
                        }
                        return [];
                    }, t.many = function(e, t, r) {
                        this.expectToken(e);
                        var n = [];
                        do n.push(t.call(this));
                        while (!this.expectOptionalToken(r));
                        return n;
                    }, e;
                }();
                function C(e, t, r) {
                    this.start = e.start, this.end = t.end, this.startToken = e, this.endToken = t, this.source = r;
                }
                function k(e) {
                    var t = e.value;
                    return t ? "".concat(e.kind, ' "').concat(t, '"') : e.kind;
                }
                s(C, function() {
                    return {
                        start: this.start,
                        end: this.end
                    };
                });
                var M = new Map, P = new Map, D = !0, F = !1;
                function L(e) {
                    return e.replace(/[\s,]+/g, " ").trim();
                }
                function j(e) {
                    var t = new Set, r = [];
                    return e.definitions.forEach(function(e) {
                        if ("FragmentDefinition" === e.kind) {
                            var n = e.name.value, i = L((a = e.loc).source.body.substring(a.start, a.end)), o = P.get(n);
                            o && !o.has(i) ? D && console.warn("Warning: fragment with name " + n + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names") : o || P.set(n, o = new Set), o.add(i), t.has(i) || (t.add(i), r.push(e));
                        } else r.push(e);
                        var a;
                    }), n(n({}, e), {
                        definitions: r
                    });
                }
                function U(e) {
                    var t = L(e);
                    if (!M.has(t)) {
                        var r = function(e, t) {
                            return new N(e, t).parseDocument();
                        }(e, {
                            experimentalFragmentVariables: F,
                            allowLegacyFragmentVariables: F
                        });
                        if (!r || "Document" !== r.kind) throw new Error("Not a valid GraphQL document.");
                        M.set(t, function(e) {
                            var t = new Set(e.definitions);
                            t.forEach(function(e) {
                                e.loc && delete e.loc, Object.keys(e).forEach(function(r) {
                                    var n = e[r];
                                    n && "object" == typeof n && t.add(n);
                                });
                            });
                            var r = e.loc;
                            return r && (delete r.startToken, delete r.endToken), e;
                        }(j(r)));
                    }
                    return M.get(t);
                }
                function B(e) {
                    for(var t = [], r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    "string" == typeof e && (e = [
                        e
                    ]);
                    var n = e[0];
                    return t.forEach(function(t, r) {
                        n += t && "Document" === t.kind ? t.loc.source.body : t, n += e[r + 1];
                    }), U(n);
                }
                function Q() {
                    M.clear(), P.clear();
                }
                function V() {
                    D = !1;
                }
                function q() {
                    F = !0;
                }
                function G() {
                    F = !1;
                }
                var z, W = B, $ = Q, H = V, K = q, Y = G;
                (z = B || (B = {})).gql = W, z.resetCaches = $, z.disableFragmentWarnings = H, z.enableExperimentalFragmentVariables = K, z.disableExperimentalFragmentVariables = Y, B.default = B;
                const X = B;
            },
            5989: function(e, t, r) {
                var n;
                e = r.nmd(e), (function() {
                    "use strict";
                    var i = {
                        function: !0,
                        object: !0
                    }, o = i[typeof window] && window || this, a = i[typeof t] && t && i.object && e && !e.nodeType && e && "object" == typeof r.g && r.g;
                    !a || a.global !== a && a.window !== a && a.self !== a || (o = a);
                    var s = Math.pow(2, 53) - 1, u = /\bOpera/, c = Object.prototype, l = c.hasOwnProperty, f = c.toString;
                    function p(e) {
                        return (e = String(e)).charAt(0).toUpperCase() + e.slice(1);
                    }
                    function d(e) {
                        return e = g(e), /^(?:webOS|i(?:OS|P))/.test(e) ? e : p(e);
                    }
                    function h(e, t) {
                        for(var r in e)l.call(e, r) && t(e[r], r, e);
                    }
                    function v(e) {
                        return null == e ? p(e) : f.call(e).slice(8, -1);
                    }
                    function m(e) {
                        return String(e).replace(/([ -])(?!$)/g, "$1?");
                    }
                    function y(e, t) {
                        var r = null;
                        return function(e, t) {
                            var r = -1, n = e ? e.length : 0;
                            if ("number" == typeof n && n > -1 && n <= s) for(; ++r < n;)t(e[r], r, e);
                            else h(e, t);
                        }(e, function(n, i) {
                            r = t(r, n, i, e);
                        }), r;
                    }
                    function g(e) {
                        return String(e).replace(/^ +| +$/g, "");
                    }
                    var E = function e(t) {
                        var r = o, n = t && "object" == typeof t && "String" != v(t);
                        n && (r = t, t = null);
                        var i = r.navigator || {}, a = i.userAgent || "";
                        t || (t = a);
                        var s, c, l, p, E, b = n ? !!i.likeChrome : /\bChrome\b/.test(t) && !/internal|\n/i.test(f.toString()), S = "Object", _ = n ? S : "ScriptBridgingProxyObject", O = n ? S : "Environment", w = n && r.java ? "JavaPackage" : v(r.java), T = n ? S : "RuntimeObject", I = /\bJava/.test(w) && r.java, R = I && v(r.environment) == O, x = I ? "a" : "\u03B1", A = I ? "b" : "\u03B2", N = r.document || {}, C = r.operamini || r.opera, k = u.test(k = n && C ? C["[[Class]]"] : v(C)) ? k : C = null, M = t, P = [], D = null, F = t == a, L = F && C && "function" == typeof C.version && C.version(), j = y([
                            {
                                label: "EdgeHTML",
                                pattern: "Edge"
                            },
                            "Trident",
                            {
                                label: "WebKit",
                                pattern: "AppleWebKit"
                            },
                            "iCab",
                            "Presto",
                            "NetFront",
                            "Tasman",
                            "KHTML",
                            "Gecko"
                        ], function(e, r) {
                            return e || RegExp("\\b" + (r.pattern || m(r)) + "\\b", "i").exec(t) && (r.label || r);
                        }), U = function(e) {
                            return y(e, function(e, r) {
                                return e || RegExp("\\b" + (r.pattern || m(r)) + "\\b", "i").exec(t) && (r.label || r);
                            });
                        }([
                            "Adobe AIR",
                            "Arora",
                            "Avant Browser",
                            "Breach",
                            "Camino",
                            "Electron",
                            "Epiphany",
                            "Fennec",
                            "Flock",
                            "Galeon",
                            "GreenBrowser",
                            "iCab",
                            "Iceweasel",
                            "K-Meleon",
                            "Konqueror",
                            "Lunascape",
                            "Maxthon",
                            {
                                label: "Microsoft Edge",
                                pattern: "(?:Edge|Edg|EdgA|EdgiOS)"
                            },
                            "Midori",
                            "Nook Browser",
                            "PaleMoon",
                            "PhantomJS",
                            "Raven",
                            "Rekonq",
                            "RockMelt",
                            {
                                label: "Samsung Internet",
                                pattern: "SamsungBrowser"
                            },
                            "SeaMonkey",
                            {
                                label: "Silk",
                                pattern: "(?:Cloud9|Silk-Accelerated)"
                            },
                            "Sleipnir",
                            "SlimBrowser",
                            {
                                label: "SRWare Iron",
                                pattern: "Iron"
                            },
                            "Sunrise",
                            "Swiftfox",
                            "Vivaldi",
                            "Waterfox",
                            "WebPositive",
                            {
                                label: "Yandex Browser",
                                pattern: "YaBrowser"
                            },
                            {
                                label: "UC Browser",
                                pattern: "UCBrowser"
                            },
                            "Opera Mini",
                            {
                                label: "Opera Mini",
                                pattern: "OPiOS"
                            },
                            "Opera",
                            {
                                label: "Opera",
                                pattern: "OPR"
                            },
                            "Chromium",
                            "Chrome",
                            {
                                label: "Chrome",
                                pattern: "(?:HeadlessChrome)"
                            },
                            {
                                label: "Chrome Mobile",
                                pattern: "(?:CriOS|CrMo)"
                            },
                            {
                                label: "Firefox",
                                pattern: "(?:Firefox|Minefield)"
                            },
                            {
                                label: "Firefox for iOS",
                                pattern: "FxiOS"
                            },
                            {
                                label: "IE",
                                pattern: "IEMobile"
                            },
                            {
                                label: "IE",
                                pattern: "MSIE"
                            },
                            "Safari"
                        ]), B = q([
                            {
                                label: "BlackBerry",
                                pattern: "BB10"
                            },
                            "BlackBerry",
                            {
                                label: "Galaxy S",
                                pattern: "GT-I9000"
                            },
                            {
                                label: "Galaxy S2",
                                pattern: "GT-I9100"
                            },
                            {
                                label: "Galaxy S3",
                                pattern: "GT-I9300"
                            },
                            {
                                label: "Galaxy S4",
                                pattern: "GT-I9500"
                            },
                            {
                                label: "Galaxy S5",
                                pattern: "SM-G900"
                            },
                            {
                                label: "Galaxy S6",
                                pattern: "SM-G920"
                            },
                            {
                                label: "Galaxy S6 Edge",
                                pattern: "SM-G925"
                            },
                            {
                                label: "Galaxy S7",
                                pattern: "SM-G930"
                            },
                            {
                                label: "Galaxy S7 Edge",
                                pattern: "SM-G935"
                            },
                            "Google TV",
                            "Lumia",
                            "iPad",
                            "iPod",
                            "iPhone",
                            "Kindle",
                            {
                                label: "Kindle Fire",
                                pattern: "(?:Cloud9|Silk-Accelerated)"
                            },
                            "Nexus",
                            "Nook",
                            "PlayBook",
                            "PlayStation Vita",
                            "PlayStation",
                            "TouchPad",
                            "Transformer",
                            {
                                label: "Wii U",
                                pattern: "WiiU"
                            },
                            "Wii",
                            "Xbox One",
                            {
                                label: "Xbox 360",
                                pattern: "Xbox"
                            },
                            "Xoom"
                        ]), Q = function(e) {
                            return y(e, function(e, r, n) {
                                return e || (r[B] || r[/^[a-z]+(?: +[a-z]+\b)*/i.exec(B)] || RegExp("\\b" + m(n) + "(?:\\b|\\w*\\d)", "i").exec(t)) && n;
                            });
                        }({
                            Apple: {
                                iPad: 1,
                                iPhone: 1,
                                iPod: 1
                            },
                            Alcatel: {},
                            Archos: {},
                            Amazon: {
                                Kindle: 1,
                                "Kindle Fire": 1
                            },
                            Asus: {
                                Transformer: 1
                            },
                            "Barnes & Noble": {
                                Nook: 1
                            },
                            BlackBerry: {
                                PlayBook: 1
                            },
                            Google: {
                                "Google TV": 1,
                                Nexus: 1
                            },
                            HP: {
                                TouchPad: 1
                            },
                            HTC: {},
                            Huawei: {},
                            Lenovo: {},
                            LG: {},
                            Microsoft: {
                                Xbox: 1,
                                "Xbox One": 1
                            },
                            Motorola: {
                                Xoom: 1
                            },
                            Nintendo: {
                                "Wii U": 1,
                                Wii: 1
                            },
                            Nokia: {
                                Lumia: 1
                            },
                            Oppo: {},
                            Samsung: {
                                "Galaxy S": 1,
                                "Galaxy S2": 1,
                                "Galaxy S3": 1,
                                "Galaxy S4": 1
                            },
                            Sony: {
                                PlayStation: 1,
                                "PlayStation Vita": 1
                            },
                            Xiaomi: {
                                Mi: 1,
                                Redmi: 1
                            }
                        }), V = function(e) {
                            return y(e, function(e, r) {
                                var n = r.pattern || m(r);
                                return !e && (e = RegExp("\\b" + n + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(t)) && (e = function(e, t, r) {
                                    var n = {
                                        "10.0": "10",
                                        6.4: "10 Technical Preview",
                                        6.3: "8.1",
                                        6.2: "8",
                                        6.1: "Server 2008 R2 / 7",
                                        "6.0": "Server 2008 / Vista",
                                        5.2: "Server 2003 / XP 64-bit",
                                        5.1: "XP",
                                        5.01: "2000 SP1",
                                        "5.0": "2000",
                                        "4.0": "NT",
                                        "4.90": "ME"
                                    };
                                    return t && r && /^Win/i.test(e) && !/^Windows Phone /i.test(e) && (n = n[/[\d.]+$/.exec(e)]) && (e = "Windows " + n), e = String(e), t && r && (e = e.replace(RegExp(t, "i"), r)), d(e.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]);
                                }(e, n, r.label || r)), e;
                            });
                        }([
                            "Windows Phone",
                            "KaiOS",
                            "Android",
                            "CentOS",
                            {
                                label: "Chrome OS",
                                pattern: "CrOS"
                            },
                            "Debian",
                            {
                                label: "DragonFly BSD",
                                pattern: "DragonFly"
                            },
                            "Fedora",
                            "FreeBSD",
                            "Gentoo",
                            "Haiku",
                            "Kubuntu",
                            "Linux Mint",
                            "OpenBSD",
                            "Red Hat",
                            "SuSE",
                            "Ubuntu",
                            "Xubuntu",
                            "Cygwin",
                            "Symbian OS",
                            "hpwOS",
                            "webOS ",
                            "webOS",
                            "Tablet OS",
                            "Tizen",
                            "Linux",
                            "Mac OS X",
                            "Macintosh",
                            "Mac",
                            "Windows 98;",
                            "Windows "
                        ]);
                        function q(e) {
                            return y(e, function(e, r) {
                                var n = r.pattern || m(r);
                                return !e && (e = RegExp("\\b" + n + " *\\d+[.\\w_]*", "i").exec(t) || RegExp("\\b" + n + " *\\w+-[\\w]*", "i").exec(t) || RegExp("\\b" + n + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(t)) && ((e = String(r.label && !RegExp(n, "i").test(r.label) ? r.label : e).split("/"))[1] && !/[\d.]+/.test(e[0]) && (e[0] += " " + e[1]), r = r.label || r, e = d(e[0].replace(RegExp(n, "i"), r).replace(RegExp("; *(?:" + r + "[_-])?", "i"), " ").replace(RegExp("(" + r + ")[-_.]?(\\w)", "i"), "$1 $2"))), e;
                            });
                        }
                        function G(e) {
                            return y(e, function(e, r) {
                                return e || (RegExp(r + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(t) || 0)[1] || null;
                            });
                        }
                        if (j && (j = [
                            j
                        ]), /\bAndroid\b/.test(V) && !B && (s = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(t)) && (B = g(s[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), Q && !B ? B = q([
                            Q
                        ]) : Q && B && (B = B.replace(RegExp("^(" + m(Q) + ")[-_.\\s]", "i"), Q + " ").replace(RegExp("^(" + m(Q) + ")[-_.]?(\\w)", "i"), Q + " $2")), (s = /\bGoogle TV\b/.exec(B)) && (B = s[0]), /\bSimulator\b/i.test(t) && (B = (B ? B + " " : "") + "Simulator"), "Opera Mini" == U && /\bOPiOS\b/.test(t) && P.push("running in Turbo/Uncompressed mode"), "IE" == U && /\blike iPhone OS\b/.test(t) ? (Q = (s = e(t.replace(/like iPhone OS/, ""))).manufacturer, B = s.product) : /^iP/.test(B) ? (U || (U = "Safari"), V = "iOS" + ((s = / OS ([\d_]+)/i.exec(t)) ? " " + s[1].replace(/_/g, ".") : "")) : "Konqueror" == U && /^Linux\b/i.test(V) ? V = "Kubuntu" : Q && "Google" != Q && (/Chrome/.test(U) && !/\bMobile Safari\b/i.test(t) || /\bVita\b/.test(B)) || /\bAndroid\b/.test(V) && /^Chrome/.test(U) && /\bVersion\//i.test(t) ? (U = "Android Browser", V = /\bAndroid\b/.test(V) ? V : "Android") : "Silk" == U ? (/\bMobi/i.test(t) || (V = "Android", P.unshift("desktop mode")), /Accelerated *= *true/i.test(t) && P.unshift("accelerated")) : "UC Browser" == U && /\bUCWEB\b/.test(t) ? P.push("speed mode") : "PaleMoon" == U && (s = /\bFirefox\/([\d.]+)\b/.exec(t)) ? P.push("identifying as Firefox " + s[1]) : "Firefox" == U && (s = /\b(Mobile|Tablet|TV)\b/i.exec(t)) ? (V || (V = "Firefox OS"), B || (B = s[1])) : !U || (s = !/\bMinefield\b/i.test(t) && /\b(?:Firefox|Safari)\b/.exec(U)) ? (U && !B && /[\/,]|^[^(]+?\)/.test(t.slice(t.indexOf(s + "/") + 8)) && (U = null), (s = B || Q || V) && (B || Q || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(V)) && (U = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(V) ? V : s) + " Browser")) : "Electron" == U && (s = (/\bChrome\/([\d.]+)\b/.exec(t) || 0)[1]) && P.push("Chromium " + s), L || (L = G([
                            "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
                            "Version",
                            m(U),
                            "(?:Firefox|Minefield|NetFront)"
                        ])), (s = ("iCab" == j && parseFloat(L) > 3 ? "WebKit" : /\bOpera\b/.test(U) && (/\bOPR\b/.test(t) ? "Blink" : "Presto")) || /\b(?:Midori|Nook|Safari)\b/i.test(t) && !/^(?:Trident|EdgeHTML)$/.test(j) && "WebKit" || !j && /\bMSIE\b/i.test(t) && ("Mac OS" == V ? "Tasman" : "Trident") || "WebKit" == j && /\bPlayStation\b(?! Vita\b)/i.test(U) && "NetFront") && (j = [
                            s
                        ]), "IE" == U && (s = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(t) || 0)[1]) ? (U += " Mobile", V = "Windows Phone " + (/\+$/.test(s) ? s : s + ".x"), P.unshift("desktop mode")) : /\bWPDesktop\b/i.test(t) ? (U = "IE Mobile", V = "Windows Phone 8.x", P.unshift("desktop mode"), L || (L = (/\brv:([\d.]+)/.exec(t) || 0)[1])) : "IE" != U && "Trident" == j && (s = /\brv:([\d.]+)/.exec(t)) && (U && P.push("identifying as " + U + (L ? " " + L : "")), U = "IE", L = s[1]), F) {
                            if (p = "global", /^(?:boolean|number|string|undefined)$/.test(E = null != (l = r) ? typeof l[p] : "number") || "object" == E && !l[p]) v(s = r.runtime) == _ ? (U = "Adobe AIR", V = s.flash.system.Capabilities.os) : v(s = r.phantom) == T ? (U = "PhantomJS", L = (s = s.version || null) && s.major + "." + s.minor + "." + s.patch) : "number" == typeof N.documentMode && (s = /\bTrident\/(\d+)/i.exec(t)) ? ((s = +s[1] + 4) != (L = [
                                L,
                                N.documentMode
                            ])[1] && (P.push("IE " + L[1] + " mode"), j && (j[1] = ""), L[1] = s), L = "IE" == U ? String(L[1].toFixed(1)) : L[0]) : "number" == typeof N.documentMode && /^(?:Chrome|Firefox)\b/.test(U) && (P.push("masking as " + U + " " + L), U = "IE", L = "11.0", j = [
                                "Trident"
                            ], V = "Windows");
                            else if (I && (M = (s = I.lang.System).getProperty("os.arch"), V = V || s.getProperty("os.name") + " " + s.getProperty("os.version")), R) {
                                try {
                                    L = r.require("ringo/engine").version.join("."), U = "RingoJS";
                                } catch (e) {
                                    (s = r.system) && s.global.system == r.system && (U = "Narwhal", V || (V = s[0].os || null));
                                }
                                U || (U = "Rhino");
                            } else "object" == typeof r.process && !r.process.browser && (s = r.process) && ("object" == typeof s.versions && ("string" == typeof s.versions.electron ? (P.push("Node " + s.versions.node), U = "Electron", L = s.versions.electron) : "string" == typeof s.versions.nw && (P.push("Chromium " + L, "Node " + s.versions.node), U = "NW.js", L = s.versions.nw)), U || (U = "Node.js", M = s.arch, V = s.platform, L = (L = /[\d.]+/.exec(s.version)) ? L[0] : null));
                            V = V && d(V);
                        }
                        if (L && (s = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(L) || /(?:alpha|beta)(?: ?\d)?/i.exec(t + ";" + (F && i.appMinorVersion)) || /\bMinefield\b/i.test(t) && "a") && (D = /b/i.test(s) ? "beta" : "alpha", L = L.replace(RegExp(s + "\\+?$"), "") + ("beta" == D ? A : x) + (/\d+\+?/.exec(s) || "")), "Fennec" == U || "Firefox" == U && /\b(?:Android|Firefox OS|KaiOS)\b/.test(V)) U = "Firefox Mobile";
                        else if ("Maxthon" == U && L) L = L.replace(/\.[\d.]+/, ".x");
                        else if (/\bXbox\b/i.test(B)) "Xbox 360" == B && (V = null), "Xbox 360" == B && /\bIEMobile\b/.test(t) && P.unshift("mobile mode");
                        else if (!/^(?:Chrome|IE|Opera)$/.test(U) && (!U || B || /Browser|Mobi/.test(U)) || "Windows CE" != V && !/Mobi/i.test(t)) {
                            if ("IE" == U && F) try {
                                null === r.external && P.unshift("platform preview");
                            } catch (e) {
                                P.unshift("embedded");
                            }
                            else (/\bBlackBerry\b/.test(B) || /\bBB10\b/.test(t)) && (s = (RegExp(B.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(t) || 0)[1] || L) ? (V = ((s = [
                                s,
                                /BB10/.test(t)
                            ])[1] ? (B = null, Q = "BlackBerry") : "Device Software") + " " + s[0], L = null) : this != h && "Wii" != B && (F && C || /Opera/.test(U) && /\b(?:MSIE|Firefox)\b/i.test(t) || "Firefox" == U && /\bOS X (?:\d+\.){2,}/.test(V) || "IE" == U && (V && !/^Win/.test(V) && L > 5.5 || /\bWindows XP\b/.test(V) && L > 8 || 8 == L && !/\bTrident\b/.test(t))) && !u.test(s = e.call(h, t.replace(u, "") + ";")) && s.name && (s = "ing as " + s.name + ((s = s.version) ? " " + s : ""), u.test(U) ? (/\bIE\b/.test(s) && "Mac OS" == V && (V = null), s = "identify" + s) : (s = "mask" + s, U = k ? d(k.replace(/([a-z])([A-Z])/g, "$1 $2")) : "Opera", /\bIE\b/.test(s) && (V = null), F || (L = null)), j = [
                                "Presto"
                            ], P.push(s));
                        } else U += " Mobile";
                        (s = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(t) || 0)[1]) && (s = [
                            parseFloat(s.replace(/\.(\d)$/, ".0$1")),
                            s
                        ], "Safari" == U && "+" == s[1].slice(-1) ? (U = "WebKit Nightly", D = "alpha", L = s[1].slice(0, -1)) : L != s[1] && L != (s[2] = (/\bSafari\/([\d.]+\+?)/i.exec(t) || 0)[1]) || (L = null), s[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(t) || 0)[1], 537.36 == s[0] && 537.36 == s[2] && parseFloat(s[1]) >= 28 && "WebKit" == j && (j = [
                            "Blink"
                        ]), F && (b || s[1]) ? (j && (j[1] = "like Chrome"), s = s[1] || ((s = s[0]) < 530 ? 1 : s < 532 ? 2 : s < 532.05 ? 3 : s < 533 ? 4 : s < 534.03 ? 5 : s < 534.07 ? 6 : s < 534.1 ? 7 : s < 534.13 ? 8 : s < 534.16 ? 9 : s < 534.24 ? 10 : s < 534.3 ? 11 : s < 535.01 ? 12 : s < 535.02 ? "13+" : s < 535.07 ? 15 : s < 535.11 ? 16 : s < 535.19 ? 17 : s < 536.05 ? 18 : s < 536.1 ? 19 : s < 537.01 ? 20 : s < 537.11 ? "21+" : s < 537.13 ? 23 : s < 537.18 ? 24 : s < 537.24 ? 25 : s < 537.36 ? 26 : "Blink" != j ? "27" : "28")) : (j && (j[1] = "like Safari"), s = (s = s[0]) < 400 ? 1 : s < 500 ? 2 : s < 526 ? 3 : s < 533 ? 4 : s < 534 ? "4+" : s < 535 ? 5 : s < 537 ? 6 : s < 538 ? 7 : s < 601 ? 8 : s < 602 ? 9 : s < 604 ? 10 : s < 606 ? 11 : s < 608 ? 12 : "12"), j && (j[1] += " " + (s += "number" == typeof s ? ".x" : /[.+]/.test(s) ? "" : "+")), "Safari" == U && (!L || parseInt(L) > 45) ? L = s : "Chrome" == U && /\bHeadlessChrome/i.test(t) && P.unshift("headless")), "Opera" == U && (s = /\bzbov|zvav$/.exec(V)) ? (U += " ", P.unshift("desktop mode"), "zvav" == s ? (U += "Mini", L = null) : U += "Mobile", V = V.replace(RegExp(" *" + s + "$"), "")) : "Safari" == U && /\bChrome\b/.exec(j && j[1]) ? (P.unshift("desktop mode"), U = "Chrome Mobile", L = null, /\bOS X\b/.test(V) ? (Q = "Apple", V = "iOS 4.3+") : V = null) : /\bSRWare Iron\b/.test(U) && !L && (L = G("Chrome")), L && 0 == L.indexOf(s = /[\d.]+$/.exec(V)) && t.indexOf("/" + s + "-") > -1 && (V = g(V.replace(s, ""))), V && -1 != V.indexOf(U) && !RegExp(U + " OS").test(V) && (V = V.replace(RegExp(" *" + m(U) + " *"), "")), j && !/\b(?:Avant|Nook)\b/.test(U) && (/Browser|Lunascape|Maxthon/.test(U) || "Safari" != U && /^iOS/.test(V) && /\bSafari\b/.test(j[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(U) && j[1]) && (s = j[j.length - 1]) && P.push(s), P.length && (P = [
                            "(" + P.join("; ") + ")"
                        ]), Q && B && B.indexOf(Q) < 0 && P.push("on " + Q), B && P.push((/^on /.test(P[P.length - 1]) ? "" : "on ") + B), V && (s = / ([\d.+]+)$/.exec(V), c = s && "/" == V.charAt(V.length - s[0].length - 1), V = {
                            architecture: 32,
                            family: s && !c ? V.replace(s[0], "") : V,
                            version: s ? s[1] : null,
                            toString: function() {
                                var e = this.version;
                                return this.family + (e && !c ? " " + e : "") + (64 == this.architecture ? " 64-bit" : "");
                            }
                        }), (s = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(M)) && !/\bi686\b/i.test(M) ? (V && (V.architecture = 64, V.family = V.family.replace(RegExp(" *" + s), "")), U && (/\bWOW64\b/i.test(t) || F && /\w(?:86|32)$/.test(i.cpuClass || i.platform) && !/\bWin64; x64\b/i.test(t)) && P.unshift("32-bit")) : V && /^OS X/.test(V.family) && "Chrome" == U && parseFloat(L) >= 39 && (V.architecture = 64), t || (t = null);
                        var z = {};
                        return z.description = t, z.layout = j && j[0], z.manufacturer = Q, z.name = U, z.prerelease = D, z.product = B, z.ua = t, z.version = U && L, z.os = V || {
                            architecture: null,
                            family: null,
                            version: null,
                            toString: function() {
                                return "null";
                            }
                        }, z.parse = e, z.toString = function() {
                            return this.description || "";
                        }, z.version && P.unshift(L), z.name && P.unshift(U), V && U && (V != String(V).split(" ")[0] || V != U.split(" ")[0] && !B) && P.push(B ? "(" + V + ")" : "on " + V), P.length && (z.description = P.join(" ")), z;
                    }();
                    o.platform = E, void 0 === (n = (function() {
                        return E;
                    }).call(t, r, t, e)) || (e.exports = n);
                }).call(this);
            },
            6160: (e, t)=>{
                var r;
                t = e.exports = y, r = function() {}, t.SEMVER_SPEC_VERSION = "2.0.0";
                var n = 256, i = Number.MAX_SAFE_INTEGER || 9007199254740991, o = n - 6, a = t.re = [], s = t.safeRe = [], u = t.src = [], c = t.tokens = {}, l = 0;
                function f(e) {
                    c[e] = l++;
                }
                var p = "[a-zA-Z0-9-]", d = [
                    [
                        "\\s",
                        1
                    ],
                    [
                        "\\d",
                        n
                    ],
                    [
                        p,
                        o
                    ]
                ];
                function h(e) {
                    for(var t = 0; t < d.length; t++){
                        var r = d[t][0], n = d[t][1];
                        e = e.split(r + "*").join(r + "{0," + n + "}").split(r + "+").join(r + "{1," + n + "}");
                    }
                    return e;
                }
                f("NUMERICIDENTIFIER"), u[c.NUMERICIDENTIFIER] = "0|[1-9]\\d*", f("NUMERICIDENTIFIERLOOSE"), u[c.NUMERICIDENTIFIERLOOSE] = "\\d+", f("NONNUMERICIDENTIFIER"), u[c.NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-]" + p + "*", f("MAINVERSION"), u[c.MAINVERSION] = "(" + u[c.NUMERICIDENTIFIER] + ")\\.(" + u[c.NUMERICIDENTIFIER] + ")\\.(" + u[c.NUMERICIDENTIFIER] + ")", f("MAINVERSIONLOOSE"), u[c.MAINVERSIONLOOSE] = "(" + u[c.NUMERICIDENTIFIERLOOSE] + ")\\.(" + u[c.NUMERICIDENTIFIERLOOSE] + ")\\.(" + u[c.NUMERICIDENTIFIERLOOSE] + ")", f("PRERELEASEIDENTIFIER"), u[c.PRERELEASEIDENTIFIER] = "(?:" + u[c.NUMERICIDENTIFIER] + "|" + u[c.NONNUMERICIDENTIFIER] + ")", f("PRERELEASEIDENTIFIERLOOSE"), u[c.PRERELEASEIDENTIFIERLOOSE] = "(?:" + u[c.NUMERICIDENTIFIERLOOSE] + "|" + u[c.NONNUMERICIDENTIFIER] + ")", f("PRERELEASE"), u[c.PRERELEASE] = "(?:-(" + u[c.PRERELEASEIDENTIFIER] + "(?:\\." + u[c.PRERELEASEIDENTIFIER] + ")*))", f("PRERELEASELOOSE"), u[c.PRERELEASELOOSE] = "(?:-?(" + u[c.PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + u[c.PRERELEASEIDENTIFIERLOOSE] + ")*))", f("BUILDIDENTIFIER"), u[c.BUILDIDENTIFIER] = p + "+", f("BUILD"), u[c.BUILD] = "(?:\\+(" + u[c.BUILDIDENTIFIER] + "(?:\\." + u[c.BUILDIDENTIFIER] + ")*))", f("FULL"), f("FULLPLAIN"), u[c.FULLPLAIN] = "v?" + u[c.MAINVERSION] + u[c.PRERELEASE] + "?" + u[c.BUILD] + "?", u[c.FULL] = "^" + u[c.FULLPLAIN] + "$", f("LOOSEPLAIN"), u[c.LOOSEPLAIN] = "[v=\\s]*" + u[c.MAINVERSIONLOOSE] + u[c.PRERELEASELOOSE] + "?" + u[c.BUILD] + "?", f("LOOSE"), u[c.LOOSE] = "^" + u[c.LOOSEPLAIN] + "$", f("GTLT"), u[c.GTLT] = "((?:<|>)?=?)", f("XRANGEIDENTIFIERLOOSE"), u[c.XRANGEIDENTIFIERLOOSE] = u[c.NUMERICIDENTIFIERLOOSE] + "|x|X|\\*", f("XRANGEIDENTIFIER"), u[c.XRANGEIDENTIFIER] = u[c.NUMERICIDENTIFIER] + "|x|X|\\*", f("XRANGEPLAIN"), u[c.XRANGEPLAIN] = "[v=\\s]*(" + u[c.XRANGEIDENTIFIER] + ")(?:\\.(" + u[c.XRANGEIDENTIFIER] + ")(?:\\.(" + u[c.XRANGEIDENTIFIER] + ")(?:" + u[c.PRERELEASE] + ")?" + u[c.BUILD] + "?)?)?", f("XRANGEPLAINLOOSE"), u[c.XRANGEPLAINLOOSE] = "[v=\\s]*(" + u[c.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + u[c.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + u[c.XRANGEIDENTIFIERLOOSE] + ")(?:" + u[c.PRERELEASELOOSE] + ")?" + u[c.BUILD] + "?)?)?", f("XRANGE"), u[c.XRANGE] = "^" + u[c.GTLT] + "\\s*" + u[c.XRANGEPLAIN] + "$", f("XRANGELOOSE"), u[c.XRANGELOOSE] = "^" + u[c.GTLT] + "\\s*" + u[c.XRANGEPLAINLOOSE] + "$", f("COERCE"), u[c.COERCE] = "(^|[^\\d])(\\d{1,16})(?:\\.(\\d{1,16}))?(?:\\.(\\d{1,16}))?(?:$|[^\\d])", f("COERCERTL"), a[c.COERCERTL] = new RegExp(u[c.COERCE], "g"), s[c.COERCERTL] = new RegExp(h(u[c.COERCE]), "g"), f("LONETILDE"), u[c.LONETILDE] = "(?:~>?)", f("TILDETRIM"), u[c.TILDETRIM] = "(\\s*)" + u[c.LONETILDE] + "\\s+", a[c.TILDETRIM] = new RegExp(u[c.TILDETRIM], "g"), s[c.TILDETRIM] = new RegExp(h(u[c.TILDETRIM]), "g");
                f("TILDE"), u[c.TILDE] = "^" + u[c.LONETILDE] + u[c.XRANGEPLAIN] + "$", f("TILDELOOSE"), u[c.TILDELOOSE] = "^" + u[c.LONETILDE] + u[c.XRANGEPLAINLOOSE] + "$", f("LONECARET"), u[c.LONECARET] = "(?:\\^)", f("CARETTRIM"), u[c.CARETTRIM] = "(\\s*)" + u[c.LONECARET] + "\\s+", a[c.CARETTRIM] = new RegExp(u[c.CARETTRIM], "g"), s[c.CARETTRIM] = new RegExp(h(u[c.CARETTRIM]), "g");
                f("CARET"), u[c.CARET] = "^" + u[c.LONECARET] + u[c.XRANGEPLAIN] + "$", f("CARETLOOSE"), u[c.CARETLOOSE] = "^" + u[c.LONECARET] + u[c.XRANGEPLAINLOOSE] + "$", f("COMPARATORLOOSE"), u[c.COMPARATORLOOSE] = "^" + u[c.GTLT] + "\\s*(" + u[c.LOOSEPLAIN] + ")$|^$", f("COMPARATOR"), u[c.COMPARATOR] = "^" + u[c.GTLT] + "\\s*(" + u[c.FULLPLAIN] + ")$|^$", f("COMPARATORTRIM"), u[c.COMPARATORTRIM] = "(\\s*)" + u[c.GTLT] + "\\s*(" + u[c.LOOSEPLAIN] + "|" + u[c.XRANGEPLAIN] + ")", a[c.COMPARATORTRIM] = new RegExp(u[c.COMPARATORTRIM], "g"), s[c.COMPARATORTRIM] = new RegExp(h(u[c.COMPARATORTRIM]), "g");
                f("HYPHENRANGE"), u[c.HYPHENRANGE] = "^\\s*(" + u[c.XRANGEPLAIN] + ")\\s+-\\s+(" + u[c.XRANGEPLAIN] + ")\\s*$", f("HYPHENRANGELOOSE"), u[c.HYPHENRANGELOOSE] = "^\\s*(" + u[c.XRANGEPLAINLOOSE] + ")\\s+-\\s+(" + u[c.XRANGEPLAINLOOSE] + ")\\s*$", f("STAR"), u[c.STAR] = "(<|>)?=?\\s*\\*";
                for(var v = 0; v < l; v++)r(v, u[v]), a[v] || (a[v] = new RegExp(u[v]), s[v] = new RegExp(h(u[v])));
                function m(e, t) {
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), e instanceof y) return e;
                    if ("string" != typeof e) return null;
                    if (e.length > n) return null;
                    if (!(t.loose ? s[c.LOOSE] : s[c.FULL]).test(e)) return null;
                    try {
                        return new y(e, t);
                    } catch (e) {
                        return null;
                    }
                }
                function y(e, t) {
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), e instanceof y) {
                        if (e.loose === t.loose) return e;
                        e = e.version;
                    } else if ("string" != typeof e) throw new TypeError("Invalid Version: " + e);
                    if (e.length > n) throw new TypeError("version is longer than " + n + " characters");
                    if (!(this instanceof y)) return new y(e, t);
                    r("SemVer", e, t), this.options = t, this.loose = !!t.loose;
                    var o = e.trim().match(t.loose ? s[c.LOOSE] : s[c.FULL]);
                    if (!o) throw new TypeError("Invalid Version: " + e);
                    if (this.raw = e, this.major = +o[1], this.minor = +o[2], this.patch = +o[3], this.major > i || this.major < 0) throw new TypeError("Invalid major version");
                    if (this.minor > i || this.minor < 0) throw new TypeError("Invalid minor version");
                    if (this.patch > i || this.patch < 0) throw new TypeError("Invalid patch version");
                    this.prerelease = o[4] ? o[4].split(".").map(function(e) {
                        if (/^[0-9]+$/.test(e)) {
                            var t = +e;
                            if (t >= 0 && t < i) return t;
                        }
                        return e;
                    }) : [], this.build = o[5] ? o[5].split(".") : [], this.format();
                }
                t.parse = m, t.valid = function(e, t) {
                    var r = m(e, t);
                    return r ? r.version : null;
                }, t.clean = function(e, t) {
                    var r = m(e.trim().replace(/^[=v]+/, ""), t);
                    return r ? r.version : null;
                }, t.SemVer = y, y.prototype.format = function() {
                    return this.version = this.major + "." + this.minor + "." + this.patch, this.prerelease.length && (this.version += "-" + this.prerelease.join(".")), this.version;
                }, y.prototype.toString = function() {
                    return this.version;
                }, y.prototype.compare = function(e) {
                    return r("SemVer.compare", this.version, this.options, e), e instanceof y || (e = new y(e, this.options)), this.compareMain(e) || this.comparePre(e);
                }, y.prototype.compareMain = function(e) {
                    return e instanceof y || (e = new y(e, this.options)), E(this.major, e.major) || E(this.minor, e.minor) || E(this.patch, e.patch);
                }, y.prototype.comparePre = function(e) {
                    if (e instanceof y || (e = new y(e, this.options)), this.prerelease.length && !e.prerelease.length) return -1;
                    if (!this.prerelease.length && e.prerelease.length) return 1;
                    if (!this.prerelease.length && !e.prerelease.length) return 0;
                    var t = 0;
                    do {
                        var n = this.prerelease[t], i = e.prerelease[t];
                        if (r("prerelease compare", t, n, i), void 0 === n && void 0 === i) return 0;
                        if (void 0 === i) return 1;
                        if (void 0 === n) return -1;
                        if (n !== i) return E(n, i);
                    }while (++t);
                }, y.prototype.compareBuild = function(e) {
                    e instanceof y || (e = new y(e, this.options));
                    var t = 0;
                    do {
                        var n = this.build[t], i = e.build[t];
                        if (r("prerelease compare", t, n, i), void 0 === n && void 0 === i) return 0;
                        if (void 0 === i) return 1;
                        if (void 0 === n) return -1;
                        if (n !== i) return E(n, i);
                    }while (++t);
                }, y.prototype.inc = function(e, t) {
                    switch(e){
                        case "premajor":
                            this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t);
                            break;
                        case "preminor":
                            this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t);
                            break;
                        case "prepatch":
                            this.prerelease.length = 0, this.inc("patch", t), this.inc("pre", t);
                            break;
                        case "prerelease":
                            0 === this.prerelease.length && this.inc("patch", t), this.inc("pre", t);
                            break;
                        case "major":
                            0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                            break;
                        case "minor":
                            0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
                            break;
                        case "patch":
                            0 === this.prerelease.length && this.patch++, this.prerelease = [];
                            break;
                        case "pre":
                            if (0 === this.prerelease.length) this.prerelease = [
                                0
                            ];
                            else {
                                for(var r = this.prerelease.length; --r >= 0;)"number" == typeof this.prerelease[r] && (this.prerelease[r]++, r = -2);
                                -1 === r && this.prerelease.push(0);
                            }
                            t && (this.prerelease[0] === t ? isNaN(this.prerelease[1]) && (this.prerelease = [
                                t,
                                0
                            ]) : this.prerelease = [
                                t,
                                0
                            ]);
                            break;
                        default:
                            throw new Error("invalid increment argument: " + e);
                    }
                    return this.format(), this.raw = this.version, this;
                }, t.inc = function(e, t, r, n) {
                    "string" == typeof r && (n = r, r = void 0);
                    try {
                        return new y(e, r).inc(t, n).version;
                    } catch (e) {
                        return null;
                    }
                }, t.diff = function(e, t) {
                    if (O(e, t)) return null;
                    var r = m(e), n = m(t), i = "";
                    if (r.prerelease.length || n.prerelease.length) {
                        i = "pre";
                        var o = "prerelease";
                    }
                    for(var a in r)if (("major" === a || "minor" === a || "patch" === a) && r[a] !== n[a]) return i + a;
                    return o;
                }, t.compareIdentifiers = E;
                var g = /^[0-9]+$/;
                function E(e, t) {
                    var r = g.test(e), n = g.test(t);
                    return r && n && (e = +e, t = +t), e === t ? 0 : r && !n ? -1 : n && !r ? 1 : e < t ? -1 : 1;
                }
                function b(e, t, r) {
                    return new y(e, r).compare(new y(t, r));
                }
                function S(e, t, r) {
                    return b(e, t, r) > 0;
                }
                function _(e, t, r) {
                    return b(e, t, r) < 0;
                }
                function O(e, t, r) {
                    return 0 === b(e, t, r);
                }
                function w(e, t, r) {
                    return 0 !== b(e, t, r);
                }
                function T(e, t, r) {
                    return b(e, t, r) >= 0;
                }
                function I(e, t, r) {
                    return b(e, t, r) <= 0;
                }
                function R(e, t, r, n) {
                    switch(t){
                        case "===":
                            return "object" == typeof e && (e = e.version), "object" == typeof r && (r = r.version), e === r;
                        case "!==":
                            return "object" == typeof e && (e = e.version), "object" == typeof r && (r = r.version), e !== r;
                        case "":
                        case "=":
                        case "==":
                            return O(e, r, n);
                        case "!=":
                            return w(e, r, n);
                        case ">":
                            return S(e, r, n);
                        case ">=":
                            return T(e, r, n);
                        case "<":
                            return _(e, r, n);
                        case "<=":
                            return I(e, r, n);
                        default:
                            throw new TypeError("Invalid operator: " + t);
                    }
                }
                function x(e, t) {
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), e instanceof x) {
                        if (e.loose === !!t.loose) return e;
                        e = e.value;
                    }
                    if (!(this instanceof x)) return new x(e, t);
                    e = e.trim().split(/\s+/).join(" "), r("comparator", e, t), this.options = t, this.loose = !!t.loose, this.parse(e), this.value = this.semver === A ? "" : this.operator + this.semver.version, r("comp", this);
                }
                t.rcompareIdentifiers = function(e, t) {
                    return E(t, e);
                }, t.major = function(e, t) {
                    return new y(e, t).major;
                }, t.minor = function(e, t) {
                    return new y(e, t).minor;
                }, t.patch = function(e, t) {
                    return new y(e, t).patch;
                }, t.compare = b, t.compareLoose = function(e, t) {
                    return b(e, t, !0);
                }, t.compareBuild = function(e, t, r) {
                    var n = new y(e, r), i = new y(t, r);
                    return n.compare(i) || n.compareBuild(i);
                }, t.rcompare = function(e, t, r) {
                    return b(t, e, r);
                }, t.sort = function(e, r) {
                    return e.sort(function(e, n) {
                        return t.compareBuild(e, n, r);
                    });
                }, t.rsort = function(e, r) {
                    return e.sort(function(e, n) {
                        return t.compareBuild(n, e, r);
                    });
                }, t.gt = S, t.lt = _, t.eq = O, t.neq = w, t.gte = T, t.lte = I, t.cmp = R, t.Comparator = x;
                var A = {};
                function N(e, t) {
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), e instanceof N) return e.loose === !!t.loose && e.includePrerelease === !!t.includePrerelease ? e : new N(e.raw, t);
                    if (e instanceof x) return new N(e.value, t);
                    if (!(this instanceof N)) return new N(e, t);
                    if (this.options = t, this.loose = !!t.loose, this.includePrerelease = !!t.includePrerelease, this.raw = e.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map(function(e) {
                        return this.parseRange(e.trim());
                    }, this).filter(function(e) {
                        return e.length;
                    }), !this.set.length) throw new TypeError("Invalid SemVer Range: " + this.raw);
                    this.format();
                }
                function C(e, t) {
                    for(var r = !0, n = e.slice(), i = n.pop(); r && n.length;)r = n.every(function(e) {
                        return i.intersects(e, t);
                    }), i = n.pop();
                    return r;
                }
                function k(e) {
                    return !e || "x" === e.toLowerCase() || "*" === e;
                }
                function M(e, t, r, n, i, o, a, s, u, c, l, f, p) {
                    return ((t = k(r) ? "" : k(n) ? ">=" + r + ".0.0" : k(i) ? ">=" + r + "." + n + ".0" : ">=" + t) + " " + (s = k(u) ? "" : k(c) ? "<" + (+u + 1) + ".0.0" : k(l) ? "<" + u + "." + (+c + 1) + ".0" : f ? "<=" + u + "." + c + "." + l + "-" + f : "<=" + s)).trim();
                }
                function P(e, t, n) {
                    for(var i = 0; i < e.length; i++)if (!e[i].test(t)) return !1;
                    if (t.prerelease.length && !n.includePrerelease) {
                        for(i = 0; i < e.length; i++)if (r(e[i].semver), e[i].semver !== A && e[i].semver.prerelease.length > 0) {
                            var o = e[i].semver;
                            if (o.major === t.major && o.minor === t.minor && o.patch === t.patch) return !0;
                        }
                        return !1;
                    }
                    return !0;
                }
                function D(e, t, r) {
                    try {
                        t = new N(t, r);
                    } catch (e) {
                        return !1;
                    }
                    return t.test(e);
                }
                function F(e, t, r, n) {
                    var i, o, a, s, u;
                    switch(e = new y(e, n), t = new N(t, n), r){
                        case ">":
                            i = S, o = I, a = _, s = ">", u = ">=";
                            break;
                        case "<":
                            i = _, o = T, a = S, s = "<", u = "<=";
                            break;
                        default:
                            throw new TypeError('Must provide a hilo val of "<" or ">"');
                    }
                    if (D(e, t, n)) return !1;
                    for(var c = 0; c < t.set.length; ++c){
                        var l = null, f = null;
                        if (t.set[c].forEach(function(e) {
                            e.semver === A && (e = new x(">=0.0.0")), f = f || e, i(e.semver, (l = l || e).semver, n) ? l = e : a(e.semver, f.semver, n) && (f = e);
                        }), l.operator === s || l.operator === u) return !1;
                        if ((!f.operator || f.operator === s) && o(e, f.semver)) return !1;
                        if (f.operator === u && a(e, f.semver)) return !1;
                    }
                    return !0;
                }
                x.prototype.parse = function(e) {
                    var t = e.match(this.options.loose ? s[c.COMPARATORLOOSE] : s[c.COMPARATOR]);
                    if (!t) throw new TypeError("Invalid comparator: " + e);
                    this.operator = void 0 !== t[1] ? t[1] : "", "=" === this.operator && (this.operator = ""), this.semver = t[2] ? new y(t[2], this.options.loose) : A;
                }, x.prototype.toString = function() {
                    return this.value;
                }, x.prototype.test = function(e) {
                    if (r("Comparator.test", e, this.options.loose), this.semver === A || e === A) return !0;
                    if ("string" == typeof e) try {
                        e = new y(e, this.options);
                    } catch (e) {
                        return !1;
                    }
                    return R(e, this.operator, this.semver, this.options);
                }, x.prototype.intersects = function(e, t) {
                    if (!(e instanceof x)) throw new TypeError("a Comparator is required");
                    var r;
                    if (t && "object" == typeof t || (t = {
                        loose: !!t,
                        includePrerelease: !1
                    }), "" === this.operator) return "" === this.value || (r = new N(e.value, t), D(this.value, r, t));
                    if ("" === e.operator) return "" === e.value || (r = new N(this.value, t), D(e.semver, r, t));
                    var n = !(">=" !== this.operator && ">" !== this.operator || ">=" !== e.operator && ">" !== e.operator), i = !("<=" !== this.operator && "<" !== this.operator || "<=" !== e.operator && "<" !== e.operator), o = this.semver.version === e.semver.version, a = !(">=" !== this.operator && "<=" !== this.operator || ">=" !== e.operator && "<=" !== e.operator), s = R(this.semver, "<", e.semver, t) && (">=" === this.operator || ">" === this.operator) && ("<=" === e.operator || "<" === e.operator), u = R(this.semver, ">", e.semver, t) && ("<=" === this.operator || "<" === this.operator) && (">=" === e.operator || ">" === e.operator);
                    return n || i || o && a || s || u;
                }, t.Range = N, N.prototype.format = function() {
                    return this.range = this.set.map(function(e) {
                        return e.join(" ").trim();
                    }).join("||").trim(), this.range;
                }, N.prototype.toString = function() {
                    return this.range;
                }, N.prototype.parseRange = function(e) {
                    var t = this.options.loose;
                    e = e.replace(t ? s[c.HYPHENRANGELOOSE] : s[c.HYPHENRANGE], M), r("hyphen replace", e), e = e.replace(s[c.COMPARATORTRIM], "$1$2$3"), r("comparator trim", e, s[c.COMPARATORTRIM]), e = (e = (e = e.replace(s[c.TILDETRIM], "$1~")).replace(s[c.CARETTRIM], "$1^")).split(/\s+/).join(" ");
                    var n = t ? s[c.COMPARATORLOOSE] : s[c.COMPARATOR], i = e.split(" ").map(function(e) {
                        return function(e, t) {
                            return r("comp", e, t), e = function(e, t) {
                                return e.trim().split(/\s+/).map(function(e) {
                                    return function(e, t) {
                                        r("caret", e, t);
                                        var n = t.loose ? s[c.CARETLOOSE] : s[c.CARET];
                                        return e.replace(n, function(t, n, i, o, a) {
                                            var s;
                                            return r("caret", e, t, n, i, o, a), k(n) ? s = "" : k(i) ? s = ">=" + n + ".0.0 <" + (+n + 1) + ".0.0" : k(o) ? s = "0" === n ? ">=" + n + "." + i + ".0 <" + n + "." + (+i + 1) + ".0" : ">=" + n + "." + i + ".0 <" + (+n + 1) + ".0.0" : a ? (r("replaceCaret pr", a), s = "0" === n ? "0" === i ? ">=" + n + "." + i + "." + o + "-" + a + " <" + n + "." + i + "." + (+o + 1) : ">=" + n + "." + i + "." + o + "-" + a + " <" + n + "." + (+i + 1) + ".0" : ">=" + n + "." + i + "." + o + "-" + a + " <" + (+n + 1) + ".0.0") : (r("no pr"), s = "0" === n ? "0" === i ? ">=" + n + "." + i + "." + o + " <" + n + "." + i + "." + (+o + 1) : ">=" + n + "." + i + "." + o + " <" + n + "." + (+i + 1) + ".0" : ">=" + n + "." + i + "." + o + " <" + (+n + 1) + ".0.0"), r("caret return", s), s;
                                        });
                                    }(e, t);
                                }).join(" ");
                            }(e, t), r("caret", e), e = function(e, t) {
                                return e.trim().split(/\s+/).map(function(e) {
                                    return function(e, t) {
                                        var n = t.loose ? s[c.TILDELOOSE] : s[c.TILDE];
                                        return e.replace(n, function(t, n, i, o, a) {
                                            var s;
                                            return r("tilde", e, t, n, i, o, a), k(n) ? s = "" : k(i) ? s = ">=" + n + ".0.0 <" + (+n + 1) + ".0.0" : k(o) ? s = ">=" + n + "." + i + ".0 <" + n + "." + (+i + 1) + ".0" : a ? (r("replaceTilde pr", a), s = ">=" + n + "." + i + "." + o + "-" + a + " <" + n + "." + (+i + 1) + ".0") : s = ">=" + n + "." + i + "." + o + " <" + n + "." + (+i + 1) + ".0", r("tilde return", s), s;
                                        });
                                    }(e, t);
                                }).join(" ");
                            }(e, t), r("tildes", e), e = function(e, t) {
                                return r("replaceXRanges", e, t), e.split(/\s+/).map(function(e) {
                                    return function(e, t) {
                                        e = e.trim();
                                        var n = t.loose ? s[c.XRANGELOOSE] : s[c.XRANGE];
                                        return e.replace(n, function(n, i, o, a, s, u) {
                                            r("xRange", e, n, i, o, a, s, u);
                                            var c = k(o), l = c || k(a), f = l || k(s);
                                            return "=" === i && f && (i = ""), u = t.includePrerelease ? "-0" : "", c ? n = ">" === i || "<" === i ? "<0.0.0-0" : "*" : i && f ? (l && (a = 0), s = 0, ">" === i ? (i = ">=", l ? (o = +o + 1, a = 0, s = 0) : (a = +a + 1, s = 0)) : "<=" === i && (i = "<", l ? o = +o + 1 : a = +a + 1), n = i + o + "." + a + "." + s + u) : l ? n = ">=" + o + ".0.0" + u + " <" + (+o + 1) + ".0.0" + u : f && (n = ">=" + o + "." + a + ".0" + u + " <" + o + "." + (+a + 1) + ".0" + u), r("xRange return", n), n;
                                        });
                                    }(e, t);
                                }).join(" ");
                            }(e, t), r("xrange", e), e = function(e, t) {
                                return r("replaceStars", e, t), e.trim().replace(s[c.STAR], "");
                            }(e, t), r("stars", e), e;
                        }(e, this.options);
                    }, this).join(" ").split(/\s+/);
                    return this.options.loose && (i = i.filter(function(e) {
                        return !!e.match(n);
                    })), i = i.map(function(e) {
                        return new x(e, this.options);
                    }, this);
                }, N.prototype.intersects = function(e, t) {
                    if (!(e instanceof N)) throw new TypeError("a Range is required");
                    return this.set.some(function(r) {
                        return C(r, t) && e.set.some(function(e) {
                            return C(e, t) && r.every(function(r) {
                                return e.every(function(e) {
                                    return r.intersects(e, t);
                                });
                            });
                        });
                    });
                }, t.toComparators = function(e, t) {
                    return new N(e, t).set.map(function(e) {
                        return e.map(function(e) {
                            return e.value;
                        }).join(" ").trim().split(" ");
                    });
                }, N.prototype.test = function(e) {
                    if (!e) return !1;
                    if ("string" == typeof e) try {
                        e = new y(e, this.options);
                    } catch (e) {
                        return !1;
                    }
                    for(var t = 0; t < this.set.length; t++)if (P(this.set[t], e, this.options)) return !0;
                    return !1;
                }, t.satisfies = D, t.maxSatisfying = function(e, t, r) {
                    var n = null, i = null;
                    try {
                        var o = new N(t, r);
                    } catch (e) {
                        return null;
                    }
                    return e.forEach(function(e) {
                        o.test(e) && (n && -1 !== i.compare(e) || (i = new y(n = e, r)));
                    }), n;
                }, t.minSatisfying = function(e, t, r) {
                    var n = null, i = null;
                    try {
                        var o = new N(t, r);
                    } catch (e) {
                        return null;
                    }
                    return e.forEach(function(e) {
                        o.test(e) && (n && 1 !== i.compare(e) || (i = new y(n = e, r)));
                    }), n;
                }, t.minVersion = function(e, t) {
                    e = new N(e, t);
                    var r = new y("0.0.0");
                    if (e.test(r)) return r;
                    if (r = new y("0.0.0-0"), e.test(r)) return r;
                    r = null;
                    for(var n = 0; n < e.set.length; ++n)e.set[n].forEach(function(e) {
                        var t = new y(e.semver.version);
                        switch(e.operator){
                            case ">":
                                0 === t.prerelease.length ? t.patch++ : t.prerelease.push(0), t.raw = t.format();
                            case "":
                            case ">=":
                                r && !S(r, t) || (r = t);
                                break;
                            case "<":
                            case "<=":
                                break;
                            default:
                                throw new Error("Unexpected operation: " + e.operator);
                        }
                    });
                    if (r && e.test(r)) return r;
                    return null;
                }, t.validRange = function(e, t) {
                    try {
                        return new N(e, t).range || "*";
                    } catch (e) {
                        return null;
                    }
                }, t.ltr = function(e, t, r) {
                    return F(e, t, "<", r);
                }, t.gtr = function(e, t, r) {
                    return F(e, t, ">", r);
                }, t.outside = F, t.prerelease = function(e, t) {
                    var r = m(e, t);
                    return r && r.prerelease.length ? r.prerelease : null;
                }, t.intersects = function(e, t, r) {
                    return e = new N(e, r), t = new N(t, r), e.intersects(t);
                }, t.coerce = function(e, t) {
                    if (e instanceof y) return e;
                    "number" == typeof e && (e = String(e));
                    if ("string" != typeof e) return null;
                    var r = null;
                    if ((t = t || {}).rtl) {
                        for(var n; (n = s[c.COERCERTL].exec(e)) && (!r || r.index + r[0].length !== e.length);)r && n.index + n[0].length === r.index + r[0].length || (r = n), s[c.COERCERTL].lastIndex = n.index + n[1].length + n[2].length;
                        s[c.COERCERTL].lastIndex = -1;
                    } else r = e.match(s[c.COERCE]);
                    if (null === r) return null;
                    return m(r[2] + "." + (r[3] || "0") + "." + (r[4] || "0"), t);
                };
            },
            1603: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                }), e = r.hmd(e);
                const n = function(e) {
                    var t, r = e.Symbol;
                    return "function" == typeof r ? r.observable ? t = r.observable : (t = r("observable"), r.observable = t) : t = "@@observable", t;
                }("undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== r.g ? r.g : e);
            },
            8754: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    ej: ()=>s,
                    kG: ()=>u
                });
                var n = r(5949), i = "Invariant Violation", o = Object.setPrototypeOf, a = void 0 === o ? function(e, t) {
                    return e.__proto__ = t, e;
                } : o, s = function(e) {
                    function t(r) {
                        void 0 === r && (r = i);
                        var n = e.call(this, "number" == typeof r ? i + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
                        return n.framesToPop = 1, n.name = i, a(n, t.prototype), n;
                    }
                    return (0, n.ZT)(t, e), t;
                }(Error);
                function u(e, t) {
                    if (!e) throw new s(t);
                }
                function c(e) {
                    return function() {
                        return console[e].apply(console, arguments);
                    };
                }
                !function(e) {
                    e.warn = c("warn"), e.error = c("error");
                }(u || (u = {}));
                var l = {
                    env: {}
                };
                try {
                    Function("stub", "process = stub")(l);
                } catch (e) {}
            },
            5949: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Jh: ()=>u,
                    ZT: ()=>i,
                    _T: ()=>a,
                    mG: ()=>s,
                    pi: ()=>o,
                    pr: ()=>c
                });
                var n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                    }, n(e, t);
                };
                function i(e, t) {
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }
                var o = function() {
                    return o = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, o.apply(this, arguments);
                };
                function a(e, t) {
                    var r = {};
                    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var i = 0;
                        for(n = Object.getOwnPropertySymbols(e); i < n.length; i++)t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
                    }
                    return r;
                }
                function s(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function a(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function s(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(a, s);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                }
                function u(e, t) {
                    var r, n, i, o, a = {
                        label: 0,
                        sent: function() {
                            if (1 & i[0]) throw i[1];
                            return i[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return o = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                        return this;
                    }), o;
                    function s(o) {
                        return function(s) {
                            return function(o) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                    switch(n = 0, i && (o = [
                                        2 & o[0],
                                        i.value
                                    ]), o[0]){
                                        case 0:
                                        case 1:
                                            i = o;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: o[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = o[1], o = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            o = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                                a.label = o[1];
                                                break;
                                            }
                                            if (6 === o[0] && a.label < i[1]) {
                                                a.label = i[1], i = o;
                                                break;
                                            }
                                            if (i && a.label < i[2]) {
                                                a.label = i[2], a.ops.push(o);
                                                break;
                                            }
                                            i[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    o = t.call(e, a);
                                } catch (e) {
                                    o = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    r = i = 0;
                                }
                                if (5 & o[0]) throw o[1];
                                return {
                                    value: o[0] ? o[1] : void 0,
                                    done: !0
                                };
                            }([
                                o,
                                s
                            ]);
                        };
                    }
                }
                function c() {
                    for(var e = 0, t = 0, r = arguments.length; t < r; t++)e += arguments[t].length;
                    var n = Array(e), i = 0;
                    for(t = 0; t < r; t++)for(var o = arguments[t], a = 0, s = o.length; a < s; a++, i++)n[i] = o[a];
                    return n;
                }
            },
            6261: function(e, t, r) {
                var n, i;
                !function(o, a) {
                    "use strict";
                    e.exports ? e.exports = a() : void 0 === (i = "function" == typeof (n = a) ? n.call(t, r, t, e) : n) || (e.exports = i);
                }(0, function(e) {
                    "use strict";
                    var t = e && e.IPv6;
                    return {
                        best: function(e) {
                            var t, r, n = e.toLowerCase().split(":"), i = n.length, o = 8;
                            for("" === n[0] && "" === n[1] && "" === n[2] ? (n.shift(), n.shift()) : "" === n[0] && "" === n[1] ? n.shift() : "" === n[i - 1] && "" === n[i - 2] && n.pop(), -1 !== n[(i = n.length) - 1].indexOf(".") && (o = 7), t = 0; t < i && "" !== n[t]; t++);
                            if (t < o) for(n.splice(t, 1, "0000"); n.length < o;)n.splice(t, 0, "0000");
                            for(var a = 0; a < o; a++){
                                r = n[a].split("");
                                for(var s = 0; s < 3 && "0" === r[0] && r.length > 1; s++)r.splice(0, 1);
                                n[a] = r.join("");
                            }
                            var u = -1, c = 0, l = 0, f = -1, p = !1;
                            for(a = 0; a < o; a++)p ? "0" === n[a] ? l += 1 : (p = !1, l > c && (u = f, c = l)) : "0" === n[a] && (p = !0, f = a, l = 1);
                            l > c && (u = f, c = l), c > 1 && n.splice(u, c, ""), i = n.length;
                            var d = "";
                            for("" === n[0] && (d = ":"), a = 0; a < i && (d += n[a], a !== i - 1); a++)d += ":";
                            return "" === n[i - 1] && (d += ":"), d;
                        },
                        noConflict: function() {
                            return e.IPv6 === this && (e.IPv6 = t), this;
                        }
                    };
                });
            },
            8776: function(e, t, r) {
                var n, i;
                !function(o, a) {
                    "use strict";
                    e.exports ? e.exports = a() : void 0 === (i = "function" == typeof (n = a) ? n.call(t, r, t, e) : n) || (e.exports = i);
                }(0, function(e) {
                    "use strict";
                    var t = e && e.SecondLevelDomains, r = {
                        list: {
                            ac: " com gov mil net org ",
                            ae: " ac co gov mil name net org pro sch ",
                            af: " com edu gov net org ",
                            al: " com edu gov mil net org ",
                            ao: " co ed gv it og pb ",
                            ar: " com edu gob gov int mil net org tur ",
                            at: " ac co gv or ",
                            au: " asn com csiro edu gov id net org ",
                            ba: " co com edu gov mil net org rs unbi unmo unsa untz unze ",
                            bb: " biz co com edu gov info net org store tv ",
                            bh: " biz cc com edu gov info net org ",
                            bn: " com edu gov net org ",
                            bo: " com edu gob gov int mil net org tv ",
                            br: " adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ",
                            bs: " com edu gov net org ",
                            bz: " du et om ov rg ",
                            ca: " ab bc mb nb nf nl ns nt nu on pe qc sk yk ",
                            ck: " biz co edu gen gov info net org ",
                            cn: " ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ",
                            co: " com edu gov mil net nom org ",
                            cr: " ac c co ed fi go or sa ",
                            cy: " ac biz com ekloges gov ltd name net org parliament press pro tm ",
                            do: " art com edu gob gov mil net org sld web ",
                            dz: " art asso com edu gov net org pol ",
                            ec: " com edu fin gov info med mil net org pro ",
                            eg: " com edu eun gov mil name net org sci ",
                            er: " com edu gov ind mil net org rochest w ",
                            es: " com edu gob nom org ",
                            et: " biz com edu gov info name net org ",
                            fj: " ac biz com info mil name net org pro ",
                            fk: " ac co gov net nom org ",
                            fr: " asso com f gouv nom prd presse tm ",
                            gg: " co net org ",
                            gh: " com edu gov mil org ",
                            gn: " ac com gov net org ",
                            gr: " com edu gov mil net org ",
                            gt: " com edu gob ind mil net org ",
                            gu: " com edu gov net org ",
                            hk: " com edu gov idv net org ",
                            hu: " 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ",
                            id: " ac co go mil net or sch web ",
                            il: " ac co gov idf k12 muni net org ",
                            in: " ac co edu ernet firm gen gov i ind mil net nic org res ",
                            iq: " com edu gov i mil net org ",
                            ir: " ac co dnssec gov i id net org sch ",
                            it: " edu gov ",
                            je: " co net org ",
                            jo: " com edu gov mil name net org sch ",
                            jp: " ac ad co ed go gr lg ne or ",
                            ke: " ac co go info me mobi ne or sc ",
                            kh: " com edu gov mil net org per ",
                            ki: " biz com de edu gov info mob net org tel ",
                            km: " asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ",
                            kn: " edu gov net org ",
                            kr: " ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ",
                            kw: " com edu gov net org ",
                            ky: " com edu gov net org ",
                            kz: " com edu gov mil net org ",
                            lb: " com edu gov net org ",
                            lk: " assn com edu gov grp hotel int ltd net ngo org sch soc web ",
                            lr: " com edu gov net org ",
                            lv: " asn com conf edu gov id mil net org ",
                            ly: " com edu gov id med net org plc sch ",
                            ma: " ac co gov m net org press ",
                            mc: " asso tm ",
                            me: " ac co edu gov its net org priv ",
                            mg: " com edu gov mil nom org prd tm ",
                            mk: " com edu gov inf name net org pro ",
                            ml: " com edu gov net org presse ",
                            mn: " edu gov org ",
                            mo: " com edu gov net org ",
                            mt: " com edu gov net org ",
                            mv: " aero biz com coop edu gov info int mil museum name net org pro ",
                            mw: " ac co com coop edu gov int museum net org ",
                            mx: " com edu gob net org ",
                            my: " com edu gov mil name net org sch ",
                            nf: " arts com firm info net other per rec store web ",
                            ng: " biz com edu gov mil mobi name net org sch ",
                            ni: " ac co com edu gob mil net nom org ",
                            np: " com edu gov mil net org ",
                            nr: " biz com edu gov info net org ",
                            om: " ac biz co com edu gov med mil museum net org pro sch ",
                            pe: " com edu gob mil net nom org sld ",
                            ph: " com edu gov i mil net ngo org ",
                            pk: " biz com edu fam gob gok gon gop gos gov net org web ",
                            pl: " art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ",
                            pr: " ac biz com edu est gov info isla name net org pro prof ",
                            ps: " com edu gov net org plo sec ",
                            pw: " belau co ed go ne or ",
                            ro: " arts com firm info nom nt org rec store tm www ",
                            rs: " ac co edu gov in org ",
                            sb: " com edu gov net org ",
                            sc: " com edu gov net org ",
                            sh: " co com edu gov net nom org ",
                            sl: " com edu gov net org ",
                            st: " co com consulado edu embaixada gov mil net org principe saotome store ",
                            sv: " com edu gob org red ",
                            sz: " ac co org ",
                            tr: " av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ",
                            tt: " aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ",
                            tw: " club com ebiz edu game gov idv mil net org ",
                            mu: " ac co com gov net or org ",
                            mz: " ac co edu gov org ",
                            na: " co com ",
                            nz: " ac co cri geek gen govt health iwi maori mil net org parliament school ",
                            pa: " abo ac com edu gob ing med net nom org sld ",
                            pt: " com edu gov int net nome org publ ",
                            py: " com edu gov mil net org ",
                            qa: " com edu gov mil net org ",
                            re: " asso com nom ",
                            ru: " ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ",
                            rw: " ac co com edu gouv gov int mil net ",
                            sa: " com edu gov med net org pub sch ",
                            sd: " com edu gov info med net org tv ",
                            se: " a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ",
                            sg: " com edu gov idn net org per ",
                            sn: " art com edu gouv org perso univ ",
                            sy: " com edu gov mil net news org ",
                            th: " ac co go in mi net or ",
                            tj: " ac biz co com edu go gov info int mil name net nic org test web ",
                            tn: " agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ",
                            tz: " ac co go ne or ",
                            ua: " biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ",
                            ug: " ac co go ne or org sc ",
                            uk: " ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ",
                            us: " dni fed isa kids nsn ",
                            uy: " com edu gub mil net org ",
                            ve: " co com edu gob info mil net org web ",
                            vi: " co com k12 net org ",
                            vn: " ac biz com edu gov health info int name net org pro ",
                            ye: " co com gov ltd me net org plc ",
                            yu: " ac co edu gov org ",
                            za: " ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ",
                            zm: " ac co com edu gov net org sch ",
                            com: "ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ",
                            net: "gb jp se uk ",
                            org: "ae",
                            de: "com "
                        },
                        has: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return !1;
                            var n = e.lastIndexOf(".", t - 1);
                            if (n <= 0 || n >= t - 1) return !1;
                            var i = r.list[e.slice(t + 1)];
                            return !!i && i.indexOf(" " + e.slice(n + 1, t) + " ") >= 0;
                        },
                        is: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return !1;
                            if (e.lastIndexOf(".", t - 1) >= 0) return !1;
                            var n = r.list[e.slice(t + 1)];
                            return !!n && n.indexOf(" " + e.slice(0, t) + " ") >= 0;
                        },
                        get: function(e) {
                            var t = e.lastIndexOf(".");
                            if (t <= 0 || t >= e.length - 1) return null;
                            var n = e.lastIndexOf(".", t - 1);
                            if (n <= 0 || n >= t - 1) return null;
                            var i = r.list[e.slice(t + 1)];
                            return i ? i.indexOf(" " + e.slice(n + 1, t) + " ") < 0 ? null : e.slice(n + 1) : null;
                        },
                        noConflict: function() {
                            return e.SecondLevelDomains === this && (e.SecondLevelDomains = t), this;
                        }
                    };
                    return r;
                });
            },
            6812: function(e, t, r) {
                var n, i, o;
                !function(a, s) {
                    "use strict";
                    e.exports ? e.exports = s(r(4344), r(6261), r(8776)) : (i = [
                        r(4344),
                        r(6261),
                        r(8776)
                    ], void 0 === (o = "function" == typeof (n = s) ? n.apply(t, i) : n) || (e.exports = o));
                }(0, function(e, t, r, n) {
                    "use strict";
                    var i = n && n.URI;
                    function o(e, t) {
                        var r = arguments.length >= 1;
                        if (!(this instanceof o)) return r ? arguments.length >= 2 ? new o(e, t) : new o(e) : new o;
                        if (void 0 === e) {
                            if (r) throw new TypeError("undefined is not a valid argument for URI");
                            e = "undefined" != typeof location ? location.href + "" : "";
                        }
                        if (null === e && r) throw new TypeError("null is not a valid argument for URI");
                        return this.href(e), void 0 !== t ? this.absoluteTo(t) : this;
                    }
                    o.version = "1.19.11";
                    var a = o.prototype, s = Object.prototype.hasOwnProperty;
                    function u(e) {
                        return e.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
                    }
                    function c(e) {
                        return void 0 === e ? "Undefined" : String(Object.prototype.toString.call(e)).slice(8, -1);
                    }
                    function l(e) {
                        return "Array" === c(e);
                    }
                    function f(e, t) {
                        var r, n, i = {};
                        if ("RegExp" === c(t)) i = null;
                        else if (l(t)) for(r = 0, n = t.length; r < n; r++)i[t[r]] = !0;
                        else i[t] = !0;
                        for(r = 0, n = e.length; r < n; r++)(i && void 0 !== i[e[r]] || !i && t.test(e[r])) && (e.splice(r, 1), n--, r--);
                        return e;
                    }
                    function p(e, t) {
                        var r, n;
                        if (l(t)) {
                            for(r = 0, n = t.length; r < n; r++)if (!p(e, t[r])) return !1;
                            return !0;
                        }
                        var i = c(t);
                        for(r = 0, n = e.length; r < n; r++)if ("RegExp" === i) {
                            if ("string" == typeof e[r] && e[r].match(t)) return !0;
                        } else if (e[r] === t) return !0;
                        return !1;
                    }
                    function d(e, t) {
                        if (!l(e) || !l(t)) return !1;
                        if (e.length !== t.length) return !1;
                        e.sort(), t.sort();
                        for(var r = 0, n = e.length; r < n; r++)if (e[r] !== t[r]) return !1;
                        return !0;
                    }
                    function h(e) {
                        return e.replace(/^\/+|\/+$/g, "");
                    }
                    function v(e) {
                        return escape(e);
                    }
                    function m(e) {
                        return encodeURIComponent(e).replace(/[!'()*]/g, v).replace(/\*/g, "%2A");
                    }
                    o._parts = function() {
                        return {
                            protocol: null,
                            username: null,
                            password: null,
                            hostname: null,
                            urn: null,
                            port: null,
                            path: null,
                            query: null,
                            fragment: null,
                            preventInvalidHostname: o.preventInvalidHostname,
                            duplicateQueryParameters: o.duplicateQueryParameters,
                            escapeQuerySpace: o.escapeQuerySpace
                        };
                    }, o.preventInvalidHostname = !1, o.duplicateQueryParameters = !1, o.escapeQuerySpace = !0, o.protocol_expression = /^[a-z][a-z0-9.+-]*$/i, o.idn_expression = /[^a-z0-9\._-]/i, o.punycode_expression = /(xn--)/i, o.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, o.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/, o.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/gi, o.findUri = {
                        start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
                        end: /[\s\r\n]|$/,
                        trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
                        parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
                    }, o.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, o.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g, o.defaultPorts = {
                        http: "80",
                        https: "443",
                        ftp: "21",
                        gopher: "70",
                        ws: "80",
                        wss: "443"
                    }, o.hostProtocols = [
                        "http",
                        "https"
                    ], o.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/, o.domAttributes = {
                        a: "href",
                        blockquote: "cite",
                        link: "href",
                        base: "href",
                        script: "src",
                        form: "action",
                        img: "src",
                        area: "href",
                        iframe: "src",
                        embed: "src",
                        source: "src",
                        track: "src",
                        input: "src",
                        audio: "src",
                        video: "src"
                    }, o.getDomAttribute = function(e) {
                        if (e && e.nodeName) {
                            var t = e.nodeName.toLowerCase();
                            if ("input" !== t || "image" === e.type) return o.domAttributes[t];
                        }
                    }, o.encode = m, o.decode = decodeURIComponent, o.iso8859 = function() {
                        o.encode = escape, o.decode = unescape;
                    }, o.unicode = function() {
                        o.encode = m, o.decode = decodeURIComponent;
                    }, o.characters = {
                        pathname: {
                            encode: {
                                expression: /%(24|26|2B|2C|3B|3D|3A|40)/gi,
                                map: {
                                    "%24": "$",
                                    "%26": "&",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "=",
                                    "%3A": ":",
                                    "%40": "@"
                                }
                            },
                            decode: {
                                expression: /[\/\?#]/g,
                                map: {
                                    "/": "%2F",
                                    "?": "%3F",
                                    "#": "%23"
                                }
                            }
                        },
                        reserved: {
                            encode: {
                                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/gi,
                                map: {
                                    "%3A": ":",
                                    "%2F": "/",
                                    "%3F": "?",
                                    "%23": "#",
                                    "%5B": "[",
                                    "%5D": "]",
                                    "%40": "@",
                                    "%21": "!",
                                    "%24": "$",
                                    "%26": "&",
                                    "%27": "'",
                                    "%28": "(",
                                    "%29": ")",
                                    "%2A": "*",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "="
                                }
                            }
                        },
                        urnpath: {
                            encode: {
                                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/gi,
                                map: {
                                    "%21": "!",
                                    "%24": "$",
                                    "%27": "'",
                                    "%28": "(",
                                    "%29": ")",
                                    "%2A": "*",
                                    "%2B": "+",
                                    "%2C": ",",
                                    "%3B": ";",
                                    "%3D": "=",
                                    "%40": "@"
                                }
                            },
                            decode: {
                                expression: /[\/\?#:]/g,
                                map: {
                                    "/": "%2F",
                                    "?": "%3F",
                                    "#": "%23",
                                    ":": "%3A"
                                }
                            }
                        }
                    }, o.encodeQuery = function(e, t) {
                        var r = o.encode(e + "");
                        return void 0 === t && (t = o.escapeQuerySpace), t ? r.replace(/%20/g, "+") : r;
                    }, o.decodeQuery = function(e, t) {
                        e += "", void 0 === t && (t = o.escapeQuerySpace);
                        try {
                            return o.decode(t ? e.replace(/\+/g, "%20") : e);
                        } catch (t) {
                            return e;
                        }
                    };
                    var y, g = {
                        encode: "encode",
                        decode: "decode"
                    }, E = function(e, t) {
                        return function(r) {
                            try {
                                return o[t](r + "").replace(o.characters[e][t].expression, function(r) {
                                    return o.characters[e][t].map[r];
                                });
                            } catch (e) {
                                return r;
                            }
                        };
                    };
                    for(y in g)o[y + "PathSegment"] = E("pathname", g[y]), o[y + "UrnPathSegment"] = E("urnpath", g[y]);
                    var b = function(e, t, r) {
                        return function(n) {
                            var i;
                            i = r ? function(e) {
                                return o[t](o[r](e));
                            } : o[t];
                            for(var a = (n + "").split(e), s = 0, u = a.length; s < u; s++)a[s] = i(a[s]);
                            return a.join(e);
                        };
                    };
                    function S(e) {
                        return function(t, r) {
                            return void 0 === t ? this._parts[e] || "" : (this._parts[e] = t || null, this.build(!r), this);
                        };
                    }
                    function _(e, t) {
                        return function(r, n) {
                            return void 0 === r ? this._parts[e] || "" : (null !== r && (r += "").charAt(0) === t && (r = r.substring(1)), this._parts[e] = r, this.build(!n), this);
                        };
                    }
                    o.decodePath = b("/", "decodePathSegment"), o.decodeUrnPath = b(":", "decodeUrnPathSegment"), o.recodePath = b("/", "encodePathSegment", "decode"), o.recodeUrnPath = b(":", "encodeUrnPathSegment", "decode"), o.encodeReserved = E("reserved", "encode"), o.parse = function(e, t) {
                        var r;
                        return t || (t = {
                            preventInvalidHostname: o.preventInvalidHostname
                        }), (r = (e = (e = e.replace(o.leading_whitespace_expression, "")).replace(o.ascii_tab_whitespace, "")).indexOf("#")) > -1 && (t.fragment = e.substring(r + 1) || null, e = e.substring(0, r)), (r = e.indexOf("?")) > -1 && (t.query = e.substring(r + 1) || null, e = e.substring(0, r)), "//" === (e = (e = e.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, "$1://")).replace(/^[/\\]{2,}/i, "//")).substring(0, 2) ? (t.protocol = null, e = e.substring(2), e = o.parseAuthority(e, t)) : (r = e.indexOf(":")) > -1 && (t.protocol = e.substring(0, r) || null, t.protocol && !t.protocol.match(o.protocol_expression) ? t.protocol = void 0 : "//" === e.substring(r + 1, r + 3).replace(/\\/g, "/") ? (e = e.substring(r + 3), e = o.parseAuthority(e, t)) : (e = e.substring(r + 1), t.urn = !0)), t.path = e, t;
                    }, o.parseHost = function(e, t) {
                        e || (e = "");
                        var r, n, i = (e = e.replace(/\\/g, "/")).indexOf("/");
                        if (-1 === i && (i = e.length), "[" === e.charAt(0)) r = e.indexOf("]"), t.hostname = e.substring(1, r) || null, t.port = e.substring(r + 2, i) || null, "/" === t.port && (t.port = null);
                        else {
                            var a = e.indexOf(":"), s = e.indexOf("/"), u = e.indexOf(":", a + 1);
                            -1 !== u && (-1 === s || u < s) ? (t.hostname = e.substring(0, i) || null, t.port = null) : (n = e.substring(0, i).split(":"), t.hostname = n[0] || null, t.port = n[1] || null);
                        }
                        return t.hostname && "/" !== e.substring(i).charAt(0) && (i++, e = "/" + e), t.preventInvalidHostname && o.ensureValidHostname(t.hostname, t.protocol), t.port && o.ensureValidPort(t.port), e.substring(i) || "/";
                    }, o.parseAuthority = function(e, t) {
                        return e = o.parseUserinfo(e, t), o.parseHost(e, t);
                    }, o.parseUserinfo = function(e, t) {
                        var r = e;
                        -1 !== e.indexOf("\\") && (e = e.replace(/\\/g, "/"));
                        var n, i = e.indexOf("/"), a = e.lastIndexOf("@", i > -1 ? i : e.length - 1);
                        return a > -1 && (-1 === i || a < i) ? (n = e.substring(0, a).split(":"), t.username = n[0] ? o.decode(n[0]) : null, n.shift(), t.password = n[0] ? o.decode(n.join(":")) : null, e = r.substring(a + 1)) : (t.username = null, t.password = null), e;
                    }, o.parseQuery = function(e, t) {
                        if (!e) return {};
                        if (!(e = e.replace(/&+/g, "&").replace(/^\?*&*|&+$/g, ""))) return {};
                        for(var r, n, i, a = {}, u = e.split("&"), c = u.length, l = 0; l < c; l++)r = u[l].split("="), n = o.decodeQuery(r.shift(), t), i = r.length ? o.decodeQuery(r.join("="), t) : null, "__proto__" !== n && (s.call(a, n) ? ("string" != typeof a[n] && null !== a[n] || (a[n] = [
                            a[n]
                        ]), a[n].push(i)) : a[n] = i);
                        return a;
                    }, o.build = function(e) {
                        var t = "", r = !1;
                        return e.protocol && (t += e.protocol + ":"), e.urn || !t && !e.hostname || (t += "//", r = !0), t += o.buildAuthority(e) || "", "string" == typeof e.path && ("/" !== e.path.charAt(0) && r && (t += "/"), t += e.path), "string" == typeof e.query && e.query && (t += "?" + e.query), "string" == typeof e.fragment && e.fragment && (t += "#" + e.fragment), t;
                    }, o.buildHost = function(e) {
                        var t = "";
                        return e.hostname ? (o.ip6_expression.test(e.hostname) ? t += "[" + e.hostname + "]" : t += e.hostname, e.port && (t += ":" + e.port), t) : "";
                    }, o.buildAuthority = function(e) {
                        return o.buildUserinfo(e) + o.buildHost(e);
                    }, o.buildUserinfo = function(e) {
                        var t = "";
                        return e.username && (t += o.encode(e.username)), e.password && (t += ":" + o.encode(e.password)), t && (t += "@"), t;
                    }, o.buildQuery = function(e, t, r) {
                        var n, i, a, u, c = "";
                        for(i in e)if ("__proto__" !== i && s.call(e, i)) {
                            if (l(e[i])) for(n = {}, a = 0, u = e[i].length; a < u; a++)void 0 !== e[i][a] && void 0 === n[e[i][a] + ""] && (c += "&" + o.buildQueryParameter(i, e[i][a], r), !0 !== t && (n[e[i][a] + ""] = !0));
                            else void 0 !== e[i] && (c += "&" + o.buildQueryParameter(i, e[i], r));
                        }
                        return c.substring(1);
                    }, o.buildQueryParameter = function(e, t, r) {
                        return o.encodeQuery(e, r) + (null !== t ? "=" + o.encodeQuery(t, r) : "");
                    }, o.addQuery = function(e, t, r) {
                        if ("object" == typeof t) for(var n in t)s.call(t, n) && o.addQuery(e, n, t[n]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
                            if (void 0 === e[t]) return void (e[t] = r);
                            "string" == typeof e[t] && (e[t] = [
                                e[t]
                            ]), l(r) || (r = [
                                r
                            ]), e[t] = (e[t] || []).concat(r);
                        }
                    }, o.setQuery = function(e, t, r) {
                        if ("object" == typeof t) for(var n in t)s.call(t, n) && o.setQuery(e, n, t[n]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.setQuery() accepts an object, string as the name parameter");
                            e[t] = void 0 === r ? null : r;
                        }
                    }, o.removeQuery = function(e, t, r) {
                        var n, i, a;
                        if (l(t)) for(n = 0, i = t.length; n < i; n++)e[t[n]] = void 0;
                        else if ("RegExp" === c(t)) for(a in e)t.test(a) && (e[a] = void 0);
                        else if ("object" == typeof t) for(a in t)s.call(t, a) && o.removeQuery(e, a, t[a]);
                        else {
                            if ("string" != typeof t) throw new TypeError("URI.removeQuery() accepts an object, string, RegExp as the first parameter");
                            void 0 !== r ? "RegExp" === c(r) ? e[t] = !l(e[t]) && r.test(e[t]) ? void 0 : f(e[t], r) : e[t] !== String(r) || l(r) && 1 !== r.length ? l(e[t]) && (e[t] = f(e[t], r)) : e[t] = void 0 : e[t] = void 0;
                        }
                    }, o.hasQuery = function(e, t, r, n) {
                        switch(c(t)){
                            case "String":
                                break;
                            case "RegExp":
                                for(var i in e)if (s.call(e, i) && t.test(i) && (void 0 === r || o.hasQuery(e, i, r))) return !0;
                                return !1;
                            case "Object":
                                for(var a in t)if (s.call(t, a) && !o.hasQuery(e, a, t[a])) return !1;
                                return !0;
                            default:
                                throw new TypeError("URI.hasQuery() accepts a string, regular expression or object as the name parameter");
                        }
                        switch(c(r)){
                            case "Undefined":
                                return t in e;
                            case "Boolean":
                                return r === Boolean(l(e[t]) ? e[t].length : e[t]);
                            case "Function":
                                return !!r(e[t], t, e);
                            case "Array":
                                return !!l(e[t]) && (n ? p : d)(e[t], r);
                            case "RegExp":
                                return l(e[t]) ? !!n && p(e[t], r) : Boolean(e[t] && e[t].match(r));
                            case "Number":
                                r = String(r);
                            case "String":
                                return l(e[t]) ? !!n && p(e[t], r) : e[t] === r;
                            default:
                                throw new TypeError("URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter");
                        }
                    }, o.joinPaths = function() {
                        for(var e = [], t = [], r = 0, n = 0; n < arguments.length; n++){
                            var i = new o(arguments[n]);
                            e.push(i);
                            for(var a = i.segment(), s = 0; s < a.length; s++)"string" == typeof a[s] && t.push(a[s]), a[s] && r++;
                        }
                        if (!t.length || !r) return new o("");
                        var u = new o("").segment(t);
                        return "" !== e[0].path() && "/" !== e[0].path().slice(0, 1) || u.path("/" + u.path()), u.normalize();
                    }, o.commonPath = function(e, t) {
                        var r, n = Math.min(e.length, t.length);
                        for(r = 0; r < n; r++)if (e.charAt(r) !== t.charAt(r)) {
                            r--;
                            break;
                        }
                        return r < 1 ? e.charAt(0) === t.charAt(0) && "/" === e.charAt(0) ? "/" : "" : ("/" === e.charAt(r) && "/" === t.charAt(r) || (r = e.substring(0, r).lastIndexOf("/")), e.substring(0, r + 1));
                    }, o.withinString = function(e, t, r) {
                        r || (r = {});
                        var n = r.start || o.findUri.start, i = r.end || o.findUri.end, a = r.trim || o.findUri.trim, s = r.parens || o.findUri.parens, u = /[a-z0-9-]=["']?$/i;
                        for(n.lastIndex = 0;;){
                            var c = n.exec(e);
                            if (!c) break;
                            var l = c.index;
                            if (r.ignoreHtml) {
                                var f = e.slice(Math.max(l - 3, 0), l);
                                if (f && u.test(f)) continue;
                            }
                            for(var p = l + e.slice(l).search(i), d = e.slice(l, p), h = -1;;){
                                var v = s.exec(d);
                                if (!v) break;
                                h = Math.max(h, v.index + v[0].length);
                            }
                            if (!((d = h > -1 ? d.slice(0, h) + d.slice(h).replace(a, "") : d.replace(a, "")).length <= c[0].length || r.ignore && r.ignore.test(d))) {
                                var m = t(d, l, p = l + d.length, e);
                                void 0 !== m ? (m = String(m), e = e.slice(0, l) + m + e.slice(p), n.lastIndex = l + m.length) : n.lastIndex = p;
                            }
                        }
                        return n.lastIndex = 0, e;
                    }, o.ensureValidHostname = function(t, r) {
                        var n = !!t, i = !1;
                        if (!!r && (i = p(o.hostProtocols, r)), i && !n) throw new TypeError("Hostname cannot be empty, if protocol is " + r);
                        if (t && t.match(o.invalid_hostname_characters)) {
                            if (!e) throw new TypeError('Hostname "' + t + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
                            if (e.toASCII(t).match(o.invalid_hostname_characters)) throw new TypeError('Hostname "' + t + '" contains characters other than [A-Z0-9.-:_]');
                        }
                    }, o.ensureValidPort = function(e) {
                        if (e) {
                            var t = Number(e);
                            if (!(/^[0-9]+$/.test(t) && t > 0 && t < 65536)) throw new TypeError('Port "' + e + '" is not a valid port');
                        }
                    }, o.noConflict = function(e) {
                        if (e) {
                            var t = {
                                URI: this.noConflict()
                            };
                            return n.URITemplate && "function" == typeof n.URITemplate.noConflict && (t.URITemplate = n.URITemplate.noConflict()), n.IPv6 && "function" == typeof n.IPv6.noConflict && (t.IPv6 = n.IPv6.noConflict()), n.SecondLevelDomains && "function" == typeof n.SecondLevelDomains.noConflict && (t.SecondLevelDomains = n.SecondLevelDomains.noConflict()), t;
                        }
                        return n.URI === this && (n.URI = i), this;
                    }, a.build = function(e) {
                        return !0 === e ? this._deferred_build = !0 : (void 0 === e || this._deferred_build) && (this._string = o.build(this._parts), this._deferred_build = !1), this;
                    }, a.clone = function() {
                        return new o(this);
                    }, a.valueOf = a.toString = function() {
                        return this.build(!1)._string;
                    }, a.protocol = S("protocol"), a.username = S("username"), a.password = S("password"), a.hostname = S("hostname"), a.port = S("port"), a.query = _("query", "?"), a.fragment = _("fragment", "#"), a.search = function(e, t) {
                        var r = this.query(e, t);
                        return "string" == typeof r && r.length ? "?" + r : r;
                    }, a.hash = function(e, t) {
                        var r = this.fragment(e, t);
                        return "string" == typeof r && r.length ? "#" + r : r;
                    }, a.pathname = function(e, t) {
                        if (void 0 === e || !0 === e) {
                            var r = this._parts.path || (this._parts.hostname ? "/" : "");
                            return e ? (this._parts.urn ? o.decodeUrnPath : o.decodePath)(r) : r;
                        }
                        return this._parts.path = this._parts.urn ? e ? o.recodeUrnPath(e) : "" : e ? o.recodePath(e) : "/", this.build(!t), this;
                    }, a.path = a.pathname, a.href = function(e, t) {
                        var r;
                        if (void 0 === e) return this.toString();
                        this._string = "", this._parts = o._parts();
                        var n = e instanceof o, i = "object" == typeof e && (e.hostname || e.path || e.pathname);
                        e.nodeName && (e = e[o.getDomAttribute(e)] || "", i = !1);
                        if (!n && i && void 0 !== e.pathname && (e = e.toString()), "string" == typeof e || e instanceof String) this._parts = o.parse(String(e), this._parts);
                        else {
                            if (!n && !i) throw new TypeError("invalid input");
                            var a = n ? e._parts : e;
                            for(r in a)"query" !== r && s.call(this._parts, r) && (this._parts[r] = a[r]);
                            a.query && this.query(a.query, !1);
                        }
                        return this.build(!t), this;
                    }, a.is = function(e) {
                        var t = !1, n = !1, i = !1, a = !1, s = !1, u = !1, c = !1, l = !this._parts.urn;
                        switch(this._parts.hostname && (l = !1, n = o.ip4_expression.test(this._parts.hostname), i = o.ip6_expression.test(this._parts.hostname), s = (a = !(t = n || i)) && r && r.has(this._parts.hostname), u = a && o.idn_expression.test(this._parts.hostname), c = a && o.punycode_expression.test(this._parts.hostname)), e.toLowerCase()){
                            case "relative":
                                return l;
                            case "absolute":
                                return !l;
                            case "domain":
                            case "name":
                                return a;
                            case "sld":
                                return s;
                            case "ip":
                                return t;
                            case "ip4":
                            case "ipv4":
                            case "inet4":
                                return n;
                            case "ip6":
                            case "ipv6":
                            case "inet6":
                                return i;
                            case "idn":
                                return u;
                            case "url":
                                return !this._parts.urn;
                            case "urn":
                                return !!this._parts.urn;
                            case "punycode":
                                return c;
                        }
                        return null;
                    };
                    var O = a.protocol, w = a.port, T = a.hostname;
                    a.protocol = function(e, t) {
                        if (e && !(e = e.replace(/:(\/\/)?$/, "")).match(o.protocol_expression)) throw new TypeError('Protocol "' + e + "\" contains characters other than [A-Z0-9.+-] or doesn't start with [A-Z]");
                        return O.call(this, e, t);
                    }, a.scheme = a.protocol, a.port = function(e, t) {
                        return this._parts.urn ? void 0 === e ? "" : this : (void 0 !== e && (0 === e && (e = null), e && (":" === (e += "").charAt(0) && (e = e.substring(1)), o.ensureValidPort(e))), w.call(this, e, t));
                    }, a.hostname = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 !== e) {
                            var r = {
                                preventInvalidHostname: this._parts.preventInvalidHostname
                            };
                            if ("/" !== o.parseHost(e, r)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                            e = r.hostname, this._parts.preventInvalidHostname && o.ensureValidHostname(e, this._parts.protocol);
                        }
                        return T.call(this, e, t);
                    }, a.origin = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            var r = this.protocol();
                            return this.authority() ? (r ? r + "://" : "") + this.authority() : "";
                        }
                        var n = o(e);
                        return this.protocol(n.protocol()).authority(n.authority()).build(!t), this;
                    }, a.host = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) return this._parts.hostname ? o.buildHost(this._parts) : "";
                        if ("/" !== o.parseHost(e, this._parts)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                        return this.build(!t), this;
                    }, a.authority = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) return this._parts.hostname ? o.buildAuthority(this._parts) : "";
                        if ("/" !== o.parseAuthority(e, this._parts)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
                        return this.build(!t), this;
                    }, a.userinfo = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            var r = o.buildUserinfo(this._parts);
                            return r ? r.substring(0, r.length - 1) : r;
                        }
                        return "@" !== e[e.length - 1] && (e += "@"), o.parseUserinfo(e, this._parts), this.build(!t), this;
                    }, a.resource = function(e, t) {
                        var r;
                        return void 0 === e ? this.path() + this.search() + this.hash() : (r = o.parse(e), this._parts.path = r.path, this._parts.query = r.query, this._parts.fragment = r.fragment, this.build(!t), this);
                    }, a.subdomain = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var r = this._parts.hostname.length - this.domain().length - 1;
                            return this._parts.hostname.substring(0, r) || "";
                        }
                        var n = this._parts.hostname.length - this.domain().length, i = this._parts.hostname.substring(0, n), a = new RegExp("^" + u(i));
                        if (e && "." !== e.charAt(e.length - 1) && (e += "."), -1 !== e.indexOf(":")) throw new TypeError("Domains cannot contain colons");
                        return e && o.ensureValidHostname(e, this._parts.protocol), this._parts.hostname = this._parts.hostname.replace(a, e), this.build(!t), this;
                    }, a.domain = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("boolean" == typeof e && (t = e, e = void 0), void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var r = this._parts.hostname.match(/\./g);
                            if (r && r.length < 2) return this._parts.hostname;
                            var n = this._parts.hostname.length - this.tld(t).length - 1;
                            return n = this._parts.hostname.lastIndexOf(".", n - 1) + 1, this._parts.hostname.substring(n) || "";
                        }
                        if (!e) throw new TypeError("cannot set domain empty");
                        if (-1 !== e.indexOf(":")) throw new TypeError("Domains cannot contain colons");
                        if (o.ensureValidHostname(e, this._parts.protocol), !this._parts.hostname || this.is("IP")) this._parts.hostname = e;
                        else {
                            var i = new RegExp(u(this.domain()) + "$");
                            this._parts.hostname = this._parts.hostname.replace(i, e);
                        }
                        return this.build(!t), this;
                    }, a.tld = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("boolean" == typeof e && (t = e, e = void 0), void 0 === e) {
                            if (!this._parts.hostname || this.is("IP")) return "";
                            var n = this._parts.hostname.lastIndexOf("."), i = this._parts.hostname.substring(n + 1);
                            return !0 !== t && r && r.list[i.toLowerCase()] && r.get(this._parts.hostname) || i;
                        }
                        var o;
                        if (!e) throw new TypeError("cannot set TLD empty");
                        if (e.match(/[^a-zA-Z0-9-]/)) {
                            if (!r || !r.is(e)) throw new TypeError('TLD "' + e + '" contains characters other than [A-Z0-9]');
                            o = new RegExp(u(this.tld()) + "$"), this._parts.hostname = this._parts.hostname.replace(o, e);
                        } else {
                            if (!this._parts.hostname || this.is("IP")) throw new ReferenceError("cannot set TLD on non-domain host");
                            o = new RegExp(u(this.tld()) + "$"), this._parts.hostname = this._parts.hostname.replace(o, e);
                        }
                        return this.build(!t), this;
                    }, a.directory = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e || !0 === e) {
                            if (!this._parts.path && !this._parts.hostname) return "";
                            if ("/" === this._parts.path) return "/";
                            var r = this._parts.path.length - this.filename().length - 1, n = this._parts.path.substring(0, r) || (this._parts.hostname ? "/" : "");
                            return e ? o.decodePath(n) : n;
                        }
                        var i = this._parts.path.length - this.filename().length, a = this._parts.path.substring(0, i), s = new RegExp("^" + u(a));
                        return this.is("relative") || (e || (e = "/"), "/" !== e.charAt(0) && (e = "/" + e)), e && "/" !== e.charAt(e.length - 1) && (e += "/"), e = o.recodePath(e), this._parts.path = this._parts.path.replace(s, e), this.build(!t), this;
                    }, a.filename = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if ("string" != typeof e) {
                            if (!this._parts.path || "/" === this._parts.path) return "";
                            var r = this._parts.path.lastIndexOf("/"), n = this._parts.path.substring(r + 1);
                            return e ? o.decodePathSegment(n) : n;
                        }
                        var i = !1;
                        "/" === e.charAt(0) && (e = e.substring(1)), e.match(/\.?\//) && (i = !0);
                        var a = new RegExp(u(this.filename()) + "$");
                        return e = o.recodePath(e), this._parts.path = this._parts.path.replace(a, e), i ? this.normalizePath(t) : this.build(!t), this;
                    }, a.suffix = function(e, t) {
                        if (this._parts.urn) return void 0 === e ? "" : this;
                        if (void 0 === e || !0 === e) {
                            if (!this._parts.path || "/" === this._parts.path) return "";
                            var r, n, i = this.filename(), a = i.lastIndexOf(".");
                            return -1 === a ? "" : (r = i.substring(a + 1), n = /^[a-z0-9%]+$/i.test(r) ? r : "", e ? o.decodePathSegment(n) : n);
                        }
                        "." === e.charAt(0) && (e = e.substring(1));
                        var s, c = this.suffix();
                        if (c) s = e ? new RegExp(u(c) + "$") : new RegExp(u("." + c) + "$");
                        else {
                            if (!e) return this;
                            this._parts.path += "." + o.recodePath(e);
                        }
                        return s && (e = o.recodePath(e), this._parts.path = this._parts.path.replace(s, e)), this.build(!t), this;
                    }, a.segment = function(e, t, r) {
                        var n = this._parts.urn ? ":" : "/", i = this.path(), o = "/" === i.substring(0, 1), a = i.split(n);
                        if (void 0 !== e && "number" != typeof e && (r = t, t = e, e = void 0), void 0 !== e && "number" != typeof e) throw new Error('Bad segment "' + e + '", must be 0-based integer');
                        if (o && a.shift(), e < 0 && (e = Math.max(a.length + e, 0)), void 0 === t) return void 0 === e ? a : a[e];
                        if (null === e || void 0 === a[e]) {
                            if (l(t)) {
                                a = [];
                                for(var s = 0, u = t.length; s < u; s++)(t[s].length || a.length && a[a.length - 1].length) && (a.length && !a[a.length - 1].length && a.pop(), a.push(h(t[s])));
                            } else (t || "string" == typeof t) && (t = h(t), "" === a[a.length - 1] ? a[a.length - 1] = t : a.push(t));
                        } else t ? a[e] = h(t) : a.splice(e, 1);
                        return o && a.unshift(""), this.path(a.join(n), r);
                    }, a.segmentCoded = function(e, t, r) {
                        var n, i, a;
                        if ("number" != typeof e && (r = t, t = e, e = void 0), void 0 === t) {
                            if (l(n = this.segment(e, t, r))) for(i = 0, a = n.length; i < a; i++)n[i] = o.decode(n[i]);
                            else n = void 0 !== n ? o.decode(n) : void 0;
                            return n;
                        }
                        if (l(t)) for(i = 0, a = t.length; i < a; i++)t[i] = o.encode(t[i]);
                        else t = "string" == typeof t || t instanceof String ? o.encode(t) : t;
                        return this.segment(e, t, r);
                    };
                    var I = a.query;
                    return a.query = function(e, t) {
                        if (!0 === e) return o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        if ("function" == typeof e) {
                            var r = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace), n = e.call(this, r);
                            return this._parts.query = o.buildQuery(n || r, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), this.build(!t), this;
                        }
                        return void 0 !== e && "string" != typeof e ? (this._parts.query = o.buildQuery(e, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), this.build(!t), this) : I.call(this, e, t);
                    }, a.setQuery = function(e, t, r) {
                        var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        if ("string" == typeof e || e instanceof String) n[e] = void 0 !== t ? t : null;
                        else {
                            if ("object" != typeof e) throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
                            for(var i in e)s.call(e, i) && (n[i] = e[i]);
                        }
                        return this._parts.query = o.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.addQuery = function(e, t, r) {
                        var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return o.addQuery(n, e, void 0 === t ? null : t), this._parts.query = o.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.removeQuery = function(e, t, r) {
                        var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return o.removeQuery(n, e, t), this._parts.query = o.buildQuery(n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (r = t), this.build(!r), this;
                    }, a.hasQuery = function(e, t, r) {
                        var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
                        return o.hasQuery(n, e, t, r);
                    }, a.setSearch = a.setQuery, a.addSearch = a.addQuery, a.removeSearch = a.removeQuery, a.hasSearch = a.hasQuery, a.normalize = function() {
                        return this._parts.urn ? this.normalizeProtocol(!1).normalizePath(!1).normalizeQuery(!1).normalizeFragment(!1).build() : this.normalizeProtocol(!1).normalizeHostname(!1).normalizePort(!1).normalizePath(!1).normalizeQuery(!1).normalizeFragment(!1).build();
                    }, a.normalizeProtocol = function(e) {
                        return "string" == typeof this._parts.protocol && (this._parts.protocol = this._parts.protocol.toLowerCase(), this.build(!e)), this;
                    }, a.normalizeHostname = function(r) {
                        return this._parts.hostname && (this.is("IDN") && e ? this._parts.hostname = e.toASCII(this._parts.hostname) : this.is("IPv6") && t && (this._parts.hostname = t.best(this._parts.hostname)), this._parts.hostname = this._parts.hostname.toLowerCase(), this.build(!r)), this;
                    }, a.normalizePort = function(e) {
                        return "string" == typeof this._parts.protocol && this._parts.port === o.defaultPorts[this._parts.protocol] && (this._parts.port = null, this.build(!e)), this;
                    }, a.normalizePath = function(e) {
                        var t, r = this._parts.path;
                        if (!r) return this;
                        if (this._parts.urn) return this._parts.path = o.recodeUrnPath(this._parts.path), this.build(!e), this;
                        if ("/" === this._parts.path) return this;
                        var n, i, a = "";
                        for("/" !== (r = o.recodePath(r)).charAt(0) && (t = !0, r = "/" + r), "/.." !== r.slice(-3) && "/." !== r.slice(-2) || (r += "/"), r = r.replace(/(\/(\.\/)+)|(\/\.$)/g, "/").replace(/\/{2,}/g, "/"), t && (a = r.substring(1).match(/^(\.\.\/)+/) || "") && (a = a[0]); -1 !== (n = r.search(/\/\.\.(\/|$)/));)0 !== n ? (-1 === (i = r.substring(0, n).lastIndexOf("/")) && (i = n), r = r.substring(0, i) + r.substring(n + 3)) : r = r.substring(3);
                        return t && this.is("relative") && (r = a + r.substring(1)), this._parts.path = r, this.build(!e), this;
                    }, a.normalizePathname = a.normalizePath, a.normalizeQuery = function(e) {
                        return "string" == typeof this._parts.query && (this._parts.query.length ? this.query(o.parseQuery(this._parts.query, this._parts.escapeQuerySpace)) : this._parts.query = null, this.build(!e)), this;
                    }, a.normalizeFragment = function(e) {
                        return this._parts.fragment || (this._parts.fragment = null, this.build(!e)), this;
                    }, a.normalizeSearch = a.normalizeQuery, a.normalizeHash = a.normalizeFragment, a.iso8859 = function() {
                        var e = o.encode, t = o.decode;
                        o.encode = escape, o.decode = decodeURIComponent;
                        try {
                            this.normalize();
                        } finally{
                            o.encode = e, o.decode = t;
                        }
                        return this;
                    }, a.unicode = function() {
                        var e = o.encode, t = o.decode;
                        o.encode = m, o.decode = unescape;
                        try {
                            this.normalize();
                        } finally{
                            o.encode = e, o.decode = t;
                        }
                        return this;
                    }, a.readable = function() {
                        var t = this.clone();
                        t.username("").password("").normalize();
                        var r = "";
                        if (t._parts.protocol && (r += t._parts.protocol + "://"), t._parts.hostname && (t.is("punycode") && e ? (r += e.toUnicode(t._parts.hostname), t._parts.port && (r += ":" + t._parts.port)) : r += t.host()), t._parts.hostname && t._parts.path && "/" !== t._parts.path.charAt(0) && (r += "/"), r += t.path(!0), t._parts.query) {
                            for(var n = "", i = 0, a = t._parts.query.split("&"), s = a.length; i < s; i++){
                                var u = (a[i] || "").split("=");
                                n += "&" + o.decodeQuery(u[0], this._parts.escapeQuerySpace).replace(/&/g, "%26"), void 0 !== u[1] && (n += "=" + o.decodeQuery(u[1], this._parts.escapeQuerySpace).replace(/&/g, "%26"));
                            }
                            r += "?" + n.substring(1);
                        }
                        return r += o.decodeQuery(t.hash(), !0);
                    }, a.absoluteTo = function(e) {
                        var t, r, n, i = this.clone(), a = [
                            "protocol",
                            "username",
                            "password",
                            "hostname",
                            "port"
                        ];
                        if (this._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
                        if (e instanceof o || (e = new o(e)), i._parts.protocol) return i;
                        if (i._parts.protocol = e._parts.protocol, this._parts.hostname) return i;
                        for(r = 0; n = a[r]; r++)i._parts[n] = e._parts[n];
                        return i._parts.path ? (".." === i._parts.path.substring(-2) && (i._parts.path += "/"), "/" !== i.path().charAt(0) && (t = (t = e.directory()) || (0 === e.path().indexOf("/") ? "/" : ""), i._parts.path = (t ? t + "/" : "") + i._parts.path, i.normalizePath())) : (i._parts.path = e._parts.path, i._parts.query || (i._parts.query = e._parts.query)), i.build(), i;
                    }, a.relativeTo = function(e) {
                        var t, r, n, i, a, s = this.clone().normalize();
                        if (s._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
                        if (e = new o(e).normalize(), t = s._parts, r = e._parts, i = s.path(), a = e.path(), "/" !== i.charAt(0)) throw new Error("URI is already relative");
                        if ("/" !== a.charAt(0)) throw new Error("Cannot calculate a URI relative to another relative URI");
                        if (t.protocol === r.protocol && (t.protocol = null), t.username !== r.username || t.password !== r.password) return s.build();
                        if (null !== t.protocol || null !== t.username || null !== t.password) return s.build();
                        if (t.hostname !== r.hostname || t.port !== r.port) return s.build();
                        if (t.hostname = null, t.port = null, i === a) return t.path = "", s.build();
                        if (!(n = o.commonPath(i, a))) return s.build();
                        var u = r.path.substring(n.length).replace(/[^\/]*$/, "").replace(/.*?\//g, "../");
                        return t.path = u + t.path.substring(n.length) || "./", s.build();
                    }, a.equals = function(e) {
                        var t, r, n, i, a, u = this.clone(), c = new o(e), f = {};
                        if (u.normalize(), c.normalize(), u.toString() === c.toString()) return !0;
                        if (n = u.query(), i = c.query(), u.query(""), c.query(""), u.toString() !== c.toString()) return !1;
                        if (n.length !== i.length) return !1;
                        for(a in t = o.parseQuery(n, this._parts.escapeQuerySpace), r = o.parseQuery(i, this._parts.escapeQuerySpace), t)if (s.call(t, a)) {
                            if (l(t[a])) {
                                if (!d(t[a], r[a])) return !1;
                            } else if (t[a] !== r[a]) return !1;
                            f[a] = !0;
                        }
                        for(a in r)if (s.call(r, a) && !f[a]) return !1;
                        return !0;
                    }, a.preventInvalidHostname = function(e) {
                        return this._parts.preventInvalidHostname = !!e, this;
                    }, a.duplicateQueryParameters = function(e) {
                        return this._parts.duplicateQueryParameters = !!e, this;
                    }, a.escapeQuerySpace = function(e) {
                        return this._parts.escapeQuerySpace = !!e, this;
                    }, o;
                });
            },
            4344: function(e, t, r) {
                var n;
                e = r.nmd(e), function(i) {
                    var o = "object" == typeof r.g && r.g;
                    var a, s = 2147483647, u = 36, c = 1, l = 26, f = 38, p = 700, d = 72, h = 128, v = "-", m = /^xn--/, y = /[^\x20-\x7E]/, g = /[\x2E\u3002\uFF0E\uFF61]/g, E = {
                        overflow: "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, b = u - c, S = Math.floor, _ = String.fromCharCode;
                    function O(e) {
                        throw new RangeError(E[e]);
                    }
                    function w(e, t) {
                        for(var r = e.length, n = []; r--;)n[r] = t(e[r]);
                        return n;
                    }
                    function T(e, t) {
                        var r = e.split("@"), n = "";
                        return r.length > 1 && (n = r[0] + "@", e = r[1]), n + w((e = e.replace(g, ".")).split("."), t).join(".");
                    }
                    function I(e) {
                        for(var t, r, n = [], i = 0, o = e.length; i < o;)(t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < o ? 56320 == (64512 & (r = e.charCodeAt(i++))) ? n.push(((1023 & t) << 10) + (1023 & r) + 65536) : (n.push(t), i--) : n.push(t);
                        return n;
                    }
                    function R(e) {
                        return w(e, function(e) {
                            var t = "";
                            return e > 65535 && (t += _((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += _(e);
                        }).join("");
                    }
                    function x(e, t) {
                        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
                    }
                    function A(e, t, r) {
                        var n = 0;
                        for(e = r ? S(e / p) : e >> 1, e += S(e / t); e > b * l >> 1; n += u)e = S(e / b);
                        return S(n + (b + 1) * e / (e + f));
                    }
                    function N(e) {
                        var t, r, n, i, o, a, f, p, m, y, g, E = [], b = e.length, _ = 0, w = h, T = d;
                        for((r = e.lastIndexOf(v)) < 0 && (r = 0), n = 0; n < r; ++n)e.charCodeAt(n) >= 128 && O("not-basic"), E.push(e.charCodeAt(n));
                        for(i = r > 0 ? r + 1 : 0; i < b;){
                            for(o = _, a = 1, f = u; i >= b && O("invalid-input"), ((p = (g = e.charCodeAt(i++)) - 48 < 10 ? g - 22 : g - 65 < 26 ? g - 65 : g - 97 < 26 ? g - 97 : u) >= u || p > S((s - _) / a)) && O("overflow"), _ += p * a, !(p < (m = f <= T ? c : f >= T + l ? l : f - T)); f += u)a > S(s / (y = u - m)) && O("overflow"), a *= y;
                            T = A(_ - o, t = E.length + 1, 0 == o), S(_ / t) > s - w && O("overflow"), w += S(_ / t), _ %= t, E.splice(_++, 0, w);
                        }
                        return R(E);
                    }
                    function C(e) {
                        var t, r, n, i, o, a, f, p, m, y, g, E, b, w, T, R = [];
                        for(E = (e = I(e)).length, t = h, r = 0, o = d, a = 0; a < E; ++a)(g = e[a]) < 128 && R.push(_(g));
                        for(n = i = R.length, i && R.push(v); n < E;){
                            for(f = s, a = 0; a < E; ++a)(g = e[a]) >= t && g < f && (f = g);
                            for(f - t > S((s - r) / (b = n + 1)) && O("overflow"), r += (f - t) * b, t = f, a = 0; a < E; ++a)if ((g = e[a]) < t && ++r > s && O("overflow"), g == t) {
                                for(p = r, m = u; !(p < (y = m <= o ? c : m >= o + l ? l : m - o)); m += u)R.push(_(x(y + (T = p - y) % (w = u - y), 0))), p = S(T / w);
                                R.push(_(x(p, 0))), o = A(r, b, n == i), r = 0, ++n;
                            }
                            ++r, ++t;
                        }
                        return R.join("");
                    }
                    a = {
                        version: "1.3.2",
                        ucs2: {
                            decode: I,
                            encode: R
                        },
                        decode: N,
                        encode: C,
                        toASCII: function(e) {
                            return T(e, function(e) {
                                return y.test(e) ? "xn--" + C(e) : e;
                            });
                        },
                        toUnicode: function(e) {
                            return T(e, function(e) {
                                return m.test(e) ? N(e.slice(4).toLowerCase()) : e;
                            });
                        }
                    }, void 0 === (n = (function() {
                        return a;
                    }).call(t, r, t, e)) || (e.exports = n);
                }();
            },
            8566: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    DOMException: ()=>S,
                    Headers: ()=>l,
                    Request: ()=>y,
                    Response: ()=>E,
                    fetch: ()=>_
                });
                var n = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== r.g && r.g || {}, i = {
                    searchParams: "URLSearchParams" in n,
                    iterable: "Symbol" in n && "iterator" in Symbol,
                    blob: "FileReader" in n && "Blob" in n && function() {
                        try {
                            return new Blob, !0;
                        } catch (e) {
                            return !1;
                        }
                    }(),
                    formData: "FormData" in n,
                    arrayBuffer: "ArrayBuffer" in n
                };
                if (i.arrayBuffer) var o = [
                    "[object Int8Array]",
                    "[object Uint8Array]",
                    "[object Uint8ClampedArray]",
                    "[object Int16Array]",
                    "[object Uint16Array]",
                    "[object Int32Array]",
                    "[object Uint32Array]",
                    "[object Float32Array]",
                    "[object Float64Array]"
                ], a = ArrayBuffer.isView || function(e) {
                    return e && o.indexOf(Object.prototype.toString.call(e)) > -1;
                };
                function s(e) {
                    if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
                    return e.toLowerCase();
                }
                function u(e) {
                    return "string" != typeof e && (e = String(e)), e;
                }
                function c(e) {
                    var t = {
                        next: function() {
                            var t = e.shift();
                            return {
                                done: void 0 === t,
                                value: t
                            };
                        }
                    };
                    return i.iterable && (t[Symbol.iterator] = function() {
                        return t;
                    }), t;
                }
                function l(e) {
                    this.map = {}, e instanceof l ? e.forEach(function(e, t) {
                        this.append(t, e);
                    }, this) : Array.isArray(e) ? e.forEach(function(e) {
                        if (2 != e.length) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + e.length);
                        this.append(e[0], e[1]);
                    }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                        this.append(t, e[t]);
                    }, this);
                }
                function f(e) {
                    if (!e._noBody) return e.bodyUsed ? Promise.reject(new TypeError("Already read")) : void (e.bodyUsed = !0);
                }
                function p(e) {
                    return new Promise(function(t, r) {
                        e.onload = function() {
                            t(e.result);
                        }, e.onerror = function() {
                            r(e.error);
                        };
                    });
                }
                function d(e) {
                    var t = new FileReader, r = p(t);
                    return t.readAsArrayBuffer(e), r;
                }
                function h(e) {
                    if (e.slice) return e.slice(0);
                    var t = new Uint8Array(e.byteLength);
                    return t.set(new Uint8Array(e)), t.buffer;
                }
                function v() {
                    return this.bodyUsed = !1, this._initBody = function(e) {
                        var t;
                        this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : i.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : i.arrayBuffer && i.blob && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = h(e.buffer), this._bodyInit = new Blob([
                            this._bodyArrayBuffer
                        ])) : i.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || a(e)) ? this._bodyArrayBuffer = h(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                    }, i.blob && (this.blob = function() {
                        var e = f(this);
                        if (e) return e;
                        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                            this._bodyArrayBuffer
                        ]));
                        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                        return Promise.resolve(new Blob([
                            this._bodyText
                        ]));
                    }), this.arrayBuffer = function() {
                        if (this._bodyArrayBuffer) {
                            var e = f(this);
                            return e || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer));
                        }
                        if (i.blob) return this.blob().then(d);
                        throw new Error("could not read as ArrayBuffer");
                    }, this.text = function() {
                        var e, t, r, n, i = f(this);
                        if (i) return i;
                        if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader, r = p(t), n = /charset=([A-Za-z0-9_-]+)/.exec(e.type), t.readAsText(e, n ? n[1] : "utf-8"), r;
                        if (this._bodyArrayBuffer) return Promise.resolve(function(e) {
                            for(var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++)r[n] = String.fromCharCode(t[n]);
                            return r.join("");
                        }(this._bodyArrayBuffer));
                        if (this._bodyFormData) throw new Error("could not read FormData body as text");
                        return Promise.resolve(this._bodyText);
                    }, i.formData && (this.formData = function() {
                        return this.text().then(g);
                    }), this.json = function() {
                        return this.text().then(JSON.parse);
                    }, this;
                }
                l.prototype.append = function(e, t) {
                    e = s(e), t = u(t);
                    var r = this.map[e];
                    this.map[e] = r ? r + ", " + t : t;
                }, l.prototype.delete = function(e) {
                    delete this.map[s(e)];
                }, l.prototype.get = function(e) {
                    return e = s(e), this.has(e) ? this.map[e] : null;
                }, l.prototype.has = function(e) {
                    return this.map.hasOwnProperty(s(e));
                }, l.prototype.set = function(e, t) {
                    this.map[s(e)] = u(t);
                }, l.prototype.forEach = function(e, t) {
                    for(var r in this.map)this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
                }, l.prototype.keys = function() {
                    var e = [];
                    return this.forEach(function(t, r) {
                        e.push(r);
                    }), c(e);
                }, l.prototype.values = function() {
                    var e = [];
                    return this.forEach(function(t) {
                        e.push(t);
                    }), c(e);
                }, l.prototype.entries = function() {
                    var e = [];
                    return this.forEach(function(t, r) {
                        e.push([
                            r,
                            t
                        ]);
                    }), c(e);
                }, i.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
                var m = [
                    "CONNECT",
                    "DELETE",
                    "GET",
                    "HEAD",
                    "OPTIONS",
                    "PATCH",
                    "POST",
                    "PUT",
                    "TRACE"
                ];
                function y(e, t) {
                    if (!(this instanceof y)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    var r, i, o = (t = t || {}).body;
                    if (e instanceof y) {
                        if (e.bodyUsed) throw new TypeError("Already read");
                        this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new l(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
                    } else this.url = String(e);
                    if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new l(t.headers)), this.method = (i = (r = t.method || this.method || "GET").toUpperCase(), m.indexOf(i) > -1 ? i : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
                        if ("AbortController" in n) return (new AbortController).signal;
                    }(), this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                    if (this._initBody(o), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
                        var a = /([?&])_=[^&]*/;
                        if (a.test(this.url)) this.url = this.url.replace(a, "$1_=" + (new Date).getTime());
                        else this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
                    }
                }
                function g(e) {
                    var t = new FormData;
                    return e.trim().split("&").forEach(function(e) {
                        if (e) {
                            var r = e.split("="), n = r.shift().replace(/\+/g, " "), i = r.join("=").replace(/\+/g, " ");
                            t.append(decodeURIComponent(n), decodeURIComponent(i));
                        }
                    }), t;
                }
                function E(e, t) {
                    if (!(this instanceof E)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    if (t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
                    this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new l(t.headers), this.url = t.url || "", this._initBody(e);
                }
                y.prototype.clone = function() {
                    return new y(this, {
                        body: this._bodyInit
                    });
                }, v.call(y.prototype), v.call(E.prototype), E.prototype.clone = function() {
                    return new E(this._bodyInit, {
                        status: this.status,
                        statusText: this.statusText,
                        headers: new l(this.headers),
                        url: this.url
                    });
                }, E.error = function() {
                    var e = new E(null, {
                        status: 200,
                        statusText: ""
                    });
                    return e.ok = !1, e.status = 0, e.type = "error", e;
                };
                var b = [
                    301,
                    302,
                    303,
                    307,
                    308
                ];
                E.redirect = function(e, t) {
                    if (-1 === b.indexOf(t)) throw new RangeError("Invalid status code");
                    return new E(null, {
                        status: t,
                        headers: {
                            location: e
                        }
                    });
                };
                var S = n.DOMException;
                try {
                    new S;
                } catch (e) {
                    (S = function(e, t) {
                        this.message = e, this.name = t;
                        var r = Error(e);
                        this.stack = r.stack;
                    }).prototype = Object.create(Error.prototype), S.prototype.constructor = S;
                }
                function _(e, t) {
                    return new Promise(function(r, o) {
                        var a = new y(e, t);
                        if (a.signal && a.signal.aborted) return o(new S("Aborted", "AbortError"));
                        var c = new XMLHttpRequest;
                        function f() {
                            c.abort();
                        }
                        if (c.onload = function() {
                            var e, t, n = {
                                statusText: c.statusText,
                                headers: (e = c.getAllResponseHeaders() || "", t = new l, e.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(e) {
                                    return 0 === e.indexOf("\n") ? e.substr(1, e.length) : e;
                                }).forEach(function(e) {
                                    var r = e.split(":"), n = r.shift().trim();
                                    if (n) {
                                        var i = r.join(":").trim();
                                        try {
                                            t.append(n, i);
                                        } catch (e) {
                                            console.warn("Response " + e.message);
                                        }
                                    }
                                }), t)
                            };
                            n.status = 0 === a.url.indexOf("file://") && (c.status < 200 || c.status > 599) ? 200 : c.status, n.url = "responseURL" in c ? c.responseURL : n.headers.get("X-Request-URL");
                            var i = "response" in c ? c.response : c.responseText;
                            setTimeout(function() {
                                r(new E(i, n));
                            }, 0);
                        }, c.onerror = function() {
                            setTimeout(function() {
                                o(new TypeError("Network request failed"));
                            }, 0);
                        }, c.ontimeout = function() {
                            setTimeout(function() {
                                o(new TypeError("Network request timed out"));
                            }, 0);
                        }, c.onabort = function() {
                            setTimeout(function() {
                                o(new S("Aborted", "AbortError"));
                            }, 0);
                        }, c.open(a.method, function(e) {
                            try {
                                return "" === e && n.location.href ? n.location.href : e;
                            } catch (t) {
                                return e;
                            }
                        }(a.url), !0), "include" === a.credentials ? c.withCredentials = !0 : "omit" === a.credentials && (c.withCredentials = !1), "responseType" in c && (i.blob ? c.responseType = "blob" : i.arrayBuffer && (c.responseType = "arraybuffer")), t && "object" == typeof t.headers && !(t.headers instanceof l || n.Headers && t.headers instanceof n.Headers)) {
                            var p = [];
                            Object.getOwnPropertyNames(t.headers).forEach(function(e) {
                                p.push(s(e)), c.setRequestHeader(e, u(t.headers[e]));
                            }), a.headers.forEach(function(e, t) {
                                -1 === p.indexOf(t) && c.setRequestHeader(t, e);
                            });
                        } else a.headers.forEach(function(e, t) {
                            c.setRequestHeader(t, e);
                        });
                        a.signal && (a.signal.addEventListener("abort", f), c.onreadystatechange = function() {
                            4 === c.readyState && a.signal.removeEventListener("abort", f);
                        }), c.send(void 0 === a._bodyInit ? null : a._bodyInit);
                    });
                }
                _.polyfill = !0, n.fetch || (n.fetch = _, n.Headers = l, n.Request = y, n.Response = E);
            },
            674: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>i
                });
                var n = r(8666);
                const i = r.n(n)();
            },
            8666: (e, t, r)=>{
                e.exports = r(7603).Observable;
            },
            7603: (e, t)=>{
                "use strict";
                function r(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function n(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                function i(e, t, r) {
                    return t && n(e.prototype, t), r && n(e, r), e;
                }
                t.Observable = void 0;
                var o = function() {
                    return "function" == typeof Symbol;
                }, a = function(e) {
                    return o() && Boolean(Symbol[e]);
                }, s = function(e) {
                    return a(e) ? Symbol[e] : "@@" + e;
                };
                o() && !a("observable") && (Symbol.observable = Symbol("observable"));
                var u = s("iterator"), c = s("observable"), l = s("species");
                function f(e, t) {
                    var r = e[t];
                    if (null != r) {
                        if ("function" != typeof r) throw new TypeError(r + " is not a function");
                        return r;
                    }
                }
                function p(e) {
                    var t = e.constructor;
                    return void 0 !== t && null === (t = t[l]) && (t = void 0), void 0 !== t ? t : _;
                }
                function d(e) {
                    return e instanceof _;
                }
                function h(e) {
                    h.log ? h.log(e) : setTimeout(function() {
                        throw e;
                    });
                }
                function v(e) {
                    Promise.resolve().then(function() {
                        try {
                            e();
                        } catch (e) {
                            h(e);
                        }
                    });
                }
                function m(e) {
                    var t = e._cleanup;
                    if (void 0 !== t && (e._cleanup = void 0, t)) try {
                        if ("function" == typeof t) t();
                        else {
                            var r = f(t, "unsubscribe");
                            r && r.call(t);
                        }
                    } catch (e) {
                        h(e);
                    }
                }
                function y(e) {
                    e._observer = void 0, e._queue = void 0, e._state = "closed";
                }
                function g(e, t, r) {
                    e._state = "running";
                    var n = e._observer;
                    try {
                        var i = f(n, t);
                        switch(t){
                            case "next":
                                i && i.call(n, r);
                                break;
                            case "error":
                                if (y(e), !i) throw r;
                                i.call(n, r);
                                break;
                            case "complete":
                                y(e), i && i.call(n);
                        }
                    } catch (e) {
                        h(e);
                    }
                    "closed" === e._state ? m(e) : "running" === e._state && (e._state = "ready");
                }
                function E(e, t, r) {
                    if ("closed" !== e._state) {
                        if ("buffering" !== e._state) return "ready" !== e._state ? (e._state = "buffering", e._queue = [
                            {
                                type: t,
                                value: r
                            }
                        ], void v(function() {
                            return function(e) {
                                var t = e._queue;
                                if (t) {
                                    e._queue = void 0, e._state = "ready";
                                    for(var r = 0; r < t.length && (g(e, t[r].type, t[r].value), "closed" !== e._state); ++r);
                                }
                            }(e);
                        })) : void g(e, t, r);
                        e._queue.push({
                            type: t,
                            value: r
                        });
                    }
                }
                var b = function() {
                    function e(t, n) {
                        r(this, e), this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
                        var i = new S(this);
                        try {
                            this._cleanup = n.call(void 0, i);
                        } catch (e) {
                            i.error(e);
                        }
                        "initializing" === this._state && (this._state = "ready");
                    }
                    return i(e, [
                        {
                            key: "unsubscribe",
                            value: function() {
                                "closed" !== this._state && (y(this), m(this));
                            }
                        },
                        {
                            key: "closed",
                            get: function() {
                                return "closed" === this._state;
                            }
                        }
                    ]), e;
                }(), S = function() {
                    function e(t) {
                        r(this, e), this._subscription = t;
                    }
                    return i(e, [
                        {
                            key: "next",
                            value: function(e) {
                                E(this._subscription, "next", e);
                            }
                        },
                        {
                            key: "error",
                            value: function(e) {
                                E(this._subscription, "error", e);
                            }
                        },
                        {
                            key: "complete",
                            value: function() {
                                E(this._subscription, "complete");
                            }
                        },
                        {
                            key: "closed",
                            get: function() {
                                return "closed" === this._subscription._state;
                            }
                        }
                    ]), e;
                }(), _ = function() {
                    function e(t) {
                        if (r(this, e), !(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
                        if ("function" != typeof t) throw new TypeError("Observable initializer must be a function");
                        this._subscriber = t;
                    }
                    return i(e, [
                        {
                            key: "subscribe",
                            value: function(e) {
                                return "object" == typeof e && null !== e || (e = {
                                    next: e,
                                    error: arguments[1],
                                    complete: arguments[2]
                                }), new b(e, this._subscriber);
                            }
                        },
                        {
                            key: "forEach",
                            value: function(e) {
                                var t = this;
                                return new Promise(function(r, n) {
                                    if ("function" == typeof e) var i = t.subscribe({
                                        next: function(t) {
                                            try {
                                                e(t, o);
                                            } catch (e) {
                                                n(e), i.unsubscribe();
                                            }
                                        },
                                        error: n,
                                        complete: r
                                    });
                                    else n(new TypeError(e + " is not a function"));
                                    function o() {
                                        i.unsubscribe(), r();
                                    }
                                });
                            }
                        },
                        {
                            key: "map",
                            value: function(e) {
                                var t = this;
                                if ("function" != typeof e) throw new TypeError(e + " is not a function");
                                return new (p(this))(function(r) {
                                    return t.subscribe({
                                        next: function(t) {
                                            try {
                                                t = e(t);
                                            } catch (e) {
                                                return r.error(e);
                                            }
                                            r.next(t);
                                        },
                                        error: function(e) {
                                            r.error(e);
                                        },
                                        complete: function() {
                                            r.complete();
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "filter",
                            value: function(e) {
                                var t = this;
                                if ("function" != typeof e) throw new TypeError(e + " is not a function");
                                return new (p(this))(function(r) {
                                    return t.subscribe({
                                        next: function(t) {
                                            try {
                                                if (!e(t)) return;
                                            } catch (e) {
                                                return r.error(e);
                                            }
                                            r.next(t);
                                        },
                                        error: function(e) {
                                            r.error(e);
                                        },
                                        complete: function() {
                                            r.complete();
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "reduce",
                            value: function(e) {
                                var t = this;
                                if ("function" != typeof e) throw new TypeError(e + " is not a function");
                                var r = p(this), n = arguments.length > 1, i = !1, o = arguments[1];
                                return new r(function(r) {
                                    return t.subscribe({
                                        next: function(t) {
                                            var a = !i;
                                            if (i = !0, !a || n) try {
                                                o = e(o, t);
                                            } catch (e) {
                                                return r.error(e);
                                            }
                                            else o = t;
                                        },
                                        error: function(e) {
                                            r.error(e);
                                        },
                                        complete: function() {
                                            if (!i && !n) return r.error(new TypeError("Cannot reduce an empty sequence"));
                                            r.next(o), r.complete();
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "concat",
                            value: function() {
                                for(var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                                var i = p(this);
                                return new i(function(t) {
                                    var n, o = 0;
                                    return function e(a) {
                                        n = a.subscribe({
                                            next: function(e) {
                                                t.next(e);
                                            },
                                            error: function(e) {
                                                t.error(e);
                                            },
                                            complete: function() {
                                                o === r.length ? (n = void 0, t.complete()) : e(i.from(r[o++]));
                                            }
                                        });
                                    }(e), function() {
                                        n && (n.unsubscribe(), n = void 0);
                                    };
                                });
                            }
                        },
                        {
                            key: "flatMap",
                            value: function(e) {
                                var t = this;
                                if ("function" != typeof e) throw new TypeError(e + " is not a function");
                                var r = p(this);
                                return new r(function(n) {
                                    var i = [], o = t.subscribe({
                                        next: function(t) {
                                            if (e) try {
                                                t = e(t);
                                            } catch (e) {
                                                return n.error(e);
                                            }
                                            var o = r.from(t).subscribe({
                                                next: function(e) {
                                                    n.next(e);
                                                },
                                                error: function(e) {
                                                    n.error(e);
                                                },
                                                complete: function() {
                                                    var e = i.indexOf(o);
                                                    e >= 0 && i.splice(e, 1), a();
                                                }
                                            });
                                            i.push(o);
                                        },
                                        error: function(e) {
                                            n.error(e);
                                        },
                                        complete: function() {
                                            a();
                                        }
                                    });
                                    function a() {
                                        o.closed && 0 === i.length && n.complete();
                                    }
                                    return function() {
                                        i.forEach(function(e) {
                                            return e.unsubscribe();
                                        }), o.unsubscribe();
                                    };
                                });
                            }
                        },
                        {
                            key: c,
                            value: function() {
                                return this;
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(t) {
                                var r = "function" == typeof this ? this : e;
                                if (null == t) throw new TypeError(t + " is not an object");
                                var n = f(t, c);
                                if (n) {
                                    var i = n.call(t);
                                    if (Object(i) !== i) throw new TypeError(i + " is not an object");
                                    return d(i) && i.constructor === r ? i : new r(function(e) {
                                        return i.subscribe(e);
                                    });
                                }
                                if (a("iterator") && (n = f(t, u))) return new r(function(e) {
                                    v(function() {
                                        if (!e.closed) {
                                            var r = !0, i = !1, o = void 0;
                                            try {
                                                for(var a, s = n.call(t)[Symbol.iterator](); !(r = (a = s.next()).done); r = !0){
                                                    if (e.next(a.value), e.closed) return;
                                                }
                                            } catch (e) {
                                                i = !0, o = e;
                                            } finally{
                                                try {
                                                    r || null == s.return || s.return();
                                                } finally{
                                                    if (i) throw o;
                                                }
                                            }
                                            e.complete();
                                        }
                                    });
                                });
                                if (Array.isArray(t)) return new r(function(e) {
                                    v(function() {
                                        if (!e.closed) {
                                            for(var r = 0; r < t.length; ++r)if (e.next(t[r]), e.closed) return;
                                            e.complete();
                                        }
                                    });
                                });
                                throw new TypeError(t + " is not observable");
                            }
                        },
                        {
                            key: "of",
                            value: function() {
                                for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                                return new ("function" == typeof this ? this : e)(function(e) {
                                    v(function() {
                                        if (!e.closed) {
                                            for(var t = 0; t < r.length; ++t)if (e.next(r[t]), e.closed) return;
                                            e.complete();
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: l,
                            get: function() {
                                return this;
                            }
                        }
                    ]), e;
                }();
                t.Observable = _, o() && Object.defineProperty(_, Symbol("extensions"), {
                    value: {
                        symbol: c,
                        hostReportError: h
                    },
                    configurable: !0
                });
            },
            1982: (e, t, r)=>{
                e.exports = r(4998);
            },
            515: (e, t, r)=>{
                e.exports = r(9844);
            },
            1806: (e, t, r)=>{
                e.exports = r(3773);
            },
            415: (e, t, r)=>{
                e.exports = r(5705);
            },
            1183: (e, t, r)=>{
                e.exports = r(6376);
            },
            8006: (e, t, r)=>{
                e.exports = r(4297);
            },
            5710: (e, t, r)=>{
                e.exports = r(1165);
            },
            3393: (e, t, r)=>{
                e.exports = r(5397);
            },
            8756: (e, t, r)=>{
                e.exports = r(7500);
            },
            7879: (e, t, r)=>{
                e.exports = r(7582);
            },
            9534: (e)=>{
                e.exports = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            7062: (e, t, r)=>{
                "use strict";
                r(6128);
                var n = r(9407);
                e.exports = n("Array", "includes");
            },
            3335: (e, t, r)=>{
                "use strict";
                r(4984);
                var n = r(9407);
                e.exports = n("Array", "indexOf");
            },
            5247: (e, t, r)=>{
                "use strict";
                r(4269);
                var n = r(9407);
                e.exports = n("Array", "reduce");
            },
            8630: (e, t, r)=>{
                "use strict";
                r(2302);
                var n = r(4388);
                e.exports = n.Date.now;
            },
            6225: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = r(7487), o = String.prototype;
                e.exports = function(e) {
                    var t = e.endsWith;
                    return "string" == typeof e || e === o || n(o, e) && t === o.endsWith ? i : t;
                };
            },
            931: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = r(7062), o = r(4858), a = Array.prototype, s = String.prototype;
                e.exports = function(e) {
                    var t = e.includes;
                    return e === a || n(a, e) && t === a.includes ? i : "string" == typeof e || e === s || n(s, e) && t === s.includes ? o : t;
                };
            },
            7888: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = r(3335), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.indexOf;
                    return e === o || n(o, e) && t === o.indexOf ? i : t;
                };
            },
            6329: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = r(5247), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.reduce;
                    return e === o || n(o, e) && t === o.reduce ? i : t;
                };
            },
            2461: (e, t, r)=>{
                "use strict";
                r(7189), r(727), r(1400), r(1732), r(9823);
                var n = r(4388);
                e.exports = n.Map;
            },
            296: (e, t, r)=>{
                "use strict";
                r(9614);
                var n = r(4388).Object, i = e.exports = function(e, t, r) {
                    return n.defineProperty(e, t, r);
                };
                n.defineProperty.sham && (i.sham = !0);
            },
            8628: (e, t, r)=>{
                "use strict";
                r(8331);
                var n = r(4388).Object, i = e.exports = function(e, t) {
                    return n.getOwnPropertyDescriptor(e, t);
                };
                n.getOwnPropertyDescriptor.sham && (i.sham = !0);
            },
            9057: (e, t, r)=>{
                "use strict";
                r(1935), r(7189), r(1732), r(7971), r(261), r(6766), r(5412), r(9363), r(9823);
                var n = r(4388);
                e.exports = n.Promise;
            },
            7487: (e, t, r)=>{
                "use strict";
                r(1381);
                var n = r(9407);
                e.exports = n("String", "endsWith");
            },
            4858: (e, t, r)=>{
                "use strict";
                r(1021);
                var n = r(9407);
                e.exports = n("String", "includes");
            },
            1170: (e, t, r)=>{
                "use strict";
                r(7189), r(1732), r(9284);
                var n = r(4388);
                e.exports = n.WeakMap;
            },
            6735: (e, t, r)=>{
                "use strict";
                var n = r(342), i = r(9665), o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not a function");
                };
            },
            1298: (e, t, r)=>{
                "use strict";
                var n = r(3878), i = r(9665), o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not a constructor");
                };
            },
            6689: (e, t, r)=>{
                "use strict";
                var n = r(500), i = String, o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o("Can't set " + i(e) + " as a prototype");
                };
            },
            9747: (e)=>{
                "use strict";
                e.exports = function() {};
            },
            6406: (e, t, r)=>{
                "use strict";
                var n = r(2242), i = TypeError;
                e.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            7934: (e, t, r)=>{
                "use strict";
                var n = r(2660), i = String, o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not an object");
                };
            },
            5872: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = n(function() {
                    if ("function" == typeof ArrayBuffer) {
                        var e = new ArrayBuffer(8);
                        Object.isExtensible(e) && Object.defineProperty(e, "a", {
                            value: 8
                        });
                    }
                });
            },
            4029: (e, t, r)=>{
                "use strict";
                var n = r(4036), i = r(3928), o = r(1159), a = function(e) {
                    return function(t, r, a) {
                        var s, u = n(t), c = o(u), l = i(a, c);
                        if (e && r != r) {
                            for(; c > l;)if ((s = u[l++]) != s) return !0;
                        } else for(; c > l; l++)if ((e || l in u) && u[l] === r) return e || l || 0;
                        return !e && -1;
                    };
                };
                e.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            1389: (e, t, r)=>{
                "use strict";
                var n = r(1492), i = r(6021), o = r(1958), a = r(9449), s = r(1159), u = r(5552), c = i([].push), l = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, l = 4 === e, f = 6 === e, p = 7 === e, d = 5 === e || f;
                    return function(h, v, m, y) {
                        for(var g, E, b = a(h), S = o(b), _ = s(S), O = n(v, m), w = 0, T = y || u, I = t ? T(h, _) : r || p ? T(h, 0) : void 0; _ > w; w++)if ((d || w in S) && (E = O(g = S[w], w, b), e)) {
                            if (t) I[w] = E;
                            else if (E) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return g;
                                case 6:
                                    return w;
                                case 2:
                                    c(I, g);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(I, g);
                            }
                        }
                        return f ? -1 : i || l ? l : I;
                    };
                };
                e.exports = {
                    forEach: l(0),
                    map: l(1),
                    filter: l(2),
                    some: l(3),
                    every: l(4),
                    find: l(5),
                    findIndex: l(6),
                    filterReject: l(7)
                };
            },
            3888: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = function(e, t) {
                    var r = [][e];
                    return !!r && n(function() {
                        r.call(null, t || function() {
                            return 1;
                        }, 1);
                    });
                };
            },
            213: (e, t, r)=>{
                "use strict";
                var n = r(6735), i = r(9449), o = r(1958), a = r(1159), s = TypeError, u = function(e) {
                    return function(t, r, u, c) {
                        var l = i(t), f = o(l), p = a(l);
                        n(r);
                        var d = e ? p - 1 : 0, h = e ? -1 : 1;
                        if (u < 2) for(;;){
                            if (d in f) {
                                c = f[d], d += h;
                                break;
                            }
                            if (d += h, e ? d < 0 : p <= d) throw new s("Reduce of empty array with no initial value");
                        }
                        for(; e ? d >= 0 : p > d; d += h)d in f && (c = r(c, f[d], d, l));
                        return c;
                    };
                };
                e.exports = {
                    left: u(!1),
                    right: u(!0)
                };
            },
            2529: (e, t, r)=>{
                "use strict";
                var n = r(6021);
                e.exports = n([].slice);
            },
            4182: (e, t, r)=>{
                "use strict";
                var n = r(7170), i = r(3878), o = r(2660), a = r(8701)("species"), s = Array;
                e.exports = function(e) {
                    var t;
                    return n(e) && (i(t = e.constructor) && (t === s || n(t.prototype)) || o(t) && null === (t = t[a])) && (t = void 0), void 0 === t ? s : t;
                };
            },
            5552: (e, t, r)=>{
                "use strict";
                var n = r(4182);
                e.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            2886: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return 1 === t ? function(t, r) {
                        return t[e](r);
                    } : function(t, r, n) {
                        return t[e](r, n);
                    };
                };
            },
            4712: (e, t, r)=>{
                "use strict";
                var n = r(8701)("iterator"), i = !1;
                try {
                    var o = 0, a = {
                        next: function() {
                            return {
                                done: !!o++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    a[n] = function() {
                        return this;
                    }, Array.from(a, function() {
                        throw 2;
                    });
                } catch (e) {}
                e.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var o = {};
                        o[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(o);
                    } catch (e) {}
                    return r;
                };
            },
            4847: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = n({}.toString), o = n("".slice);
                e.exports = function(e) {
                    return o(i(e), 8, -1);
                };
            },
            6220: (e, t, r)=>{
                "use strict";
                var n = r(3895), i = r(342), o = r(4847), a = r(8701)("toStringTag"), s = Object, u = "Arguments" === o(function() {
                    return arguments;
                }());
                e.exports = n ? o : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = s(e), a)) ? r : u ? o(t) : "Object" === (n = o(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            329: (e, t, r)=>{
                "use strict";
                var n = r(4136), i = r(4843), o = r(9102), a = r(1492), s = r(6406), u = r(2237), c = r(3762), l = r(3259), f = r(8893), p = r(6331), d = r(4451), h = r(1854).fastKey, v = r(8354), m = v.set, y = v.getterFor;
                e.exports = {
                    getConstructor: function(e, t, r, l) {
                        var f = e(function(e, i) {
                            s(e, p), m(e, {
                                type: t,
                                index: n(null),
                                first: void 0,
                                last: void 0,
                                size: 0
                            }), d || (e.size = 0), u(i) || c(i, e[l], {
                                that: e,
                                AS_ENTRIES: r
                            });
                        }), p = f.prototype, v = y(t), g = function(e, t, r) {
                            var n, i, o = v(e), a = E(e, t);
                            return a ? a.value = r : (o.last = a = {
                                index: i = h(t, !0),
                                key: t,
                                value: r,
                                previous: n = o.last,
                                next: void 0,
                                removed: !1
                            }, o.first || (o.first = a), n && (n.next = a), d ? o.size++ : e.size++, "F" !== i && (o.index[i] = a)), e;
                        }, E = function(e, t) {
                            var r, n = v(e), i = h(t);
                            if ("F" !== i) return n.index[i];
                            for(r = n.first; r; r = r.next)if (r.key === t) return r;
                        };
                        return o(p, {
                            clear: function() {
                                for(var e = v(this), t = e.first; t;)t.removed = !0, t.previous && (t.previous = t.previous.next = void 0), t = t.next;
                                e.first = e.last = void 0, e.index = n(null), d ? e.size = 0 : this.size = 0;
                            },
                            delete: function(e) {
                                var t = this, r = v(t), n = E(t, e);
                                if (n) {
                                    var i = n.next, o = n.previous;
                                    delete r.index[n.index], n.removed = !0, o && (o.next = i), i && (i.previous = o), r.first === n && (r.first = i), r.last === n && (r.last = o), d ? r.size-- : t.size--;
                                }
                                return !!n;
                            },
                            forEach: function(e) {
                                for(var t, r = v(this), n = a(e, arguments.length > 1 ? arguments[1] : void 0); t = t ? t.next : r.first;)for(n(t.value, t.key, this); t && t.removed;)t = t.previous;
                            },
                            has: function(e) {
                                return !!E(this, e);
                            }
                        }), o(p, r ? {
                            get: function(e) {
                                var t = E(this, e);
                                return t && t.value;
                            },
                            set: function(e, t) {
                                return g(this, 0 === e ? 0 : e, t);
                            }
                        } : {
                            add: function(e) {
                                return g(this, e = 0 === e ? 0 : e, e);
                            }
                        }), d && i(p, "size", {
                            configurable: !0,
                            get: function() {
                                return v(this).size;
                            }
                        }), f;
                    },
                    setStrong: function(e, t, r) {
                        var n = t + " Iterator", i = y(t), o = y(n);
                        l(e, t, function(e, t) {
                            m(this, {
                                type: n,
                                target: e,
                                state: i(e),
                                kind: t,
                                last: void 0
                            });
                        }, function() {
                            for(var e = o(this), t = e.kind, r = e.last; r && r.removed;)r = r.previous;
                            return e.target && (e.last = r = r ? r.next : e.state.first) ? f("keys" === t ? r.key : "values" === t ? r.value : [
                                r.key,
                                r.value
                            ], !1) : (e.target = void 0, f(void 0, !0));
                        }, r ? "entries" : "values", !r, !0), p(t);
                    }
                };
            },
            943: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(9102), o = r(1854).getWeakData, a = r(6406), s = r(7934), u = r(2237), c = r(2660), l = r(3762), f = r(1389), p = r(9489), d = r(8354), h = d.set, v = d.getterFor, m = f.find, y = f.findIndex, g = n([].splice), E = 0, b = function(e) {
                    return e.frozen || (e.frozen = new S);
                }, S = function() {
                    this.entries = [];
                }, _ = function(e, t) {
                    return m(e.entries, function(e) {
                        return e[0] === t;
                    });
                };
                S.prototype = {
                    get: function(e) {
                        var t = _(this, e);
                        if (t) return t[1];
                    },
                    has: function(e) {
                        return !!_(this, e);
                    },
                    set: function(e, t) {
                        var r = _(this, e);
                        r ? r[1] = t : this.entries.push([
                            e,
                            t
                        ]);
                    },
                    delete: function(e) {
                        var t = y(this.entries, function(t) {
                            return t[0] === e;
                        });
                        return ~t && g(this.entries, t, 1), !!~t;
                    }
                }, e.exports = {
                    getConstructor: function(e, t, r, n) {
                        var f = e(function(e, i) {
                            a(e, d), h(e, {
                                type: t,
                                id: E++,
                                frozen: void 0
                            }), u(i) || l(i, e[n], {
                                that: e,
                                AS_ENTRIES: r
                            });
                        }), d = f.prototype, m = v(t), y = function(e, t, r) {
                            var n = m(e), i = o(s(t), !0);
                            return !0 === i ? b(n).set(t, r) : i[n.id] = r, e;
                        };
                        return i(d, {
                            delete: function(e) {
                                var t = m(this);
                                if (!c(e)) return !1;
                                var r = o(e);
                                return !0 === r ? b(t).delete(e) : r && p(r, t.id) && delete r[t.id];
                            },
                            has: function(e) {
                                var t = m(this);
                                if (!c(e)) return !1;
                                var r = o(e);
                                return !0 === r ? b(t).has(e) : r && p(r, t.id);
                            }
                        }), i(d, r ? {
                            get: function(e) {
                                var t = m(this);
                                if (c(e)) {
                                    var r = o(e);
                                    return !0 === r ? b(t).get(e) : r ? r[t.id] : void 0;
                                }
                            },
                            set: function(e, t) {
                                return y(this, e, t);
                            }
                        } : {
                            add: function(e) {
                                return y(this, e, !0);
                            }
                        }), f;
                    }
                };
            },
            1577: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(5620), o = r(1854), a = r(7909), s = r(6847), u = r(3762), c = r(6406), l = r(342), f = r(2660), p = r(2237), d = r(6752), h = r(1032).f, v = r(1389).forEach, m = r(4451), y = r(8354), g = y.set, E = y.getterFor;
                e.exports = function(e, t, r) {
                    var y, b = -1 !== e.indexOf("Map"), S = -1 !== e.indexOf("Weak"), _ = b ? "set" : "add", O = i[e], w = O && O.prototype, T = {};
                    if (m && l(O) && (S || w.forEach && !a(function() {
                        (new O).entries().next();
                    }))) {
                        var I = (y = t(function(t, r) {
                            g(c(t, I), {
                                type: e,
                                collection: new O
                            }), p(r) || u(r, t[_], {
                                that: t,
                                AS_ENTRIES: b
                            });
                        })).prototype, R = E(e);
                        v([
                            "add",
                            "clear",
                            "delete",
                            "forEach",
                            "get",
                            "has",
                            "set",
                            "keys",
                            "values",
                            "entries"
                        ], function(e) {
                            var t = "add" === e || "set" === e;
                            !(e in w) || S && "clear" === e || s(I, e, function(r, n) {
                                var i = R(this).collection;
                                if (!t && S && !f(r)) return "get" === e && void 0;
                                var o = i[e](0 === r ? 0 : r, n);
                                return t ? this : o;
                            });
                        }), S || h(I, "size", {
                            configurable: !0,
                            get: function() {
                                return R(this).collection.size;
                            }
                        });
                    } else y = r.getConstructor(t, e, b, _), o.enable();
                    return d(y, e, !1, !0), T[e] = y, n({
                        global: !0,
                        forced: !0
                    }, T), S || r.setStrong(y, e, b), y;
                };
            },
            6965: (e, t, r)=>{
                "use strict";
                var n = r(9489), i = r(3419), o = r(8428), a = r(1032);
                e.exports = function(e, t, r) {
                    for(var s = i(t), u = a.f, c = o.f, l = 0; l < s.length; l++){
                        var f = s[l];
                        n(e, f) || r && n(r, f) || u(e, f, c(t, f));
                    }
                };
            },
            2541: (e, t, r)=>{
                "use strict";
                var n = r(8701)("match");
                e.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            380: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            8893: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            6847: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(1032), o = r(618);
                e.exports = n ? function(e, t, r) {
                    return i.f(e, t, o(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            618: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            4843: (e, t, r)=>{
                "use strict";
                var n = r(1032);
                e.exports = function(e, t, r) {
                    return n.f(e, t, r);
                };
            },
            4423: (e, t, r)=>{
                "use strict";
                var n = r(6847);
                e.exports = function(e, t, r, i) {
                    return i && i.enumerable ? e[t] = r : n(e, t, r), e;
                };
            },
            9102: (e, t, r)=>{
                "use strict";
                var n = r(4423);
                e.exports = function(e, t, r) {
                    for(var i in t)r && r.unsafe && e[i] ? e[i] = t[i] : n(e, i, t[i], r);
                    return e;
                };
            },
            1395: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = Object.defineProperty;
                e.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            4451: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            5338: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(2660), o = n.document, a = i(o) && i(o.createElement);
                e.exports = function(e) {
                    return a ? o.createElement(e) : {};
                };
            },
            1753: (e)=>{
                "use strict";
                e.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            },
            8783: (e, t, r)=>{
                "use strict";
                var n = r(6933), i = r(811);
                e.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            6933: (e)=>{
                "use strict";
                e.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            2024: (e, t, r)=>{
                "use strict";
                var n = r(4906);
                e.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            2079: (e, t, r)=>{
                "use strict";
                var n = r(4906);
                e.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            811: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(4847);
                e.exports = "process" === i(n.process);
            },
            7356: (e, t, r)=>{
                "use strict";
                var n = r(4906);
                e.exports = /web0s(?!.*chrome)/i.test(n);
            },
            4906: (e)=>{
                "use strict";
                e.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            119: (e, t, r)=>{
                "use strict";
                var n, i, o = r(5620), a = r(4906), s = o.process, u = o.Deno, c = s && s.versions || u && u.version, l = c && c.v8;
                l && (i = (n = l.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && a && (!(n = a.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = a.match(/Chrome\/(\d+)/)) && (i = +n[1]), e.exports = i;
            },
            7812: (e)=>{
                "use strict";
                e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            6715: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = Error, o = n("".replace), a = String(new i("zxcasd").stack), s = /\n\s*at [^:]*:[^\n]*/, u = s.test(a);
                e.exports = function(e, t) {
                    if (u && "string" == typeof e && !i.prepareStackTrace) for(; t--;)e = o(e, s, "");
                    return e;
                };
            },
            4079: (e, t, r)=>{
                "use strict";
                var n = r(6847), i = r(6715), o = r(8761), a = Error.captureStackTrace;
                e.exports = function(e, t, r, s) {
                    o && (a ? a(e, t) : n(e, "stack", i(r, s)));
                };
            },
            8761: (e, t, r)=>{
                "use strict";
                var n = r(7909), i = r(618);
                e.exports = !n(function() {
                    var e = new Error("a");
                    return !("stack" in e) || (Object.defineProperty(e, "stack", i(1, 7)), 7 !== e.stack);
                });
            },
            434: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(9522), o = r(3806), a = r(342), s = r(8428).f, u = r(7025), c = r(4388), l = r(1492), f = r(6847), p = r(9489), d = function(e) {
                    var t = function(r, n, o) {
                        if (this instanceof t) {
                            switch(arguments.length){
                                case 0:
                                    return new e;
                                case 1:
                                    return new e(r);
                                case 2:
                                    return new e(r, n);
                            }
                            return new e(r, n, o);
                        }
                        return i(e, this, arguments);
                    };
                    return t.prototype = e.prototype, t;
                };
                e.exports = function(e, t) {
                    var r, i, h, v, m, y, g, E, b, S = e.target, _ = e.global, O = e.stat, w = e.proto, T = _ ? n : O ? n[S] : (n[S] || {}).prototype, I = _ ? c : c[S] || f(c, S, {})[S], R = I.prototype;
                    for(v in t)i = !(r = u(_ ? v : S + (O ? "." : "#") + v, e.forced)) && T && p(T, v), y = I[v], i && (g = e.dontCallGetSet ? (b = s(T, v)) && b.value : T[v]), m = i && g ? g : t[v], i && typeof y == typeof m || (E = e.bind && i ? l(m, n) : e.wrap && i ? d(m) : w && a(m) ? o(m) : m, (e.sham || m && m.sham || y && y.sham) && f(E, "sham", !0), f(I, v, E), w && (p(c, h = S + "Prototype") || f(c, h, {}), f(c[h], v, m), e.real && R && (r || !R[v]) && f(R, v, m)));
                };
            },
            7909: (e)=>{
                "use strict";
                e.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            7036: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = !n(function() {
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            },
            9522: (e, t, r)=>{
                "use strict";
                var n = r(2396), i = Function.prototype, o = i.apply, a = i.call;
                e.exports = "object" == typeof Reflect && Reflect.apply || (n ? a.bind(o) : function() {
                    return a.apply(o, arguments);
                });
            },
            1492: (e, t, r)=>{
                "use strict";
                var n = r(3806), i = r(6735), o = r(2396), a = n(n.bind);
                e.exports = function(e, t) {
                    return i(e), void 0 === t ? e : o ? a(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            2396: (e, t, r)=>{
                "use strict";
                var n = r(7909);
                e.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            9556: (e, t, r)=>{
                "use strict";
                var n = r(2396), i = Function.prototype.call;
                e.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            172: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(9489), o = Function.prototype, a = n && Object.getOwnPropertyDescriptor, s = i(o, "name"), u = s && "something" === (function() {}).name, c = s && (!n || n && a(o, "name").configurable);
                e.exports = {
                    EXISTS: s,
                    PROPER: u,
                    CONFIGURABLE: c
                };
            },
            1645: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(6735);
                e.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            3806: (e, t, r)=>{
                "use strict";
                var n = r(4847), i = r(6021);
                e.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            6021: (e, t, r)=>{
                "use strict";
                var n = r(2396), i = Function.prototype, o = i.call, a = n && i.bind.bind(o, o);
                e.exports = n ? a : function(e) {
                    return function() {
                        return o.apply(e, arguments);
                    };
                };
            },
            9407: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(4388);
                e.exports = function(e, t) {
                    var r = i[e + "Prototype"], o = r && r[t];
                    if (o) return o;
                    var a = n[e], s = a && a.prototype;
                    return s && s[t];
                };
            },
            889: (e, t, r)=>{
                "use strict";
                var n = r(4388), i = r(5620), o = r(342), a = function(e) {
                    return o(e) ? e : void 0;
                };
                e.exports = function(e, t) {
                    return arguments.length < 2 ? a(n[e]) || a(i[e]) : n[e] && n[e][t] || i[e] && i[e][t];
                };
            },
            3856: (e, t, r)=>{
                "use strict";
                var n = r(6220), i = r(787), o = r(2237), a = r(1724), s = r(8701)("iterator");
                e.exports = function(e) {
                    if (!o(e)) return i(e, s) || i(e, "@@iterator") || a[n(e)];
                };
            },
            2346: (e, t, r)=>{
                "use strict";
                var n = r(9556), i = r(6735), o = r(7934), a = r(9665), s = r(3856), u = TypeError;
                e.exports = function(e, t) {
                    var r = arguments.length < 2 ? s(e) : t;
                    if (i(r)) return o(n(r, e));
                    throw new u(a(e) + " is not iterable");
                };
            },
            787: (e, t, r)=>{
                "use strict";
                var n = r(6735), i = r(2237);
                e.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            5620: function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.Math === Math && e;
                };
                e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof r.g && r.g) || n("object" == typeof this && this) || function() {
                    return this;
                }() || Function("return this")();
            },
            9489: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(9449), o = n({}.hasOwnProperty);
                e.exports = Object.hasOwn || function(e, t) {
                    return o(i(e), t);
                };
            },
            9290: (e)=>{
                "use strict";
                e.exports = {};
            },
            8831: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            4206: (e, t, r)=>{
                "use strict";
                var n = r(889);
                e.exports = n("document", "documentElement");
            },
            8713: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(7909), o = r(5338);
                e.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(o("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            1958: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(7909), o = r(4847), a = Object, s = n("".split);
                e.exports = i(function() {
                    return !a("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === o(e) ? s(e, "") : a(e);
                } : a;
            },
            8228: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(342), o = r(9188), a = n(Function.toString);
                i(o.inspectSource) || (o.inspectSource = function(e) {
                    return a(e);
                }), e.exports = o.inspectSource;
            },
            9654: (e, t, r)=>{
                "use strict";
                var n = r(2660), i = r(6847);
                e.exports = function(e, t) {
                    n(t) && "cause" in t && i(e, "cause", t.cause);
                };
            },
            1854: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6021), o = r(9290), a = r(2660), s = r(9489), u = r(1032).f, c = r(6141), l = r(1620), f = r(644), p = r(7644), d = r(7036), h = !1, v = p("meta"), m = 0, y = function(e) {
                    u(e, v, {
                        value: {
                            objectID: "O" + m++,
                            weakData: {}
                        }
                    });
                }, g = e.exports = {
                    enable: function() {
                        g.enable = function() {}, h = !0;
                        var e = c.f, t = i([].splice), r = {};
                        r[v] = 1, e(r).length && (c.f = function(r) {
                            for(var n = e(r), i = 0, o = n.length; i < o; i++)if (n[i] === v) {
                                t(n, i, 1);
                                break;
                            }
                            return n;
                        }, n({
                            target: "Object",
                            stat: !0,
                            forced: !0
                        }, {
                            getOwnPropertyNames: l.f
                        }));
                    },
                    fastKey: function(e, t) {
                        if (!a(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
                        if (!s(e, v)) {
                            if (!f(e)) return "F";
                            if (!t) return "E";
                            y(e);
                        }
                        return e[v].objectID;
                    },
                    getWeakData: function(e, t) {
                        if (!s(e, v)) {
                            if (!f(e)) return !0;
                            if (!t) return !1;
                            y(e);
                        }
                        return e[v].weakData;
                    },
                    onFreeze: function(e) {
                        return d && h && f(e) && !s(e, v) && y(e), e;
                    }
                };
                o[v] = !0;
            },
            8354: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(8224), s = r(5620), u = r(2660), c = r(6847), l = r(9489), f = r(9188), p = r(546), d = r(9290), h = "Object already initialized", v = s.TypeError;
                if (a || f.state) {
                    var m = f.state || (f.state = new s.WeakMap);
                    m.get = m.get, m.has = m.has, m.set = m.set, n = function(e, t) {
                        if (m.has(e)) throw new v(h);
                        return t.facade = e, m.set(e, t), t;
                    }, i = function(e) {
                        return m.get(e) || {};
                    }, o = function(e) {
                        return m.has(e);
                    };
                } else {
                    var y = p("state");
                    d[y] = !0, n = function(e, t) {
                        if (l(e, y)) throw new v(h);
                        return t.facade = e, c(e, y, t), t;
                    }, i = function(e) {
                        return l(e, y) ? e[y] : {};
                    }, o = function(e) {
                        return l(e, y);
                    };
                }
                e.exports = {
                    set: n,
                    get: i,
                    has: o,
                    enforce: function(e) {
                        return o(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!u(t) || (r = i(t)).type !== e) throw new v("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            6808: (e, t, r)=>{
                "use strict";
                var n = r(8701), i = r(1724), o = n("iterator"), a = Array.prototype;
                e.exports = function(e) {
                    return void 0 !== e && (i.Array === e || a[o] === e);
                };
            },
            7170: (e, t, r)=>{
                "use strict";
                var n = r(4847);
                e.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            342: (e)=>{
                "use strict";
                var t = "object" == typeof document && document.all;
                e.exports = void 0 === t && void 0 !== t ? function(e) {
                    return "function" == typeof e || e === t;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            3878: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(7909), o = r(342), a = r(6220), s = r(889), u = r(8228), c = function() {}, l = [], f = s("Reflect", "construct"), p = /^\s*(?:class|function)\b/, d = n(p.exec), h = !p.test(c), v = function(e) {
                    if (!o(e)) return !1;
                    try {
                        return f(c, l, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, m = function(e) {
                    if (!o(e)) return !1;
                    switch(a(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return h || !!d(p, u(e));
                    } catch (e) {
                        return !0;
                    }
                };
                m.sham = !0, e.exports = !f || i(function() {
                    var e;
                    return v(v.call) || !v(Object) || !v(function() {
                        e = !0;
                    }) || e;
                }) ? m : v;
            },
            7025: (e, t, r)=>{
                "use strict";
                var n = r(7909), i = r(342), o = /#|\.prototype\./, a = function(e, t) {
                    var r = u[s(e)];
                    return r === l || r !== c && (i(t) ? n(t) : !!t);
                }, s = a.normalize = function(e) {
                    return String(e).replace(o, ".").toLowerCase();
                }, u = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
                e.exports = a;
            },
            2237: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return null == e;
                };
            },
            2660: (e, t, r)=>{
                "use strict";
                var n = r(342);
                e.exports = function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            500: (e, t, r)=>{
                "use strict";
                var n = r(2660);
                e.exports = function(e) {
                    return n(e) || null === e;
                };
            },
            6338: (e)=>{
                "use strict";
                e.exports = !0;
            },
            465: (e, t, r)=>{
                "use strict";
                var n = r(2660), i = r(4847), o = r(8701)("match");
                e.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[o]) ? !!t : "RegExp" === i(e));
                };
            },
            3197: (e, t, r)=>{
                "use strict";
                var n = r(889), i = r(342), o = r(2242), a = r(69), s = Object;
                e.exports = a ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && o(t.prototype, s(e));
                };
            },
            3762: (e, t, r)=>{
                "use strict";
                var n = r(1492), i = r(9556), o = r(7934), a = r(9665), s = r(6808), u = r(1159), c = r(2242), l = r(2346), f = r(3856), p = r(2928), d = TypeError, h = function(e, t) {
                    this.stopped = e, this.result = t;
                }, v = h.prototype;
                e.exports = function(e, t, r) {
                    var m, y, g, E, b, S, _, O = !(!r || !r.AS_ENTRIES), w = !(!r || !r.IS_RECORD), T = !(!r || !r.IS_ITERATOR), I = !(!r || !r.INTERRUPTED), R = n(t, r && r.that), x = function(e) {
                        return m && p(m, "normal", e), new h(!0, e);
                    }, A = function(e) {
                        return O ? (o(e), I ? R(e[0], e[1], x) : R(e[0], e[1])) : I ? R(e, x) : R(e);
                    };
                    if (w) m = e.iterator;
                    else if (T) m = e;
                    else {
                        if (!(y = f(e))) throw new d(a(e) + " is not iterable");
                        if (s(y)) {
                            for(g = 0, E = u(e); E > g; g++)if ((b = A(e[g])) && c(v, b)) return b;
                            return new h(!1);
                        }
                        m = l(e, y);
                    }
                    for(S = w ? e.next : m.next; !(_ = i(S, m)).done;){
                        try {
                            b = A(_.value);
                        } catch (e) {
                            p(m, "throw", e);
                        }
                        if ("object" == typeof b && b && c(v, b)) return b;
                    }
                    return new h(!1);
                };
            },
            2928: (e, t, r)=>{
                "use strict";
                var n = r(9556), i = r(7934), o = r(787);
                e.exports = function(e, t, r) {
                    var a, s;
                    i(e);
                    try {
                        if (!(a = o(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        a = n(a, e);
                    } catch (e) {
                        s = !0, a = e;
                    }
                    if ("throw" === t) throw r;
                    if (s) throw a;
                    return i(a), r;
                };
            },
            7171: (e, t, r)=>{
                "use strict";
                var n = r(8335).IteratorPrototype, i = r(4136), o = r(618), a = r(6752), s = r(1724), u = function() {
                    return this;
                };
                e.exports = function(e, t, r, c) {
                    var l = t + " Iterator";
                    return e.prototype = i(n, {
                        next: o(+!c, r)
                    }), a(e, l, !1, !0), s[l] = u, e;
                };
            },
            3259: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6338), a = r(172), s = r(342), u = r(7171), c = r(6167), l = r(44), f = r(6752), p = r(6847), d = r(4423), h = r(8701), v = r(1724), m = r(8335), y = a.PROPER, g = a.CONFIGURABLE, E = m.IteratorPrototype, b = m.BUGGY_SAFARI_ITERATORS, S = h("iterator"), _ = "keys", O = "values", w = "entries", T = function() {
                    return this;
                };
                e.exports = function(e, t, r, a, h, m, I) {
                    u(r, t, a);
                    var R, x, A, N = function(e) {
                        if (e === h && D) return D;
                        if (!b && e && e in M) return M[e];
                        switch(e){
                            case _:
                            case O:
                            case w:
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, C = t + " Iterator", k = !1, M = e.prototype, P = M[S] || M["@@iterator"] || h && M[h], D = !b && P || N(h), F = "Array" === t && M.entries || P;
                    if (F && (R = c(F.call(new e))) !== Object.prototype && R.next && (o || c(R) === E || (l ? l(R, E) : s(R[S]) || d(R, S, T)), f(R, C, !0, !0), o && (v[C] = T)), y && h === O && P && P.name !== O && (!o && g ? p(M, "name", O) : (k = !0, D = function() {
                        return i(P, this);
                    })), h) {
                        if (x = {
                            values: N(O),
                            keys: m ? D : N(_),
                            entries: N(w)
                        }, I) for(A in x)(b || k || !(A in M)) && d(M, A, x[A]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: b || k
                        }, x);
                    }
                    return o && !I || M[S] === D || d(M, S, D, {
                        name: h
                    }), v[t] = D, x;
                };
            },
            8335: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(7909), s = r(342), u = r(2660), c = r(4136), l = r(6167), f = r(4423), p = r(8701), d = r(6338), h = p("iterator"), v = !1;
                [].keys && ("next" in (o = [].keys()) ? (i = l(l(o))) !== Object.prototype && (n = i) : v = !0), !u(n) || a(function() {
                    var e = {};
                    return n[h].call(e) !== e;
                }) ? n = {} : d && (n = c(n)), s(n[h]) || f(n, h, function() {
                    return this;
                }), e.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: v
                };
            },
            1724: (e)=>{
                "use strict";
                e.exports = {};
            },
            1159: (e, t, r)=>{
                "use strict";
                var n = r(9505);
                e.exports = function(e) {
                    return n(e.length);
                };
            },
            850: (e, t, r)=>{
                "use strict";
                var n = r(889), i = r(2886), o = n("Map");
                e.exports = {
                    Map: o,
                    set: i("set", 2),
                    get: i("get", 1),
                    has: i("has", 1),
                    remove: i("delete", 1),
                    proto: o.prototype
                };
            },
            1686: (e)=>{
                "use strict";
                var t = Math.ceil, r = Math.floor;
                e.exports = Math.trunc || function(e) {
                    var n = +e;
                    return (n > 0 ? r : t)(n);
                };
            },
            9194: (e, t, r)=>{
                "use strict";
                var n, i, o, a, s, u = r(5620), c = r(751), l = r(1492), f = r(7112).set, p = r(750), d = r(2079), h = r(2024), v = r(7356), m = r(811), y = u.MutationObserver || u.WebKitMutationObserver, g = u.document, E = u.process, b = u.Promise, S = c("queueMicrotask");
                if (!S) {
                    var _ = new p, O = function() {
                        var e, t;
                        for(m && (e = E.domain) && e.exit(); t = _.get();)try {
                            t();
                        } catch (e) {
                            throw _.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || m || v || !y || !g ? !h && b && b.resolve ? ((a = b.resolve(void 0)).constructor = b, s = l(a.then, a), n = function() {
                        s(O);
                    }) : m ? n = function() {
                        E.nextTick(O);
                    } : (f = l(f, u), n = function() {
                        f(O);
                    }) : (i = !0, o = g.createTextNode(""), new y(O).observe(o, {
                        characterData: !0
                    }), n = function() {
                        o.data = i = !i;
                    }), S = function(e) {
                        _.head || n(), _.add(e);
                    };
                }
                e.exports = S;
            },
            5759: (e, t, r)=>{
                "use strict";
                var n = r(6735), i = TypeError, o = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                e.exports.f = function(e) {
                    return new o(e);
                };
            },
            823: (e, t, r)=>{
                "use strict";
                var n = r(7482);
                e.exports = function(e, t) {
                    return void 0 === e ? arguments.length < 2 ? "" : t : n(e);
                };
            },
            2679: (e, t, r)=>{
                "use strict";
                var n = r(465), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            4136: (e, t, r)=>{
                "use strict";
                var n, i = r(7934), o = r(2539), a = r(7812), s = r(9290), u = r(4206), c = r(5338), l = r(546), f = "prototype", p = "script", d = l("IE_PROTO"), h = function() {}, v = function(e) {
                    return "<" + p + ">" + e + "</" + p + ">";
                }, m = function(e) {
                    e.write(v("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, y = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t, r;
                    y = "undefined" != typeof document ? document.domain && n ? m(n) : (t = c("iframe"), r = "java" + p + ":", t.style.display = "none", u.appendChild(t), t.src = String(r), (e = t.contentWindow.document).open(), e.write(v("document.F=Object")), e.close(), e.F) : m(n);
                    for(var i = a.length; i--;)delete y[f][a[i]];
                    return y();
                };
                s[d] = !0, e.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (h[f] = i(e), r = new h, h[f] = null, r[d] = e) : r = y(), void 0 === t ? r : o.f(r, t);
                };
            },
            2539: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(9095), o = r(1032), a = r(7934), s = r(4036), u = r(8564);
                t.f = n && !i ? Object.defineProperties : function(e, t) {
                    a(e);
                    for(var r, n = s(t), i = u(t), c = i.length, l = 0; c > l;)o.f(e, r = i[l++], n[r]);
                    return e;
                };
            },
            1032: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(8713), o = r(9095), a = r(7934), s = r(7966), u = TypeError, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, f = "enumerable", p = "configurable", d = "writable";
                t.f = n ? o ? function(e, t, r) {
                    if (a(e), t = s(t), a(r), "function" == typeof e && "prototype" === t && "value" in r && d in r && !r[d]) {
                        var n = l(e, t);
                        n && n[d] && (e[t] = r.value, r = {
                            configurable: p in r ? r[p] : n[p],
                            enumerable: f in r ? r[f] : n[f],
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (a(e), t = s(t), a(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new u("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            8428: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(9556), o = r(7196), a = r(618), s = r(4036), u = r(7966), c = r(9489), l = r(8713), f = Object.getOwnPropertyDescriptor;
                t.f = n ? f : function(e, t) {
                    if (e = s(e), t = u(t), l) try {
                        return f(e, t);
                    } catch (e) {}
                    if (c(e, t)) return a(!i(o.f, e, t), e[t]);
                };
            },
            1620: (e, t, r)=>{
                "use strict";
                var n = r(4847), i = r(4036), o = r(6141).f, a = r(2529), s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                e.exports.f = function(e) {
                    return s && "Window" === n(e) ? function(e) {
                        try {
                            return o(e);
                        } catch (e) {
                            return a(s);
                        }
                    }(e) : o(i(e));
                };
            },
            6141: (e, t, r)=>{
                "use strict";
                var n = r(1224), i = r(7812).concat("length", "prototype");
                t.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            3529: (e, t)=>{
                "use strict";
                t.f = Object.getOwnPropertySymbols;
            },
            6167: (e, t, r)=>{
                "use strict";
                var n = r(9489), i = r(342), o = r(9449), a = r(546), s = r(380), u = a("IE_PROTO"), c = Object, l = c.prototype;
                e.exports = s ? c.getPrototypeOf : function(e) {
                    var t = o(e);
                    if (n(t, u)) return t[u];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof c ? l : null;
                };
            },
            644: (e, t, r)=>{
                "use strict";
                var n = r(7909), i = r(2660), o = r(4847), a = r(5872), s = Object.isExtensible, u = n(function() {
                    s(1);
                });
                e.exports = u || a ? function(e) {
                    return !!i(e) && (!a || "ArrayBuffer" !== o(e)) && (!s || s(e));
                } : s;
            },
            2242: (e, t, r)=>{
                "use strict";
                var n = r(6021);
                e.exports = n({}.isPrototypeOf);
            },
            1224: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(9489), o = r(4036), a = r(4029).indexOf, s = r(9290), u = n([].push);
                e.exports = function(e, t) {
                    var r, n = o(e), c = 0, l = [];
                    for(r in n)!i(s, r) && i(n, r) && u(l, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~a(l, r) || u(l, r));
                    return l;
                };
            },
            8564: (e, t, r)=>{
                "use strict";
                var n = r(1224), i = r(7812);
                e.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            7196: (e, t)=>{
                "use strict";
                var r = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, i = n && !r.call({
                    1: 2
                }, 1);
                t.f = i ? function(e) {
                    var t = n(this, e);
                    return !!t && t.enumerable;
                } : r;
            },
            44: (e, t, r)=>{
                "use strict";
                var n = r(1645), i = r(7934), o = r(6689);
                e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), o(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            3111: (e, t, r)=>{
                "use strict";
                var n = r(3895), i = r(6220);
                e.exports = n ? ({}).toString : function() {
                    return "[object " + i(this) + "]";
                };
            },
            4374: (e, t, r)=>{
                "use strict";
                var n = r(9556), i = r(342), o = r(2660), a = TypeError;
                e.exports = function(e, t) {
                    var r, s;
                    if ("string" === t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    if (i(r = e.valueOf) && !o(s = n(r, e))) return s;
                    if ("string" !== t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    throw new a("Can't convert object to primitive value");
                };
            },
            3419: (e, t, r)=>{
                "use strict";
                var n = r(889), i = r(6021), o = r(6141), a = r(3529), s = r(7934), u = i([].concat);
                e.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = o.f(s(e)), r = a.f;
                    return r ? u(t, r(e)) : t;
                };
            },
            4388: (e)=>{
                "use strict";
                e.exports = {};
            },
            7854: (e)=>{
                "use strict";
                e.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            4194: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(2882), o = r(342), a = r(7025), s = r(8228), u = r(8701), c = r(8783), l = r(6933), f = r(6338), p = r(119), d = i && i.prototype, h = u("species"), v = !1, m = o(n.PromiseRejectionEvent), y = a("Promise", function() {
                    var e = s(i), t = e !== String(i);
                    if (!t && 66 === p) return !0;
                    if (f && (!d.catch || !d.finally)) return !0;
                    if (!p || p < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[h] = n, !(v = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (c || l) && !m;
                });
                e.exports = {
                    CONSTRUCTOR: y,
                    REJECTION_EVENT: m,
                    SUBCLASSING: v
                };
            },
            2882: (e, t, r)=>{
                "use strict";
                var n = r(5620);
                e.exports = n.Promise;
            },
            2764: (e, t, r)=>{
                "use strict";
                var n = r(7934), i = r(2660), o = r(5759);
                e.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = o.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            4549: (e, t, r)=>{
                "use strict";
                var n = r(2882), i = r(4712), o = r(4194).CONSTRUCTOR;
                e.exports = o || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            750: (e)=>{
                "use strict";
                var t = function() {
                    this.head = null, this.tail = null;
                };
                t.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, e.exports = t;
            },
            4734: (e, t, r)=>{
                "use strict";
                var n = r(2237), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            751: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(4451), o = Object.getOwnPropertyDescriptor;
                e.exports = function(e) {
                    if (!i) return n[e];
                    var t = o(n, e);
                    return t && t.value;
                };
            },
            6331: (e, t, r)=>{
                "use strict";
                var n = r(889), i = r(4843), o = r(8701), a = r(4451), s = o("species");
                e.exports = function(e) {
                    var t = n(e);
                    a && t && !t[s] && i(t, s, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            6752: (e, t, r)=>{
                "use strict";
                var n = r(3895), i = r(1032).f, o = r(6847), a = r(9489), s = r(3111), u = r(8701)("toStringTag");
                e.exports = function(e, t, r, c) {
                    var l = r ? e : e && e.prototype;
                    l && (a(l, u) || i(l, u, {
                        configurable: !0,
                        value: t
                    }), c && !n && o(l, "toString", s));
                };
            },
            546: (e, t, r)=>{
                "use strict";
                var n = r(5260), i = r(7644), o = n("keys");
                e.exports = function(e) {
                    return o[e] || (o[e] = i(e));
                };
            },
            9188: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(1395), o = "__core-js_shared__", a = n[o] || i(o, {});
                e.exports = a;
            },
            5260: (e, t, r)=>{
                "use strict";
                var n = r(6338), i = r(9188);
                (e.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.35.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.35.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            4889: (e, t, r)=>{
                "use strict";
                var n = r(7934), i = r(1298), o = r(2237), a = r(8701)("species");
                e.exports = function(e, t) {
                    var r, s = n(e).constructor;
                    return void 0 === s || o(r = n(s)[a]) ? t : i(r);
                };
            },
            8115: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = r(1977), o = r(7482), a = r(4734), s = n("".charAt), u = n("".charCodeAt), c = n("".slice), l = function(e) {
                    return function(t, r) {
                        var n, l, f = o(a(t)), p = i(r), d = f.length;
                        return p < 0 || p >= d ? e ? "" : void 0 : (n = u(f, p)) < 55296 || n > 56319 || p + 1 === d || (l = u(f, p + 1)) < 56320 || l > 57343 ? e ? s(f, p) : n : e ? c(f, p, p + 2) : l - 56320 + (n - 55296 << 10) + 65536;
                    };
                };
                e.exports = {
                    codeAt: l(!1),
                    charAt: l(!0)
                };
            },
            6498: (e, t, r)=>{
                "use strict";
                var n = r(119), i = r(7909), o = r(5620).String;
                e.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !o(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            7112: (e, t, r)=>{
                "use strict";
                var n, i, o, a, s = r(5620), u = r(9522), c = r(1492), l = r(342), f = r(9489), p = r(7909), d = r(4206), h = r(2529), v = r(5338), m = r(5636), y = r(2079), g = r(811), E = s.setImmediate, b = s.clearImmediate, S = s.process, _ = s.Dispatch, O = s.Function, w = s.MessageChannel, T = s.String, I = 0, R = {}, x = "onreadystatechange";
                p(function() {
                    n = s.location;
                });
                var A = function(e) {
                    if (f(R, e)) {
                        var t = R[e];
                        delete R[e], t();
                    }
                }, N = function(e) {
                    return function() {
                        A(e);
                    };
                }, C = function(e) {
                    A(e.data);
                }, k = function(e) {
                    s.postMessage(T(e), n.protocol + "//" + n.host);
                };
                E && b || (E = function(e) {
                    m(arguments.length, 1);
                    var t = l(e) ? e : O(e), r = h(arguments, 1);
                    return R[++I] = function() {
                        u(t, void 0, r);
                    }, i(I), I;
                }, b = function(e) {
                    delete R[e];
                }, g ? i = function(e) {
                    S.nextTick(N(e));
                } : _ && _.now ? i = function(e) {
                    _.now(N(e));
                } : w && !y ? (a = (o = new w).port2, o.port1.onmessage = C, i = c(a.postMessage, a)) : s.addEventListener && l(s.postMessage) && !s.importScripts && n && "file:" !== n.protocol && !p(k) ? (i = k, s.addEventListener("message", C, !1)) : i = x in v("script") ? function(e) {
                    d.appendChild(v("script"))[x] = function() {
                        d.removeChild(this), A(e);
                    };
                } : function(e) {
                    setTimeout(N(e), 0);
                }), e.exports = {
                    set: E,
                    clear: b
                };
            },
            3928: (e, t, r)=>{
                "use strict";
                var n = r(1977), i = Math.max, o = Math.min;
                e.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : o(r, t);
                };
            },
            4036: (e, t, r)=>{
                "use strict";
                var n = r(1958), i = r(4734);
                e.exports = function(e) {
                    return n(i(e));
                };
            },
            1977: (e, t, r)=>{
                "use strict";
                var n = r(1686);
                e.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            9505: (e, t, r)=>{
                "use strict";
                var n = r(1977), i = Math.min;
                e.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            9449: (e, t, r)=>{
                "use strict";
                var n = r(4734), i = Object;
                e.exports = function(e) {
                    return i(n(e));
                };
            },
            5107: (e, t, r)=>{
                "use strict";
                var n = r(9556), i = r(2660), o = r(3197), a = r(787), s = r(4374), u = r(8701), c = TypeError, l = u("toPrimitive");
                e.exports = function(e, t) {
                    if (!i(e) || o(e)) return e;
                    var r, u = a(e, l);
                    if (u) {
                        if (void 0 === t && (t = "default"), r = n(u, e, t), !i(r) || o(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), s(e, t);
                };
            },
            7966: (e, t, r)=>{
                "use strict";
                var n = r(5107), i = r(3197);
                e.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            3895: (e, t, r)=>{
                "use strict";
                var n = {};
                n[r(8701)("toStringTag")] = "z", e.exports = "[object z]" === String(n);
            },
            7482: (e, t, r)=>{
                "use strict";
                var n = r(6220), i = String;
                e.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            9665: (e)=>{
                "use strict";
                var t = String;
                e.exports = function(e) {
                    try {
                        return t(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            7644: (e, t, r)=>{
                "use strict";
                var n = r(6021), i = 0, o = Math.random(), a = n(1..toString);
                e.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++i + o, 36);
                };
            },
            69: (e, t, r)=>{
                "use strict";
                var n = r(6498);
                e.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            9095: (e, t, r)=>{
                "use strict";
                var n = r(4451), i = r(7909);
                e.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            5636: (e)=>{
                "use strict";
                var t = TypeError;
                e.exports = function(e, r) {
                    if (e < r) throw new t("Not enough arguments");
                    return e;
                };
            },
            8224: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(342), o = n.WeakMap;
                e.exports = i(o) && /native code/.test(String(o));
            },
            8701: (e, t, r)=>{
                "use strict";
                var n = r(5620), i = r(5260), o = r(9489), a = r(7644), s = r(6498), u = r(69), c = n.Symbol, l = i("wks"), f = u ? c.for || c : c && c.withoutSetter || a;
                e.exports = function(e) {
                    return o(l, e) || (l[e] = s && o(c, e) ? c[e] : f("Symbol." + e)), l[e];
                };
            },
            9166: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(2242), o = r(6167), a = r(44), s = r(6965), u = r(4136), c = r(6847), l = r(618), f = r(9654), p = r(4079), d = r(3762), h = r(823), v = r(8701)("toStringTag"), m = Error, y = [].push, g = function(e, t) {
                    var r, n = i(E, this);
                    a ? r = a(new m, n ? o(this) : E) : (r = n ? this : u(E), c(r, v, "Error")), void 0 !== t && c(r, "message", h(t)), p(r, g, r.stack, 1), arguments.length > 2 && f(r, arguments[2]);
                    var s = [];
                    return d(e, y, {
                        that: s
                    }), c(r, "errors", s), r;
                };
                a ? a(g, m) : s(g, m, {
                    name: !0
                });
                var E = g.prototype = u(m.prototype, {
                    constructor: l(1, g),
                    message: l(1, ""),
                    name: l(1, "AggregateError")
                });
                n({
                    global: !0,
                    constructor: !0,
                    arity: 2
                }, {
                    AggregateError: g
                });
            },
            1935: (e, t, r)=>{
                "use strict";
                r(9166);
            },
            6128: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(4029).includes, o = r(7909), a = r(9747);
                n({
                    target: "Array",
                    proto: !0,
                    forced: o(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), a("includes");
            },
            4984: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(3806), o = r(4029).indexOf, a = r(3888), s = i([].indexOf), u = !!s && 1 / s([
                    1
                ], 1, -0) < 0;
                n({
                    target: "Array",
                    proto: !0,
                    forced: u || !a("indexOf")
                }, {
                    indexOf: function(e) {
                        var t = arguments.length > 1 ? arguments[1] : void 0;
                        return u ? s(this, e, t) || 0 : o(this, e, t);
                    }
                });
            },
            7189: (e, t, r)=>{
                "use strict";
                var n = r(4036), i = r(9747), o = r(1724), a = r(8354), s = r(1032).f, u = r(3259), c = r(8893), l = r(6338), f = r(4451), p = "Array Iterator", d = a.set, h = a.getterFor(p);
                e.exports = u(Array, "Array", function(e, t) {
                    d(this, {
                        type: p,
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = h(this), t = e.target, r = e.index++;
                    if (!t || r >= t.length) return e.target = void 0, c(void 0, !0);
                    switch(e.kind){
                        case "keys":
                            return c(r, !1);
                        case "values":
                            return c(t[r], !1);
                    }
                    return c([
                        r,
                        t[r]
                    ], !1);
                }, "values");
                var v = o.Arguments = o.Array;
                if (i("keys"), i("values"), i("entries"), !l && f && "values" !== v.name) try {
                    s(v, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            4269: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(213).left, o = r(3888), a = r(119);
                n({
                    target: "Array",
                    proto: !0,
                    forced: !r(811) && a > 79 && a < 83 || !o("reduce")
                }, {
                    reduce: function(e) {
                        var t = arguments.length;
                        return i(this, e, t, t > 1 ? arguments[1] : void 0);
                    }
                });
            },
            2302: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6021), o = Date, a = i(o.prototype.getTime);
                n({
                    target: "Date",
                    stat: !0
                }, {
                    now: function() {
                        return a(new o);
                    }
                });
            },
            4341: (e, t, r)=>{
                "use strict";
                r(1577)("Map", function(e) {
                    return function() {
                        return e(this, arguments.length ? arguments[0] : void 0);
                    };
                }, r(329));
            },
            1400: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6021), o = r(6735), a = r(4734), s = r(3762), u = r(850), c = r(6338), l = u.Map, f = u.has, p = u.get, d = u.set, h = i([].push);
                n({
                    target: "Map",
                    stat: !0,
                    forced: c
                }, {
                    groupBy: function(e, t) {
                        a(e), o(t);
                        var r = new l, n = 0;
                        return s(e, function(e) {
                            var i = t(e, n++);
                            f(r, i) ? h(p(r, i), e) : d(r, i, [
                                e
                            ]);
                        }), r;
                    }
                });
            },
            727: (e, t, r)=>{
                "use strict";
                r(4341);
            },
            9614: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(4451), o = r(1032).f;
                n({
                    target: "Object",
                    stat: !0,
                    forced: Object.defineProperty !== o,
                    sham: !i
                }, {
                    defineProperty: o
                });
            },
            8331: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(7909), o = r(4036), a = r(8428).f, s = r(4451);
                n({
                    target: "Object",
                    stat: !0,
                    forced: !s || i(function() {
                        a(1);
                    }),
                    sham: !s
                }, {
                    getOwnPropertyDescriptor: function(e, t) {
                        return a(o(e), t);
                    }
                });
            },
            1732: ()=>{},
            261: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6735), a = r(5759), s = r(7854), u = r(3762);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(4549)
                }, {
                    allSettled: function(e) {
                        var t = this, r = a.f(t), n = r.resolve, c = r.reject, l = s(function() {
                            var r = o(t.resolve), a = [], s = 0, c = 1;
                            u(e, function(e) {
                                var o = s++, u = !1;
                                c++, i(r, t, e).then(function(e) {
                                    u || (u = !0, a[o] = {
                                        status: "fulfilled",
                                        value: e
                                    }, --c || n(a));
                                }, function(e) {
                                    u || (u = !0, a[o] = {
                                        status: "rejected",
                                        reason: e
                                    }, --c || n(a));
                                });
                            }), --c || n(a);
                        });
                        return l.error && c(l.value), r.promise;
                    }
                });
            },
            2118: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6735), a = r(5759), s = r(7854), u = r(3762);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(4549)
                }, {
                    all: function(e) {
                        var t = this, r = a.f(t), n = r.resolve, c = r.reject, l = s(function() {
                            var r = o(t.resolve), a = [], s = 0, l = 1;
                            u(e, function(e) {
                                var o = s++, u = !1;
                                l++, i(r, t, e).then(function(e) {
                                    u || (u = !0, a[o] = e, --l || n(a));
                                }, c);
                            }), --l || n(a);
                        });
                        return l.error && c(l.value), r.promise;
                    }
                });
            },
            6766: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6735), a = r(889), s = r(5759), u = r(7854), c = r(3762), l = r(4549), f = "No one promise resolved";
                n({
                    target: "Promise",
                    stat: !0,
                    forced: l
                }, {
                    any: function(e) {
                        var t = this, r = a("AggregateError"), n = s.f(t), l = n.resolve, p = n.reject, d = u(function() {
                            var n = o(t.resolve), a = [], s = 0, u = 1, d = !1;
                            c(e, function(e) {
                                var o = s++, c = !1;
                                u++, i(n, t, e).then(function(e) {
                                    c || d || (d = !0, l(e));
                                }, function(e) {
                                    c || d || (c = !0, a[o] = e, --u || p(new r(a, f)));
                                });
                            }), --u || p(new r(a, f));
                        });
                        return d.error && p(d.value), n.promise;
                    }
                });
            },
            9227: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6338), o = r(4194).CONSTRUCTOR, a = r(2882), s = r(889), u = r(342), c = r(4423), l = a && a.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: o,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && u(a)) {
                    var f = s("Promise").prototype.catch;
                    l.catch !== f && c(l, "catch", f, {
                        unsafe: !0
                    });
                }
            },
            8668: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(434), s = r(6338), u = r(811), c = r(5620), l = r(9556), f = r(4423), p = r(44), d = r(6752), h = r(6331), v = r(6735), m = r(342), y = r(2660), g = r(6406), E = r(4889), b = r(7112).set, S = r(9194), _ = r(8831), O = r(7854), w = r(750), T = r(8354), I = r(2882), R = r(4194), x = r(5759), A = "Promise", N = R.CONSTRUCTOR, C = R.REJECTION_EVENT, k = R.SUBCLASSING, M = T.getterFor(A), P = T.set, D = I && I.prototype, F = I, L = D, j = c.TypeError, U = c.document, B = c.process, Q = x.f, V = Q, q = !!(U && U.createEvent && c.dispatchEvent), G = "unhandledrejection", z = function(e) {
                    var t;
                    return !(!y(e) || !m(t = e.then)) && t;
                }, W = function(e, t) {
                    var r, n, i, o = t.value, a = 1 === t.state, s = a ? e.ok : e.fail, u = e.resolve, c = e.reject, f = e.domain;
                    try {
                        s ? (a || (2 === t.rejection && X(t), t.rejection = 1), !0 === s ? r = o : (f && f.enter(), r = s(o), f && (f.exit(), i = !0)), r === e.promise ? c(new j("Promise-chain cycle")) : (n = z(r)) ? l(n, r, u, c) : u(r)) : c(o);
                    } catch (e) {
                        f && !i && f.exit(), c(e);
                    }
                }, $ = function(e, t) {
                    e.notified || (e.notified = !0, S(function() {
                        for(var r, n = e.reactions; r = n.get();)W(r, e);
                        e.notified = !1, t && !e.rejection && K(e);
                    }));
                }, H = function(e, t, r) {
                    var n, i;
                    q ? ((n = U.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), c.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !C && (i = c["on" + e]) ? i(n) : e === G && _("Unhandled promise rejection", r);
                }, K = function(e) {
                    l(b, c, function() {
                        var t, r = e.facade, n = e.value;
                        if (Y(e) && (t = O(function() {
                            u ? B.emit("unhandledRejection", n, r) : H(G, r, n);
                        }), e.rejection = u || Y(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, Y = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, X = function(e) {
                    l(b, c, function() {
                        var t = e.facade;
                        u ? B.emit("rejectionHandled", t) : H("rejectionhandled", t, e.value);
                    });
                }, J = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, Z = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, $(e, !0));
                }, ee = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new j("Promise can't be resolved itself");
                            var n = z(t);
                            n ? S(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    l(n, t, J(ee, r, e), J(Z, r, e));
                                } catch (t) {
                                    Z(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, $(e, !1));
                        } catch (t) {
                            Z({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (N && (F = function(e) {
                    g(this, L), v(e), l(n, this);
                    var t = M(this);
                    try {
                        e(J(ee, t), J(Z, t));
                    } catch (e) {
                        Z(t, e);
                    }
                }, (n = function(e) {
                    P(this, {
                        type: A,
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new w,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = f(L = F.prototype, "then", function(e, t) {
                    var r = M(this), n = Q(E(this, F));
                    return r.parent = !0, n.ok = !m(e) || e, n.fail = m(t) && t, n.domain = u ? B.domain : void 0, 0 === r.state ? r.reactions.add(n) : S(function() {
                        W(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = M(e);
                    this.promise = e, this.resolve = J(ee, t), this.reject = J(Z, t);
                }, x.f = Q = function(e) {
                    return e === F || undefined === e ? new i(e) : V(e);
                }, !s && m(I) && D !== Object.prototype)) {
                    o = D.then, k || f(D, "then", function(e, t) {
                        var r = this;
                        return new F(function(e, t) {
                            l(o, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete D.constructor;
                    } catch (e) {}
                    p && p(D, L);
                }
                a({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: N
                }, {
                    Promise: F
                }), d(F, A, !1, !0), h(A);
            },
            9363: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6338), o = r(2882), a = r(7909), s = r(889), u = r(342), c = r(4889), l = r(2764), f = r(4423), p = o && o.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!o && a(function() {
                        p.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = c(this, s("Promise")), r = u(e);
                        return this.then(r ? function(r) {
                            return l(t, e()).then(function() {
                                return r;
                            });
                        } : e, r ? function(r) {
                            return l(t, e()).then(function() {
                                throw r;
                            });
                        } : e);
                    }
                }), !i && u(o)) {
                    var d = s("Promise").prototype.finally;
                    p.finally !== d && f(p, "finally", d, {
                        unsafe: !0
                    });
                }
            },
            7971: (e, t, r)=>{
                "use strict";
                r(8668), r(2118), r(9227), r(1912), r(8981), r(8469);
            },
            1912: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(9556), o = r(6735), a = r(5759), s = r(7854), u = r(3762);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(4549)
                }, {
                    race: function(e) {
                        var t = this, r = a.f(t), n = r.reject, c = s(function() {
                            var a = o(t.resolve);
                            u(e, function(e) {
                                i(a, t, e).then(r.resolve, n);
                            });
                        });
                        return c.error && n(c.value), r.promise;
                    }
                });
            },
            8981: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(5759);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(4194).CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = i.f(this);
                        return (0, t.reject)(e), t.promise;
                    }
                });
            },
            8469: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(889), o = r(6338), a = r(2882), s = r(4194).CONSTRUCTOR, u = r(2764), c = i("Promise"), l = o && !s;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: o || s
                }, {
                    resolve: function(e) {
                        return u(l && this === c ? a : this, e);
                    }
                });
            },
            5412: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(5759);
                n({
                    target: "Promise",
                    stat: !0
                }, {
                    withResolvers: function() {
                        var e = i.f(this);
                        return {
                            promise: e.promise,
                            resolve: e.resolve,
                            reject: e.reject
                        };
                    }
                });
            },
            1381: (e, t, r)=>{
                "use strict";
                var n, i = r(434), o = r(3806), a = r(8428).f, s = r(9505), u = r(7482), c = r(2679), l = r(4734), f = r(2541), p = r(6338), d = o("".slice), h = Math.min, v = f("endsWith");
                i({
                    target: "String",
                    proto: !0,
                    forced: !!(p || v || (n = a(String.prototype, "endsWith"), !n || n.writable)) && !v
                }, {
                    endsWith: function(e) {
                        var t = u(l(this));
                        c(e);
                        var r = arguments.length > 1 ? arguments[1] : void 0, n = t.length, i = void 0 === r ? n : h(s(r), n), o = u(e);
                        return d(t, i - o.length, i) === o;
                    }
                });
            },
            1021: (e, t, r)=>{
                "use strict";
                var n = r(434), i = r(6021), o = r(2679), a = r(4734), s = r(7482), u = r(2541), c = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !u("includes")
                }, {
                    includes: function(e) {
                        return !!~c(s(a(this)), s(o(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            9823: (e, t, r)=>{
                "use strict";
                var n = r(8115).charAt, i = r(7482), o = r(8354), a = r(3259), s = r(8893), u = "String Iterator", c = o.set, l = o.getterFor(u);
                a(String, "String", function(e) {
                    c(this, {
                        type: u,
                        string: i(e),
                        index: 0
                    });
                }, function() {
                    var e, t = l(this), r = t.string, i = t.index;
                    return i >= r.length ? s(void 0, !0) : (e = n(r, i), t.index += e.length, s(e, !1));
                });
            },
            4043: (e, t, r)=>{
                "use strict";
                var n, i = r(7036), o = r(5620), a = r(6021), s = r(9102), u = r(1854), c = r(1577), l = r(943), f = r(2660), p = r(8354).enforce, d = r(7909), h = r(8224), v = Object, m = Array.isArray, y = v.isExtensible, g = v.isFrozen, E = v.isSealed, b = v.freeze, S = v.seal, _ = !o.ActiveXObject && "ActiveXObject" in o, O = function(e) {
                    return function() {
                        return e(this, arguments.length ? arguments[0] : void 0);
                    };
                }, w = c("WeakMap", O, l), T = w.prototype, I = a(T.set);
                if (h) {
                    if (_) {
                        n = l.getConstructor(O, "WeakMap", !0), u.enable();
                        var R = a(T.delete), x = a(T.has), A = a(T.get);
                        s(T, {
                            delete: function(e) {
                                if (f(e) && !y(e)) {
                                    var t = p(this);
                                    return t.frozen || (t.frozen = new n), R(this, e) || t.frozen.delete(e);
                                }
                                return R(this, e);
                            },
                            has: function(e) {
                                if (f(e) && !y(e)) {
                                    var t = p(this);
                                    return t.frozen || (t.frozen = new n), x(this, e) || t.frozen.has(e);
                                }
                                return x(this, e);
                            },
                            get: function(e) {
                                if (f(e) && !y(e)) {
                                    var t = p(this);
                                    return t.frozen || (t.frozen = new n), x(this, e) ? A(this, e) : t.frozen.get(e);
                                }
                                return A(this, e);
                            },
                            set: function(e, t) {
                                if (f(e) && !y(e)) {
                                    var r = p(this);
                                    r.frozen || (r.frozen = new n), x(this, e) ? I(this, e, t) : r.frozen.set(e, t);
                                } else I(this, e, t);
                                return this;
                            }
                        });
                    } else i && d(function() {
                        var e = b([]);
                        return I(new w, e, 1), !g(e);
                    }) && s(T, {
                        set: function(e, t) {
                            var r;
                            return m(e) && (g(e) ? r = b : E(e) && (r = S)), I(this, e, t), r && r(e), this;
                        }
                    });
                }
            },
            9284: (e, t, r)=>{
                "use strict";
                r(4043);
            },
            469: (e, t, r)=>{
                "use strict";
                r(7189);
                var n = r(1753), i = r(5620), o = r(6752), a = r(1724);
                for(var s in n)o(i[s], s), a[s] = a.Array;
            },
            4998: (e, t, r)=>{
                "use strict";
                var n = r(8630);
                e.exports = n;
            },
            9844: (e, t, r)=>{
                "use strict";
                var n = r(6225);
                e.exports = n;
            },
            3773: (e, t, r)=>{
                "use strict";
                var n = r(931);
                e.exports = n;
            },
            5705: (e, t, r)=>{
                "use strict";
                var n = r(7888);
                e.exports = n;
            },
            6376: (e, t, r)=>{
                "use strict";
                var n = r(6329);
                e.exports = n;
            },
            4297: (e, t, r)=>{
                "use strict";
                var n = r(2461);
                r(469), e.exports = n;
            },
            1165: (e, t, r)=>{
                "use strict";
                var n = r(296);
                e.exports = n;
            },
            5397: (e, t, r)=>{
                "use strict";
                var n = r(8628);
                e.exports = n;
            },
            7500: (e, t, r)=>{
                "use strict";
                var n = r(9057);
                r(469), e.exports = n;
            },
            7582: (e, t, r)=>{
                "use strict";
                var n = r(1170);
                r(469), e.exports = n;
            },
            607: (e, t, r)=>{
                "use strict";
                var n = r(5547), i = r(3454), o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not a function");
                };
            },
            293: (e, t, r)=>{
                "use strict";
                var n = r(4942).charAt;
                e.exports = function(e, t, r) {
                    return t + (r ? n(e, t).length : 1);
                };
            },
            4738: (e, t, r)=>{
                "use strict";
                var n = r(2922), i = String, o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not an object");
                };
            },
            3458: (e, t, r)=>{
                "use strict";
                var n = r(3238), i = r(645), o = r(1024), a = function(e) {
                    return function(t, r, a) {
                        var s, u = n(t), c = o(u), l = i(a, c);
                        if (e && r != r) {
                            for(; c > l;)if ((s = u[l++]) != s) return !0;
                        } else for(; c > l; l++)if ((e || l in u) && u[l] === r) return e || l || 0;
                        return !e && -1;
                    };
                };
                e.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            5067: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = n({}.toString), o = n("".slice);
                e.exports = function(e) {
                    return o(i(e), 8, -1);
                };
            },
            1331: (e, t, r)=>{
                "use strict";
                var n = r(7804), i = r(5547), o = r(5067), a = r(5553)("toStringTag"), s = Object, u = "Arguments" === o(function() {
                    return arguments;
                }());
                e.exports = n ? o : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = s(e), a)) ? r : u ? o(t) : "Object" === (n = o(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            775: (e, t, r)=>{
                "use strict";
                var n = r(3531), i = r(66), o = r(9070), a = r(2030);
                e.exports = function(e, t, r) {
                    for(var s = i(t), u = a.f, c = o.f, l = 0; l < s.length; l++){
                        var f = s[l];
                        n(e, f) || r && n(r, f) || u(e, f, c(t, f));
                    }
                };
            },
            9238: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(2030), o = r(7999);
                e.exports = n ? function(e, t, r) {
                    return i.f(e, t, o(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            7999: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            3300: (e, t, r)=>{
                "use strict";
                var n = r(5547), i = r(2030), o = r(6543), a = r(4143);
                e.exports = function(e, t, r, s) {
                    s || (s = {});
                    var u = s.enumerable, c = void 0 !== s.name ? s.name : t;
                    if (n(r) && o(r, c, s), s.global) u ? e[t] = r : a(t, r);
                    else {
                        try {
                            s.unsafe ? e[t] && (u = !0) : delete e[t];
                        } catch (e) {}
                        u ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !s.nonConfigurable,
                            writable: !s.nonWritable
                        });
                    }
                    return e;
                };
            },
            4143: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = Object.defineProperty;
                e.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            4694: (e, t, r)=>{
                "use strict";
                var n = r(5392);
                e.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            7694: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(2922), o = n.document, a = i(o) && i(o.createElement);
                e.exports = function(e) {
                    return a ? o.createElement(e) : {};
                };
            },
            8270: (e)=>{
                "use strict";
                e.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            6262: (e, t, r)=>{
                "use strict";
                var n, i, o = r(5628), a = r(8270), s = o.process, u = o.Deno, c = s && s.versions || u && u.version, l = c && c.v8;
                l && (i = (n = l.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && a && (!(n = a.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = a.match(/Chrome\/(\d+)/)) && (i = +n[1]), e.exports = i;
            },
            1989: (e)=>{
                "use strict";
                e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            3937: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(9070).f, o = r(9238), a = r(3300), s = r(4143), u = r(775), c = r(5416);
                e.exports = function(e, t) {
                    var r, l, f, p, d, h = e.target, v = e.global, m = e.stat;
                    if (r = v ? n : m ? n[h] || s(h, {}) : (n[h] || {}).prototype) for(l in t){
                        if (p = t[l], f = e.dontCallGetSet ? (d = i(r, l)) && d.value : r[l], !c(v ? l : h + (m ? "." : "#") + l, e.forced) && void 0 !== f) {
                            if (typeof p == typeof f) continue;
                            u(p, f);
                        }
                        (e.sham || f && f.sham) && o(p, "sham", !0), a(r, l, p, e);
                    }
                };
            },
            5392: (e)=>{
                "use strict";
                e.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            9041: (e, t, r)=>{
                "use strict";
                r(6433);
                var n = r(8209), i = r(3300), o = r(4493), a = r(5392), s = r(5553), u = r(9238), c = s("species"), l = RegExp.prototype;
                e.exports = function(e, t, r, f) {
                    var p = s(e), d = !a(function() {
                        var t = {};
                        return t[p] = function() {
                            return 7;
                        }, 7 !== ""[e](t);
                    }), h = d && !a(function() {
                        var t = !1, r = /a/;
                        return "split" === e && ((r = {}).constructor = {}, r.constructor[c] = function() {
                            return r;
                        }, r.flags = "", r[p] = /./[p]), r.exec = function() {
                            return t = !0, null;
                        }, r[p](""), !t;
                    });
                    if (!d || !h || r) {
                        var v = n(/./[p]), m = t(p, ""[e], function(e, t, r, i, a) {
                            var s = n(e), u = t.exec;
                            return u === o || u === l.exec ? d && !a ? {
                                done: !0,
                                value: v(t, r, i)
                            } : {
                                done: !0,
                                value: s(r, t, i)
                            } : {
                                done: !1
                            };
                        });
                        i(String.prototype, e, m[0]), i(l, p, m[1]);
                    }
                    f && u(l[p], "sham", !0);
                };
            },
            9500: (e, t, r)=>{
                "use strict";
                var n = r(9232), i = Function.prototype, o = i.apply, a = i.call;
                e.exports = "object" == typeof Reflect && Reflect.apply || (n ? a.bind(o) : function() {
                    return a.apply(o, arguments);
                });
            },
            9232: (e, t, r)=>{
                "use strict";
                var n = r(5392);
                e.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            5304: (e, t, r)=>{
                "use strict";
                var n = r(9232), i = Function.prototype.call;
                e.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            4930: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(3531), o = Function.prototype, a = n && Object.getOwnPropertyDescriptor, s = i(o, "name"), u = s && "something" === (function() {}).name, c = s && (!n || n && a(o, "name").configurable);
                e.exports = {
                    EXISTS: s,
                    PROPER: u,
                    CONFIGURABLE: c
                };
            },
            8209: (e, t, r)=>{
                "use strict";
                var n = r(5067), i = r(5207);
                e.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            5207: (e, t, r)=>{
                "use strict";
                var n = r(9232), i = Function.prototype, o = i.call, a = n && i.bind.bind(o, o);
                e.exports = n ? a : function(e) {
                    return function() {
                        return o.apply(e, arguments);
                    };
                };
            },
            6341: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(5547);
                e.exports = function(e, t) {
                    var r;
                    return arguments.length < 2 ? i(r = n[e]) ? r : void 0 : n[e] && n[e][t];
                };
            },
            2698: (e, t, r)=>{
                "use strict";
                var n = r(607), i = r(7930);
                e.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            5095: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(4874), o = Math.floor, a = n("".charAt), s = n("".replace), u = n("".slice), c = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
                e.exports = function(e, t, r, n, f, p) {
                    var d = r + e.length, h = n.length, v = l;
                    return void 0 !== f && (f = i(f), v = c), s(p, v, function(i, s) {
                        var c;
                        switch(a(s, 0)){
                            case "$":
                                return "$";
                            case "&":
                                return e;
                            case "`":
                                return u(t, 0, r);
                            case "'":
                                return u(t, d);
                            case "<":
                                c = f[u(s, 1, -1)];
                                break;
                            default:
                                var l = +s;
                                if (0 === l) return i;
                                if (l > h) {
                                    var p = o(l / 10);
                                    return 0 === p ? i : p <= h ? void 0 === n[p - 1] ? a(s, 1) : n[p - 1] + a(s, 1) : i;
                                }
                                c = n[l - 1];
                        }
                        return void 0 === c ? "" : c;
                    });
                };
            },
            5628: function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.Math === Math && e;
                };
                e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof r.g && r.g) || n("object" == typeof this && this) || function() {
                    return this;
                }() || Function("return this")();
            },
            3531: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(4874), o = n({}.hasOwnProperty);
                e.exports = Object.hasOwn || function(e, t) {
                    return o(i(e), t);
                };
            },
            6710: (e)=>{
                "use strict";
                e.exports = {};
            },
            5913: (e, t, r)=>{
                "use strict";
                var n = r(6341);
                e.exports = n("document", "documentElement");
            },
            7199: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(5392), o = r(7694);
                e.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(o("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            3415: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(5392), o = r(5067), a = Object, s = n("".split);
                e.exports = i(function() {
                    return !a("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === o(e) ? s(e, "") : a(e);
                } : a;
            },
            8833: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(5547), o = r(8866), a = n(Function.toString);
                i(o.inspectSource) || (o.inspectSource = function(e) {
                    return a(e);
                }), e.exports = o.inspectSource;
            },
            5972: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(1337), s = r(5628), u = r(2922), c = r(9238), l = r(3531), f = r(8866), p = r(2992), d = r(6710), h = "Object already initialized", v = s.TypeError;
                if (a || f.state) {
                    var m = f.state || (f.state = new s.WeakMap);
                    m.get = m.get, m.has = m.has, m.set = m.set, n = function(e, t) {
                        if (m.has(e)) throw new v(h);
                        return t.facade = e, m.set(e, t), t;
                    }, i = function(e) {
                        return m.get(e) || {};
                    }, o = function(e) {
                        return m.has(e);
                    };
                } else {
                    var y = p("state");
                    d[y] = !0, n = function(e, t) {
                        if (l(e, y)) throw new v(h);
                        return t.facade = e, c(e, y, t), t;
                    }, i = function(e) {
                        return l(e, y) ? e[y] : {};
                    }, o = function(e) {
                        return l(e, y);
                    };
                }
                e.exports = {
                    set: n,
                    get: i,
                    has: o,
                    enforce: function(e) {
                        return o(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!u(t) || (r = i(t)).type !== e) throw new v("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            5547: (e)=>{
                "use strict";
                var t = "object" == typeof document && document.all;
                e.exports = void 0 === t && void 0 !== t ? function(e) {
                    return "function" == typeof e || e === t;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            5416: (e, t, r)=>{
                "use strict";
                var n = r(5392), i = r(5547), o = /#|\.prototype\./, a = function(e, t) {
                    var r = u[s(e)];
                    return r === l || r !== c && (i(t) ? n(t) : !!t);
                }, s = a.normalize = function(e) {
                    return String(e).replace(o, ".").toLowerCase();
                }, u = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
                e.exports = a;
            },
            7930: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return null == e;
                };
            },
            2922: (e, t, r)=>{
                "use strict";
                var n = r(5547);
                e.exports = function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            5988: (e)=>{
                "use strict";
                e.exports = !1;
            },
            6610: (e, t, r)=>{
                "use strict";
                var n = r(6341), i = r(5547), o = r(5692), a = r(8675), s = Object;
                e.exports = a ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && o(t.prototype, s(e));
                };
            },
            1024: (e, t, r)=>{
                "use strict";
                var n = r(7450);
                e.exports = function(e) {
                    return n(e.length);
                };
            },
            6543: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(5392), o = r(5547), a = r(3531), s = r(4694), u = r(4930).CONFIGURABLE, c = r(8833), l = r(5972), f = l.enforce, p = l.get, d = String, h = Object.defineProperty, v = n("".slice), m = n("".replace), y = n([].join), g = s && !i(function() {
                    return 8 !== h(function() {}, "length", {
                        value: 8
                    }).length;
                }), E = String(String).split("String"), b = e.exports = function(e, t, r) {
                    "Symbol(" === v(d(t), 0, 7) && (t = "[" + m(d(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!a(e, "name") || u && e.name !== t) && (s ? h(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), g && r && a(r, "arity") && e.length !== r.arity && h(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && a(r, "constructor") && r.constructor ? s && h(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = f(e);
                    return a(n, "source") || (n.source = y(E, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = b(function() {
                    return o(this) && p(this).source || c(this);
                }, "toString");
            },
            5779: (e)=>{
                "use strict";
                var t = Math.ceil, r = Math.floor;
                e.exports = Math.trunc || function(e) {
                    var n = +e;
                    return (n > 0 ? r : t)(n);
                };
            },
            5572: (e, t, r)=>{
                "use strict";
                var n, i = r(4738), o = r(3742), a = r(1989), s = r(6710), u = r(5913), c = r(7694), l = r(2992), f = "prototype", p = "script", d = l("IE_PROTO"), h = function() {}, v = function(e) {
                    return "<" + p + ">" + e + "</" + p + ">";
                }, m = function(e) {
                    e.write(v("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, y = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t, r;
                    y = "undefined" != typeof document ? document.domain && n ? m(n) : (t = c("iframe"), r = "java" + p + ":", t.style.display = "none", u.appendChild(t), t.src = String(r), (e = t.contentWindow.document).open(), e.write(v("document.F=Object")), e.close(), e.F) : m(n);
                    for(var i = a.length; i--;)delete y[f][a[i]];
                    return y();
                };
                s[d] = !0, e.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (h[f] = i(e), r = new h, h[f] = null, r[d] = e) : r = y(), void 0 === t ? r : o.f(r, t);
                };
            },
            3742: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(1089), o = r(2030), a = r(4738), s = r(3238), u = r(5265);
                t.f = n && !i ? Object.defineProperties : function(e, t) {
                    a(e);
                    for(var r, n = s(t), i = u(t), c = i.length, l = 0; c > l;)o.f(e, r = i[l++], n[r]);
                    return e;
                };
            },
            2030: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(7199), o = r(1089), a = r(4738), s = r(3561), u = TypeError, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, f = "enumerable", p = "configurable", d = "writable";
                t.f = n ? o ? function(e, t, r) {
                    if (a(e), t = s(t), a(r), "function" == typeof e && "prototype" === t && "value" in r && d in r && !r[d]) {
                        var n = l(e, t);
                        n && n[d] && (e[t] = r.value, r = {
                            configurable: p in r ? r[p] : n[p],
                            enumerable: f in r ? r[f] : n[f],
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (a(e), t = s(t), a(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new u("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            9070: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(5304), o = r(5085), a = r(7999), s = r(3238), u = r(3561), c = r(3531), l = r(7199), f = Object.getOwnPropertyDescriptor;
                t.f = n ? f : function(e, t) {
                    if (e = s(e), t = u(t), l) try {
                        return f(e, t);
                    } catch (e) {}
                    if (c(e, t)) return a(!i(o.f, e, t), e[t]);
                };
            },
            3817: (e, t, r)=>{
                "use strict";
                var n = r(9864), i = r(1989).concat("length", "prototype");
                t.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            68: (e, t)=>{
                "use strict";
                t.f = Object.getOwnPropertySymbols;
            },
            5692: (e, t, r)=>{
                "use strict";
                var n = r(5207);
                e.exports = n({}.isPrototypeOf);
            },
            9864: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(3531), o = r(3238), a = r(3458).indexOf, s = r(6710), u = n([].push);
                e.exports = function(e, t) {
                    var r, n = o(e), c = 0, l = [];
                    for(r in n)!i(s, r) && i(n, r) && u(l, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~a(l, r) || u(l, r));
                    return l;
                };
            },
            5265: (e, t, r)=>{
                "use strict";
                var n = r(9864), i = r(1989);
                e.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            5085: (e, t)=>{
                "use strict";
                var r = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, i = n && !r.call({
                    1: 2
                }, 1);
                t.f = i ? function(e) {
                    var t = n(this, e);
                    return !!t && t.enumerable;
                } : r;
            },
            3085: (e, t, r)=>{
                "use strict";
                var n = r(5304), i = r(5547), o = r(2922), a = TypeError;
                e.exports = function(e, t) {
                    var r, s;
                    if ("string" === t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    if (i(r = e.valueOf) && !o(s = n(r, e))) return s;
                    if ("string" !== t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    throw new a("Can't convert object to primitive value");
                };
            },
            66: (e, t, r)=>{
                "use strict";
                var n = r(6341), i = r(5207), o = r(3817), a = r(68), s = r(4738), u = i([].concat);
                e.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = o.f(s(e)), r = a.f;
                    return r ? u(t, r(e)) : t;
                };
            },
            2493: (e, t, r)=>{
                "use strict";
                var n = r(5304), i = r(4738), o = r(5547), a = r(5067), s = r(4493), u = TypeError;
                e.exports = function(e, t) {
                    var r = e.exec;
                    if (o(r)) {
                        var c = n(r, e, t);
                        return null !== c && i(c), c;
                    }
                    if ("RegExp" === a(e)) return n(s, e, t);
                    throw new u("RegExp#exec called on incompatible receiver");
                };
            },
            4493: (e, t, r)=>{
                "use strict";
                var n, i, o = r(5304), a = r(5207), s = r(9338), u = r(5337), c = r(2053), l = r(7995), f = r(5572), p = r(5972).get, d = r(9383), h = r(3275), v = l("native-string-replace", String.prototype.replace), m = RegExp.prototype.exec, y = m, g = a("".charAt), E = a("".indexOf), b = a("".replace), S = a("".slice), _ = (i = /b*/g, o(m, n = /a/, "a"), o(m, i, "a"), 0 !== n.lastIndex || 0 !== i.lastIndex), O = c.BROKEN_CARET, w = void 0 !== /()??/.exec("")[1];
                (_ || w || O || d || h) && (y = function(e) {
                    var t, r, n, i, a, c, l, d = this, h = p(d), T = s(e), I = h.raw;
                    if (I) return I.lastIndex = d.lastIndex, t = o(y, I, T), d.lastIndex = I.lastIndex, t;
                    var R = h.groups, x = O && d.sticky, A = o(u, d), N = d.source, C = 0, k = T;
                    if (x && (A = b(A, "y", ""), -1 === E(A, "g") && (A += "g"), k = S(T, d.lastIndex), d.lastIndex > 0 && (!d.multiline || d.multiline && "\n" !== g(T, d.lastIndex - 1)) && (N = "(?: " + N + ")", k = " " + k, C++), r = new RegExp("^(?:" + N + ")", A)), w && (r = new RegExp("^" + N + "$(?!\\s)", A)), _ && (n = d.lastIndex), i = o(m, x ? r : d, k), x ? i ? (i.input = S(i.input, C), i[0] = S(i[0], C), i.index = d.lastIndex, d.lastIndex += i[0].length) : d.lastIndex = 0 : _ && i && (d.lastIndex = d.global ? i.index + i[0].length : n), w && i && i.length > 1 && o(v, i[0], r, function() {
                        for(a = 1; a < arguments.length - 2; a++)void 0 === arguments[a] && (i[a] = void 0);
                    }), i && R) for(i.groups = c = f(null), a = 0; a < R.length; a++)c[(l = R[a])[0]] = i[l[1]];
                    return i;
                }), e.exports = y;
            },
            5337: (e, t, r)=>{
                "use strict";
                var n = r(4738);
                e.exports = function() {
                    var e = n(this), t = "";
                    return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
                };
            },
            2053: (e, t, r)=>{
                "use strict";
                var n = r(5392), i = r(5628).RegExp, o = n(function() {
                    var e = i("a", "y");
                    return e.lastIndex = 2, null !== e.exec("abcd");
                }), a = o || n(function() {
                    return !i("a", "y").sticky;
                }), s = o || n(function() {
                    var e = i("^r", "gy");
                    return e.lastIndex = 2, null !== e.exec("str");
                });
                e.exports = {
                    BROKEN_CARET: s,
                    MISSED_STICKY: a,
                    UNSUPPORTED_Y: o
                };
            },
            9383: (e, t, r)=>{
                "use strict";
                var n = r(5392), i = r(5628).RegExp;
                e.exports = n(function() {
                    var e = i(".", "s");
                    return !(e.dotAll && e.test("\n") && "s" === e.flags);
                });
            },
            3275: (e, t, r)=>{
                "use strict";
                var n = r(5392), i = r(5628).RegExp;
                e.exports = n(function() {
                    var e = i("(?<a>b)", "g");
                    return "b" !== e.exec("b").groups.a || "bc" !== "b".replace(e, "$<a>c");
                });
            },
            4202: (e, t, r)=>{
                "use strict";
                var n = r(7930), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            2992: (e, t, r)=>{
                "use strict";
                var n = r(7995), i = r(1188), o = n("keys");
                e.exports = function(e) {
                    return o[e] || (o[e] = i(e));
                };
            },
            8866: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(4143), o = "__core-js_shared__", a = n[o] || i(o, {});
                e.exports = a;
            },
            7995: (e, t, r)=>{
                "use strict";
                var n = r(5988), i = r(8866);
                (e.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.35.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.35.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            4942: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = r(2501), o = r(9338), a = r(4202), s = n("".charAt), u = n("".charCodeAt), c = n("".slice), l = function(e) {
                    return function(t, r) {
                        var n, l, f = o(a(t)), p = i(r), d = f.length;
                        return p < 0 || p >= d ? e ? "" : void 0 : (n = u(f, p)) < 55296 || n > 56319 || p + 1 === d || (l = u(f, p + 1)) < 56320 || l > 57343 ? e ? s(f, p) : n : e ? c(f, p, p + 2) : l - 56320 + (n - 55296 << 10) + 65536;
                    };
                };
                e.exports = {
                    codeAt: l(!1),
                    charAt: l(!0)
                };
            },
            2083: (e, t, r)=>{
                "use strict";
                var n = r(6262), i = r(5392), o = r(5628).String;
                e.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !o(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            645: (e, t, r)=>{
                "use strict";
                var n = r(2501), i = Math.max, o = Math.min;
                e.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : o(r, t);
                };
            },
            3238: (e, t, r)=>{
                "use strict";
                var n = r(3415), i = r(4202);
                e.exports = function(e) {
                    return n(i(e));
                };
            },
            2501: (e, t, r)=>{
                "use strict";
                var n = r(5779);
                e.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            7450: (e, t, r)=>{
                "use strict";
                var n = r(2501), i = Math.min;
                e.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            4874: (e, t, r)=>{
                "use strict";
                var n = r(4202), i = Object;
                e.exports = function(e) {
                    return i(n(e));
                };
            },
            1086: (e, t, r)=>{
                "use strict";
                var n = r(5304), i = r(2922), o = r(6610), a = r(2698), s = r(3085), u = r(5553), c = TypeError, l = u("toPrimitive");
                e.exports = function(e, t) {
                    if (!i(e) || o(e)) return e;
                    var r, u = a(e, l);
                    if (u) {
                        if (void 0 === t && (t = "default"), r = n(u, e, t), !i(r) || o(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), s(e, t);
                };
            },
            3561: (e, t, r)=>{
                "use strict";
                var n = r(1086), i = r(6610);
                e.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            7804: (e, t, r)=>{
                "use strict";
                var n = {};
                n[r(5553)("toStringTag")] = "z", e.exports = "[object z]" === String(n);
            },
            9338: (e, t, r)=>{
                "use strict";
                var n = r(1331), i = String;
                e.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            3454: (e)=>{
                "use strict";
                var t = String;
                e.exports = function(e) {
                    try {
                        return t(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            1188: (e, t, r)=>{
                "use strict";
                var n = r(5207), i = 0, o = Math.random(), a = n(1..toString);
                e.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++i + o, 36);
                };
            },
            8675: (e, t, r)=>{
                "use strict";
                var n = r(2083);
                e.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            1089: (e, t, r)=>{
                "use strict";
                var n = r(4694), i = r(5392);
                e.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            1337: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(5547), o = n.WeakMap;
                e.exports = i(o) && /native code/.test(String(o));
            },
            5553: (e, t, r)=>{
                "use strict";
                var n = r(5628), i = r(7995), o = r(3531), a = r(1188), s = r(2083), u = r(8675), c = n.Symbol, l = i("wks"), f = u ? c.for || c : c && c.withoutSetter || a;
                e.exports = function(e) {
                    return o(l, e) || (l[e] = s && o(c, e) ? c[e] : f("Symbol." + e)), l[e];
                };
            },
            6433: (e, t, r)=>{
                "use strict";
                var n = r(3937), i = r(4493);
                n({
                    target: "RegExp",
                    proto: !0,
                    forced: /./.exec !== i
                }, {
                    exec: i
                });
            },
            9064: (e, t, r)=>{
                "use strict";
                var n = r(9500), i = r(5304), o = r(5207), a = r(9041), s = r(5392), u = r(4738), c = r(5547), l = r(7930), f = r(2501), p = r(7450), d = r(9338), h = r(4202), v = r(293), m = r(2698), y = r(5095), g = r(2493), E = r(5553)("replace"), b = Math.max, S = Math.min, _ = o([].concat), O = o([].push), w = o("".indexOf), T = o("".slice), I = "$0" === "a".replace(/./, "$0"), R = !!/./[E] && "" === /./[E]("a", "$0");
                a("replace", function(e, t, r) {
                    var o = R ? "$" : "$0";
                    return [
                        function(e, r) {
                            var n = h(this), o = l(e) ? void 0 : m(e, E);
                            return o ? i(o, e, n, r) : i(t, d(n), e, r);
                        },
                        function(e, i) {
                            var a = u(this), s = d(e);
                            if ("string" == typeof i && -1 === w(i, o) && -1 === w(i, "$<")) {
                                var l = r(t, a, s, i);
                                if (l.done) return l.value;
                            }
                            var h = c(i);
                            h || (i = d(i));
                            var m, E = a.global;
                            E && (m = a.unicode, a.lastIndex = 0);
                            for(var I, R = []; null !== (I = g(a, s)) && (O(R, I), E);)"" === d(I[0]) && (a.lastIndex = v(s, p(a.lastIndex), m));
                            for(var x, A = "", N = 0, C = 0; C < R.length; C++){
                                for(var k, M = d((I = R[C])[0]), P = b(S(f(I.index), s.length), 0), D = [], F = 1; F < I.length; F++)O(D, void 0 === (x = I[F]) ? x : String(x));
                                var L = I.groups;
                                if (h) {
                                    var j = _([
                                        M
                                    ], D, P, s);
                                    void 0 !== L && O(j, L), k = d(n(i, void 0, j));
                                } else k = y(M, s, P, D, L, i);
                                P >= N && (A += T(s, N, P) + k, N = P + M.length);
                            }
                            return A + T(s, N);
                        }
                    ];
                }, !!s(function() {
                    var e = /./;
                    return e.exec = function() {
                        var e = [];
                        return e.groups = {
                            a: "7"
                        }, e;
                    }, "7" !== "".replace(e, "$<a>");
                }) || !I || R);
            },
            4636: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>s
                });
                var n = r(8921);
                function i(e) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, i(e);
                }
                var o = 10, a = 2;
                function s(e) {
                    return u(e, []);
                }
                function u(e, t) {
                    switch(i(e)){
                        case "string":
                            return JSON.stringify(e);
                        case "function":
                            return e.name ? "[function ".concat(e.name, "]") : "[function]";
                        case "object":
                            return null === e ? "null" : function(e, t) {
                                if (-1 !== t.indexOf(e)) return "[Circular]";
                                var r = [].concat(t, [
                                    e
                                ]), i = function(e) {
                                    var t = e[String(n.Z)];
                                    if ("function" == typeof t) return t;
                                    if ("function" == typeof e.inspect) return e.inspect;
                                }(e);
                                if (void 0 !== i) {
                                    var s = i.call(e);
                                    if (s !== e) return "string" == typeof s ? s : u(s, r);
                                } else if (Array.isArray(e)) return function(e, t) {
                                    if (0 === e.length) return "[]";
                                    if (t.length > a) return "[Array]";
                                    for(var r = Math.min(o, e.length), n = e.length - r, i = [], s = 0; s < r; ++s)i.push(u(e[s], t));
                                    1 === n ? i.push("... 1 more item") : n > 1 && i.push("... ".concat(n, " more items"));
                                    return "[" + i.join(", ") + "]";
                                }(e, r);
                                return function(e, t) {
                                    var r = Object.keys(e);
                                    if (0 === r.length) return "{}";
                                    if (t.length > a) return "[" + function(e) {
                                        var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
                                        if ("Object" === t && "function" == typeof e.constructor) {
                                            var r = e.constructor.name;
                                            if ("string" == typeof r && "" !== r) return r;
                                        }
                                        return t;
                                    }(e) + "]";
                                    var n = r.map(function(r) {
                                        return r + ": " + u(e[r], t);
                                    });
                                    return "{ " + n.join(", ") + " }";
                                }(e, r);
                            }(e, t);
                        default:
                            return String(e);
                    }
                }
            },
            8921: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : void 0;
            },
            3306: (e, t, r)=>{
                "use strict";
                function n(e) {
                    var t = e.split(/\r\n|[\n\r]/g), r = function(e) {
                        for(var t = null, r = 1; r < e.length; r++){
                            var n = e[r], o = i(n);
                            if (o !== n.length && (null === t || o < t) && 0 === (t = o)) break;
                        }
                        return null === t ? 0 : t;
                    }(t);
                    if (0 !== r) for(var n = 1; n < t.length; n++)t[n] = t[n].slice(r);
                    for(; t.length > 0 && o(t[0]);)t.shift();
                    for(; t.length > 0 && o(t[t.length - 1]);)t.pop();
                    return t.join("\n");
                }
                function i(e) {
                    for(var t = 0; t < e.length && (" " === e[t] || "\t" === e[t]);)t++;
                    return t;
                }
                function o(e) {
                    return i(e) === e.length;
                }
                function a(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = -1 === e.indexOf("\n"), i = !n || '"' === e[e.length - 1] || r, o = "";
                    return !i || n && (" " === e[0] || "\t" === e[0]) || (o += "\n" + t), o += t ? e.replace(/\n/g, "\n" + t) : e, i && (o += "\n"), '"""' + o.replace(/"""/g, '\\"""') + '"""';
                }
                r.d(t, {
                    LZ: ()=>a,
                    W7: ()=>n
                });
            },
            7525: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    $_: ()=>o,
                    Vn: ()=>a
                });
                var n = r(4636), i = {
                    Name: [],
                    Document: [
                        "definitions"
                    ],
                    OperationDefinition: [
                        "name",
                        "variableDefinitions",
                        "directives",
                        "selectionSet"
                    ],
                    VariableDefinition: [
                        "variable",
                        "type",
                        "defaultValue",
                        "directives"
                    ],
                    Variable: [
                        "name"
                    ],
                    SelectionSet: [
                        "selections"
                    ],
                    Field: [
                        "alias",
                        "name",
                        "arguments",
                        "directives",
                        "selectionSet"
                    ],
                    Argument: [
                        "name",
                        "value"
                    ],
                    FragmentSpread: [
                        "name",
                        "directives"
                    ],
                    InlineFragment: [
                        "typeCondition",
                        "directives",
                        "selectionSet"
                    ],
                    FragmentDefinition: [
                        "name",
                        "variableDefinitions",
                        "typeCondition",
                        "directives",
                        "selectionSet"
                    ],
                    IntValue: [],
                    FloatValue: [],
                    StringValue: [],
                    BooleanValue: [],
                    NullValue: [],
                    EnumValue: [],
                    ListValue: [
                        "values"
                    ],
                    ObjectValue: [
                        "fields"
                    ],
                    ObjectField: [
                        "name",
                        "value"
                    ],
                    Directive: [
                        "name",
                        "arguments"
                    ],
                    NamedType: [
                        "name"
                    ],
                    ListType: [
                        "type"
                    ],
                    NonNullType: [
                        "type"
                    ],
                    SchemaDefinition: [
                        "directives",
                        "operationTypes"
                    ],
                    OperationTypeDefinition: [
                        "type"
                    ],
                    ScalarTypeDefinition: [
                        "description",
                        "name",
                        "directives"
                    ],
                    ObjectTypeDefinition: [
                        "description",
                        "name",
                        "interfaces",
                        "directives",
                        "fields"
                    ],
                    FieldDefinition: [
                        "description",
                        "name",
                        "arguments",
                        "type",
                        "directives"
                    ],
                    InputValueDefinition: [
                        "description",
                        "name",
                        "type",
                        "defaultValue",
                        "directives"
                    ],
                    InterfaceTypeDefinition: [
                        "description",
                        "name",
                        "directives",
                        "fields"
                    ],
                    UnionTypeDefinition: [
                        "description",
                        "name",
                        "directives",
                        "types"
                    ],
                    EnumTypeDefinition: [
                        "description",
                        "name",
                        "directives",
                        "values"
                    ],
                    EnumValueDefinition: [
                        "description",
                        "name",
                        "directives"
                    ],
                    InputObjectTypeDefinition: [
                        "description",
                        "name",
                        "directives",
                        "fields"
                    ],
                    DirectiveDefinition: [
                        "description",
                        "name",
                        "arguments",
                        "locations"
                    ],
                    SchemaExtension: [
                        "directives",
                        "operationTypes"
                    ],
                    ScalarTypeExtension: [
                        "name",
                        "directives"
                    ],
                    ObjectTypeExtension: [
                        "name",
                        "interfaces",
                        "directives",
                        "fields"
                    ],
                    InterfaceTypeExtension: [
                        "name",
                        "directives",
                        "fields"
                    ],
                    UnionTypeExtension: [
                        "name",
                        "directives",
                        "types"
                    ],
                    EnumTypeExtension: [
                        "name",
                        "directives",
                        "values"
                    ],
                    InputObjectTypeExtension: [
                        "name",
                        "directives",
                        "fields"
                    ]
                }, o = Object.freeze({});
                function a(e, t) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i, a = void 0, c = Array.isArray(e), l = [
                        e
                    ], f = -1, p = [], d = void 0, h = void 0, v = void 0, m = [], y = [], g = e;
                    do {
                        var E = ++f === l.length, b = E && 0 !== p.length;
                        if (E) {
                            if (h = 0 === y.length ? void 0 : m[m.length - 1], d = v, v = y.pop(), b) {
                                if (c) d = d.slice();
                                else {
                                    for(var S = {}, _ = 0, O = Object.keys(d); _ < O.length; _++){
                                        var w = O[_];
                                        S[w] = d[w];
                                    }
                                    d = S;
                                }
                                for(var T = 0, I = 0; I < p.length; I++){
                                    var R = p[I][0], x = p[I][1];
                                    c && (R -= T), c && null === x ? (d.splice(R, 1), T++) : d[R] = x;
                                }
                            }
                            f = a.index, l = a.keys, p = a.edits, c = a.inArray, a = a.prev;
                        } else {
                            if (h = v ? c ? f : l[f] : void 0, null == (d = v ? v[h] : g)) continue;
                            v && m.push(h);
                        }
                        var A = void 0;
                        if (!Array.isArray(d)) {
                            if (!s(d)) throw new Error("Invalid AST Node: " + (0, n.Z)(d));
                            var N = u(t, d.kind, E);
                            if (N) {
                                if ((A = N.call(t, d, h, v, m, y)) === o) break;
                                if (!1 === A) {
                                    if (!E) {
                                        m.pop();
                                        continue;
                                    }
                                } else if (void 0 !== A && (p.push([
                                    h,
                                    A
                                ]), !E)) {
                                    if (!s(A)) {
                                        m.pop();
                                        continue;
                                    }
                                    d = A;
                                }
                            }
                        }
                        void 0 === A && b && p.push([
                            h,
                            d
                        ]), E ? m.pop() : (a = {
                            inArray: c,
                            index: f,
                            keys: l,
                            edits: p,
                            prev: a
                        }, l = (c = Array.isArray(d)) ? d : r[d.kind] || [], f = -1, p = [], v && y.push(v), v = d);
                    }while (void 0 !== a);
                    return 0 !== p.length && (g = p[p.length - 1][1]), g;
                }
                function s(e) {
                    return Boolean(e && "string" == typeof e.kind);
                }
                function u(e, t, r) {
                    var n = e[t];
                    if (n) {
                        if (!r && "function" == typeof n) return n;
                        var i = r ? n.leave : n.enter;
                        if ("function" == typeof i) return i;
                    } else {
                        var o = r ? e.leave : e.enter;
                        if (o) {
                            if ("function" == typeof o) return o;
                            var a = o[t];
                            if ("function" == typeof a) return a;
                        }
                    }
                }
            }
        }, t = {};
        function r(n) {
            var i = t[n];
            if (void 0 !== i) return i.exports;
            var o = t[n] = {
                id: n,
                loaded: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
        }
        return r.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(t, {
                a: t
            }), t;
        }, r.d = (e, t)=>{
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.hmd = (e)=>((e = Object.create(e)).children || (e.children = []), Object.defineProperty(e, "exports", {
                enumerable: !0,
                set: ()=>{
                    throw new Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + e.id);
                }
            }), e), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.nmd = (e)=>(e.paths = [], e.children || (e.children = []), e), r(8901);
    })()); //# sourceMappingURL=maps/api.js.map

});

parcelRegister("4zVoD", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $3556f40848c63521$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $3556f40848c63521$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $3556f40848c63521$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $3556f40848c63521$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $3556f40848c63521$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $3556f40848c63521$export$b0244d5063c0b61b; });

var $hv7EP = parcelRequire("hv7EP");

var $dPLPm = parcelRequire("dPLPm");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");

var $kWdMm = parcelRequire("kWdMm");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $3556f40848c63521$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $3556f40848c63521$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $3556f40848c63521$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $3556f40848c63521$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $3556f40848c63521$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3556f40848c63521$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $3556f40848c63521$export$62ff257738bf57f5(value) {
    if ((0, $9ISAs.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$3556f40848c63521$var$getOwnProperties(value)
    };
    else if ((0, $9ISAs.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $3556f40848c63521$var$serializeEventTarget(value.target),
            currentTarget: $3556f40848c63521$var$serializeEventTarget(value.currentTarget),
            ...$3556f40848c63521$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $9ISAs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $3556f40848c63521$var$serializeEventTarget(target) {
    try {
        return (0, $9ISAs.isElement)(target) ? (0, $dPLPm.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $3556f40848c63521$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $3556f40848c63521$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($3556f40848c63521$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $kWdMm.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $kWdMm.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $3556f40848c63521$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $3556f40848c63521$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $3556f40848c63521$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($3556f40848c63521$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($3556f40848c63521$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $3556f40848c63521$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $3556f40848c63521$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $3556f40848c63521$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9ISAs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("hv7EP", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $cbdb458af46ab2df$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $cbdb458af46ab2df$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("dPLPm", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $a125234a7f829168$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $a125234a7f829168$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $a125234a7f829168$export$26727cfcc4d7e0fc; });

var $9ISAs = parcelRequire("9ISAs");

var $bZENS = parcelRequire("bZENS");
const $a125234a7f829168$var$WINDOW = (0, $bZENS.GLOBAL_OBJ);
const $a125234a7f829168$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a125234a7f829168$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $a125234a7f829168$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a125234a7f829168$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a125234a7f829168$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($a125234a7f829168$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9ISAs.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $a125234a7f829168$export$1cfafeee2987818b() {
    try {
        return $a125234a7f829168$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $a125234a7f829168$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$a125234a7f829168$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("9ISAs", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $714290faee0377ff$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $714290faee0377ff$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $714290faee0377ff$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $714290faee0377ff$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $714290faee0377ff$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $714290faee0377ff$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $714290faee0377ff$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $714290faee0377ff$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $714290faee0377ff$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $714290faee0377ff$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $714290faee0377ff$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $714290faee0377ff$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $714290faee0377ff$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $714290faee0377ff$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $714290faee0377ff$export$7916fad0ebc23f48; });
$parcel$export(module.exports, "isRequest", function () { return $714290faee0377ff$export$6d3d1f317d7cda57; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $714290faee0377ff$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$e6127cc7fe7395c3(wat) {
    switch($714290faee0377ff$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $714290faee0377ff$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$var$isBuiltin(wat, className) {
    return $714290faee0377ff$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$9f9636d330b71954(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$ef9e2056653f0c8e(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$12e869b2a583f783(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$844ec244b1367d54(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$c3825b437cbdea5c(wat) {
    return wat === null || $714290faee0377ff$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$53b83ca8eaab0383(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $714290faee0377ff$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $714290faee0377ff$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$49841c62b9eff15(wat) {
    return $714290faee0377ff$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $714290faee0377ff$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$bc2894c7158efbac(wat) {
    return $714290faee0377ff$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $714290faee0377ff$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $714290faee0377ff$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $714290faee0377ff$export$49034edbe6b62415(request, Request);
}

});

parcelRegister("bZENS", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $8bb50aeefa1651fc$export$f1a6cdb1459e81d1; });
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $8bb50aeefa1651fc$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("w8bd7", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $0609559d4cdceb9f$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $0609559d4cdceb9f$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $0609559d4cdceb9f$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "debug", function () { return $0609559d4cdceb9f$export$1c9f709888824e05; });

var $2vdTp = parcelRequire("2vdTp");

var $hv7EP = parcelRequire("hv7EP");

var $bZENS = parcelRequire("bZENS");
const $0609559d4cdceb9f$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $0609559d4cdceb9f$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $0609559d4cdceb9f$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $0609559d4cdceb9f$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $bZENS.GLOBAL_OBJ))) return callback();
    const console = (0, $bZENS.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($0609559d4cdceb9f$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $0609559d4cdceb9f$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $0609559d4cdceb9f$var$enable() {
    $0609559d4cdceb9f$var$_getLoggerSettings().enabled = true;
}
function $0609559d4cdceb9f$var$disable() {
    $0609559d4cdceb9f$var$_getLoggerSettings().enabled = false;
}
function $0609559d4cdceb9f$var$isEnabled() {
    return $0609559d4cdceb9f$var$_getLoggerSettings().enabled;
}
function $0609559d4cdceb9f$var$log(...args) {
    $0609559d4cdceb9f$var$_maybeLog('log', ...args);
}
function $0609559d4cdceb9f$var$warn(...args) {
    $0609559d4cdceb9f$var$_maybeLog('warn', ...args);
}
function $0609559d4cdceb9f$var$error(...args) {
    $0609559d4cdceb9f$var$_maybeLog('error', ...args);
}
function $0609559d4cdceb9f$var$_maybeLog(level, ...args) {
    if (!(0, $hv7EP.DEBUG_BUILD)) return;
    if ($0609559d4cdceb9f$var$isEnabled()) $0609559d4cdceb9f$export$cda52e2a8927a2ca(()=>{
        (0, $bZENS.GLOBAL_OBJ).console[level](`${$0609559d4cdceb9f$var$PREFIX}[${level}]:`, ...args);
    });
}
function $0609559d4cdceb9f$var$_getLoggerSettings() {
    if (!(0, $hv7EP.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, $2vdTp.getGlobalSingleton)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $0609559d4cdceb9f$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $0609559d4cdceb9f$var$enable,
    disable: /** Disable logging. */ $0609559d4cdceb9f$var$disable,
    isEnabled: /** Check if logging is enabled. */ $0609559d4cdceb9f$var$isEnabled,
    log: /** Log a message. */ $0609559d4cdceb9f$var$log,
    warn: /** Log a warning. */ $0609559d4cdceb9f$var$warn,
    error: /** Log an error. */ $0609559d4cdceb9f$var$error
};

});
parcelRegister("2vdTp", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $1d2940d79e14f202$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $1d2940d79e14f202$export$c8bfa33e4e8ae492; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $1d2940d79e14f202$export$7e223ec222791509; });

var $iOjzR = parcelRequire("iOjzR");

var $bZENS = parcelRequire("bZENS");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $1d2940d79e14f202$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $1d2940d79e14f202$export$c8bfa33e4e8ae492((0, $bZENS.GLOBAL_OBJ));
    return 0, $bZENS.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $1d2940d79e14f202$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $iOjzR.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $iOjzR.SDK_VERSION] = __SENTRY__[0, $iOjzR.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $1d2940d79e14f202$export$7e223ec222791509(name, creator, obj = (0, $bZENS.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $iOjzR.SDK_VERSION] = __SENTRY__[0, $iOjzR.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("iOjzR", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $db1c152eaa57e264$export$31499a9cd224b78c; });
// This is a magic string replaced by rollup
const $db1c152eaa57e264$export$31499a9cd224b78c = "10.22.0";

});



parcelRegister("kWdMm", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $f3e3e9a546966dcd$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $f3e3e9a546966dcd$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $f3e3e9a546966dcd$export$465e9d514283d4fd; });
$parcel$export(module.exports, "isMatchingPattern", function () { return $f3e3e9a546966dcd$export$cdded5b28a5f8c6d; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $f3e3e9a546966dcd$export$a7a5ec66062ea5d; });

var $9ISAs = parcelRequire("9ISAs");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $f3e3e9a546966dcd$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $f3e3e9a546966dcd$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $f3e3e9a546966dcd$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9ISAs.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $f3e3e9a546966dcd$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9ISAs.isString)(value)) return false;
    if ((0, $9ISAs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $9ISAs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $f3e3e9a546966dcd$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$f3e3e9a546966dcd$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});


parcelRegister("7Y1KN", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $5ccf7f459efe79d7$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $5ccf7f459efe79d7$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $5ccf7f459efe79d7$export$baf075a948ffc0bf; });

var $bZENS = parcelRequire("bZENS");
const $5ccf7f459efe79d7$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $5ccf7f459efe79d7$export$7740643b9eeaf0c4() {
    return Date.now() / $5ccf7f459efe79d7$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $5ccf7f459efe79d7$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $bZENS.GLOBAL_OBJ);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $5ccf7f459efe79d7$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $5ccf7f459efe79d7$var$ONE_SECOND_IN_MS;
    };
}
let $5ccf7f459efe79d7$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $5ccf7f459efe79d7$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $5ccf7f459efe79d7$var$_cachedTimestampInSeconds ?? ($5ccf7f459efe79d7$var$_cachedTimestampInSeconds = $5ccf7f459efe79d7$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $5ccf7f459efe79d7$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $5ccf7f459efe79d7$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $bZENS.GLOBAL_OBJ);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $5ccf7f459efe79d7$export$baf075a948ffc0bf() {
    if (!$5ccf7f459efe79d7$var$cachedTimeOrigin) $5ccf7f459efe79d7$var$cachedTimeOrigin = $5ccf7f459efe79d7$var$getBrowserTimeOrigin();
    return $5ccf7f459efe79d7$var$cachedTimeOrigin[0];
}

});

parcelRegister("arYTK", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", function () { return $79bbaa211fcfeb5f$export$dc6d7ea554bcce10; });
$parcel$export(module.exports, "generateSpanId", function () { return $79bbaa211fcfeb5f$export$295213bc4d0c54ad; });

var $h9p4m = parcelRequire("h9p4m");
/**
 * Generate a random, valid trace ID.
 */ function $79bbaa211fcfeb5f$export$dc6d7ea554bcce10() {
    return (0, $h9p4m.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $79bbaa211fcfeb5f$export$295213bc4d0c54ad() {
    return (0, $h9p4m.uuid4)().substring(16);
}

});
parcelRegister("h9p4m", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $c7c6b931de73f37c$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $c7c6b931de73f37c$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $c7c6b931de73f37c$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $c7c6b931de73f37c$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $c7c6b931de73f37c$export$6de4ffac6a2f1098; });

var $4zVoD = parcelRequire("4zVoD");

var $kWdMm = parcelRequire("kWdMm");

var $bZENS = parcelRequire("bZENS");
function $c7c6b931de73f37c$var$getCrypto() {
    const gbl = (0, $bZENS.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
let $c7c6b931de73f37c$var$emptyUuid;
function $c7c6b931de73f37c$var$getRandomByte() {
    return Math.random() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $c7c6b931de73f37c$export$19f53698e68b2496(crypto = $c7c6b931de73f37c$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$c7c6b931de73f37c$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $c7c6b931de73f37c$var$emptyUuid = "10000000100040008000100000000000";
    return $c7c6b931de73f37c$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($c7c6b931de73f37c$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $c7c6b931de73f37c$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $c7c6b931de73f37c$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $c7c6b931de73f37c$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $c7c6b931de73f37c$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $c7c6b931de73f37c$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $c7c6b931de73f37c$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $c7c6b931de73f37c$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $c7c6b931de73f37c$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $c7c6b931de73f37c$export$d364f2020ab30578(input) {
    const match = input.match($c7c6b931de73f37c$var$SEMVER_REGEXP) || [];
    const major = $c7c6b931de73f37c$var$_parseInt(match[1]);
    const minor = $c7c6b931de73f37c$var$_parseInt(match[2]);
    const patch = $c7c6b931de73f37c$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $c7c6b931de73f37c$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $kWdMm.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $kWdMm.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $kWdMm.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $c7c6b931de73f37c$export$6de4ffac6a2f1098(exception) {
    if ($c7c6b931de73f37c$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $4zVoD.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $c7c6b931de73f37c$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});


parcelRegister("dHEV3", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", function () { return $9f9f083568f3177b$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $9f9f083568f3177b$export$68f3af03034c9e90; });
$parcel$export(module.exports, "getGlobalScope", function () { return $9f9f083568f3177b$export$aa55d5ab8e05984f; });
$parcel$export(module.exports, "withScope", function () { return $9f9f083568f3177b$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $9f9f083568f3177b$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "getClient", function () { return $9f9f083568f3177b$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "getTraceContextFromScope", function () { return $9f9f083568f3177b$export$1e83db7ee4876dc4; });

var $dO8ql = parcelRequire("dO8ql");

var $2vdTp = parcelRequire("2vdTp");

var $kyg1b = parcelRequire("kyg1b");

var $arYTK = parcelRequire("arYTK");
/**
 * Get the currently active scope.
 */ function $9f9f083568f3177b$export$c7be4b0125a10cba() {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $dO8ql.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $9f9f083568f3177b$export$68f3af03034c9e90() {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $dO8ql.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $9f9f083568f3177b$export$aa55d5ab8e05984f() {
    return (0, $2vdTp.getGlobalSingleton)('globalScope', ()=>new (0, $kyg1b.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $9f9f083568f3177b$export$ec58d9285c204497(...rest) {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $dO8ql.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $9f9f083568f3177b$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $dO8ql.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $9f9f083568f3177b$export$6bb76d6eba7e258c() {
    return $9f9f083568f3177b$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $9f9f083568f3177b$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $arYTK.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("dO8ql", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $a0d67ab23fb41d37$export$f639b0c2752203be; });

var $2vdTp = parcelRequire("2vdTp");

var $2dlhf = parcelRequire("2dlhf");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $a0d67ab23fb41d37$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $2vdTp.getMainCarrier)();
    const sentry = (0, $2vdTp.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $a0d67ab23fb41d37$export$f639b0c2752203be(carrier) {
    const sentry = (0, $2vdTp.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $2dlhf.getStackAsyncContextStrategy)();
}

});
parcelRegister("2dlhf", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $19cd4ce48fbfcace$export$329d4d4d54e42710; });

var $7BCE0 = parcelRequire("7BCE0");

var $kyg1b = parcelRequire("kyg1b");

var $9ISAs = parcelRequire("9ISAs");

var $2vdTp = parcelRequire("2vdTp");
/**
 * This is an object that holds a stack of scopes.
 */ class $19cd4ce48fbfcace$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $kyg1b.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $kyg1b.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9ISAs.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $19cd4ce48fbfcace$var$getAsyncContextStack() {
    const registry = (0, $2vdTp.getMainCarrier)();
    const sentry = (0, $2vdTp.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $19cd4ce48fbfcace$export$d36ec451f120cfba((0, $7BCE0.getDefaultCurrentScope)(), (0, $7BCE0.getDefaultIsolationScope)());
}
function $19cd4ce48fbfcace$var$withScope(callback) {
    return $19cd4ce48fbfcace$var$getAsyncContextStack().withScope(callback);
}
function $19cd4ce48fbfcace$var$withSetScope(scope, callback) {
    const stack = $19cd4ce48fbfcace$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $19cd4ce48fbfcace$var$withIsolationScope(callback) {
    return $19cd4ce48fbfcace$var$getAsyncContextStack().withScope(()=>{
        return callback($19cd4ce48fbfcace$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $19cd4ce48fbfcace$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $19cd4ce48fbfcace$var$withIsolationScope,
        withScope: $19cd4ce48fbfcace$var$withScope,
        withSetScope: $19cd4ce48fbfcace$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $19cd4ce48fbfcace$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$19cd4ce48fbfcace$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$19cd4ce48fbfcace$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("7BCE0", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $5899f70749d8aa02$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $5899f70749d8aa02$export$de9862929b76bf57; });

var $2vdTp = parcelRequire("2vdTp");

var $kyg1b = parcelRequire("kyg1b");
/** Get the default current scope. */ function $5899f70749d8aa02$export$6f1b9191db9c4d5() {
    return (0, $2vdTp.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $kyg1b.Scope)());
}
/** Get the default isolation scope. */ function $5899f70749d8aa02$export$de9862929b76bf57() {
    return (0, $2vdTp.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $kyg1b.Scope)());
}

});
parcelRegister("kyg1b", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $ef63688041cb6965$export$775b6bb06e53a214; });

var $hv7EP = parcelRequire("hv7EP");

var $WJI3S = parcelRequire("WJI3S");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");

var $8TzsF = parcelRequire("8TzsF");

var $h9p4m = parcelRequire("h9p4m");

var $arYTK = parcelRequire("arYTK");

var $4L3PL = parcelRequire("4L3PL");

var $kWdMm = parcelRequire("kWdMm");

var $7Y1KN = parcelRequire("7Y1KN");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $ef63688041cb6965$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $ef63688041cb6965$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $arYTK.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $ef63688041cb6965$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $4L3PL._setSpanForScope)(newScope, (0, $4L3PL._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $WJI3S.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $ef63688041cb6965$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $9ISAs.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $4L3PL._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $arYTK.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $ef63688041cb6965$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $7Y1KN.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $kWdMm.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $4L3PL._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $8TzsF.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $h9p4m.uuid4)();
        if (!this._client) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $h9p4m.uuid4)();
        if (!this._client) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $h9p4m.uuid4)();
        if (!this._client) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("WJI3S", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $0b08dfe1f7a400f1$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $0b08dfe1f7a400f1$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $0b08dfe1f7a400f1$export$56521d9ba90f62ee; });

var $h9p4m = parcelRequire("h9p4m");

var $7Y1KN = parcelRequire("7Y1KN");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $0b08dfe1f7a400f1$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $7Y1KN.timestampInSeconds)();
    const session = {
        sid: (0, $h9p4m.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$0b08dfe1f7a400f1$var$sessionToJSON(session)
    };
    if (context) $0b08dfe1f7a400f1$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $0b08dfe1f7a400f1$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $7Y1KN.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $h9p4m.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $0b08dfe1f7a400f1$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $0b08dfe1f7a400f1$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $0b08dfe1f7a400f1$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});

parcelRegister("8TzsF", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $679ef7acd798ab4f$export$4950aa0f605343fb; });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $679ef7acd798ab4f$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $679ef7acd798ab4f$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("4L3PL", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", function () { return $376e868a0a8b0a7f$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $376e868a0a8b0a7f$export$91f063ebb8eff307; });

var $4zVoD = parcelRequire("4zVoD");
const $376e868a0a8b0a7f$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $376e868a0a8b0a7f$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $4zVoD.addNonEnumerableProperty)(scope, $376e868a0a8b0a7f$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$376e868a0a8b0a7f$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $376e868a0a8b0a7f$export$91f063ebb8eff307(scope) {
    return scope[$376e868a0a8b0a7f$var$SCOPE_SPAN_FIELD];
}

});






parcelRegister("7oIfw", function(module, exports) {

$parcel$export(module.exports, "freezeDscOnSpan", function () { return $562d1947906178e8$export$7398c93e763ca9fd; });
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", function () { return $562d1947906178e8$export$89ef1736f08c6b2b; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $562d1947906178e8$export$a117f995597e25df; });

var $dvLpL = parcelRequire("dvLpL");

var $dHEV3 = parcelRequire("dHEV3");

var $gKbJW = parcelRequire("gKbJW");

var $7Fxjp = parcelRequire("7Fxjp");

var $5vQzr = parcelRequire("5vQzr");

var $B8qZj = parcelRequire("B8qZj");

var $4zVoD = parcelRequire("4zVoD");

var $iaBjX = parcelRequire("iaBjX");

var $98MSm = parcelRequire("98MSm");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $562d1947906178e8$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $562d1947906178e8$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $4zVoD.addNonEnumerableProperty)(spanWithMaybeDsc, $562d1947906178e8$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $562d1947906178e8$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $dvLpL.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $5vQzr.extractOrgIdFromClient)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $562d1947906178e8$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $562d1947906178e8$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $562d1947906178e8$export$a117f995597e25df(span) {
    const client = (0, $dHEV3.getClient)();
    if (!client) return {};
    const rootSpan = (0, $iaBjX.getRootSpan)(span);
    const rootSpanJson = (0, $iaBjX.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$562d1947906178e8$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $7Fxjp.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $562d1947906178e8$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $B8qZj.hasSpansEnabled)()) {
        dsc.sampled = String((0, $iaBjX.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $98MSm.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $562d1947906178e8$export$95cf936fdacaff7b(span) {
    const dsc = $562d1947906178e8$export$a117f995597e25df(span);
    return (0, $7Fxjp.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("dvLpL", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $9d62f32dd646eccc$export$849dbeeeda01ae98; });
const $9d62f32dd646eccc$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("gKbJW", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $c30a0c8ed977cb48$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $c30a0c8ed977cb48$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function () { return $c30a0c8ed977cb48$export$889fb736668e1ecc; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $c30a0c8ed977cb48$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $c30a0c8ed977cb48$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function () { return $c30a0c8ed977cb48$export$ba73f34502b7a3b3; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function () { return $c30a0c8ed977cb48$export$f5f95cff026507b5; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function () { return $c30a0c8ed977cb48$export$69cd5c610c7bb96a; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function () { return $c30a0c8ed977cb48$export$165ce9a229f6f050; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $c30a0c8ed977cb48$export$1efec95406bbe327; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function () { return $c30a0c8ed977cb48$export$fea48ba9f4550879; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function () { return $c30a0c8ed977cb48$export$be7a251980e7e946; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function () { return $c30a0c8ed977cb48$export$25dfd73e0e32c6e1; });
$parcel$export(module.exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", function () { return $c30a0c8ed977cb48$export$ff77b5fd5b2d627b; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $c30a0c8ed977cb48$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $c30a0c8ed977cb48$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $c30a0c8ed977cb48$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $c30a0c8ed977cb48$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $c30a0c8ed977cb48$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $c30a0c8ed977cb48$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $c30a0c8ed977cb48$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $c30a0c8ed977cb48$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $c30a0c8ed977cb48$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $c30a0c8ed977cb48$export$1efec95406bbe327 = 'sentry.profile_id';
const $c30a0c8ed977cb48$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $c30a0c8ed977cb48$export$b016f89ac1066ec = 'cache.hit';
const $c30a0c8ed977cb48$export$3110e4c3f4386399 = 'cache.key';
const $c30a0c8ed977cb48$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $c30a0c8ed977cb48$export$be7a251980e7e946 = 'http.request.method';
const $c30a0c8ed977cb48$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $c30a0c8ed977cb48$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("7Fxjp", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BAGGAGE_KEY_PREFIX", function () { return $595633d6b82db2c0$export$6e69537d67fa20f; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $595633d6b82db2c0$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $595633d6b82db2c0$export$56766feef403f365; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");
const $595633d6b82db2c0$export$6e69537d67fa20f = 'sentry-';
const $595633d6b82db2c0$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $595633d6b82db2c0$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $595633d6b82db2c0$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $595633d6b82db2c0$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($595633d6b82db2c0$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($595633d6b82db2c0$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $595633d6b82db2c0$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$595633d6b82db2c0$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $595633d6b82db2c0$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $595633d6b82db2c0$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9ISAs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $595633d6b82db2c0$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $595633d6b82db2c0$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $595633d6b82db2c0$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $595633d6b82db2c0$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $595633d6b82db2c0$export$bdd844ddb2def819) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});

parcelRegister("5vQzr", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $4038a06ed5b23254$export$44d472fbb931a776; });
$parcel$export(module.exports, "extractOrgIdFromClient", function () { return $4038a06ed5b23254$export$b7ac9b8efa4bb595; });
$parcel$export(module.exports, "makeDsn", function () { return $4038a06ed5b23254$export$128827c3562ec0cb; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");
/** Regular expression used to extract org ID from a DSN host. */ const $4038a06ed5b23254$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $4038a06ed5b23254$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $4038a06ed5b23254$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $4038a06ed5b23254$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $4038a06ed5b23254$export$b892860177f70a30(str) {
    const match = $4038a06ed5b23254$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $w8bd7.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $4038a06ed5b23254$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $4038a06ed5b23254$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $4038a06ed5b23254$var$validateDsn(dsn) {
    if (!(0, $hv7EP.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $w8bd7.debug).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $w8bd7.debug).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$4038a06ed5b23254$var$isValidProtocol(protocol)) {
        (0, $w8bd7.debug).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $w8bd7.debug).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $4038a06ed5b23254$export$5914f4e7748c29c9(host) {
    const match = host.match($4038a06ed5b23254$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $4038a06ed5b23254$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $4038a06ed5b23254$export$5914f4e7748c29c9(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $4038a06ed5b23254$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $4038a06ed5b23254$export$b892860177f70a30(from) : $4038a06ed5b23254$var$dsnFromComponents(from);
    if (!components || !$4038a06ed5b23254$var$validateDsn(components)) return undefined;
    return components;
}

});

parcelRegister("B8qZj", function(module, exports) {

$parcel$export(module.exports, "hasSpansEnabled", function () { return $06f9ffb0ac5b9d0a$export$1f70765132c3c225; });

var $dHEV3 = parcelRequire("dHEV3");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $06f9ffb0ac5b9d0a$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $dHEV3.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}

});

parcelRegister("iaBjX", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $d3a61c536a2d1d8c$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $d3a61c536a2d1d8c$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTransactionTraceContext", function () { return $d3a61c536a2d1d8c$export$4c3967a8a2f6bbd6; });
$parcel$export(module.exports, "spanToJSON", function () { return $d3a61c536a2d1d8c$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $d3a61c536a2d1d8c$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $d3a61c536a2d1d8c$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $d3a61c536a2d1d8c$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "spanToTraceparentHeader", function () { return $d3a61c536a2d1d8c$export$cda58d87bc594e9f; });
$parcel$export(module.exports, "convertSpanLinksForEnvelope", function () { return $d3a61c536a2d1d8c$export$cb3e3a12e0eec16c; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $d3a61c536a2d1d8c$export$3f7581298f56c6d7; });
$parcel$export(module.exports, "getStatusMessage", function () { return $d3a61c536a2d1d8c$export$e238a77ea3a8cd66; });
$parcel$export(module.exports, "addChildSpanToSpan", function () { return $d3a61c536a2d1d8c$export$81397d924722cc65; });
$parcel$export(module.exports, "removeChildSpanFromSpan", function () { return $d3a61c536a2d1d8c$export$c2a0c9438bb89d91; });
$parcel$export(module.exports, "getSpanDescendants", function () { return $d3a61c536a2d1d8c$export$340c5c8a13ffc680; });
$parcel$export(module.exports, "getRootSpan", function () { return $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $d3a61c536a2d1d8c$export$1be426a8e585c83e; });
$parcel$export(module.exports, "showSpanDropWarning", function () { return $d3a61c536a2d1d8c$export$d11691ff45a3e535; });

var $dO8ql = parcelRequire("dO8ql");

var $2vdTp = parcelRequire("2vdTp");

var $dHEV3 = parcelRequire("dHEV3");

var $gKbJW = parcelRequire("gKbJW");

var $cDZNc = parcelRequire("cDZNc");

var $98MSm = parcelRequire("98MSm");

var $4zVoD = parcelRequire("4zVoD");

var $arYTK = parcelRequire("arYTK");

var $7Y1KN = parcelRequire("7Y1KN");

var $jeERW = parcelRequire("jeERW");

var $w8bd7 = parcelRequire("w8bd7");

var $4L3PL = parcelRequire("4L3PL");
// These are aligned with OpenTelemetry trace flags
const $d3a61c536a2d1d8c$export$208d5b368507fb8b = 0x0;
const $d3a61c536a2d1d8c$export$eb571cd9b5d98de8 = 0x1;
let $d3a61c536a2d1d8c$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $d3a61c536a2d1d8c$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $d3a61c536a2d1d8c$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $d3a61c536a2d1d8c$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $d3a61c536a2d1d8c$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $98MSm.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $arYTK.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $d3a61c536a2d1d8c$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d3a61c536a2d1d8c$export$5caecac1caaf3a71(span);
    return (0, $jeERW.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $d3a61c536a2d1d8c$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d3a61c536a2d1d8c$export$5caecac1caaf3a71(span);
    return (0, $jeERW.generateTraceparentHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $d3a61c536a2d1d8c$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $d3a61c536a2d1d8c$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $d3a61c536a2d1d8c$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $d3a61c536a2d1d8c$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $d3a61c536a2d1d8c$var$ensureTimestampInSeconds(input.getTime());
    return (0, $7Y1KN.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $d3a61c536a2d1d8c$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $d3a61c536a2d1d8c$export$92d8c23565496537(span) {
    if ($d3a61c536a2d1d8c$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($d3a61c536a2d1d8c$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $d3a61c536a2d1d8c$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $d3a61c536a2d1d8c$export$3f7581298f56c6d7(endTime) || undefined,
            status: $d3a61c536a2d1d8c$export$e238a77ea3a8cd66(status),
            op: attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $d3a61c536a2d1d8c$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $d3a61c536a2d1d8c$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $d3a61c536a2d1d8c$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $d3a61c536a2d1d8c$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $d3a61c536a2d1d8c$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $d3a61c536a2d1d8c$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $cDZNc.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $cDZNc.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $d3a61c536a2d1d8c$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $d3a61c536a2d1d8c$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$d3a61c536a2d1d8c$var$ROOT_SPAN_FIELD] || span;
    (0, $4zVoD.addNonEnumerableProperty)(childSpan, $d3a61c536a2d1d8c$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD]) span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $4zVoD.addNonEnumerableProperty)(span, $d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $d3a61c536a2d1d8c$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD]) span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $d3a61c536a2d1d8c$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($d3a61c536a2d1d8c$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD] ? Array.from(span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b(span) {
    return span[$d3a61c536a2d1d8c$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $d3a61c536a2d1d8c$export$1be426a8e585c83e() {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $dO8ql.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $4L3PL._getSpanForScope)((0, $dHEV3.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $d3a61c536a2d1d8c$export$d11691ff45a3e535() {
    if (!$d3a61c536a2d1d8c$var$hasShownSpanDropWarning) {
        (0, $w8bd7.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        $d3a61c536a2d1d8c$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $d3a61c536a2d1d8c$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("cDZNc", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $93490f49a9d2f84d$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $93490f49a9d2f84d$export$58f7963109c806fc; });
$parcel$export(module.exports, "SPAN_STATUS_ERROR", function () { return $93490f49a9d2f84d$export$f966a0446ece71e; });
$parcel$export(module.exports, "setHttpStatus", function () { return $93490f49a9d2f84d$export$2ad6630ec8164254; });
const $93490f49a9d2f84d$export$136e25984ba4a383 = 0;
const $93490f49a9d2f84d$export$58f7963109c806fc = 1;
const $93490f49a9d2f84d$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $93490f49a9d2f84d$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $93490f49a9d2f84d$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $93490f49a9d2f84d$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $93490f49a9d2f84d$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $93490f49a9d2f84d$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("98MSm", function(module, exports) {

$parcel$export(module.exports, "setCapturedScopesOnSpan", function () { return $6a7ac6221a05ac94$export$cddb4027e3b0dd66; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $6a7ac6221a05ac94$export$c08fbc656a245d03; });

var $4zVoD = parcelRequire("4zVoD");

var $bZENS = parcelRequire("bZENS");
const $6a7ac6221a05ac94$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $6a7ac6221a05ac94$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Wrap a scope with a WeakRef if available, falling back to a direct scope. */ function $6a7ac6221a05ac94$var$wrapScopeWithWeakRef(scope) {
    try {
        // @ts-expect-error - WeakRef is not available in all environments
        const WeakRefClass = (0, $bZENS.GLOBAL_OBJ).WeakRef;
        if (typeof WeakRefClass === 'function') return new WeakRefClass(scope);
    } catch  {
    // WeakRef not available or failed to create
    // We'll fall back to a direct scope
    }
    return scope;
}
/** Try to unwrap a scope from a potential WeakRef wrapper. */ function $6a7ac6221a05ac94$var$unwrapScopeFromWeakRef(scopeRef) {
    if (!scopeRef) return undefined;
    if (typeof scopeRef === 'object' && 'deref' in scopeRef && typeof scopeRef.deref === 'function') try {
        return scopeRef.deref();
    } catch  {
        return undefined;
    }
    // Fallback to a direct scope
    return scopeRef;
}
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $6a7ac6221a05ac94$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $4zVoD.addNonEnumerableProperty)(span, $6a7ac6221a05ac94$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $6a7ac6221a05ac94$var$wrapScopeWithWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, $4zVoD.addNonEnumerableProperty)(span, $6a7ac6221a05ac94$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $6a7ac6221a05ac94$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$6a7ac6221a05ac94$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $6a7ac6221a05ac94$var$unwrapScopeFromWeakRef(spanWithScopes[$6a7ac6221a05ac94$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}

});

parcelRegister("jeERW", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", function () { return $e00f06df584cff55$export$394a210812ba3012; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $e00f06df584cff55$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $e00f06df584cff55$export$f35d907436da45cf; });
$parcel$export(module.exports, "generateTraceparentHeader", function () { return $e00f06df584cff55$export$1aff3752542747dd; });
$parcel$export(module.exports, "shouldContinueTrace", function () { return $e00f06df584cff55$export$18811bc99eefceaa; });

var $w8bd7 = parcelRequire("w8bd7");

var $7Fxjp = parcelRequire("7Fxjp");

var $5vQzr = parcelRequire("5vQzr");

var $a5tr3 = parcelRequire("a5tr3");

var $arYTK = parcelRequire("arYTK");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $e00f06df584cff55$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $e00f06df584cff55$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($e00f06df584cff55$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $e00f06df584cff55$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $e00f06df584cff55$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $7Fxjp.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $arYTK.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $e00f06df584cff55$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $e00f06df584cff55$export$f35d907436da45cf(traceId = (0, $arYTK.generateTraceId)(), spanId = (0, $arYTK.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $e00f06df584cff55$export$1aff3752542747dd(traceId = (0, $arYTK.generateTraceId)(), spanId = (0, $arYTK.generateSpanId)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? '01' : '00'}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $e00f06df584cff55$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $a5tr3.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $a5tr3.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $e00f06df584cff55$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $5vQzr.extractOrgIdFromClient)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $w8bd7.debug).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $w8bd7.debug).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}

});
parcelRegister("a5tr3", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", function () { return $75813448dd2615ee$export$a5bd2d81656d9546; });
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $75813448dd2615ee$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});




parcelRegister("f82Ej", function(module, exports) {

$parcel$export(module.exports, "isURLObjectRelative", function () { return $b039a86df453775d$export$e258e13805402ba7; });
$parcel$export(module.exports, "parseStringToURLObject", function () { return $b039a86df453775d$export$2004d912a9ead694; });
$parcel$export(module.exports, "getSanitizedUrlStringFromUrlObject", function () { return $b039a86df453775d$export$5339fcdc8e2a427c; });
$parcel$export(module.exports, "parseUrl", function () { return $b039a86df453775d$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "stripUrlQueryAndFragment", function () { return $b039a86df453775d$export$ce084c78234bd35; });

var $gKbJW = parcelRequire("gKbJW");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $b039a86df453775d$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $b039a86df453775d$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $b039a86df453775d$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $b039a86df453775d$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $b039a86df453775d$export$5339fcdc8e2a427c(url) {
    if ($b039a86df453775d$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $b039a86df453775d$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $b039a86df453775d$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $b039a86df453775d$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request?.method) attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$b039a86df453775d$export$e258e13805402ba7(urlObject)) {
            attributes[0, $gKbJW.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $b039a86df453775d$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $b039a86df453775d$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $b039a86df453775d$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $b039a86df453775d$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("7C8eI", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $58b2788f5c524205$export$55b5c3ba2194f0c6; });

var $bZENS = parcelRequire("bZENS");

var $f5byn = parcelRequire("f5byn");
let $58b2788f5c524205$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $58b2788f5c524205$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $58b2788f5c524205$var$instrumentError);
}
function $58b2788f5c524205$var$instrumentError() {
    $58b2788f5c524205$var$_oldOnErrorHandler = (0, $bZENS.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $bZENS.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f5byn.triggerHandlers)('error', handlerData);
        if ($58b2788f5c524205$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $58b2788f5c524205$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $bZENS.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("f5byn", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $afb048eead44b8aa$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $afb048eead44b8aa$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $afb048eead44b8aa$export$b18c893e424d3127; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $iFp2j = parcelRequire("iFp2j");
// We keep the handlers globally
const $afb048eead44b8aa$var$handlers = {};
const $afb048eead44b8aa$var$instrumented = {};
/** Add a handler function. */ function $afb048eead44b8aa$export$a4e09611e30da72e(type, handler) {
    $afb048eead44b8aa$var$handlers[type] = $afb048eead44b8aa$var$handlers[type] || [];
    $afb048eead44b8aa$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $afb048eead44b8aa$export$b17eab759a1cb5fe() {
    Object.keys($afb048eead44b8aa$var$handlers).forEach((key)=>{
        $afb048eead44b8aa$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $afb048eead44b8aa$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$afb048eead44b8aa$var$instrumented[type]) {
        $afb048eead44b8aa$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $afb048eead44b8aa$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $afb048eead44b8aa$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $iFp2j.getFunctionName)(handler)}\nError:`, e);
    }
}

});
parcelRegister("iFp2j", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", function () { return $d96f7a0a70f757cf$export$27c7e15d453fc0ac; });
$parcel$export(module.exports, "createStackParser", function () { return $d96f7a0a70f757cf$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $d96f7a0a70f757cf$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $d96f7a0a70f757cf$export$aad197c7121a6651; });
$parcel$export(module.exports, "getFramesFromEvent", function () { return $d96f7a0a70f757cf$export$91d8ca51bd9f6a47; });
const $d96f7a0a70f757cf$var$STACKTRACE_FRAME_LIMIT = 50;
const $d96f7a0a70f757cf$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $d96f7a0a70f757cf$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $d96f7a0a70f757cf$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $d96f7a0a70f757cf$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $d96f7a0a70f757cf$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($d96f7a0a70f757cf$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $d96f7a0a70f757cf$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $d96f7a0a70f757cf$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $d96f7a0a70f757cf$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $d96f7a0a70f757cf$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $d96f7a0a70f757cf$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($d96f7a0a70f757cf$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($d96f7a0a70f757cf$var$STRIP_FRAME_REGEXP.test($d96f7a0a70f757cf$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($d96f7a0a70f757cf$var$STRIP_FRAME_REGEXP.test($d96f7a0a70f757cf$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $d96f7a0a70f757cf$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $d96f7a0a70f757cf$var$getLastStackFrame(localStack).filename,
            function: frame.function || $d96f7a0a70f757cf$export$27c7e15d453fc0ac
        }));
}
function $d96f7a0a70f757cf$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $d96f7a0a70f757cf$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $d96f7a0a70f757cf$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $d96f7a0a70f757cf$var$defaultFunctionName;
        return fn.name || $d96f7a0a70f757cf$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $d96f7a0a70f757cf$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $d96f7a0a70f757cf$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}

});



parcelRegister("eUf1i", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $ada1f24933fdbea1$export$8bf4fc6858821a4e; });

var $bZENS = parcelRequire("bZENS");

var $f5byn = parcelRequire("f5byn");
let $ada1f24933fdbea1$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ada1f24933fdbea1$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $ada1f24933fdbea1$var$instrumentUnhandledRejection);
}
function $ada1f24933fdbea1$var$instrumentUnhandledRejection() {
    $ada1f24933fdbea1$var$_oldOnUnhandledRejectionHandler = (0, $bZENS.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $bZENS.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f5byn.triggerHandlers)('unhandledrejection', handlerData);
        if ($ada1f24933fdbea1$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $ada1f24933fdbea1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $bZENS.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("9VTV3", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreSpan", function () { return $73b4d053d3a4847d$export$5d569ac97c389400; });
$parcel$export(module.exports, "reparentChildSpans", function () { return $73b4d053d3a4847d$export$ddf57376e818b444; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $kWdMm = parcelRequire("kWdMm");
function $73b4d053d3a4847d$var$logIgnoredSpan(droppedSpan) {
    (0, $w8bd7.debug).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $73b4d053d3a4847d$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length || !span.description) return false;
    for (const pattern of ignoreSpans){
        if ($73b4d053d3a4847d$var$isStringOrRegExp(pattern)) {
            if ((0, $kWdMm.isMatchingPattern)(span.description, pattern)) {
                (0, $hv7EP.DEBUG_BUILD) && $73b4d053d3a4847d$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        if (!pattern.name && !pattern.op) continue;
        const nameMatches = pattern.name ? (0, $kWdMm.isMatchingPattern)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $kWdMm.isMatchingPattern)(span.op, pattern.op) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
        // not both op and name actually have to match. This is the most efficient way to check
        // for all combinations of name and op patterns.
        if (nameMatches && opMatches) {
            (0, $hv7EP.DEBUG_BUILD) && $73b4d053d3a4847d$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $73b4d053d3a4847d$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $73b4d053d3a4847d$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}

});

parcelRegister("3pr37", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $27b8b052dd77f94f$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $27b8b052dd77f94f$export$c31057337a18010f; });
$parcel$export(module.exports, "createSpanEnvelope", function () { return $27b8b052dd77f94f$export$19a0081d4b39d77; });

var $7oIfw = parcelRequire("7oIfw");

var $5vQzr = parcelRequire("5vQzr");

var $cARsW = parcelRequire("cARsW");

var $9VTV3 = parcelRequire("9VTV3");

var $iaBjX = parcelRequire("iaBjX");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $27b8b052dd77f94f$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $27b8b052dd77f94f$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $cARsW.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $5vQzr.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $cARsW.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $27b8b052dd77f94f$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $cARsW.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $27b8b052dd77f94f$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $cARsW.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $cARsW.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $27b8b052dd77f94f$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $7oIfw.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $5vQzr.dsnToString)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>!(0, $9VTV3.shouldIgnoreSpan)((0, $iaBjX.spanToJSON)(span), ignoreSpans)) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $iaBjX.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $iaBjX.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $iaBjX.spanToJSON);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $cARsW.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $cARsW.createEnvelope)(headers, items);
}

});
parcelRegister("cARsW", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $92b251ff2d014359$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $92b251ff2d014359$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $92b251ff2d014359$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $92b251ff2d014359$export$32f9b428425aac85; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $92b251ff2d014359$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $92b251ff2d014359$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $92b251ff2d014359$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $92b251ff2d014359$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $92b251ff2d014359$export$92b6093782fe661b; });

var $2vdTp = parcelRequire("2vdTp");

var $5vQzr = parcelRequire("5vQzr");

var $7viyI = parcelRequire("7viyI");

var $bZENS = parcelRequire("bZENS");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $92b251ff2d014359$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $92b251ff2d014359$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $92b251ff2d014359$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $92b251ff2d014359$export$604a45d95a155e2b(envelope, types) {
    return $92b251ff2d014359$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $92b251ff2d014359$var$encodeUTF8(input) {
    const carrier = (0, $2vdTp.getSentryCarrier)((0, $bZENS.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $92b251ff2d014359$var$decodeUTF8(input) {
    const carrier = (0, $2vdTp.getSentryCarrier)((0, $bZENS.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $92b251ff2d014359$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $92b251ff2d014359$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $92b251ff2d014359$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $7viyI.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $92b251ff2d014359$var$concatBuffers(parts);
}
function $92b251ff2d014359$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $92b251ff2d014359$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $92b251ff2d014359$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($92b251ff2d014359$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $92b251ff2d014359$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $92b251ff2d014359$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $92b251ff2d014359$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $92b251ff2d014359$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item',
    metric: 'metric',
    trace_metric: 'metric'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $92b251ff2d014359$export$b11169581eeaf237(type) {
    return $92b251ff2d014359$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $92b251ff2d014359$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $92b251ff2d014359$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $5vQzr.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

});
parcelRegister("7viyI", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $5769d31048f08858$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $5769d31048f08858$export$23fbbb20bed71033; });

var $9ISAs = parcelRequire("9ISAs");

var $4zVoD = parcelRequire("4zVoD");

var $iFp2j = parcelRequire("iFp2j");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5769d31048f08858$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5769d31048f08858$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5769d31048f08858$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5769d31048f08858$export$a3295358bff77e(object, depth);
    if ($5769d31048f08858$var$jsonSize(normalized) > maxSize) return $5769d31048f08858$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5769d31048f08858$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $5769d31048f08858$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $5769d31048f08858$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5769d31048f08858$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $4zVoD.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5769d31048f08858$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5769d31048f08858$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $9ISAs.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $9ISAs.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $iFp2j.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5769d31048f08858$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5769d31048f08858$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $5769d31048f08858$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5769d31048f08858$var$jsonSize(value) {
    return $5769d31048f08858$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5769d31048f08858$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $5769d31048f08858$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});



parcelRegister("3kfyQ", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $26bf4f74a999bc5d$export$3f18c56c58114e75; });

var $f5byn = parcelRequire("f5byn");
var $4zVoD = parcelRequire("4zVoD");
var $i0qqg = parcelRequire("i0qqg");

var $bxVth = parcelRequire("bxVth");
let $26bf4f74a999bc5d$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $26bf4f74a999bc5d$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $26bf4f74a999bc5d$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $26bf4f74a999bc5d$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $bxVth.WINDOW).addEventListener('popstate', ()=>{
        const to = (0, $bxVth.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $26bf4f74a999bc5d$var$lastHref;
        $26bf4f74a999bc5d$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f5byn.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $i0qqg.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $26bf4f74a999bc5d$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $26bf4f74a999bc5d$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $26bf4f74a999bc5d$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f5byn.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $4zVoD.fill)((0, $bxVth.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $4zVoD.fill)((0, $bxVth.WINDOW).history, 'replaceState', historyReplacementFunction);
}
function $26bf4f74a999bc5d$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $bxVth.WINDOW).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}

});
parcelRegister("i0qqg", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $d1bcb909590b5d4d$export$67fc34576016d6ec; });
$parcel$export(module.exports, "isNativeFunction", function () { return $d1bcb909590b5d4d$export$d5f608b368e73f38; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $d1bcb909590b5d4d$export$c82d238e23c40b21; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $bZENS = parcelRequire("bZENS");
const $d1bcb909590b5d4d$var$WINDOW = (0, $bZENS.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $d1bcb909590b5d4d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $d1bcb909590b5d4d$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $d1bcb909590b5d4d$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $d1bcb909590b5d4d$export$67fc34576016d6ec() {
    return 'history' in $d1bcb909590b5d4d$var$WINDOW && !!$d1bcb909590b5d4d$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $d1bcb909590b5d4d$export$edf3cb81fd7d2a3e = $d1bcb909590b5d4d$var$_isFetchSupported;
function $d1bcb909590b5d4d$var$_isFetchSupported() {
    if (!('fetch' in $d1bcb909590b5d4d$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $d1bcb909590b5d4d$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $d1bcb909590b5d4d$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$d1bcb909590b5d4d$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($d1bcb909590b5d4d$export$d5f608b368e73f38($d1bcb909590b5d4d$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $d1bcb909590b5d4d$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $d1bcb909590b5d4d$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $d1bcb909590b5d4d$export$531055a6c684a70a() {
    return 'ReportingObserver' in $d1bcb909590b5d4d$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $d1bcb909590b5d4d$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$d1bcb909590b5d4d$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}

});

parcelRegister("bxVth", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $867f5b598c99915d$export$56d8a8a25bd48b81; });

var $bZENS = parcelRequire("bZENS");
const $867f5b598c99915d$export$56d8a8a25bd48b81 = (0, $bZENS.GLOBAL_OBJ);

});


parcelRegister("5q5cQ", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $3f236b524052cd02$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3f236b524052cd02$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("2sCie", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $1cabe67bf1998329$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1cabe67bf1998329$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("bC06r", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $874352c439fc9630$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $874352c439fc9630$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $874352c439fc9630$export$4997ffc0176396a6; });
$parcel$export(module.exports, "getHttpRequestData", function () { return $874352c439fc9630$export$a3c4a8453e8936f0; });

var $h9p4m = parcelRequire("h9p4m");
var $4zVoD = parcelRequire("4zVoD");
var $cPuNx = parcelRequire("cPuNx");
var $dPLPm = parcelRequire("dPLPm");
var $bZENS = parcelRequire("bZENS");
var $dHEV3 = parcelRequire("dHEV3");
const $874352c439fc9630$export$56d8a8a25bd48b81 = (0, $bZENS.GLOBAL_OBJ);
let $874352c439fc9630$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $874352c439fc9630$export$b79738ab10c590b2() {
    return $874352c439fc9630$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $874352c439fc9630$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $874352c439fc9630$var$ignoreOnError++;
    setTimeout(()=>{
        $874352c439fc9630$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $874352c439fc9630$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $4zVoD.getOriginalFunction)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$874352c439fc9630$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $874352c439fc9630$export$1265a142ff5ba165();
            (0, $dHEV3.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $h9p4m.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $h9p4m.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $cPuNx.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $4zVoD.markFunctionWrapped)(sentryWrapped, fn);
    (0, $4zVoD.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $874352c439fc9630$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $dPLPm.getLocationHref)();
    const { referrer: referrer } = $874352c439fc9630$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $874352c439fc9630$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}

});
parcelRegister("cPuNx", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $957223523b4ccc21$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $957223523b4ccc21$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $957223523b4ccc21$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "setContext", function () { return $957223523b4ccc21$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setUser", function () { return $957223523b4ccc21$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "isEnabled", function () { return $957223523b4ccc21$export$3b029eb57ac4d562; });
$parcel$export(module.exports, "startSession", function () { return $957223523b4ccc21$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $957223523b4ccc21$export$667e7b4d445d566b; });

var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $WJI3S = parcelRequire("WJI3S");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");

var $h9p4m = parcelRequire("h9p4m");

var $jTCUq = parcelRequire("jTCUq");

var $7Y1KN = parcelRequire("7Y1KN");

var $bZENS = parcelRequire("bZENS");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $957223523b4ccc21$export$f5282963edea4a68(exception, hint) {
    return (0, $dHEV3.getCurrentScope)().captureException(exception, (0, $jTCUq.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $957223523b4ccc21$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $dHEV3.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $957223523b4ccc21$export$1462b974fdcf6ba2(event, hint) {
    return (0, $dHEV3.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $957223523b4ccc21$export$2f04de43fe27971a(name, context) {
    (0, $dHEV3.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $957223523b4ccc21$export$bb4922da0dd51b92(extras) {
    (0, $dHEV3.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $957223523b4ccc21$export$8e8e7789d42ed61d(key, extra) {
    (0, $dHEV3.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $957223523b4ccc21$export$74a8fb34822092e6(tags) {
    (0, $dHEV3.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $957223523b4ccc21$export$a37d07ee78eb4569(key, value) {
    (0, $dHEV3.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $957223523b4ccc21$export$8b6bb3dd62a01be2(user) {
    (0, $dHEV3.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $957223523b4ccc21$export$5d4e9fd7fac8e617() {
    return (0, $dHEV3.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $957223523b4ccc21$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $dHEV3.getCurrentScope)();
    const client = (0, $dHEV3.getClient)();
    if (!client) (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $h9p4m.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $957223523b4ccc21$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $957223523b4ccc21$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $7Y1KN.timestampInSeconds)();
    function finishCheckIn(status) {
        $957223523b4ccc21$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $7Y1KN.timestampInSeconds)() - now
        });
    }
    return (0, $dHEV3.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $9ISAs.isThenable)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $957223523b4ccc21$export$4909b86c8034bf73(timeout) {
    const client = (0, $dHEV3.getClient)();
    if (client) return client.flush(timeout);
    (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $957223523b4ccc21$export$8360e631d277ea4d(timeout) {
    const client = (0, $dHEV3.getClient)();
    if (client) return client.close(timeout);
    (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $957223523b4ccc21$export$3f95c6f800b78024() {
    return !!(0, $dHEV3.getClient)();
}
/** If the SDK is initialized & enabled. */ function $957223523b4ccc21$export$3b029eb57ac4d562() {
    const client = (0, $dHEV3.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $957223523b4ccc21$export$9aac0b9f77928fbf(callback) {
    (0, $dHEV3.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $957223523b4ccc21$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $dHEV3.getIsolationScope)();
    const currentScope = (0, $dHEV3.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $bZENS.GLOBAL_OBJ).navigator || {};
    const session = (0, $WJI3S.makeSession)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $WJI3S.updateSession)(currentSession, {
        status: 'exited'
    });
    $957223523b4ccc21$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $957223523b4ccc21$export$17a5be43989a0bc1() {
    const isolationScope = (0, $dHEV3.getIsolationScope)();
    const currentScope = (0, $dHEV3.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $WJI3S.closeSession)(session);
    $957223523b4ccc21$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $957223523b4ccc21$var$_sendSessionUpdate() {
    const isolationScope = (0, $dHEV3.getIsolationScope)();
    const client = (0, $dHEV3.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $957223523b4ccc21$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $957223523b4ccc21$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $957223523b4ccc21$var$_sendSessionUpdate();
}

});
parcelRegister("jTCUq", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $e7c155e86fadac48$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $e7c155e86fadac48$export$76b5f966996d1653; });

var $dvLpL = parcelRequire("dvLpL");

var $dHEV3 = parcelRequire("dHEV3");

var $iBqoc = parcelRequire("iBqoc");

var $kyg1b = parcelRequire("kyg1b");

var $pciS5 = parcelRequire("pciS5");

var $4Ka6M = parcelRequire("4Ka6M");

var $h9p4m = parcelRequire("h9p4m");

var $7viyI = parcelRequire("7viyI");

var $kWdMm = parcelRequire("kWdMm");

var $7Y1KN = parcelRequire("7Y1KN");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $e7c155e86fadac48$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $h9p4m.uuid4)(),
        timestamp: event.timestamp || (0, $7Y1KN.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $e7c155e86fadac48$export$d7e04067a6fbc882(prepared, options);
    $e7c155e86fadac48$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $e7c155e86fadac48$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $e7c155e86fadac48$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $h9p4m.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $dHEV3.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $pciS5.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $pciS5.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $pciS5.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $iBqoc.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $e7c155e86fadac48$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $e7c155e86fadac48$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $e7c155e86fadac48$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $dvLpL.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $kWdMm.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $e7c155e86fadac48$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $4Ka6M.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $e7c155e86fadac48$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $e7c155e86fadac48$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $e7c155e86fadac48$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $7viyI.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $7viyI.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $7viyI.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $7viyI.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $7viyI.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $7viyI.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $7viyI.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $e7c155e86fadac48$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $kyg1b.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $e7c155e86fadac48$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($e7c155e86fadac48$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($e7c155e86fadac48$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $e7c155e86fadac48$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $kyg1b.Scope) || typeof hint === 'function';
}
const $e7c155e86fadac48$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $e7c155e86fadac48$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$e7c155e86fadac48$var$captureContextKeys.includes(key));
}

});
parcelRegister("iBqoc", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", function () { return $d8b02716904e0bf4$export$bf2a096c3e883e79; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");

var $eNEeE = parcelRequire("eNEeE");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $d8b02716904e0bf4$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $d8b02716904e0bf4$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $9ISAs.isThenable)(result) ? result : (0, $eNEeE.resolvedSyncPromise)(result);
    } catch (error) {
        return (0, $eNEeE.rejectedSyncPromise)(error);
    }
}
function $d8b02716904e0bf4$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $hv7EP.DEBUG_BUILD) && result === null && (0, $w8bd7.debug).log(`Event processor "${processor.id || '?'}" dropped event`);
    if ((0, $9ISAs.isThenable)(result)) return result.then((final)=>$d8b02716904e0bf4$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $d8b02716904e0bf4$var$_notifyEventProcessors(result, hint, processors, index + 1);
}

});
parcelRegister("eNEeE", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $ac64da2b010372be$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $ac64da2b010372be$export$78e43115b553f358; });

var $9ISAs = parcelRequire("9ISAs");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $ac64da2b010372be$var$STATE_PENDING = 0;
const $ac64da2b010372be$var$STATE_RESOLVED = 1;
const $ac64da2b010372be$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $ac64da2b010372be$export$1fda8aa4d135f8aa(value) {
    return new $ac64da2b010372be$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $ac64da2b010372be$export$78e43115b553f358(reason) {
    return new $ac64da2b010372be$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $ac64da2b010372be$export$6f292d4960313241 {
    constructor(executor){
        this._state = $ac64da2b010372be$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $ac64da2b010372be$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $ac64da2b010372be$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $ac64da2b010372be$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $ac64da2b010372be$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $ac64da2b010372be$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $ac64da2b010372be$var$STATE_PENDING) return;
            if ((0, $9ISAs.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($ac64da2b010372be$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($ac64da2b010372be$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("pciS5", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $04bbe11bd52d73e5$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $04bbe11bd52d73e5$export$25ac7e259a513db4; });

var $7oIfw = parcelRequire("7oIfw");

var $8TzsF = parcelRequire("8TzsF");

var $iaBjX = parcelRequire("iaBjX");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $04bbe11bd52d73e5$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $04bbe11bd52d73e5$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $04bbe11bd52d73e5$var$applySpanToEvent(event, span);
    $04bbe11bd52d73e5$var$applyFingerprintToEvent(event, fingerprint);
    $04bbe11bd52d73e5$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $04bbe11bd52d73e5$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $04bbe11bd52d73e5$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $04bbe11bd52d73e5$export$b1a120a2871faa46(data, 'extra', extra);
    $04bbe11bd52d73e5$export$b1a120a2871faa46(data, 'tags', tags);
    $04bbe11bd52d73e5$export$b1a120a2871faa46(data, 'user', user);
    $04bbe11bd52d73e5$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $8TzsF.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $04bbe11bd52d73e5$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $8TzsF.merge)(data[prop], mergeVal, 1);
}
function $04bbe11bd52d73e5$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $04bbe11bd52d73e5$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $04bbe11bd52d73e5$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $04bbe11bd52d73e5$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $iaBjX.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $7oIfw.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $iaBjX.getRootSpan)(span);
    const transactionName = (0, $iaBjX.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $04bbe11bd52d73e5$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});

parcelRegister("4Ka6M", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", function () { return $37434c9a2e0deb82$export$e069fee9c632ed00; });

var $bZENS = parcelRequire("bZENS");
let $37434c9a2e0deb82$var$parsedStackResults;
let $37434c9a2e0deb82$var$lastSentryKeysCount;
let $37434c9a2e0deb82$var$lastNativeKeysCount;
let $37434c9a2e0deb82$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function $37434c9a2e0deb82$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $bZENS.GLOBAL_OBJ)._sentryDebugIds;
    const nativeDebugIdMap = (0, $bZENS.GLOBAL_OBJ)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($37434c9a2e0deb82$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $37434c9a2e0deb82$var$lastSentryKeysCount && nativeDebugIdKeys.length === $37434c9a2e0deb82$var$lastNativeKeysCount) return $37434c9a2e0deb82$var$cachedFilenameDebugIds;
    $37434c9a2e0deb82$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $37434c9a2e0deb82$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    $37434c9a2e0deb82$var$cachedFilenameDebugIds = {};
    if (!$37434c9a2e0deb82$var$parsedStackResults) $37434c9a2e0deb82$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $37434c9a2e0deb82$var$parsedStackResults?.[key];
            if (result && $37434c9a2e0deb82$var$cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                $37434c9a2e0deb82$var$cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if ($37434c9a2e0deb82$var$parsedStackResults) $37434c9a2e0deb82$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $37434c9a2e0deb82$var$cachedFilenameDebugIds && $37434c9a2e0deb82$var$parsedStackResults) {
                        $37434c9a2e0deb82$var$cachedFilenameDebugIds[filename] = debugId;
                        $37434c9a2e0deb82$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $37434c9a2e0deb82$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $37434c9a2e0deb82$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $37434c9a2e0deb82$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});




parcelRegister("gfqT4", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $bd42e74f4b5ffd2b$export$f75d3c772c923df0; });
$parcel$export(module.exports, "addFetchEndInstrumentationHandler", function () { return $bd42e74f4b5ffd2b$export$1a79663eb318fe6a; });

var $9ISAs = parcelRequire("9ISAs");

var $4zVoD = parcelRequire("4zVoD");

var $i0qqg = parcelRequire("i0qqg");

var $7Y1KN = parcelRequire("7Y1KN");

var $bZENS = parcelRequire("bZENS");

var $f5byn = parcelRequire("f5byn");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $bd42e74f4b5ffd2b$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, ()=>$bd42e74f4b5ffd2b$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $bd42e74f4b5ffd2b$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, ()=>$bd42e74f4b5ffd2b$var$instrumentFetch($bd42e74f4b5ffd2b$var$streamHandler));
}
function $bd42e74f4b5ffd2b$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $i0qqg.supportsNativeFetch)()) return;
    (0, $4zVoD.fill)((0, $bZENS.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $bd42e74f4b5ffd2b$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $bd42e74f4b5ffd2b$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $f5byn.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $bZENS.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $f5byn.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $f5byn.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $9ISAs.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $4zVoD.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $bd42e74f4b5ffd2b$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $bd42e74f4b5ffd2b$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $bd42e74f4b5ffd2b$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $f5byn.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $bd42e74f4b5ffd2b$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $bd42e74f4b5ffd2b$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($bd42e74f4b5ffd2b$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $bd42e74f4b5ffd2b$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $bd42e74f4b5ffd2b$var$getUrlFromResource(url),
            method: $bd42e74f4b5ffd2b$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $bd42e74f4b5ffd2b$var$getUrlFromResource(arg),
        method: $bd42e74f4b5ffd2b$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $bd42e74f4b5ffd2b$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $9ISAs.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

});

parcelRegister("9X7xs", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $73ef78c03f7e25e0$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $73ef78c03f7e25e0$export$26ace48dd54c9aea; });

var $f5byn = parcelRequire("f5byn");
var $9ISAs = parcelRequire("9ISAs");
var $7Y1KN = parcelRequire("7Y1KN");

var $bxVth = parcelRequire("bxVth");
const $73ef78c03f7e25e0$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $73ef78c03f7e25e0$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $73ef78c03f7e25e0$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $73ef78c03f7e25e0$export$c67d533bf77cbf54() {
    if (!(0, $bxVth.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $7Y1KN.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9ISAs.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $73ef78c03f7e25e0$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$73ef78c03f7e25e0$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$73ef78c03f7e25e0$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $f5byn.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$73ef78c03f7e25e0$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9ISAs.isString)(header) && (0, $9ISAs.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$73ef78c03f7e25e0$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $f5byn.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $73ef78c03f7e25e0$var$parseXhrUrlArg(url) {
    if ((0, $9ISAs.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("6gxho", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $48fe0d4ea08dd7a8$export$1d6e0d073f9e6723; });

var $w8bd7 = parcelRequire("w8bd7");

var $4zVoD = parcelRequire("4zVoD");

var $bZENS = parcelRequire("bZENS");

var $f5byn = parcelRequire("f5byn");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $48fe0d4ea08dd7a8$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $48fe0d4ea08dd7a8$var$instrumentConsole);
}
function $48fe0d4ea08dd7a8$var$instrumentConsole() {
    if (!('console' in (0, $bZENS.GLOBAL_OBJ))) return;
    (0, $w8bd7.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $bZENS.GLOBAL_OBJ).console)) return;
        (0, $4zVoD.fill)((0, $bZENS.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $w8bd7.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f5byn.triggerHandlers)('console', handlerData);
                const log = (0, $w8bd7.originalConsoleMethods)[level];
                log?.apply((0, $bZENS.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("j1zPl", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $dd99e6d3a0bfc61a$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $dd99e6d3a0bfc61a$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $dd99e6d3a0bfc61a$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $dd99e6d3a0bfc61a$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "defineIntegration", function () { return $dd99e6d3a0bfc61a$export$2323046b9414659f; });

var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");
const $dd99e6d3a0bfc61a$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $dd99e6d3a0bfc61a$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $dd99e6d3a0bfc61a$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $dd99e6d3a0bfc61a$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $dd99e6d3a0bfc61a$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $dd99e6d3a0bfc61a$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $dd99e6d3a0bfc61a$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $dd99e6d3a0bfc61a$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($dd99e6d3a0bfc61a$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $dd99e6d3a0bfc61a$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $dd99e6d3a0bfc61a$export$2d8f5188773bcddd(integration) {
    const client = (0, $dHEV3.getClient)();
    if (!client) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $dd99e6d3a0bfc61a$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("dOy0j", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $a0ea525cd5522800$export$d771ef054122c30a; });
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $a0ea525cd5522800$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

});

parcelRegister("jN5EV", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $e686fbaeb650f069$export$2cd8252107eb640b; });

var $j18z0 = parcelRequire("j18z0");
var $cSyvn = parcelRequire("cSyvn");
var $j1zPl = parcelRequire("j1zPl");
var $iTyfp = parcelRequire("iTyfp");
var $arkxi = parcelRequire("arkxi");
var $iFp2j = parcelRequire("iFp2j");

var $hffIK = parcelRequire("hffIK");

var $3SlHQ = parcelRequire("3SlHQ");

var $2GRLG = parcelRequire("2GRLG");

var $iPvgx = parcelRequire("iPvgx");

var $ew6DM = parcelRequire("ew6DM");

var $hf4AU = parcelRequire("hf4AU");

var $69FHl = parcelRequire("69FHl");

var $lT9Dc = parcelRequire("lT9Dc");

var $919im = parcelRequire("919im");

var $89CO5 = parcelRequire("89CO5");
/** Get the default integrations for the browser SDK. */ function $e686fbaeb650f069$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $iTyfp.inboundFiltersIntegration)(),
        (0, $cSyvn.functionToStringIntegration)(),
        (0, $2GRLG.browserApiErrorsIntegration)(),
        (0, $3SlHQ.breadcrumbsIntegration)(),
        (0, $ew6DM.globalHandlersIntegration)(),
        (0, $69FHl.linkedErrorsIntegration)(),
        (0, $j18z0.dedupeIntegration)(),
        (0, $hf4AU.httpContextIntegration)(),
        (0, $iPvgx.browserSessionIntegration)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $e686fbaeb650f069$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $89CO5.checkAndWarnIfIsEmbeddedBrowserExtension)();
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $iFp2j.stackParserFromStackParserOptions)(options.stackParser || (0, $lT9Dc.defaultStackParser)),
        integrations: (0, $j1zPl.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $e686fbaeb650f069$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $919im.makeFetchTransport)
    };
    return (0, $arkxi.initAndBind)((0, $hffIK.BrowserClient), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $e686fbaeb650f069$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $e686fbaeb650f069$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("j18z0", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $dd84c0e0f14fe2ef$export$6d39aa44cd0c7567; });

var $hv7EP = parcelRequire("hv7EP");

var $j1zPl = parcelRequire("j1zPl");

var $w8bd7 = parcelRequire("w8bd7");

var $iFp2j = parcelRequire("iFp2j");
const $dd84c0e0f14fe2ef$var$INTEGRATION_NAME = 'Dedupe';
const $dd84c0e0f14fe2ef$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $dd84c0e0f14fe2ef$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($dd84c0e0f14fe2ef$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $dd84c0e0f14fe2ef$export$6d39aa44cd0c7567 = (0, $j1zPl.defineIntegration)($dd84c0e0f14fe2ef$var$_dedupeIntegration);
/** only exported for tests. */ function $dd84c0e0f14fe2ef$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($dd84c0e0f14fe2ef$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($dd84c0e0f14fe2ef$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $dd84c0e0f14fe2ef$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$dd84c0e0f14fe2ef$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$dd84c0e0f14fe2ef$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $dd84c0e0f14fe2ef$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $dd84c0e0f14fe2ef$var$_getExceptionFromEvent(previousEvent);
    const currentException = $dd84c0e0f14fe2ef$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$dd84c0e0f14fe2ef$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$dd84c0e0f14fe2ef$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $dd84c0e0f14fe2ef$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $iFp2j.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $iFp2j.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $dd84c0e0f14fe2ef$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch  {
        return false;
    }
}
function $dd84c0e0f14fe2ef$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}

});

parcelRegister("cSyvn", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $96054b2d9eeeb205$export$7918117e9202e4fb; });

var $dHEV3 = parcelRequire("dHEV3");

var $j1zPl = parcelRequire("j1zPl");

var $4zVoD = parcelRequire("4zVoD");
let $96054b2d9eeeb205$var$originalFunctionToString;
const $96054b2d9eeeb205$var$INTEGRATION_NAME = 'FunctionToString';
const $96054b2d9eeeb205$var$SETUP_CLIENTS = new WeakMap();
const $96054b2d9eeeb205$var$_functionToStringIntegration = ()=>{
    return {
        name: $96054b2d9eeeb205$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $96054b2d9eeeb205$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $4zVoD.getOriginalFunction)(this);
                    const context = $96054b2d9eeeb205$var$SETUP_CLIENTS.has((0, $dHEV3.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $96054b2d9eeeb205$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $96054b2d9eeeb205$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $96054b2d9eeeb205$export$7918117e9202e4fb = (0, $j1zPl.defineIntegration)($96054b2d9eeeb205$var$_functionToStringIntegration);

});

parcelRegister("iTyfp", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $dc17ede41ec71668$export$cb3c5c2ceb9818ba; });

var $hv7EP = parcelRequire("hv7EP");

var $j1zPl = parcelRequire("j1zPl");

var $w8bd7 = parcelRequire("w8bd7");

var $7yXyQ = parcelRequire("7yXyQ");

var $h9p4m = parcelRequire("h9p4m");

var $kWdMm = parcelRequire("kWdMm");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $dc17ede41ec71668$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $dc17ede41ec71668$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $dc17ede41ec71668$export$9a84f518c163c552 = (0, $j1zPl.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: $dc17ede41ec71668$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $dc17ede41ec71668$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $dc17ede41ec71668$var$_mergeOptions(options, clientOptions);
            }
            return $dc17ede41ec71668$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $dc17ede41ec71668$export$cb3c5c2ceb9818ba = (0, $j1zPl.defineIntegration)((options = {})=>{
    return {
        ...$dc17ede41ec71668$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $dc17ede41ec71668$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $dc17ede41ec71668$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $dc17ede41ec71668$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($dc17ede41ec71668$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $h9p4m.getEventDescription)(event)}`);
            return true;
        }
        if ($dc17ede41ec71668$var$_isUselessError(event)) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $h9p4m.getEventDescription)(event)}`);
            return true;
        }
        if ($dc17ede41ec71668$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $h9p4m.getEventDescription)(event)}.\nUrl: ${$dc17ede41ec71668$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$dc17ede41ec71668$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $h9p4m.getEventDescription)(event)}.\nUrl: ${$dc17ede41ec71668$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($dc17ede41ec71668$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $h9p4m.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $dc17ede41ec71668$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $7yXyQ.getPossibleEventMessages)(event).some((message)=>(0, $kWdMm.stringMatchesSomePattern)(message, ignoreErrors));
}
function $dc17ede41ec71668$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $kWdMm.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $dc17ede41ec71668$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $dc17ede41ec71668$var$_getEventFilterUrl(event);
    return !url ? false : (0, $kWdMm.stringMatchesSomePattern)(url, denyUrls);
}
function $dc17ede41ec71668$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $dc17ede41ec71668$var$_getEventFilterUrl(event);
    return !url ? true : (0, $kWdMm.stringMatchesSomePattern)(url, allowUrls);
}
function $dc17ede41ec71668$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $dc17ede41ec71668$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $dc17ede41ec71668$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error(`Cannot extract url for event ${(0, $h9p4m.getEventDescription)(event)}`);
        return null;
    }
}
function $dc17ede41ec71668$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}

});
parcelRegister("7yXyQ", function(module, exports) {

$parcel$export(module.exports, "getPossibleEventMessages", function () { return $5819e8f8325ea7f2$export$d55a97c329cacfcc; });
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $5819e8f8325ea7f2$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}

});


parcelRegister("arkxi", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $799c5b09b6f625d4$export$5333c3f1c58d9bc1; });

var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $799c5b09b6f625d4$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $hv7EP.DEBUG_BUILD) (0, $w8bd7.debug).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $w8bd7.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $dHEV3.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $799c5b09b6f625d4$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $799c5b09b6f625d4$export$ecb76f41d43c0e43(client) {
    (0, $dHEV3.getCurrentScope)().setClient(client);
}

});

parcelRegister("hffIK", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $c8e0082b273dddec$export$1df9218a526d318d; });

var $8elHx = parcelRequire("8elHx");
var $aZRB9 = parcelRequire("aZRB9");
var $juCo4 = parcelRequire("juCo4");
var $1AdE0 = parcelRequire("1AdE0");
var $l4feF = parcelRequire("l4feF");
var $5UIir = parcelRequire("5UIir");

var $b95ae = parcelRequire("b95ae");

var $bC06r = parcelRequire("bC06r");
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $c8e0082b273dddec$export$1df9218a526d318d extends (0, $l4feF.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $c8e0082b273dddec$export$4e107b20a7f977(options);
        const sdkSource = (0, $bC06r.WINDOW).SENTRY_SDK_SOURCE || (0, $5UIir.getSDKSource)();
        (0, $1AdE0.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never',
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments } = this._options;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        if ((0, $bC06r.WINDOW).document && (sendClientReports || enableLogs || _experiments?.enableMetrics)) (0, $bC06r.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $bC06r.WINDOW).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $8elHx._INTERNAL_flushLogsBuffer)(this);
                if (_experiments?.enableMetrics) (0, $aZRB9._INTERNAL_flushMetricsBuffer)(this);
            }
        });
        if (sendDefaultPii) this.on('beforeSendSession', (0, $juCo4.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $b95ae.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $b95ae.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $c8e0082b273dddec$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $bC06r.WINDOW).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}

});
parcelRegister("8elHx", function(module, exports) {

$parcel$export(module.exports, "_INTERNAL_flushLogsBuffer", function () { return $5fe076f28a9d2039$export$f8ed83d3b6a0b504; });

var $2vdTp = parcelRequire("2vdTp");

var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $pciS5 = parcelRequire("pciS5");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");

var $4L3PL = parcelRequire("4L3PL");

var $7Y1KN = parcelRequire("7Y1KN");

var $axqAo = parcelRequire("axqAo");

var $ibphB = parcelRequire("ibphB");

var $bZ4sR = parcelRequire("bZ4sR");
const $5fe076f28a9d2039$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $5fe076f28a9d2039$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $5fe076f28a9d2039$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $5fe076f28a9d2039$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $5fe076f28a9d2039$var$_getBufferMap();
    const logBuffer = $5fe076f28a9d2039$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else {
        bufferMap.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $5fe076f28a9d2039$var$MAX_LOG_BUFFER_SIZE) $5fe076f28a9d2039$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $5fe076f28a9d2039$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $dHEV3.getCurrentScope)(), captureSerializedLog = $5fe076f28a9d2039$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $dHEV3.getClient)();
    if (!client) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $axqAo._getTraceInfoFromScope)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username } } = $5fe076f28a9d2039$var$getMergedScopeData(currentScope);
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'sentry._internal.replay_is_buffering', true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $9ISAs.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $4L3PL._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $5fe076f28a9d2039$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $w8bd7.consoleSandbox)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $7Y1KN.timestampInSeconds)(),
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $ibphB.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $5fe076f28a9d2039$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $5fe076f28a9d2039$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $5fe076f28a9d2039$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $bZ4sR.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $5fe076f28a9d2039$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $5fe076f28a9d2039$export$5365c9902fb9e770(client) {
    return $5fe076f28a9d2039$var$_getBufferMap().get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $5fe076f28a9d2039$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $dHEV3.getGlobalScope)().getScopeData();
    (0, $pciS5.mergeScopeData)(scopeData, (0, $dHEV3.getIsolationScope)().getScopeData());
    (0, $pciS5.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $5fe076f28a9d2039$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $2vdTp.getGlobalSingleton)('clientToLogBufferMap', ()=>new WeakMap());
}

});
parcelRegister("axqAo", function(module, exports) {

$parcel$export(module.exports, "_getTraceInfoFromScope", function () { return $7ac19be1518cdb07$export$fb7d833b3fdedf5f; });

var $dHEV3 = parcelRequire("dHEV3");

var $7oIfw = parcelRequire("7oIfw");

var $iaBjX = parcelRequire("iaBjX");
/** Extract trace information from scope */ function $7ac19be1518cdb07$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $dHEV3.withScope)(scope, ()=>{
        const span = (0, $iaBjX.getActiveSpan)();
        const traceContext = span ? (0, $iaBjX.spanToTraceContext)(span) : (0, $dHEV3.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $7oIfw.getDynamicSamplingContextFromSpan)(span) : (0, $7oIfw.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

});

parcelRegister("ibphB", function(module, exports) {

$parcel$export(module.exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", function () { return $d3ccddbfab9c4cab$export$4fb50c0840d636d1; });
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $d3ccddbfab9c4cab$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

});

parcelRegister("bZ4sR", function(module, exports) {

$parcel$export(module.exports, "createLogEnvelope", function () { return $8b98dac1de1a4a60$export$cdcd668e6516443f; });

var $5vQzr = parcelRequire("5vQzr");

var $cARsW = parcelRequire("cARsW");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $8b98dac1de1a4a60$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $8b98dac1de1a4a60$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $5vQzr.dsnToString)(dsn);
    return (0, $cARsW.createEnvelope)(headers, [
        $8b98dac1de1a4a60$export$efdf3b13edb1118e(logs)
    ]);
}

});


parcelRegister("aZRB9", function(module, exports) {

$parcel$export(module.exports, "_INTERNAL_flushMetricsBuffer", function () { return $80192d5c4d93eb40$export$91c9ef254b7d0f67; });

var $2vdTp = parcelRequire("2vdTp");

var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $pciS5 = parcelRequire("pciS5");

var $w8bd7 = parcelRequire("w8bd7");

var $4L3PL = parcelRequire("4L3PL");

var $7Y1KN = parcelRequire("7Y1KN");

var $axqAo = parcelRequire("axqAo");

var $3MPyD = parcelRequire("3MPyD");
const $80192d5c4d93eb40$var$MAX_METRIC_BUFFER_SIZE = 100;
/**
 * Converts a metric attribute to a serialized metric attribute.
 *
 * @param value - The value of the metric attribute.
 * @returns The serialized metric attribute.
 */ function $80192d5c4d93eb40$export$efd45b4a67542589(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $80192d5c4d93eb40$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $80192d5c4d93eb40$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $80192d5c4d93eb40$var$_getBufferMap();
    const metricBuffer = $80192d5c4d93eb40$export$49385134251b08ff(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else {
        bufferMap.set(client, [
            ...metricBuffer,
            serializedMetric
        ]);
        if (metricBuffer.length >= $80192d5c4d93eb40$var$MAX_METRIC_BUFFER_SIZE) $80192d5c4d93eb40$export$91c9ef254b7d0f67(client, metricBuffer);
    }
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $80192d5c4d93eb40$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $dHEV3.getCurrentScope)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $80192d5c4d93eb40$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $dHEV3.getClient)();
    if (!client) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('No client available to capture metric.');
        return;
    }
    const { release: release, environment: environment, _experiments: _experiments } = client.getOptions();
    if (!_experiments?.enableMetrics) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('metrics option not enabled, metric will not be captured.');
        return;
    }
    const [, traceContext] = (0, $axqAo._getTraceInfoFromScope)(client, currentScope);
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    const { user: { id: id, email: email, username: username } } = $80192d5c4d93eb40$var$getMergedScopeData(currentScope);
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'user.id', id, false);
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'user.email', email, false);
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'user.name', username, false);
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'sentry.release', release);
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.name', name);
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $80192d5c4d93eb40$var$setMetricAttribute(processedMetricAttributes, 'sentry._internal.replay_is_buffering', true);
    const metric = {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
    // Run beforeSendMetric callback
    const processedMetric = _experiments?.beforeSendMetric ? _experiments.beforeSendMetric(metric) : metric;
    if (!processedMetric) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('`beforeSendMetric` returned `null`, will not send metric.');
        return;
    }
    const serializedAttributes = {};
    for(const key in processedMetric.attributes)if (processedMetric.attributes[key] !== undefined) serializedAttributes[key] = $80192d5c4d93eb40$export$efd45b4a67542589(processedMetric.attributes[key]);
    const span = (0, $4L3PL._getSpanForScope)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    const serializedMetric = {
        timestamp: (0, $7Y1KN.timestampInSeconds)(),
        trace_id: traceId,
        span_id: spanId,
        name: processedMetric.name,
        type: processedMetric.type,
        unit: processedMetric.unit,
        value: processedMetric.value,
        attributes: serializedAttributes
    };
    (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('[Metric]', serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit('afterCaptureMetric', metric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $80192d5c4d93eb40$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $80192d5c4d93eb40$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $3MPyD.createMetricEnvelope)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the metric buffer after envelopes have been constructed.
    $80192d5c4d93eb40$var$_getBufferMap().set(client, []);
    client.emit('flushMetrics');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function $80192d5c4d93eb40$export$49385134251b08ff(client) {
    return $80192d5c4d93eb40$var$_getBufferMap().get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $80192d5c4d93eb40$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $dHEV3.getGlobalScope)().getScopeData();
    (0, $pciS5.mergeScopeData)(scopeData, (0, $dHEV3.getIsolationScope)().getScopeData());
    (0, $pciS5.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $80192d5c4d93eb40$var$_getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return (0, $2vdTp.getGlobalSingleton)('clientToMetricBufferMap', ()=>new WeakMap());
}

});
parcelRegister("3MPyD", function(module, exports) {

$parcel$export(module.exports, "createMetricEnvelope", function () { return $2c1dd90ca894f200$export$f23eb96e33154901; });

var $5vQzr = parcelRequire("5vQzr");

var $cARsW = parcelRequire("cARsW");
/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @returns The created metric container envelope item.
 */ function $2c1dd90ca894f200$export$58e45eb52ad1077d(items) {
    return [
        {
            type: 'trace_metric',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.trace-metric+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $2c1dd90ca894f200$export$f23eb96e33154901(metrics, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $5vQzr.dsnToString)(dsn);
    return (0, $cARsW.createEnvelope)(headers, [
        $2c1dd90ca894f200$export$58e45eb52ad1077d(metrics)
    ]);
}

});


parcelRegister("juCo4", function(module, exports) {

$parcel$export(module.exports, "addAutoIpAddressToSession", function () { return $e30e988f45ad27da$export$e8e2d07ba63e2b6c; });
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ function $e30e988f45ad27da$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $e30e988f45ad27da$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

});

parcelRegister("1AdE0", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $1273bcae78260b65$export$b9f95b027256052c; });

var $iOjzR = parcelRequire("iOjzR");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $1273bcae78260b65$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $iOjzR.SDK_VERSION)
            })),
        version: (0, $iOjzR.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("l4feF", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $f565ca273b931561$export$1f2bb630327ac4b6; });

var $edtDH = parcelRequire("edtDH");

var $dvLpL = parcelRequire("dvLpL");

var $dHEV3 = parcelRequire("dHEV3");

var $hv7EP = parcelRequire("hv7EP");

var $3pr37 = parcelRequire("3pr37");

var $j1zPl = parcelRequire("j1zPl");

var $8elHx = parcelRequire("8elHx");

var $aZRB9 = parcelRequire("aZRB9");

var $WJI3S = parcelRequire("WJI3S");

var $7oIfw = parcelRequire("7oIfw");

var $8pmuM = parcelRequire("8pmuM");

var $w8bd7 = parcelRequire("w8bd7");

var $5vQzr = parcelRequire("5vQzr");

var $cARsW = parcelRequire("cARsW");

var $7yXyQ = parcelRequire("7yXyQ");

var $9ISAs = parcelRequire("9ISAs");

var $8TzsF = parcelRequire("8TzsF");

var $h9p4m = parcelRequire("h9p4m");

var $a5tr3 = parcelRequire("a5tr3");

var $jTCUq = parcelRequire("jTCUq");

var $9VTV3 = parcelRequire("9VTV3");

var $iaBjX = parcelRequire("iaBjX");

var $eNEeE = parcelRequire("eNEeE");

var $cDgJy = parcelRequire("cDgJy");
/* eslint-disable max-lines */ const $f565ca273b931561$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $f565ca273b931561$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $f565ca273b931561$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $f565ca273b931561$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
// Default interval for flushing logs and metrics (5 seconds)
const $f565ca273b931561$var$DEFAULT_FLUSH_INTERVAL = 5000;
function $f565ca273b931561$var$_makeInternalError(message) {
    return {
        message: message,
        [$f565ca273b931561$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $f565ca273b931561$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$f565ca273b931561$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $f565ca273b931561$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $f565ca273b931561$var$INTERNAL_ERROR_SYMBOL in error;
}
function $f565ca273b931561$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $f565ca273b931561$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after idle timeout if no new items arrive
 *
 * Uses closure variables to track weight and timeout state.
 */ function $f565ca273b931561$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else {
            clearTimeout(flushTimeout);
            flushTimeout = setTimeout(()=>{
                flushFn(client);
            }, $f565ca273b931561$var$DEFAULT_FLUSH_INTERVAL);
        }
    });
    client.on('flush', ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $f565ca273b931561$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $5vQzr.makeDsn)(options.dsn);
        else (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $edtDH.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) $f565ca273b931561$var$setupWeightBasedFlushing(this, 'afterCaptureLog', 'flushLogs', $f565ca273b931561$var$estimateLogSizeInBytes, (0, $8elHx._INTERNAL_flushLogsBuffer));
        // Setup metric flushing with weight and timeout tracking
        if (this._options._experiments?.enableMetrics) $f565ca273b931561$var$setupWeightBasedFlushing(this, 'afterCaptureMetric', 'flushMetrics', $f565ca273b931561$var$estimateMetricSizeInBytes, (0, $aZRB9._INTERNAL_flushMetricsBuffer));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $h9p4m.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $h9p4m.checkOrSetAlreadyCaught)(exception)) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log($f565ca273b931561$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $h9p4m.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $9ISAs.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $9ISAs.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $h9p4m.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $h9p4m.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log($f565ca273b931561$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $WJI3S.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        if (!transport) return true;
        this.emit('flush');
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit('close');
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $j1zPl.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $j1zPl.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $3pr37.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $cARsW.addItemToEnvelope)(env, (0, $cARsW.createAttachmentEnvelopeItem)(attachment));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $dvLpL.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn($f565ca273b931561$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn($f565ca273b931561$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $3pr37.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error('Error while sending envelope:', reason);
            return {};
        }
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error('Transport disabled');
        return {};
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $j1zPl.setupIntegrations)(this, integrations);
        (0, $j1zPl.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $WJI3S.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        // if no timeout is provided, we wait "forever" until everything is processed
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $jTCUq.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $dHEV3.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $7oIfw.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $dHEV3.getCurrentScope)(), isolationScope = (0, $dHEV3.getIsolationScope)()) {
        if ((0, $hv7EP.DEBUG_BUILD) && $f565ca273b931561$var$isErrorEvent(event)) (0, $w8bd7.debug).log(`Captured error event \`${(0, $7yXyQ.getPossibleEventMessages)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $hv7EP.DEBUG_BUILD) {
                if ($f565ca273b931561$var$_isDoNotSendEventError(reason)) (0, $w8bd7.debug).log(reason.message);
                else if ($f565ca273b931561$var$_isInternalError(reason)) (0, $w8bd7.debug).warn(reason.message);
                else (0, $w8bd7.debug).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $f565ca273b931561$var$isTransactionEvent(event);
        const isError = $f565ca273b931561$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $a5tr3.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $eNEeE.rejectedSyncPromise)($f565ca273b931561$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $f565ca273b931561$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $f565ca273b931561$var$processBeforeSend(this, options, prepared, hint);
            return $f565ca273b931561$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $f565ca273b931561$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($f565ca273b931561$var$_isDoNotSendEventError(reason) || $f565ca273b931561$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: 'internal'
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $f565ca273b931561$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log('Sending outcomes:', outcomes);
        const envelope = (0, $8pmuM.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $5vQzr.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $f565ca273b931561$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9ISAs.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9ISAs.isPlainObject)(event) && event !== null) throw $f565ca273b931561$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $f565ca273b931561$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9ISAs.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $f565ca273b931561$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $f565ca273b931561$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = options;
    let processedEvent = event;
    if ($f565ca273b931561$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($f565ca273b931561$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = (0, $cDgJy.convertTransactionEventToSpanJson)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && (0, $9VTV3.shouldIgnoreSpan)(rootSpanJson, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $iaBjX.showSpanDropWarning)();
                else // update event with processed root span values
                processedEvent = (0, $8TzsF.merge)(event, (0, $cDgJy.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && (0, $9VTV3.shouldIgnoreSpan)(span, ignoreSpans)) {
                        (0, $9VTV3.reparentChildSpans)(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $iaBjX.showSpanDropWarning)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $f565ca273b931561$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $f565ca273b931561$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function $f565ca273b931561$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for the value
    if (typeof metric.value === 'string') weight += metric.value.length * 2;
    else weight += 8; // number
    return weight + $f565ca273b931561$var$estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function $f565ca273b931561$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + $f565ca273b931561$var$estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function $f565ca273b931561$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $f565ca273b931561$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $9ISAs.isPrimitive)(value)) weight += $f565ca273b931561$var$estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function $f565ca273b931561$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'number') return 8;
    else if (typeof value === 'boolean') return 4;
    return 0;
}

});
parcelRegister("edtDH", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $a599455155839dd8$export$9964600bfe84e6a3; });

var $5vQzr = parcelRequire("5vQzr");
const $a599455155839dd8$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a599455155839dd8$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $a599455155839dd8$var$_getIngestEndpoint(dsn) {
    return `${$a599455155839dd8$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a599455155839dd8$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $a599455155839dd8$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $a599455155839dd8$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$a599455155839dd8$var$_getIngestEndpoint(dsn)}?${$a599455155839dd8$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $a599455155839dd8$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $5vQzr.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$a599455155839dd8$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $5vQzr.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("8pmuM", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $61f21bac485f1cc7$export$f3b9ed77c03eeb00; });

var $cARsW = parcelRequire("cARsW");

var $7Y1KN = parcelRequire("7Y1KN");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $61f21bac485f1cc7$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $7Y1KN.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $cARsW.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("cDgJy", function(module, exports) {

$parcel$export(module.exports, "convertTransactionEventToSpanJson", function () { return $93261b83735ed7fe$export$d9c6b2464b0a687e; });
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", function () { return $93261b83735ed7fe$export$f2d8fce5ae150e92; });

var $gKbJW = parcelRequire("gKbJW");
/**
 * Converts a transaction event to a span JSON object.
 */ function $93261b83735ed7fe$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $gKbJW.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $gKbJW.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $93261b83735ed7fe$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $gKbJW.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}

});


parcelRegister("5UIir", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", function () { return $44e48b16239d933c$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $44e48b16239d933c$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $44e48b16239d933c$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});

parcelRegister("b95ae", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $81d48a7411cd736f$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $81d48a7411cd736f$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $81d48a7411cd736f$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $81d48a7411cd736f$export$5425b53185d13d6c; });

var $h9p4m = parcelRequire("h9p4m");
var $4zVoD = parcelRequire("4zVoD");
var $dHEV3 = parcelRequire("dHEV3");
var $9ISAs = parcelRequire("9ISAs");
var $7viyI = parcelRequire("7viyI");
var $eNEeE = parcelRequire("eNEeE");
/**
 * This function creates an exception from a JavaScript Error
 */ function $81d48a7411cd736f$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $81d48a7411cd736f$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $81d48a7411cd736f$export$2e9ae379995d99e3(ex),
        value: $81d48a7411cd736f$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $81d48a7411cd736f$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $dHEV3.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $81d48a7411cd736f$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $7viyI.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $81d48a7411cd736f$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9ISAs.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $81d48a7411cd736f$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $81d48a7411cd736f$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $81d48a7411cd736f$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $81d48a7411cd736f$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $81d48a7411cd736f$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $81d48a7411cd736f$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $81d48a7411cd736f$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $81d48a7411cd736f$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $81d48a7411cd736f$var$getSkipFirstStackStringLines(ex) {
    if (ex && $81d48a7411cd736f$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $81d48a7411cd736f$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $81d48a7411cd736f$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $81d48a7411cd736f$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $81d48a7411cd736f$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $81d48a7411cd736f$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($81d48a7411cd736f$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $81d48a7411cd736f$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $81d48a7411cd736f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $h9p4m.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $eNEeE.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $81d48a7411cd736f$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $81d48a7411cd736f$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $eNEeE.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $81d48a7411cd736f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9ISAs.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $81d48a7411cd736f$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9ISAs.isDOMError)(exception) || (0, $9ISAs.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $81d48a7411cd736f$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $9ISAs.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $81d48a7411cd736f$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $h9p4m.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $9ISAs.isError)(exception)) // we have a real Error object, do nothing
    return $81d48a7411cd736f$var$eventFromError(stackParser, exception);
    if ((0, $9ISAs.isPlainObject)(exception) || (0, $9ISAs.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $81d48a7411cd736f$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $h9p4m.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $81d48a7411cd736f$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $h9p4m.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $h9p4m.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $81d48a7411cd736f$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $81d48a7411cd736f$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $h9p4m.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $9ISAs.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $81d48a7411cd736f$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $4zVoD.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9ISAs.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9ISAs.isEvent)(exception)) {
        const className = $81d48a7411cd736f$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $81d48a7411cd736f$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $81d48a7411cd736f$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});


parcelRegister("3SlHQ", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $2d27409c85b6756b$export$c079d904b326663a; });

var $imn0b = parcelRequire("imn0b");
var $6gxho = parcelRequire("6gxho");
var $gfqT4 = parcelRequire("gfqT4");
var $w8bd7 = parcelRequire("w8bd7");
var $j1zPl = parcelRequire("j1zPl");
var $bTIV2 = parcelRequire("bTIV2");
var $dHEV3 = parcelRequire("dHEV3");
var $dPLPm = parcelRequire("dPLPm");
var $h9p4m = parcelRequire("h9p4m");
var $f82Ej = parcelRequire("f82Ej");
var $kWdMm = parcelRequire("kWdMm");
var $dOy0j = parcelRequire("dOy0j");

var $bM6aW = parcelRequire("bM6aW");
var $3kfyQ = parcelRequire("3kfyQ");
var $9X7xs = parcelRequire("9X7xs");

var $2sCie = parcelRequire("2sCie");

var $bC06r = parcelRequire("bC06r");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $2d27409c85b6756b$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $2d27409c85b6756b$var$INTEGRATION_NAME = 'Breadcrumbs';
const $2d27409c85b6756b$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $2d27409c85b6756b$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $6gxho.addConsoleInstrumentationHandler)($2d27409c85b6756b$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $bM6aW.addClickKeypressInstrumentationHandler)($2d27409c85b6756b$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $9X7xs.addXhrInstrumentationHandler)($2d27409c85b6756b$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $gfqT4.addFetchInstrumentationHandler)($2d27409c85b6756b$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3kfyQ.addHistoryInstrumentationHandler)($2d27409c85b6756b$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $2d27409c85b6756b$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $2d27409c85b6756b$export$c079d904b326663a = (0, $j1zPl.defineIntegration)($2d27409c85b6756b$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $2d27409c85b6756b$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $dHEV3.getClient)() !== client) return;
        (0, $imn0b.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $h9p4m.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $2d27409c85b6756b$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $dHEV3.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $2d27409c85b6756b$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$2d27409c85b6756b$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$2d27409c85b6756b$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $2d27409c85b6756b$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $2d27409c85b6756b$var$_isEvent(event) ? event.target : event;
            target = (0, $dPLPm.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $dPLPm.getComponentName)(element);
        } catch  {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $imn0b.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $2d27409c85b6756b$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $dHEV3.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $dOy0j.severityLevelFromString)(handlerData.level),
            message: (0, $kWdMm.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $kWdMm.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $imn0b.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $2d27409c85b6756b$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $dHEV3.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $9X7xs.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $bTIV2.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $imn0b.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $2d27409c85b6756b$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $dHEV3.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $imn0b.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $bTIV2.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $imn0b.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $2d27409c85b6756b$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $dHEV3.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $f82Ej.parseUrl)((0, $bC06r.WINDOW).location.href);
        let parsedFrom = from ? (0, $f82Ej.parseUrl)(from) : undefined;
        const parsedTo = (0, $f82Ej.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $imn0b.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $2d27409c85b6756b$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("imn0b", function(module, exports) {

$parcel$export(module.exports, "addBreadcrumb", function () { return $d5dc1fcb5d5ec12d$export$efda9a273d7a036d; });

var $dHEV3 = parcelRequire("dHEV3");

var $w8bd7 = parcelRequire("w8bd7");

var $7Y1KN = parcelRequire("7Y1KN");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $d5dc1fcb5d5ec12d$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $d5dc1fcb5d5ec12d$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $dHEV3.getClient)();
    const isolationScope = (0, $dHEV3.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $d5dc1fcb5d5ec12d$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $7Y1KN.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $w8bd7.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});

parcelRegister("bTIV2", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", function () { return $8a97acbe9204ad2b$export$b8cfcc4175694bcc; });
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $8a97acbe9204ad2b$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

});

parcelRegister("bM6aW", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $8928f7b810eb0d46$export$5aeffd3db2cf9df7; });

var $f5byn = parcelRequire("f5byn");
var $4zVoD = parcelRequire("4zVoD");
var $h9p4m = parcelRequire("h9p4m");

var $bxVth = parcelRequire("bxVth");
const $8928f7b810eb0d46$var$DEBOUNCE_DURATION = 1000;
let $8928f7b810eb0d46$var$debounceTimerID;
let $8928f7b810eb0d46$var$lastCapturedEventType;
let $8928f7b810eb0d46$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8928f7b810eb0d46$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, $8928f7b810eb0d46$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $8928f7b810eb0d46$export$3014bbf0af0e1d4a() {
    if (!(0, $bxVth.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f5byn.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $8928f7b810eb0d46$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $bxVth.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $bxVth.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $bxVth.WINDOW);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $4zVoD.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $8928f7b810eb0d46$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $4zVoD.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $8928f7b810eb0d46$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $8928f7b810eb0d46$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $8928f7b810eb0d46$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $8928f7b810eb0d46$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $8928f7b810eb0d46$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $8928f7b810eb0d46$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($8928f7b810eb0d46$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $4zVoD.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $4zVoD.addNonEnumerableProperty)(target, '_sentryId', (0, $h9p4m.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$8928f7b810eb0d46$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $8928f7b810eb0d46$var$lastCapturedEventType = event.type;
            $8928f7b810eb0d46$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($8928f7b810eb0d46$var$debounceTimerID);
        $8928f7b810eb0d46$var$debounceTimerID = (0, $bxVth.WINDOW).setTimeout(()=>{
            $8928f7b810eb0d46$var$lastCapturedEventTargetId = undefined;
            $8928f7b810eb0d46$var$lastCapturedEventType = undefined;
        }, $8928f7b810eb0d46$var$DEBOUNCE_DURATION);
    };
}
function $8928f7b810eb0d46$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});


parcelRegister("2GRLG", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $1f5936388ff396fc$export$59bfe9f1c76150e; });

var $j1zPl = parcelRequire("j1zPl");
var $4zVoD = parcelRequire("4zVoD");
var $iFp2j = parcelRequire("iFp2j");

var $bC06r = parcelRequire("bC06r");
const $1f5936388ff396fc$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $1f5936388ff396fc$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $1f5936388ff396fc$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $1f5936388ff396fc$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $4zVoD.fill)((0, $bC06r.WINDOW), 'setTimeout', $1f5936388ff396fc$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $4zVoD.fill)((0, $bC06r.WINDOW), 'setInterval', $1f5936388ff396fc$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $4zVoD.fill)((0, $bC06r.WINDOW), 'requestAnimationFrame', $1f5936388ff396fc$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $bC06r.WINDOW)) (0, $4zVoD.fill)(XMLHttpRequest.prototype, 'send', $1f5936388ff396fc$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $1f5936388ff396fc$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$1f5936388ff396fc$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $1f5936388ff396fc$export$59bfe9f1c76150e = (0, $j1zPl.defineIntegration)($1f5936388ff396fc$var$_browserApiErrorsIntegration);
function $1f5936388ff396fc$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $bC06r.wrap)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $iFp2j.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $1f5936388ff396fc$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $bC06r.wrap)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $iFp2j.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function $1f5936388ff396fc$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $4zVoD.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $iFp2j.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $4zVoD.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $iFp2j.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $bC06r.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $1f5936388ff396fc$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $bC06r.WINDOW);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $4zVoD.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($1f5936388ff396fc$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $bC06r.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $iFp2j.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $1f5936388ff396fc$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $bC06r.wrap)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $iFp2j.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, $4zVoD.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $1f5936388ff396fc$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $1f5936388ff396fc$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}

});

parcelRegister("iPvgx", function(module, exports) {

$parcel$export(module.exports, "browserSessionIntegration", function () { return $db553e29b7459d8f$export$1baa7880e357371c; });

var $cPuNx = parcelRequire("cPuNx");
var $w8bd7 = parcelRequire("w8bd7");
var $j1zPl = parcelRequire("j1zPl");

var $3kfyQ = parcelRequire("3kfyQ");

var $2sCie = parcelRequire("2sCie");

var $bC06r = parcelRequire("bC06r");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $db553e29b7459d8f$export$1baa7880e357371c = (0, $j1zPl.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $bC06r.WINDOW).document === 'undefined') {
                (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $cPuNx.startSession)({
                ignoreDuration: true
            });
            (0, $cPuNx.captureSession)();
            // We want to create a session for every navigation as well
            (0, $3kfyQ.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $cPuNx.startSession)({
                        ignoreDuration: true
                    });
                    (0, $cPuNx.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("ew6DM", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $a9193486f0d7112b$export$66acc70e8cf2b71a; });

var $7C8eI = parcelRequire("7C8eI");
var $eUf1i = parcelRequire("eUf1i");
var $cPuNx = parcelRequire("cPuNx");
var $w8bd7 = parcelRequire("w8bd7");
var $j1zPl = parcelRequire("j1zPl");
var $dHEV3 = parcelRequire("dHEV3");
var $dPLPm = parcelRequire("dPLPm");
var $9ISAs = parcelRequire("9ISAs");
var $iFp2j = parcelRequire("iFp2j");

var $2sCie = parcelRequire("2sCie");

var $b95ae = parcelRequire("b95ae");

var $bC06r = parcelRequire("bC06r");
const $a9193486f0d7112b$var$INTEGRATION_NAME = 'GlobalHandlers';
const $a9193486f0d7112b$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $a9193486f0d7112b$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $a9193486f0d7112b$var$_installGlobalOnErrorHandler(client);
                $a9193486f0d7112b$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $a9193486f0d7112b$var$_installGlobalOnUnhandledRejectionHandler(client);
                $a9193486f0d7112b$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $a9193486f0d7112b$export$66acc70e8cf2b71a = (0, $j1zPl.defineIntegration)($a9193486f0d7112b$var$_globalHandlersIntegration);
function $a9193486f0d7112b$var$_installGlobalOnErrorHandler(client) {
    (0, $7C8eI.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $a9193486f0d7112b$var$getOptions();
        if ((0, $dHEV3.getClient)() !== client || (0, $bC06r.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $a9193486f0d7112b$var$_enhanceEventWithInitialFrame((0, $b95ae.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $cPuNx.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function $a9193486f0d7112b$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $eUf1i.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $a9193486f0d7112b$var$getOptions();
        if ((0, $dHEV3.getClient)() !== client || (0, $bC06r.shouldIgnoreOnError)()) return;
        const error = $a9193486f0d7112b$var$_getUnhandledRejectionError(e);
        const event = (0, $9ISAs.isPrimitive)(error) ? $a9193486f0d7112b$var$_eventFromRejectionWithPrimitive(error) : (0, $b95ae.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $cPuNx.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
function $a9193486f0d7112b$var$_getUnhandledRejectionError(error) {
    if ((0, $9ISAs.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $a9193486f0d7112b$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $a9193486f0d7112b$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = $a9193486f0d7112b$var$getFilenameFromUrl(url) ?? (0, $dPLPm.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $iFp2j.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $a9193486f0d7112b$var$globalHandlerLog(type) {
    (0, $2sCie.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Global Handler attached: ${type}`);
}
function $a9193486f0d7112b$var$getOptions() {
    const client = (0, $dHEV3.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $a9193486f0d7112b$var$getFilenameFromUrl(url) {
    if (!(0, $9ISAs.isString)(url) || url.length === 0) return undefined;
    // stack frame urls can be data urls, for example when initializing a Worker with a base64 encoded script
    // in this case we just show the data prefix and mime type to avoid too long raw data urls
    if (url.startsWith('data:')) {
        const match = url.match(/^data:([^;]+)/);
        const mimeType = match ? match[1] : 'text/javascript';
        const isBase64 = url.includes('base64,');
        return `<data:${mimeType}${isBase64 ? ',base64' : ''}>`;
    }
    return url.slice(0, 1024);
}

});

parcelRegister("hf4AU", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $c8d766b0e9172b2b$export$1378794447170364; });

var $j1zPl = parcelRequire("j1zPl");

var $bC06r = parcelRequire("bC06r");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $c8d766b0e9172b2b$export$1378794447170364 = (0, $j1zPl.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $bC06r.WINDOW).navigator && !(0, $bC06r.WINDOW).location && !(0, $bC06r.WINDOW).document) return;
            const reqData = (0, $bC06r.getHttpRequestData)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});

});

parcelRegister("69FHl", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $47b3edbc010415b3$export$ebabb00eb7f3a395; });

var $8r2gM = parcelRequire("8r2gM");
var $j1zPl = parcelRequire("j1zPl");

var $b95ae = parcelRequire("b95ae");
const $47b3edbc010415b3$var$DEFAULT_KEY = 'cause';
const $47b3edbc010415b3$var$DEFAULT_LIMIT = 5;
const $47b3edbc010415b3$var$INTEGRATION_NAME = 'LinkedErrors';
const $47b3edbc010415b3$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $47b3edbc010415b3$var$DEFAULT_LIMIT;
    const key = options.key || $47b3edbc010415b3$var$DEFAULT_KEY;
    return {
        name: $47b3edbc010415b3$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $8r2gM.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $b95ae.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $47b3edbc010415b3$export$ebabb00eb7f3a395 = (0, $j1zPl.defineIntegration)($47b3edbc010415b3$var$_linkedErrorsIntegration);

});
parcelRegister("8r2gM", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $62429b0d2c654dd9$export$b91c38ed7d8ae9b2; });

var $9ISAs = parcelRequire("9ISAs");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $62429b0d2c654dd9$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $9ISAs.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $62429b0d2c654dd9$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $62429b0d2c654dd9$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9ISAs.isInstanceOf)(error[key], Error)) {
        $62429b0d2c654dd9$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $62429b0d2c654dd9$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $62429b0d2c654dd9$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9ISAs.isInstanceOf)(childError, Error)) {
            $62429b0d2c654dd9$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $62429b0d2c654dd9$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $62429b0d2c654dd9$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $62429b0d2c654dd9$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    exception.mechanism = {
        handled: true,
        type: 'auto.core.linked_errors',
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $62429b0d2c654dd9$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}

});


parcelRegister("lT9Dc", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $fef6349ce3dd148e$export$2b2b997d81bf3907; });

var $iFp2j = parcelRequire("iFp2j");
const $fef6349ce3dd148e$var$OPERA10_PRIORITY = 10;
const $fef6349ce3dd148e$var$OPERA11_PRIORITY = 20;
const $fef6349ce3dd148e$var$CHROME_PRIORITY = 30;
const $fef6349ce3dd148e$var$WINJS_PRIORITY = 40;
const $fef6349ce3dd148e$var$GECKO_PRIORITY = 50;
function $fef6349ce3dd148e$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $iFp2j.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $fef6349ce3dd148e$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $fef6349ce3dd148e$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $fef6349ce3dd148e$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $fef6349ce3dd148e$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $fef6349ce3dd148e$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($fef6349ce3dd148e$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $fef6349ce3dd148e$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $fef6349ce3dd148e$var$createFrame(filename, (0, $iFp2j.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $fef6349ce3dd148e$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $fef6349ce3dd148e$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $fef6349ce3dd148e$var$extractSafariExtensionDetails(parts[1] || (0, $iFp2j.UNKNOWN_FUNCTION), parts[2]);
        return $fef6349ce3dd148e$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $fef6349ce3dd148e$export$263a749fff749872 = [
    $fef6349ce3dd148e$var$CHROME_PRIORITY,
    $fef6349ce3dd148e$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $fef6349ce3dd148e$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $fef6349ce3dd148e$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $fef6349ce3dd148e$var$gecko = (line)=>{
    const parts = $fef6349ce3dd148e$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $fef6349ce3dd148e$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $iFp2j.UNKNOWN_FUNCTION);
        [func, filename] = $fef6349ce3dd148e$var$extractSafariExtensionDetails(func, filename);
        return $fef6349ce3dd148e$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $fef6349ce3dd148e$export$cdba47a5dd2804d = [
    $fef6349ce3dd148e$var$GECKO_PRIORITY,
    $fef6349ce3dd148e$var$gecko
];
const $fef6349ce3dd148e$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $fef6349ce3dd148e$var$winjs = (line)=>{
    const parts = $fef6349ce3dd148e$var$winjsRegex.exec(line);
    return parts ? $fef6349ce3dd148e$var$createFrame(parts[2], parts[1] || (0, $iFp2j.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $fef6349ce3dd148e$export$179460296da408e8 = [
    $fef6349ce3dd148e$var$WINJS_PRIORITY,
    $fef6349ce3dd148e$var$winjs
];
const $fef6349ce3dd148e$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $fef6349ce3dd148e$var$opera10 = (line)=>{
    const parts = $fef6349ce3dd148e$var$opera10Regex.exec(line);
    return parts ? $fef6349ce3dd148e$var$createFrame(parts[2], parts[3] || (0, $iFp2j.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $fef6349ce3dd148e$export$f892b52c880ffc7a = [
    $fef6349ce3dd148e$var$OPERA10_PRIORITY,
    $fef6349ce3dd148e$var$opera10
];
const $fef6349ce3dd148e$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $fef6349ce3dd148e$var$opera11 = (line)=>{
    const parts = $fef6349ce3dd148e$var$opera11Regex.exec(line);
    return parts ? $fef6349ce3dd148e$var$createFrame(parts[5], parts[3] || parts[4] || (0, $iFp2j.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $fef6349ce3dd148e$export$af11af13f09fb0dc = [
    $fef6349ce3dd148e$var$OPERA11_PRIORITY,
    $fef6349ce3dd148e$var$opera11
];
const $fef6349ce3dd148e$export$7197c0fe6554c079 = [
    $fef6349ce3dd148e$export$263a749fff749872,
    $fef6349ce3dd148e$export$cdba47a5dd2804d
];
const $fef6349ce3dd148e$export$2b2b997d81bf3907 = (0, $iFp2j.createStackParser)(...$fef6349ce3dd148e$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $fef6349ce3dd148e$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $iFp2j.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("919im", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $690b6adb9fbcdfb0$export$b2311068c46d7cc8; });

var $hb6jf = parcelRequire("hb6jf");

var $cwqT4 = parcelRequire("cwqT4");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $690b6adb9fbcdfb0$export$b2311068c46d7cc8(options, nativeFetch = (0, $cwqT4.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            // Note: We do not need to suppress tracing here, because we are using the native fetch, instead of our wrapped one.
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After')
                }
            };
        } catch (e) {
            (0, $cwqT4.clearCachedImplementation)('fetch');
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $hb6jf.createTransport)(options, makeRequest);
}

});
parcelRegister("hb6jf", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $c8185bb1211f9479$export$d09f50d9ab7f7b69; });

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $cARsW = parcelRequire("cARsW");

var $94ljG = parcelRequire("94ljG");

var $2UEaw = parcelRequire("2UEaw");
const $c8185bb1211f9479$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $c8185bb1211f9479$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $94ljG.makePromiseBuffer)(options.bufferSize || $c8185bb1211f9479$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $cARsW.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $cARsW.envelopeItemTypeToDataCategory)(type);
            if ((0, $2UEaw.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $cARsW.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $cARsW.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $cARsW.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $cARsW.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $2UEaw.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $94ljG.SENTRY_BUFFER_FULL_ERROR)) {
                (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("94ljG", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BUFFER_FULL_ERROR", function () { return $69a505cebc9b147f$export$c8667f1887a128dc; });
$parcel$export(module.exports, "makePromiseBuffer", function () { return $69a505cebc9b147f$export$85a4f67f852183e6; });

var $eNEeE = parcelRequire("eNEeE");
const $69a505cebc9b147f$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $69a505cebc9b147f$export$85a4f67f852183e6(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $eNEeE.rejectedSyncPromise)($69a505cebc9b147f$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return (0, $eNEeE.resolvedSyncPromise)(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>setTimeout(()=>resolve(false), timeout))
        ];
        // Promise.race will resolve to the first promise that resolves or rejects
        // So if the drainPromise resolves, the timeout promise will be ignored
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}

});

parcelRegister("2UEaw", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $21eff86a6001db1a$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $21eff86a6001db1a$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $21eff86a6001db1a$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $21eff86a6001db1a$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $21eff86a6001db1a$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $21eff86a6001db1a$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $21eff86a6001db1a$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $21eff86a6001db1a$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $21eff86a6001db1a$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $21eff86a6001db1a$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});


parcelRegister("cwqT4", function(module, exports) {

$parcel$export(module.exports, "getNativeImplementation", function () { return $91dd546e249d0044$export$e464f4a514ac28a8; });
$parcel$export(module.exports, "clearCachedImplementation", function () { return $91dd546e249d0044$export$8aa36702e8c8978; });

var $w8bd7 = parcelRequire("w8bd7");
var $i0qqg = parcelRequire("i0qqg");

var $5q5cQ = parcelRequire("5q5cQ");

var $bxVth = parcelRequire("bxVth");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $91dd546e249d0044$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $91dd546e249d0044$export$e464f4a514ac28a8(name) {
    const cached = $91dd546e249d0044$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $bxVth.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $i0qqg.isNativeFunction)(impl)) return $91dd546e249d0044$var$cachedImplementations[name] = impl.bind((0, $bxVth.WINDOW));
    const document = (0, $bxVth.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $5q5cQ.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $91dd546e249d0044$var$cachedImplementations[name] = impl.bind((0, $bxVth.WINDOW));
}
/** Clear a cached implementation. */ function $91dd546e249d0044$export$8aa36702e8c8978(name) {
    $91dd546e249d0044$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $91dd546e249d0044$export$e7aa7bc5c1b3cfb3(...rest) {
    return $91dd546e249d0044$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $91dd546e249d0044$export$831dc9f2ab0a617b(...rest) {
    return $91dd546e249d0044$export$e464f4a514ac28a8('setTimeout')(...rest);
}

});


parcelRegister("89CO5", function(module, exports) {

$parcel$export(module.exports, "checkAndWarnIfIsEmbeddedBrowserExtension", function () { return $5efd4433623eb022$export$dc236a86065879fc; });

var $w8bd7 = parcelRequire("w8bd7");
var $dPLPm = parcelRequire("dPLPm");

var $2sCie = parcelRequire("2sCie");

var $bC06r = parcelRequire("bC06r");
/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $5efd4433623eb022$export$dc236a86065879fc() {
    if ($5efd4433623eb022$var$_isEmbeddedBrowserExtension()) {
        if (0, $2sCie.DEBUG_BUILD) (0, $w8bd7.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $5efd4433623eb022$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $bC06r.WINDOW).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $bC06r.WINDOW);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $dPLPm.getLocationHref)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $bC06r.WINDOW) === (0, $bC06r.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}

});


parcelRegister("fZ4oz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66f7f8f8da9935f5$export$2e2bcd8739ae039; });

var $ltXBQ = parcelRequire("ltXBQ");
function $66f7f8f8da9935f5$export$2e2bcd8739ae039(selectedRegion) {
    let addedElement = null;
    try {
        const regionInfo = (0, $ltXBQ.getRegionInfo)(selectedRegion);
        if (!regionInfo) return undefined;
        const randomString = Math.floor(Math.random() * 0xfffffffffffff).toString(36);
        addedElement = document.createElement("div");
        addedElement.id = randomString;
        addedElement.className = "pingRegion";
        document.body.insertBefore(addedElement, document.body.firstChild);
        const imageCell = document.createElement("img");
        imageCell.id = `imageCell-${randomString}`;
        imageCell.style.display = "none";
        addedElement.appendChild(imageCell);
        const targetUrl = `${regionInfo.endpoint}ping?x=${randomString}`;
        const pingImageOne = document.createElement("img");
        pingImageOne.id = `pingImageOne-${randomString}`;
        pingImageOne.dataset.image = "1";
        pingImageOne.style.display = "none";
        imageCell.appendChild(pingImageOne);
        const pingImageTwo = document.createElement("img");
        pingImageTwo.id = `pingImageTwo-${randomString}`;
        pingImageTwo.dataset.image = "2";
        pingImageTwo.style.display = "none";
        imageCell.appendChild(pingImageTwo);
        return new Promise((resolve)=>{
            pingImageOne.addEventListener("error", ()=>{
                const startTime = new Date().getTime();
                imageCell.innerHTML = "";
                imageCell.appendChild(pingImageTwo);
                pingImageTwo.addEventListener("error", ()=>{
                    const endTime = new Date().getTime();
                    const elapsed = endTime - startTime;
                    resolve({
                        id: regionInfo.id,
                        name: regionInfo.name,
                        latency: elapsed
                    });
                    document.body.removeChild(addedElement); // Remove the dynamically created element
                });
                pingImageTwo.setAttribute("src", targetUrl);
            });
            pingImageOne.setAttribute("src", targetUrl);
        });
    } catch (error) {
        if (addedElement && document.body.contains(addedElement)) document.body.removeChild(addedElement); // Ensure cleanup in case of an error
        console.error(error);
    }
}

});

parcelRegister("cqTsR", function(module, exports) {

$parcel$export(module.exports, "checkUntilClosed", function () { return $5adb9af6043686d4$export$dc096980b9559842; });
$parcel$export(module.exports, "startSession", function () { return $5adb9af6043686d4$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "loadFrame", function () { return $5adb9af6043686d4$export$ce24fe47d96d8eb0; });

var $4DjaP = parcelRequire("4DjaP");

var $cPuNx = parcelRequire("cPuNx");

var $4V4G7 = parcelRequire("4V4G7");

var $ltXBQ = parcelRequire("ltXBQ");
/**
 * Returns session.state as a comparable string.
 *
 * SDK NOTE: @fra.me/terminal-factory v7 types Session.state as `typeof SessionState`
 * (the whole constant object) rather than as a string value. At runtime the value IS
 * a string like "OPEN" or "CLOSING". This helper applies a cast and documents the
 * SDK type inaccuracy in one place.
 * See api.d.ts line 160: `state: typeof SessionState`.
 * TODO: Remove cast when SDK fixes the type declaration.
 */ function $5adb9af6043686d4$var$sessionStateString(session) {
    return session.state;
}
async function $5adb9af6043686d4$export$dc096980b9559842(deps) {
    const { terminal: terminal, startButton: startButton, statusMessage: statusMessage } = deps;
    // SDK types getOpenSession() as non-nullable, but at runtime it CAN return null.
    const session = await terminal.getOpenSession();
    if (session && session.state) {
        const isClosing = $5adb9af6043686d4$var$sessionStateString(session) === (0, $4DjaP.SessionState).CLOSING;
        if (isClosing) {
            (0, $4V4G7.toggleStartButton)(startButton, false, "Closing last session...");
            statusMessage.innerText = "We're doing some cleanup from the previous session. We'll be ready to launch soon.";
            const sessionGetter = async ()=>terminal.getOpenSession();
            const isClosingCheck = (result)=>result !== null && $5adb9af6043686d4$var$sessionStateString(result) === (0, $4DjaP.SessionState).CLOSING;
            await (0, $ltXBQ.pollSession)(sessionGetter, isClosingCheck, 1000);
            return true;
        }
    }
    // Session is either null (closed) or not in CLOSING state (already closed)
    return true;
}
async function $5adb9af6043686d4$export$c0d84948cecf78d8(applicationId, deps) {
    const { terminal: terminal, kwInput: kwInput, kwPasswordInput: kwPasswordInput, userNameInput: userNameInput } = deps;
    $cPuNx.setContext("Application", {
        id: applicationId
    });
    if (!terminal) throw new Error(`Terminal not loaded. Could not start session. Application ID: ${applicationId}`);
    let session = await terminal.getOpenSession();
    if (session) {
        console.info("Resuming session", session.id);
        session = await terminal.resume(session.id);
    } else {
        console.info("Starting session", applicationId);
        const sessionData = `${kwInput.value}_${kwPasswordInput.value}_${userNameInput.value}`;
        session = await terminal.start({
            appId: applicationId,
            userData: sessionData
        });
        console.info("Session started", session.id);
    }
    return session;
}
async function $5adb9af6043686d4$export$ce24fe47d96d8eb0(accountConfig, token, deps, setTerminal) {
    const { startButton: startButton, statusMessage: statusMessage, loginFieldset: loginFieldset, kwInput: kwInput, kwPasswordInput: kwPasswordInput, userNameInput: userNameInput } = deps;
    const sessionOptions = {
        serviceUrl: deps.serviceUrl,
        terminalConfigId: accountConfig.terminalConfigId,
        token: token
    };
    try {
        const terminal = await (0, $4DjaP.createInstance)(sessionOptions);
        setTerminal(terminal);
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_STARTING, ()=>{
            statusMessage.innerText = "Connecting...";
            (0, $4V4G7.toggleStartButton)(startButton, false, "Connecting...");
            loginFieldset.disabled = true;
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_RESUMING, ()=>{
            statusMessage.innerText = "Resuming previous session...";
            (0, $4V4G7.toggleStartButton)(startButton, false, "Resuming...");
            loginFieldset.disabled = true;
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_STARTED, ()=>{
            statusMessage.innerText = "Connected.";
            loginFieldset.disabled = true;
            (0, $4V4G7.toggleStartButton)(startButton, false, "Connected.");
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_RESUMED, ()=>{
            statusMessage.innerText = "Connected.";
            loginFieldset.disabled = true;
            (0, $4V4G7.toggleStartButton)(startButton, false, "Connected.");
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_DISCONNECTED, async ()=>{
            statusMessage.innerText = "Disconnected. Click Resume to reconnect to your previous session or change location to start a new session.";
            loginFieldset.disabled = false;
            (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, false);
            (0, $4V4G7.toggleStartButton)(startButton, true, "Resume");
            const sessionClosed = await $5adb9af6043686d4$export$dc096980b9559842({
                ...deps,
                terminal: terminal
            });
            if (sessionClosed) {
                statusMessage.innerText = "Session disconnected. Click Launch to start a new session.";
                (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
                loginFieldset.disabled = false;
                (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, true);
            }
        });
        terminal.bind((0, $4DjaP.TerminalEvent).SESSION_CLOSED, async ()=>{
            statusMessage.innerText = "Closing session...";
            (0, $4V4G7.toggleStartButton)(startButton, false, "Closing...");
            const sessionClosed = await $5adb9af6043686d4$export$dc096980b9559842({
                ...deps,
                terminal: terminal
            });
            if (sessionClosed) {
                statusMessage.innerText = "Session ended.";
                loginFieldset.disabled = false;
                (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
            }
        });
        // check for open session right away
        const session = await terminal.getOpenSession();
        if (session && $5adb9af6043686d4$var$sessionStateString(session) === (0, $4DjaP.SessionState).OPEN) {
            loginFieldset.disabled = false;
            (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, false);
            statusMessage.innerText = "An active session is already running. Click Resume to reconnect or change location to start a new session.";
            (0, $4V4G7.toggleStartButton)(startButton, true, "Resume");
        } else if (session && $5adb9af6043686d4$var$sessionStateString(session) === (0, $4DjaP.SessionState).CLOSING) {
            const sessionClosed = await $5adb9af6043686d4$export$dc096980b9559842({
                ...deps,
                terminal: terminal
            });
            if (sessionClosed) {
                statusMessage.innerText = "Click Launch to start a new session.";
                (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
                loginFieldset.disabled = false;
                (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, true);
            }
        } else if (session === null) {
            loginFieldset.disabled = false;
            (0, $4V4G7.toggleKwInputs)(kwInput, kwPasswordInput, userNameInput, true);
            (0, $4V4G7.toggleStartButton)(startButton, true, "Launch");
        }
    } catch (error) {
        console.warn(`Error loading Frame terminal: ${error}`);
        throw error;
    }
}

});
parcelRegister("4V4G7", function(module, exports) {

$parcel$export(module.exports, "toggleKwInputs", function () { return $82937af3788bbfe5$export$cda5838fb0faae2e; });
$parcel$export(module.exports, "toggleStartButton", function () { return $82937af3788bbfe5$export$8d98d7aa87d5cfd9; });
$parcel$export(module.exports, "updateYear", function () { return $82937af3788bbfe5$export$b3bed366e0f3268b; });
/**
 * UI Module
 *
 * Handles DOM manipulation and user interface updates.
 */ /**
 * Toggles the disabled state of keyword input fields.
 *
 * @param kwInput - The KW number input element.
 * @param kwPasswordInput - The KW password input element.
 * @param userNameInput - The username input element.
 * @param enabled - If true, enables the input fields; if false, disables them.
 * @returns void
 */ function $82937af3788bbfe5$export$cda5838fb0faae2e(kwInput, kwPasswordInput, userNameInput, enabled) {
    kwInput.disabled = !enabled;
    kwPasswordInput.disabled = !enabled;
    userNameInput.disabled = !enabled;
}
function $82937af3788bbfe5$export$8d98d7aa87d5cfd9(startButton, enabled, buttonText) {
    startButton.disabled = !enabled;
    startButton.innerText = buttonText;
    startButton.classList.toggle("disabled", !enabled);
}
function $82937af3788bbfe5$export$b3bed366e0f3268b(copyrightYearElement) {
    const year = new Date().getFullYear();
    if (year) copyrightYearElement.textContent = year.toString();
}

});


parcelRegister("js5ua", function(module, exports) {

$parcel$export(module.exports, "setSentryUser", function () { return $2f96a94ffa07465a$export$5ceec5c8be62fa1b; });
$parcel$export(module.exports, "setSentryLocation", function () { return $2f96a94ffa07465a$export$52377dc05369123a; });
$parcel$export(module.exports, "postScreenSpecs", function () { return $2f96a94ffa07465a$export$2362e295bf7b7337; });
/**
 * Telemetry Module
 *
 * Handles Sentry integration and screen specifications reporting.
 */ 
var $cPuNx = parcelRequire("cPuNx");

var $3Kq1x = parcelRequire("3Kq1x");

var $bAPCA = parcelRequire("bAPCA");

var $ltXBQ = parcelRequire("ltXBQ");
function $2f96a94ffa07465a$export$5ceec5c8be62fa1b(kwInput, userNameInput) {
    $cPuNx.setUser({
        id: kwInput.value,
        username: userNameInput.value
    });
}
function $2f96a94ffa07465a$export$52377dc05369123a(option) {
    if (!option) {
        console.warn("No option provided to setSentryLocation");
        return;
    }
    $cPuNx.setContext("Location", {
        id: option.id,
        name: option.label
    });
}
async function $2f96a94ffa07465a$export$2362e295bf7b7337(kwInput) {
    const kwNumber = kwInput.value.slice(-5);
    const screenSpecs = {
        ScreenHeightPixels: window.screen.height,
        ScreenWidthPixels: window.screen.width,
        ExecutionPlatform: "cloud",
        ProductName: "SE",
        KWNumber: kwNumber,
        ClientOS: (0, $ltXBQ.detectOS)(navigator)
    };
    try {
        await (0, $3Kq1x.default).post((0, $bAPCA.ApiEndpoints).SCREEN_SPECS, screenSpecs);
    } catch (error) {
        $cPuNx.captureException(error);
        console.warn(`ERROR: Error posting screen specs: ${error}`);
    }
}

});

parcelRegister("fN5b4", function(module, exports) {

$parcel$export(module.exports, "getToken", function () { return $e487d876ad4cd512$export$257b2d10b709d8ef; });
/**
 * Token Management Module
 *
 * Handles JWT token retrieval, validation, and caching for Frame authentication.
 */ 
var $bAPCA = parcelRequire("bAPCA");

var $1mFEN = parcelRequire("1mFEN");
function $e487d876ad4cd512$export$d1a8c8b605234fe8(payload) {
    return payload.exp * 1000 - Date.now() > 1800000;
}
async function $e487d876ad4cd512$export$257b2d10b709d8ef() {
    let token = localStorage.getItem((0, $bAPCA.StorageKeys).FRAME_TOKEN);
    if (token === null) token = await (0, $1mFEN.requestToken)((0, $bAPCA.ApiEndpoints).TOKEN);
    const payload = (0, $1mFEN.getTokenPayload)(token);
    if (!$e487d876ad4cd512$export$d1a8c8b605234fe8(payload)) token = await (0, $1mFEN.requestToken)((0, $bAPCA.ApiEndpoints).TOKEN);
    localStorage.setItem((0, $bAPCA.StorageKeys).FRAME_TOKEN, token);
    return token;
}

});


//# sourceMappingURL=src1970441075.3d6b5283.js.map
